webpackJsonp([1],{

/***/ "+7az":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"block-header"},[_c('h2',[_vm._v(_vm._s(_vm.nama))])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            List "+_vm._s(_vm.nama)+"\n                        ")]),_vm._v(" "),_c('ul',{staticClass:"header-dropdown m-r--5 m-t--10"},[_c('router-link',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect",attrs:{"to":'/main/informasi/' + _vm.link + '/tambah',"type":"button"}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#fff"}},[_vm._v("add_box")]),_vm._v(" "),_c('span',[_vm._v("Tambah")])])],1)]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"dataTables_wrapper form-inline dt-bootstrap",attrs:{"id":"DataTables_Table_0_wrapper"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_length",attrs:{"id":"DataTables_Table_0_length"}},[_c('label',[_vm._v("Show "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.perPage),expression:"perPage"}],staticClass:"form-control input-sm",attrs:{"name":"DataTables_Table_0_length","aria-controls":"DataTables_Table_0"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.perPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_c('option',{attrs:{"value":"100"}},[_vm._v("100")])]),_vm._v(" entries")])])]),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_filter",attrs:{"id":"DataTables_Table_0_filter"}},[_c('label',[_vm._v("Search:"),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control input-sm",attrs:{"type":"search","placeholder":"","aria-controls":"DataTables_Table_0"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])])])]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped table-hover js-basic-example dataTable"},[_vm._m(0),_vm._v(" "),_c('tbody',[(_vm.isLoading)?_c('tr',[_vm._m(1)]):_vm._e(),_vm._v(" "),(_vm.list == '')?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"4"}},[_vm._v("Data tidak ditemukan")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(item,index){return (!_vm.isLoading)?_c('tr',[_c('td',[_vm._v(_vm._s(++index + ((_vm.currentPage-1)*_vm.perPage)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.judul))]),_vm._v(" "),_c('td',[(item.file != null)?_c('a',{staticClass:"btn btn-info",attrs:{"target":"_blank","href":item.file}},[_c('i',{staticClass:"fa fa-paperclip"}),_vm._v(" File")]):_vm._e()]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn bg-green waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.push('/main/informasi/' + _vm.link + '/edit/' + item.id_informasi_download)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("create")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmDelete(item.id_informasi_download)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")])]),_vm._v(" "),(index != 1)?_c('button',{staticClass:"btn btn-primary waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.moveUp(index)}}},[_c('i',{staticClass:"fa fa-chevron-up"})]):_vm._e(),_vm._v(" "),(index !== (_vm.list.length))?_c('button',{staticClass:"btn btn-primary waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.moveDown(index)}}},[_c('i',{staticClass:"fa fa-chevron-down"})]):_vm._e()])]):_vm._e()})],2)])]),_vm._v(" "),_c('pagination',{attrs:{"total-rows":_vm.result.totalElements,"per-page":_vm.result.size},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("No.")]),_vm._v(" "),_c('th',[_vm._v("Judul")]),_vm._v(" "),_c('th',[_vm._v("File")]),_vm._v(" "),_c('th',[_vm._v("Aksi")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center",attrs:{"colspan":"4"}},[_c('i',{staticClass:"fa fa-spin fa-spinner"}),_vm._v(" Loading data...")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+Btm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");




var baseURL = 'https://api.dapenbi.co.id/';

var a = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
  baseURL: baseURL,
  headers: {
    'Accept': 'application/json'
  }
});

a.defaults.baseURL = baseURL;

a.interceptors.response.use(null, function (error) {
  if (error.response.data.message === 'Token expired') {
    localStorage.removeItem('_token');
    localStorage.removeItem('username');
    localStorage.removeItem('namaLengkap');
    localStorage.removeItem('akses');
    __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].router.push('/login');
    location.reload();
  }
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = (a);

/***/ }),

/***/ "+OgC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_api__ = __webpack_require__("+Btm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FormLine_vue__ = __webpack_require__("w3AW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_3__components_FormLine_vue__["a" /* default */] },
  name: 'ListFaqCategory',
  data: function data() {
    return {
      result: {},
      list: [],
      currentPage: 1,
      perPage: 10,
      search: '',
      modal: null,
      isLoading: true,
      link: '',
      tipe: '',
      nama: ''
    };
  },
  methods: {
    moveUp: function moveUp(index) {
      var a = this.list[index - 1];
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(this.list, index - 1, this.list[index - 2]);
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(this.list, index - 2, a);

      this.saveUrutan();
    },
    moveDown: function moveDown(index) {
      var a = this.list[index - 1];
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(this.list, index - 1, this.list[index]);
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(this.list, index, a);

      this.saveUrutan();
    },
    saveUrutan: function saveUrutan() {
      var _this = this;

      var data = [];
      for (var i = 0; i < this.list.length; i++) {
        data.push({
          'id': this.list[i].id,
          'urutan': i,
          'tipe': this.tipe
        });
      }

      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].post('/faq/move', data).then(function (result) {
        _this.$toastr.s('Urutan berhasil diubah.');
      }).catch(function (ex) {
        _this.$toastr.e('Gagal mengubah urutan, terjadi kesalahan pada server.');
      });
    },
    getData: function getData() {
      var _this2 = this;

      var params = [];
      params.search = this.search;
      params.page = this.currentPage - 1;
      params.size = this.perPage;

      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].get('/getALLFaqCategory?' + __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(params)).then(function (result) {
        _this2.result = result.data;
        _this2.list = result.data.content;
        _this2.isLoading = false;
      }).catch(function (ex) {
        _this2.isLoading = false;
      });
    },
    confirmDelete: function confirmDelete(id) {
      var _this3 = this;

      this.$swal({
        title: 'Konfirmasi',
        text: 'Anda yakin ingin menghapus data ini?',
        icon: 'warning',
        buttons: [true, {
          text: 'Ok',
          closeModal: false
        }],
        dangerMode: true
      }).then(function (result) {
        if (result) _this3.delete(id);
      });
    },
    delete: function _delete(id) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].delete('/deleteFaqById/' + id).then(function (result) {
        if (result.data.code === 200) _this4.$toastr.s('Data berhasil dihapus.');else _this4.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this4.$swal.close();
        _this4.getData();
      }).catch(function (e) {
        _this4.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this4.$swal.close();
      });
    }
  },
  mounted: function mounted() {
    this.getData();
  },
  watch: {
    currentPage: function currentPage(e) {
      this.getData();
    },
    perPage: function perPage(e) {
      this.getData();
    },
    search: function search(e) {
      this.getData();
    }
  }
});

/***/ }),

/***/ "+aAy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"block-header"},[_c('h2',[_vm._v(_vm._s(_vm.nama))])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v(_vm._s(_vm.id != null ? 'Edit' : 'Tambah')+" "+_vm._s(_vm.nama))])]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit.apply(null, arguments)}}},[_c('div',{staticClass:"row clearfix"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"nip","type":"text"},model:{value:(_vm.data.nip),callback:function ($$v) {_vm.$set(_vm.data, "nip", $$v)},expression:"data.nip"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"Pertanyaan","type":"text","disabled":true},model:{value:(_vm.data.pesan),callback:function ($$v) {_vm.$set(_vm.data, "pesan", $$v)},expression:"data.pesan"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"Jenis","type":"text","disabled":true},model:{value:(_vm.data.jenisPengajuan),callback:function ($$v) {_vm.$set(_vm.data, "jenisPengajuan", $$v)},expression:"data.jenisPengajuan"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"jawaban","type":"text"},model:{value:(_vm.data.jawaban),callback:function ($$v) {_vm.$set(_vm.data, "jawaban", $$v)},expression:"data.jawaban"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[(_vm.id != null)?_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-warning waves-effect waves-button",attrs:{"type":"button","disabled":_vm.isLoading},on:{"click":_vm.update}},[(_vm.isLoading)?_c('i',{staticClass:"fa fa-spin fa-spinner"}):_vm._e(),(!_vm.isLoading)?_c('i',{staticClass:"material-icons"},[_vm._v("save")]):_vm._e(),_vm._v(" Edit\n                  ")]):_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect waves-button",attrs:{"type":"button","disabled":_vm.isLoading},on:{"click":_vm.save}},[(_vm.isLoading)?_c('i',{staticClass:"fa fa-spin fa-spinner"}):_vm._e(),(!_vm.isLoading)?_c('i',{staticClass:"material-icons"},[_vm._v("save")]):_vm._e(),_vm._v("\n                    Simpan\n                  ")]),_vm._v(" "),_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")]),_vm._v(" Batal\n                  ")])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"nip"}},[_vm._v("Nip")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"Pertanyaan"}},[_vm._v("Pertanyaan")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"Jenis"}},[_vm._v("Jenis Pengajuan")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"jawaban"}},[_vm._v("Jawaban")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+cgv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+sAT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FormLine_vue__ = __webpack_require__("w3AW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_api__ = __webpack_require__("+Btm");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FormGaleri',
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_0__components_FormLine_vue__["a" /* default */] },
  data: function data() {
    return {
      data: {
        file: '',
        deskripsi: '',
        tipe: 2
      },
      id_galeri: '',
      isLoading: false,
      uploadProgress: 0
    };
  },

  methods: {
    handleFileUpload: function handleFileUpload(event) {
      var _this = this;

      var file = event.target.files[0];
      if (!file) return;

      console.log('File dipilih:', file.name, file.type, file.size);

      var formData = new FormData();
      formData.append('file', file);

      var token = localStorage.getItem('_token');

      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].post('/upload_galeri', formData, {
        headers: {
          Authorization: 'Bearer ' + token
          // Jangan set Content-Type manual agar browser yang handle boundary
        },
        timeout: 0, // No timeout untuk file besar
        onUploadProgress: function onUploadProgress(e) {
          if (e.lengthComputable) {
            _this.uploadProgress = Math.round(e.loaded * 100 / e.total);
          }
        }
      }).then(function (response) {
        console.log('Respon upload:', response);

        var uploaded = '';
        if (response.data && response.data.object && response.data.object.id) {
          uploaded = response.data.object.id;
        } else if (response.data && response.data.file) {
          uploaded = response.data.file;
        }

        if (uploaded) {
          _this.data.file = uploaded;
          _this.$toastr.s('Upload berhasil');
        } else {
          _this.$toastr.e('Upload berhasil tapi file tidak dikenali');
        }
      }).catch(function (err) {
        console.error('Upload error:', err);
        _this.$toastr.e('Upload gagal: ' + (err.response.data.message || 'Terjadi kesalahan'));
      });
    },
    save: function save() {
      var _this2 = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');

      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].post('/galeri', this.data).then(function (res) {
        if (res.data.code === 200) {
          _this2.$toastr.s('Tambah data berhasil');
          _this2.$router.replace('/main/informasi/galeri');
        } else {
          _this2.$toastr.e(res.data.message || 'Tambah data gagal');
        }
        _this2.isLoading = false;
      }).catch(function (err) {
        _this2.isLoading = false;
        var msg = err.response && err.response.data && err.response.data.message || 'Terjadi kesalahan';
        _this2.$toastr.e(msg);
      });
    },
    update: function update() {
      var _this3 = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');

      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].post('/galeri/' + this.id_galeri, this.data).then(function (res) {
        if (res.data.code === 200) {
          _this3.$toastr.s('Ubah data berhasil');
          _this3.$router.replace('/main/informasi/galeri');
        }
        _this3.isLoading = false;
      }).catch(function (err) {
        _this3.isLoading = false;
        var msg = err.response && err.response.data && err.response.data.message || 'Terjadi kesalahan';
        _this3.$toastr.e(msg);
      });
    },
    getDetail: function getDetail() {
      var _this4 = this;

      var id = this.id_galeri;
      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].get('/galeri/' + id).then(function (res) {
        _this4.data = res.data;
      }).catch(function () {
        _this4.$toastr.e('Gagal memuat data');
      });
    }
  },
  mounted: function mounted() {
    this.id_galeri = this.$route.params.id;
    if (this.id_galeri) {
      this.getDetail();
    }
  }
});

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "02jA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_api__ = __webpack_require__("+Btm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__ = __webpack_require__("w3AW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__["a" /* default */] },
  name: 'PendapatList',
  data: function data() {
    return {
      result: {},
      list: [],
      currentPage: 1,
      perPage: 10,
      search: '',
      modal: null,
      isLoading: true,
      link: '',
      nama: ''
    };
  },
  methods: {
    getData: function getData() {
      var _this = this;

      var params = [];
      params.search = this.search;
      params.page = this.currentPage - 1;
      params.size = this.perPage;

      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].get('/getAllTiket?' + __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(params)).then(function (result) {
        _this.result = result.data;
        _this.list = result.data.content;
        _this.isLoading = false;
      }).catch(function (ex) {
        _this.isLoading = false;
        _this.$toastr.e('Gagal terhubung dengan server.');
      });
    },
    confirmDelete: function confirmDelete(id) {
      var _this2 = this;

      this.$swal({
        title: 'Konfirmasi',
        text: 'Anda yakin ingin menghapus data ini?',
        icon: 'warning',
        buttons: [true, {
          text: 'Ok',
          closeModal: false
        }],
        dangerMode: true
      }).then(function (result) {
        if (result) _this2.delete(id);
      });
    },
    delete: function _delete(id) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].delete('/deleteTiket/' + id).then(function (result) {
        if (result.data.code === 200) _this3.$toastr.s('Data berhasil dihapus.');else _this3.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this3.$swal.close();
        _this3.getData();
      }).catch(function (e) {
        _this3.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this3.$swal.close();
      });
    },
    rejectRequest: function rejectRequest(item) {
      var _this4 = this;

      console.log("Item yang dikirim ke rejectRequest:", item.deskripsi, item.nama, item.nip, item.id);

      if (!item || !item.id) {
        this.$toastr.e("Data tidak valid untuk ditolak.");
        return;
      }
      this.$swal({
        title: 'Konfirmasi',
        text: 'Tolak permintaan cetak ini?',
        icon: 'warning',
        buttons: [true, 'Ya, Tolak']
      }).then(function (result) {
        if (result) {
          __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
          __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].post('/updateTiket/' + item.id, {
            deskripsi: item.deskripsi,
            nama: item.nama,
            nip: item.nip,
            keterangan: 'Ditolak',
            statusTiket: 'Pengajuan selesai',
            jawaban: 'Untuk pertanyaan tidak relevan dengan topik yang dipilih. Silahkan lakukan pengajuan ulang'
          }).then(function () {
            _this4.$toastr.s('Permintaan berhasil ditolak.');
            _this4.getData();
          }).catch(function () {
            _this4.$toastr.e('Gagal menolak permintaan.');
          });
        }
      });
    },
    checkRoute: function checkRoute(route) {
      console.log("ini routenamenya", route.name);
      if (route.name === 'Pengaduan') {
        this.link = 'Pengaduan';
        this.nama = 'Pengaduan';
        console.log(this.link);
      }
    }
  },
  mounted: function mounted() {
    this.checkRoute(this.$route);
    this.getData();
  },
  watch: {
    currentPage: function currentPage(e) {
      this.getData();
    },
    perPage: function perPage(e) {
      this.getData();
    },
    search: function search(e) {
      this.getData();
    },
    '$route': function $route(to, from) {
      this.checkRoute(to);
      this.getData();
    }
  }
});

/***/ }),

/***/ "04IV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"block-header"},[_c('h2',[_vm._v(_vm._s(_vm.nama))])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            List "+_vm._s(_vm.nama)+"\n                        ")]),_vm._v(" "),_c('ul',{staticClass:"header-dropdown m-r--5 m-t--10"},[_c('router-link',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect waves-button",attrs:{"to":'/main/informasi/' + _vm.link + '/tambah',"type":"button"}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#fff"}},[_vm._v("add_box")]),_vm._v(" "),_c('span',[_vm._v("Tambah")])])],1)]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"dataTables_wrapper form-inline dt-bootstrap",attrs:{"id":"DataTables_Table_0_wrapper"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_length",attrs:{"id":"DataTables_Table_0_length"}},[_c('label',[_vm._v("Show "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.perPage),expression:"perPage"}],staticClass:"form-control input-sm",attrs:{"name":"DataTables_Table_0_length","aria-controls":"DataTables_Table_0"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.perPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_c('option',{attrs:{"value":"100"}},[_vm._v("100")])]),_vm._v(" entries")])])]),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_filter",attrs:{"id":"DataTables_Table_0_filter"}},[_c('label',[_vm._v("Search:"),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control input-sm",attrs:{"type":"search","placeholder":"","aria-controls":"DataTables_Table_0"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])])])]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped table-hover js-basic-example dataTable"},[_vm._m(0),_vm._v(" "),_c('tbody',[(_vm.isLoading)?_c('tr',[_vm._m(1)]):_vm._e(),_vm._v(" "),(_vm.list == '')?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"5"}},[_vm._v("Data tidak ditemukan")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(item,index){return (!_vm.isLoading)?_c('tr',[_c('td',[_vm._v(_vm._s(++index + ((_vm.currentPage-1)*_vm.perPage)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.judul))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.stripTags(item.deskripsi)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.tanggal ? _vm.$moment(item.tanggal, 'YYYY-MM-DD').format("Do MMMM YYYY") : '-'))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn bg-green waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.push('/main/informasi/' + _vm.link + '/edit/' + item.id_informasi_kegiatan)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("create")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmDelete(item.id_informasi_kegiatan)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")])])])]):_vm._e()})],2)])]),_vm._v(" "),_c('pagination',{attrs:{"total-rows":_vm.result.totalElements,"per-page":_vm.result.size},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("No.")]),_vm._v(" "),_c('th',[_vm._v("Judul")]),_vm._v(" "),_c('th',[_vm._v("Deskripsi")]),_vm._v(" "),_c('th',[_vm._v("Tanggal")]),_vm._v(" "),_c('th',[_vm._v("Aksi")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center",attrs:{"colspan":"5"}},[_c('i',{staticClass:"fa fa-spin fa-spinner"}),_vm._v(" Loading data...")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0Q4w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"block-header"},[_c('h2',[_vm._v(_vm._s(_vm.nama))])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            List "+_vm._s(_vm.nama)+"\n                        ")]),_vm._v(" "),_c('ul',{staticClass:"header-dropdown m-r--5 m-t--10"},[_c('router-link',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect waves-button",attrs:{"to":'/main/pensiunRegistrasi/' + _vm.link + '/tambah',"type":"button"}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#fff"}},[_vm._v("add_box")]),_vm._v(" "),_c('span',[_vm._v("Tambah")])])],1)]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"dataTables_wrapper form-inline dt-bootstrap",attrs:{"id":"DataTables_Table_0_wrapper"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_length",attrs:{"id":"DataTables_Table_0_length"}},[_c('label',[_vm._v("Show "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.perPage),expression:"perPage"}],staticClass:"form-control input-sm",attrs:{"name":"DataTables_Table_0_length","aria-controls":"DataTables_Table_0"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.perPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_c('option',{attrs:{"value":"100"}},[_vm._v("100")])]),_vm._v(" entries")])])]),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_filter",attrs:{"id":"DataTables_Table_0_filter"}},[_c('label',[_vm._v("Search:"),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control input-sm",attrs:{"type":"search","placeholder":"","aria-controls":"DataTables_Table_0"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])])])]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped table-hover js-basic-example dataTable"},[_vm._m(0),_vm._v(" "),_c('tbody',[(_vm.isLoading)?_c('tr',[_vm._m(1)]):_vm._e(),_vm._v(" "),(_vm.list == '')?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"5"}},[_vm._v("Data tidak ditemukan")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(item,index){return (!_vm.isLoading)?_c('tr',[_c('td',[_vm._v(_vm._s(++index + ((_vm.currentPage-1)*_vm.perPage)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.createdAt ? _vm.$moment(item.createdAt, 'YYYY-MM-DD').format("Do MMMM YYYY") : '-'))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn bg-green waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.push('/main/pensiunRegistrasi/pensiuntype/edit/' + item.id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("create")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmDelete(item.id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")])])])]):_vm._e()})],2)])]),_vm._v(" "),_c('pagination',{attrs:{"total-rows":_vm.result.totalElements,"per-page":_vm.result.size},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("No.")]),_vm._v(" "),_c('th',[_vm._v("Title")]),_vm._v(" "),_c('th',[_vm._v("Tanggal di buat")]),_vm._v(" "),_c('th',[_vm._v("Aksi")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center",attrs:{"colspan":"5"}},[_c('i',{staticClass:"fa fa-spin fa-spinner"}),_vm._v(" Loading data...")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0esc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_api__ = __webpack_require__("+Btm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FormLine__ = __webpack_require__("w3AW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_3__components_FormLine__["a" /* default */] },
  name: 'ListFaq',
  data: function data() {
    return {
      result: {},
      list: [],
      currentPage: 1,
      perPage: 10,
      search: '',
      modal: null,
      isLoading: true,
      link: '',
      tipe: '',
      nama: ''
    };
  },
  methods: {
    moveUp: function moveUp(index) {
      var a = this.list[index - 1];
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(this.list, index - 1, this.list[index - 2]);
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(this.list, index - 2, a);

      this.saveUrutan();
    },
    moveDown: function moveDown(index) {
      var a = this.list[index - 1];
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(this.list, index - 1, this.list[index]);
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(this.list, index, a);

      this.saveUrutan();
    },
    saveUrutan: function saveUrutan() {
      var _this = this;

      var data = [];
      for (var i = 0; i < this.list.length; i++) {
        data.push({
          'id': this.list[i].idMasterSurvey,
          'urutan': i
        });
      }

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].post('/survey/move', data).then(function (result) {
        _this.$toastr.s('Urutan berhasil diubah.');
      }).catch(function (ex) {
        _this.$toastr.e('Gagal mengubah urutan, terjadi kesalahan pada server.');
      });
    },
    getData: function getData() {
      var _this2 = this;

      var params = [];
      params.search = this.search;
      params.page = this.currentPage - 1;
      params.size = this.perPage;

      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].get('/survey?' + __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(params)).then(function (result) {
        _this2.result = result.data;
        _this2.list = result.data.content;
        _this2.isLoading = false;
      }).catch(function (ex) {
        _this2.isLoading = false;
      });
    },
    confirmDelete: function confirmDelete(id) {
      var _this3 = this;

      this.$swal({
        title: 'Konfirmasi',
        text: 'Anda yakin ingin menghapus data ini?',
        icon: 'warning',
        buttons: [true, {
          text: 'Ok',
          closeModal: false
        }],
        dangerMode: true
      }).then(function (result) {
        if (result) _this3.delete(id);
      });
    },
    delete: function _delete(id) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].delete('/survey/' + id).then(function (result) {
        if (result.data.code === 200) _this4.$toastr.s('Data berhasil dihapus.');else _this4.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this4.$swal.close();
        _this4.getData();
      }).catch(function (e) {
        _this4.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this4.$swal.close();
      });
    }
  },
  mounted: function mounted() {
    this.getData();
  },
  watch: {
    currentPage: function currentPage(e) {
      this.getData();
    },
    perPage: function perPage(e) {
      this.getData();
    },
    search: function search(e) {
      this.getData();
    }
  }
});

/***/ }),

/***/ "17LW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"block-header"},[_c('h2',[_vm._v(_vm._s(_vm.nama))])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            List "+_vm._s(_vm.nama)+"\n                        ")]),_vm._v(" "),_c('ul',{staticClass:"header-dropdown m-r--5 m-t--10"},[_c('router-link',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect waves-button",attrs:{"to":'/main/informasi/' + _vm.link + '/tambah',"type":"button"}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#fff"}},[_vm._v("add_box")]),_vm._v(" "),_c('span',[_vm._v("Tambah")])])],1)]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"dataTables_wrapper form-inline dt-bootstrap",attrs:{"id":"DataTables_Table_0_wrapper"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_length",attrs:{"id":"DataTables_Table_0_length"}},[_c('label',[_vm._v("Show "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.perPage),expression:"perPage"}],staticClass:"form-control input-sm",attrs:{"name":"DataTables_Table_0_length","aria-controls":"DataTables_Table_0"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.perPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_c('option',{attrs:{"value":"100"}},[_vm._v("100")])]),_vm._v(" entries")])])]),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_filter",attrs:{"id":"DataTables_Table_0_filter"}},[_c('label',[_vm._v("Search:"),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control input-sm",attrs:{"type":"search","placeholder":"","aria-controls":"DataTables_Table_0"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])])])]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped table-hover js-basic-example dataTable"},[_vm._m(0),_vm._v(" "),_c('tbody',[(_vm.isLoading)?_c('tr',[_vm._m(1)]):_vm._e(),_vm._v(" "),(_vm.list == '')?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"5"}},[_vm._v("Data tidak ditemukan")])]):_vm._e(),_vm._v(" "),(!_vm.isLoading)?_vm._l((_vm.list),function(item,index){return _c('tr',{key:item.id},[_c('td',[_vm._v(_vm._s(++index + ((_vm.currentPage-1)*_vm.perPage)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.nip))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.nama))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.topik))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.createdAt ? _vm.$moment(item.createdAt, 'YYYY-MM-DD').format("Do MMMM YYYY") : '-'))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.stripTags(item.deskripsi)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.topik))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn bg-green waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.push('/main/layanan/' + _vm.link + '/edit/' + item.id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("create")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmDelete(item.id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.rejectRequest(item)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")])])])])}):_vm._e()],2)])]),_vm._v(" "),_c('pagination',{attrs:{"total-rows":_vm.result.totalElements,"per-page":_vm.result.size},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("No.")]),_vm._v(" "),_c('th',[_vm._v("Nip")]),_vm._v(" "),_c('th',[_vm._v("nama")]),_vm._v(" "),_c('th',[_vm._v("Topik")]),_vm._v(" "),_c('th',[_vm._v("Tanggal")]),_vm._v(" "),_c('th',[_vm._v("deskripsi")]),_vm._v(" "),_c('th',[_vm._v("Aksi")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center",attrs:{"colspan":"5"}},[_c('i',{staticClass:"fa fa-spin fa-spinner"}),_vm._v(" Loading data...")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1MN2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Chart__ = __webpack_require__("40sN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Bar__ = __webpack_require__("wY8d");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Dashboard',
  components: {
    PieChart: __WEBPACK_IMPORTED_MODULE_0__components_Chart__["a" /* default */], BarChart: __WEBPACK_IMPORTED_MODULE_1__components_Bar__["a" /* default */]
  },
  data: function data() {
    return {
      chartData: {
        labels: ['Desktop', 'Mobile'],
        datasets: [{
          data: [212, 55],
          backgroundColor: ['rgb(75, 192, 192)', 'rgb(255, 205, 86)', 'rgb(255, 99, 132)', 'rgb(255, 159, 64)']
        }]
      },
      chartData2: {
        labels: ['Mon', 'Tue', 'Wed'],
        datasets: [{
          label: 'Visitor',
          data: [35, 25, 35],
          backgroundColor: ['rgb(255, 99, 132)', 'rgb(255, 99, 132)', 'rgb(255, 99, 132)']
        }]
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      }
    };
  }
});

/***/ }),

/***/ "1TRU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Headline_vue__ = __webpack_require__("e1SM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0527b7c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Headline_vue__ = __webpack_require__("E8P5");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Headline_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0527b7c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Headline_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1Wcb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            List User Level\n                        ")]),_vm._v(" "),_c('ul',{staticClass:"header-dropdown m-r--5 m-t--10"},[_c('router-link',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect waves-button",attrs:{"to":"/main/admin/tambah","type":"button"}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#fff"}},[_vm._v("add_box")]),_vm._v(" "),_c('span',[_vm._v("Tambah")])])],1)]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-bordered table-striped table-hover js-basic-example dataTable"},[_vm._m(1),_vm._v(" "),_c('tbody',[(_vm.isLoading)?_c('tr',[_vm._m(2)]):_vm._e(),_vm._v(" "),(_vm.list == '')?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"7"}},[_vm._v("Data tidak ditemukan")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(item,index){return (!_vm.isLoading)?_c('tr',[_c('td',[_vm._v(_vm._s(++index + ((_vm.currentPage-1)*_vm.perPage)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.registrasi.username))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.namaLengkap))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.email))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.narasumber.nama)+" ("+_vm._s(item.narasumber.singkatan)+")")]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn bg-green waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.push('/main/admin/edit/' + item.id_user)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("create")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmDelete(item.id_user)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")])])])]):_vm._e()})],2)]),_vm._v(" "),_c('pagination',{attrs:{"total-rows":_vm.result.totalElements,"per-page":_vm.result.size},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-header"},[_c('h2',[_vm._v("User Level")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("No.")]),_vm._v(" "),_c('th',[_vm._v("Username")]),_vm._v(" "),_c('th',[_vm._v("Nama Lengkap")]),_vm._v(" "),_c('th',[_vm._v("Email")]),_vm._v(" "),_c('th',[_vm._v("Narasumber")]),_vm._v(" "),_c('th',[_vm._v("Aksi")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center",attrs:{"colspan":"7"}},[_c('i',{staticClass:"fa fa-spin fa-spinner"}),_vm._v(" Loading data...")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2BDT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2HTw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            List Narasumber\n                        ")]),_vm._v(" "),_c('ul',{staticClass:"header-dropdown m-r--5 m-t--10"},[_c('router-link',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect waves-button",attrs:{"to":"/main/narasumber/tambah","type":"button"}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#fff"}},[_vm._v("add_box")]),_vm._v(" "),_c('span',[_vm._v("Tambah")])])],1)]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-bordered table-striped table-hover js-basic-example dataTable"},[_vm._m(1),_vm._v(" "),_c('tbody',[(_vm.isLoading)?_c('tr',[_vm._m(2)]):_vm._e(),_vm._v(" "),(_vm.list == '')?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"4"}},[_vm._v("Data tidak ditemukan")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(item,index){return (!_vm.isLoading)?_c('tr',[_c('td',[_vm._v(_vm._s(++index + ((_vm.currentPage-1)*_vm.perPage)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.nama))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.singkatan))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn bg-green waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.push('/main/narasumber/edit/' + item.idNarasumber)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("create")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmDelete(item.idNarasumber)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")])])])]):_vm._e()})],2)]),_vm._v(" "),_c('pagination',{attrs:{"total-rows":_vm.result.totalElements,"per-page":_vm.result.size},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-header"},[_c('h2',[_vm._v("NARASUMBER")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("No.")]),_vm._v(" "),_c('th',[_vm._v("Nama")]),_vm._v(" "),_c('th',[_vm._v("Singkatan")]),_vm._v(" "),_c('th',[_vm._v("Aksi")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center",attrs:{"colspan":"4"}},[_c('i',{staticClass:"fa fa-spin fa-spinner"}),_vm._v(" Loading data...")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2obV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormKegiatan_vue__ = __webpack_require__("Yvti");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b6096a34_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormKegiatan_vue__ = __webpack_require__("gZlT");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormKegiatan_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b6096a34_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormKegiatan_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3IVZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            "+_vm._s(_vm.id_whistleblower != null ? 'Edit' : 'Tambah')+" WhistleBlower\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_c('div',{staticClass:"row clearfix"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"subjek","type":"text"},model:{value:(_vm.whistleblower.subjek),callback:function ($$v) {_vm.$set(_vm.whistleblower, "subjek", $$v)},expression:"whistleblower.subjek"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"email","type":"email"},model:{value:(_vm.whistleblower.email),callback:function ($$v) {_vm.$set(_vm.whistleblower, "email", $$v)},expression:"whistleblower.email"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[(_vm.id_whistleblower != null)?_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-warning waves-effect waves-button",attrs:{"type":"button"},on:{"click":_vm.update}},[_c('i',{staticClass:"material-icons"},[_vm._v("save")]),_vm._v(" Edit")]):_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect waves-button",attrs:{"type":"button"},on:{"click":_vm.save}},[_c('i',{staticClass:"material-icons"},[_vm._v("save")]),_vm._v(" Simpan")]),_vm._v(" "),_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-danger waves-effect waves-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")]),_vm._v(" Batal")])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-header"},[_c('h2',[_vm._v("WhistleBlower")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"subjek"}},[_vm._v("Subjek")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"subjek"}},[_vm._v("Email")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3OUF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"block-header"},[_c('h2',[_vm._v(_vm._s(_vm.nama))])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            "+_vm._s(_vm.id != null ? 'Edit' : 'Tambah')+" "+_vm._s(_vm.nama)+"\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit.apply(null, arguments)}}},[_c('div',{staticClass:"row clearfix"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"title","type":"text"},model:{value:(_vm.content.title),callback:function ($$v) {_vm.$set(_vm.content, "title", $$v)},expression:"content.title"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('Ckeditor',{attrs:{"id":"deskripsi","config":_vm.config},model:{value:(_vm.content.content),callback:function ($$v) {_vm.$set(_vm.content, "content", $$v)},expression:"content.content"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[(_vm.id != null)?_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-warning waves-effect waves-button",attrs:{"type":"button","disabled":_vm.isLoading},on:{"click":_vm.update}},[(_vm.isLoading)?_c('i',{staticClass:"fa fa-spin fa-spinner"}):_vm._e(),(!_vm.isLoading)?_c('i',{staticClass:"material-icons"},[_vm._v("save")]):_vm._e(),_vm._v(" Edit")]):_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect waves-button",attrs:{"type":"button","disabled":_vm.isLoading},on:{"click":_vm.save}},[(_vm.isLoading)?_c('i',{staticClass:"fa fa-spin fa-spinner"}):_vm._e(),(!_vm.isLoading)?_c('i',{staticClass:"material-icons"},[_vm._v("save")]):_vm._e(),_vm._v(" Simpan")]),_vm._v(" "),_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")]),_vm._v(" Batal")])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"title"}},[_vm._v("Title")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"deskripsi"}},[_vm._v("Deskripsi")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3PKr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_ckeditor2__ = __webpack_require__("42+j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FormLine_vue__ = __webpack_require__("w3AW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_api__ = __webpack_require__("+Btm");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_1__components_FormLine_vue__["a" /* default */], Ckeditor: __WEBPACK_IMPORTED_MODULE_0_vue_ckeditor2__["a" /* default */] },
  name: 'FormFaq',
  data: function data() {
    return {
      config: {
        toolbar: [{ name: 'stuff', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] }, { name: 'morestuff', items: ['NumberedList', 'BulletedList'] }, { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Superscript', 'Subscript'] }, { name: 'colors', items: ['TextColor'] }, { name: 'paragraph2', items: ['JustifyLeft', 'JustiftyCenter', 'JustifyRight', 'Outdent', 'Indent'] }, '/', { name: 'document', items: ['Source'] }],
        height: 300
      },
      data: {
        category: ''
      },
      gambar: '',
      id: '',
      isLoading: false
    };
  },
  methods: {
    save: function save() {
      var _this = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].post('/createCategoryFaq', this.data).then(function (result) {
        if (result.data.code === 200) {
          _this.$router.replace('/main/faq/Categoryfaq');
          _this.$toastr.s('Tambah data berhasil');
        } else {
          var msg = 'Tambah data gagal';
          if (result.data.message !== '') msg = result.data.message;
          _this.$toastr.e(msg);
        }
        _this.isLoading = false;
      }).catch(function (e) {
        var msg = 'Terjadi kesalahan pada server, mohon ulangi';
        if (e.response.data.message) msg = e.response.data.message;
        _this.$toastr.e(msg);
        _this.isLoading = false;
      });
    },
    update: function update() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].post('/updateCategoryFaqByid/' + this.id, this.data).then(function (result) {
        if (result.data.code === 200) {
          _this2.$router.replace('/main/faq/Categoryfaq');
          _this2.$toastr.s('Ubah data berhasil');
        }
      }).catch(function (ex) {
        _this2.$toastr.e('Terjadi kesalahan pada server, mohon ulangi');
      });
    },
    getDetail: function getDetail() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].get('/getFaqByid/' + this.id).then(function (result) {
        _this3.data = result.data.object;
      }).catch(function (ex) {
        _this3.$toastr.e('Terjadi kesalahan pada server, mohon ulangi');
      });
    },
    handleFile: function handleFile(file) {
      this.file = file.target.files[0];
    }
  },
  mounted: function mounted() {
    this.id = this.$route.params.id;
    if (this.id != null) {
      console.log('ID FAQ Category:', this.id);
      this.getDetail();
    }
  }
});

/***/ }),

/***/ "3f40":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3qs0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v(_vm._s(_vm.id_galeri != null ? 'Edit' : 'Tambah')+" Video")])]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_c('div',{staticClass:"row clearfix"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"file","type":"text"},model:{value:(_vm.data.file),callback:function ($$v) {_vm.$set(_vm.data, "file", $$v)},expression:"data.file"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"file","id":"upload","accept":"video/*,image/*"},on:{"change":_vm.handleFileUpload}}),_vm._v(" "),(_vm.uploadProgress > 0)?_c('div',[_vm._v("Progress: "+_vm._s(_vm.uploadProgress)+"%")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"deskripsi","type":"text"},model:{value:(_vm.data.deskripsi),callback:function ($$v) {_vm.$set(_vm.data, "deskripsi", $$v)},expression:"data.deskripsi"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[(_vm.id_galeri != null)?_c('button',{staticClass:"btn btn-warning",attrs:{"disabled":_vm.isLoading,"type":"button"},on:{"click":_vm.update}},[(!_vm.isLoading)?_c('span',[_c('i',{staticClass:"material-icons"},[_vm._v("save")]),_vm._v(" Edit")]):_c('span',[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" Loading")])]):_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.isLoading,"type":"button"},on:{"click":_vm.save}},[(!_vm.isLoading)?_c('span',[_c('i',{staticClass:"material-icons"},[_vm._v("save")]),_vm._v(" Simpan")]):_c('span',[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" Loading")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")]),_vm._v(" Batal\n                  ")])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-header"},[_c('h2',[_vm._v("Galeri")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"file"}},[_vm._v("Link")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"upload"}},[_vm._v("Foto/Video")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"deskripsi"}},[_vm._v("Deskripsi")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "40sN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chart_vue__ = __webpack_require__("RePM");
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chart_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4GO5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FormLine_vue__ = __webpack_require__("w3AW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_api__ = __webpack_require__("+Btm");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_0__components_FormLine_vue__["a" /* default */] },
  name: 'Login',
  data: function data() {
    return {
      user: {
        username: '',
        password: '',
        rememberMe: false
      },
      isLoading: false
    };
  },
  beforeMount: function beforeMount() {
    var log = localStorage.getItem('_token');
    var akses = localStorage.getItem('akses');

    if (log && akses) this.$router.replace('/main/dashboard');
  },

  methods: {
    lupaPassword: function lupaPassword() {
      var _this = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].post('/lupa-password-admin', this.user).then(function (result) {
        _this.isLoading = false;
        _this.$swal('Perhatian', 'Lupa Password Berhasil.', 'success').then(function () {
          _this.$router.replace('/');
          location.reload();
          _this.isLoading = false;
        });
      }).catch(function (e) {
        _this.$swal('Perhatian', e.response.data.message, 'error');
        _this.isLoading = false;
      });
    }
  }
});

/***/ }),

/***/ "4GXZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"block-header"},[_c('h2',[_vm._v(_vm._s(_vm.nama))])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            "+_vm._s(_vm.id_officer != null ? 'Edit' : 'Tambah')+" "+_vm._s(_vm.nama)+"\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_c('div',{staticClass:"row clearfix"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('Ckeditor',{attrs:{"id":"deskripsi","config":_vm.config},model:{value:(_vm.officer.deskripsi),callback:function ($$v) {_vm.$set(_vm.officer, "deskripsi", $$v)},expression:"officer.deskripsi"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[(_vm.officer.foto != null)?_c('img',{attrs:{"src":_vm.officer.foto,"width":"150px","alt":"Foto"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"id":"foto","type":"file","name":"icon"},on:{"change":function($event){return _vm.handleFile($event)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[(_vm.id_officer != null)?_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-warning waves-effect waves-button",attrs:{"disabled":_vm.isLoading,"type":"button"},on:{"click":_vm.update}},[(!_vm.isLoading)?_c('span',[_c('i',{staticClass:"material-icons"},[_vm._v("save")]),_vm._v(" Edit")]):_c('span',[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" Loading")])]):_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect waves-button",attrs:{"disabled":_vm.isLoading,"type":"button"},on:{"click":_vm.save}},[(!_vm.isLoading)?_c('span',[_c('i',{staticClass:"material-icons"},[_vm._v("save")]),_vm._v(" Simpan")]):_c('span',[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" Loading")])]),_vm._v(" "),_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")]),_vm._v(" Batal")])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"deskripsi"}},[_vm._v("Deskripsi")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"foto"}},[_vm._v("Foto")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4Tob":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FormLine_vue__ = __webpack_require__("w3AW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_api__ = __webpack_require__("+Btm");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_0__components_FormLine_vue__["a" /* default */] },
  name: 'Notifikasi',
  data: function data() {
    return {
      send: {
        tipe: 13,
        message: ''
      },
      isLoading: false
    };
  },
  methods: {
    kirim: function kirim() {
      var _this = this;

      this.isLoading = true;
      var form = new FormData();
      form.append('message', this.send.message);
      form.append('tipe', this.send.tipe);
      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].post('/notif', form).then(function (result) {
        if (result.data.message_id) {
          _this.$toastr.s('Notifikasi berhasil dikirim');
          _this.send.message = '';
        } else {
          var msg = 'Notifikasi gagal dikirim, silahkan coba kembali';
          if (result.data.message !== '') msg = result.data.message;
          _this.$toastr.e(msg);
        }
        _this.isLoading = false;
      }).catch(function (e) {
        var msg = 'Terjadi kesalahan pada server, mohon ulangi';
        if (e.response.data.message) msg = e.response.data.message;
        _this.$toastr.e(msg);
        _this.isLoading = false;
      });
    }
  }
});

/***/ }),

/***/ "4qOc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "50bq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            List FAQ Category\n                        ")]),_vm._v(" "),_c('ul',{staticClass:"header-dropdown m-r--5 m-t--10"},[_c('router-link',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect waves-button",attrs:{"to":'/main/faq/TambahFaqCategory',"type":"button"}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#fff"}},[_vm._v("add_box")]),_vm._v(" "),_c('span',[_vm._v("Tambah")])])],1)]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"dataTables_wrapper form-inline dt-bootstrap",attrs:{"id":"DataTables_Table_0_wrapper"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_length",attrs:{"id":"DataTables_Table_0_length"}},[_c('label',[_vm._v("Show "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.perPage),expression:"perPage"}],staticClass:"form-control input-sm",attrs:{"name":"DataTables_Table_0_length","aria-controls":"DataTables_Table_0"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.perPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_c('option',{attrs:{"value":"100"}},[_vm._v("100")])]),_vm._v(" entries")])])]),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_filter",attrs:{"id":"DataTables_Table_0_filter"}},[_c('label',[_vm._v("Search:"),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control input-sm",attrs:{"type":"search","placeholder":"","aria-controls":"DataTables_Table_0"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])])])]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped table-hover js-basic-example dataTable"},[_vm._m(1),_vm._v(" "),_c('tbody',[(_vm.isLoading)?_c('tr',[_vm._m(2)]):_vm._e(),_vm._v(" "),(_vm.list == '')?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"5"}},[_vm._v("Data tidak ditemukan")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(item,index){return (!_vm.isLoading)?_c('tr',[_c('td',[_vm._v(_vm._s(++index + ((_vm.currentPage-1)*_vm.perPage)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.category))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn bg-green waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.push('/main/faq/editCategory/' + item.id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("create")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmDelete(item.id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")])])])]):_vm._e()})],2)])]),_vm._v(" "),_c('pagination',{attrs:{"total-rows":_vm.result.totalElements,"per-page":_vm.result.size},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-header"},[_c('h2',[_vm._v("FAQ Category")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("No.")]),_vm._v(" "),_c('th',[_vm._v("FaqCategory")]),_vm._v(" "),_c('th',[_vm._v("Aksi")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center",attrs:{"colspan":"5"}},[_c('i',{staticClass:"fa fa-spin fa-spinner"}),_vm._v(" Loading data...")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5Hvf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CetakApprove_vue__ = __webpack_require__("eiXj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b9d781f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CetakApprove_vue__ = __webpack_require__("7CBn");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CetakApprove_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b9d781f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CetakApprove_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5KM7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormGaleri_vue__ = __webpack_require__("+sAT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a705291_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormGaleri_vue__ = __webpack_require__("3qs0");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormGaleri_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a705291_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormGaleri_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5WHR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_ckeditor2__ = __webpack_require__("42+j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FormLine_vue__ = __webpack_require__("w3AW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_api__ = __webpack_require__("+Btm");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_1__components_FormLine_vue__["a" /* default */], Ckeditor: __WEBPACK_IMPORTED_MODULE_0_vue_ckeditor2__["a" /* default */] },
  name: 'HakdanKewajiban',
  data: function data() {
    return {
      config: {
        toolbar: [{ name: 'stuff', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] }, { name: 'morestuff', items: ['NumberedList', 'BulletedList'] }, { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Superscript', 'Subscript'] }, { name: 'colors', items: ['TextColor'] }, { name: 'paragraph2', items: ['JustifyLeft', 'JustiftyCenter', 'JustifyRight', 'Outdent', 'Indent'] }, '/', { name: 'document', items: ['Source'] }],
        height: 300
      },
      content: {
        title: '',
        content: ''
      },
      tanggal: '',
      id: '',
      nama: '',
      tipe: '',
      link: '',
      isLoading: false,
      init: false
    };
  },
  methods: {
    save: function save() {
      var _this = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].post('/createHakDanKewajiban', this.content).then(function (result) {
        if (result.data.code === 200) {
          _this.$toastr.s('Tambah data berhasil');
          _this.$router.replace('/main/HakdanWajiban/ListHakdanKewajiban');
          location.reload();
        } else {
          var msg = 'Tambah data gagal';
          if (result.data.message !== '') msg = result.data.message;
          _this.$toastr.e(msg);
        }
        _this.isLoading = false;
      }).catch(function (e) {
        var msg = 'Terjadi kesalahan pada server, mohon ulangi';
        if (e.response.data.message) msg = e.response.data.message;
        _this.$toastr.e(msg);
        _this.isLoading = false;
      });
    },
    update: function update() {
      var _this2 = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].post('/updateHakdanKewajiban/' + this.id, this.content).then(function (result) {
        if (result.data.code === 200) {
          _this2.$router.replace('/main/HakdanWajiban/' + _this2.link);
          _this2.$toastr.s('Ubah data berhasil');
        }
        _this2.isLoading = false;
      }).catch(function (e) {
        var msg = 'Terjadi kesalahan pada server, mohon ulangi';
        if (e.response.data.message) msg = e.response.data.message;
        _this2.$toastr.e(msg);
        _this2.isLoading = false;
      });
    },
    getDetail: function getDetail() {
      var _this3 = this;

      this.init = true;
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].get('/getHakDanKewajiban/' + this.id).then(function (result) {
        _this3.content = result.data.object;
        _this3.tanggal = _this3.$moment(_this3.content.tanggal, 'YYYY-MM-DD').format('DD-MM-YYYY');
        _this3.init = false;
      }).catch(function (ex) {
        _this3.$toastr.e('Terjadi kesalahan pada server, mohon ulangi');
        _this3.init = false;
      });
    },
    sendingEvent: function sendingEvent(file, xhr, formData) {
      console.log(this.id);
      formData.append('id', parseInt(this.id));
    },
    onSubmit: function onSubmit() {
      if (this.id != null) this.update();else this.save();
    },
    checkRoute: function checkRoute(route) {
      console.log(route.name);
      if (route.name === 'EditHakKewajiban') {
        this.link = 'ListHakdanKewajiban';
        this.nama = 'ListHakdanKewajiban';
      }
    },
    vremoved: function vremoved(file, xhr, error) {
      console.log(file);
      if (!this.init) this.delete(file.id);
    },
    delete: function _delete(id) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].delete('/deleteHakdanKewajiban/' + id).then(function (result) {
        _this4.$toastr.s('Foto berhasil dihapus');
        _this4.getData();
        _this4.$swal.close();
      }).catch(function (e) {
        _this4.getData();
        _this4.$swal.close();
      });
    }
  },
  mounted: function mounted() {
    this.checkRoute(this.$route);
    this.id = this.$route.params.id;
    if (this.id != null) {
      this.getDetail();
    }
  },

  watch: {
    '$route': function $route(to, from) {
      this.checkRoute(to);
      this.getData();
    },

    tanggal: function tanggal(val) {
      this.content.tanggal = this.$moment(val, 'DD-MM-YYYY').format('YYYY-MM-DD');
    }
  }
});

/***/ }),

/***/ "5fFZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_api__ = __webpack_require__("+Btm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FormLine_vue__ = __webpack_require__("w3AW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_3__components_FormLine_vue__["a" /* default */] },
  name: 'ListFaq',
  data: function data() {
    return {
      result: {},
      list: [],
      currentPage: 1,
      perPage: 10,
      search: '',
      modal: null,
      isLoading: true,
      link: '',
      tipe: '',
      nama: ''
    };
  },
  methods: {
    moveUp: function moveUp(index) {
      var a = this.list[index - 1];
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(this.list, index - 1, this.list[index - 2]);
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(this.list, index - 2, a);

      this.saveUrutan();
    },
    moveDown: function moveDown(index) {
      var a = this.list[index - 1];
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(this.list, index - 1, this.list[index]);
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(this.list, index, a);

      this.saveUrutan();
    },
    saveUrutan: function saveUrutan() {
      var _this = this;

      var data = [];
      for (var i = 0; i < this.list.length; i++) {
        data.push({
          'id': this.list[i].id_faq,
          'urutan': i,
          'tipe': this.tipe
        });
      }

      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].post('/faq/move', data).then(function (result) {
        _this.$toastr.s('Urutan berhasil diubah.');
      }).catch(function (ex) {
        _this.$toastr.e('Gagal mengubah urutan, terjadi kesalahan pada server.');
      });
    },
    getData: function getData() {
      var _this2 = this;

      var params = [];
      params.search = this.search;
      params.page = this.currentPage - 1;
      params.size = this.perPage;

      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].get('/faq?' + __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(params)).then(function (result) {
        _this2.result = result.data;
        _this2.list = result.data.content;
        _this2.isLoading = false;
      }).catch(function (ex) {
        _this2.isLoading = false;
      });
    },
    confirmDelete: function confirmDelete(id) {
      var _this3 = this;

      this.$swal({
        title: 'Konfirmasi',
        text: 'Anda yakin ingin menghapus data ini?',
        icon: 'warning',
        buttons: [true, {
          text: 'Ok',
          closeModal: false
        }],
        dangerMode: true
      }).then(function (result) {
        if (result) _this3.delete(id);
      });
    },
    delete: function _delete(id) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].delete('/faq/' + id).then(function (result) {
        if (result.data.code === 200) _this4.$toastr.s('Data berhasil dihapus.');else _this4.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this4.$swal.close();
        _this4.getData();
      }).catch(function (e) {
        _this4.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this4.$swal.close();
      });
    }
  },
  mounted: function mounted() {
    this.getData();
  },
  watch: {
    currentPage: function currentPage(e) {
      this.getData();
    },
    perPage: function perPage(e) {
      this.getData();
    },
    search: function search(e) {
      this.getData();
    }
  }
});

/***/ }),

/***/ "5nV0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FormLine_vue__ = __webpack_require__("w3AW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_api__ = __webpack_require__("+Btm");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_0__components_FormLine_vue__["a" /* default */] },
  name: 'FormNarasumber',
  data: function data() {
    return {
      data: {
        nama: '',
        singkatan: ''
      },
      id_narasumber: '',
      isLoading: false
    };
  },
  methods: {
    save: function save() {
      var _this = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].post('/narasumber', this.data).then(function (result) {
        if (result.data.code === 200) {
          _this.$router.replace('/main/narasumber');
          _this.$toastr.s('Tambah data berhasil');
        } else {
          var msg = 'Tambah data gagal';
          if (result.data.message !== '') msg = result.data.message;
          _this.$toastr.e(msg);
        }
        _this.isLoading = false;
      }).catch(function (e) {
        var msg = 'Terjadi kesalahan pada server, mohon ulangi';
        if (e.response.data.message) msg = e.response.data.message;
        _this.$toastr.e(msg);
        _this.isLoading = false;
      });
    },
    update: function update() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].post('/narasumber/' + this.id_narasumber, this.data).then(function (result) {
        if (result.data.code === 200) {
          _this2.$router.replace('/main/narasumber');
          _this2.$toastr.s('Ubah data berhasil');
        }
      }).catch(function (ex) {
        _this2.$toastr.e('Terjadi kesalahan pada server, mohon ulangi');
      });
    },
    getDetail: function getDetail() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].get('/narasumber/' + this.id_narasumber).then(function (result) {
        _this3.data = result.data;
      }).catch(function (ex) {
        _this3.$toastr.e('Terjadi kesalahan pada server, mohon ulangi');
      });
    },
    handleFile: function handleFile(file) {
      this.file = file.target.files[0];
    }
  },
  mounted: function mounted() {
    this.id_narasumber = this.$route.params.id;
    if (this.id_narasumber != null) {
      this.getDetail();
    }
  }
});

/***/ }),

/***/ "62fL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"block-header"},[_c('h2',[_vm._v(_vm._s(_vm.nama))])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            List "+_vm._s(_vm.nama)+"\n                        ")]),_vm._v(" "),_c('ul',{staticClass:"header-dropdown m-r--5 m-t--10"},[_c('router-link',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect waves-button",attrs:{"to":'/main/informasi/' + _vm.link + '/tambah',"type":"button"}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#fff"}},[_vm._v("add_box")]),_vm._v(" "),_c('span',[_vm._v("Tambah")])])],1)]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"dataTables_wrapper form-inline dt-bootstrap",attrs:{"id":"DataTables_Table_0_wrapper"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_length",attrs:{"id":"DataTables_Table_0_length"}},[_c('label',[_vm._v("Show "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.perPage),expression:"perPage"}],staticClass:"form-control input-sm",attrs:{"name":"DataTables_Table_0_length","aria-controls":"DataTables_Table_0"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.perPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_c('option',{attrs:{"value":"100"}},[_vm._v("100")])]),_vm._v(" entries")])])]),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_filter",attrs:{"id":"DataTables_Table_0_filter"}},[_c('label',[_vm._v("Search:"),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control input-sm",attrs:{"type":"search","placeholder":"","aria-controls":"DataTables_Table_0"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])])])]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped table-hover js-basic-example dataTable"},[_vm._m(0),_vm._v(" "),_c('tbody',[(_vm.isLoading)?_c('tr',[_vm._m(1)]):_vm._e(),_vm._v(" "),(_vm.list == '')?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"5"}},[_vm._v("Data tidak ditemukan")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(item,index){return (!_vm.isLoading)?_c('tr',[_c('td',[_vm._v(_vm._s(++index + ((_vm.currentPage-1)*_vm.perPage)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.judul))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.stripTags(item.content).slice(0, 50))+"...")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.createdAt ? _vm.$moment(item.createdAt, 'YYYY-MM-DD').format("Do MMMM YYYY") : '-'))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn bg-green waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.push('/main/informasi/' + _vm.link + '/edit/' + item.id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("create")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmDelete(item.id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")])])])]):_vm._e()})],2)])]),_vm._v(" "),_c('pagination',{attrs:{"total-rows":_vm.result.totalElements,"per-page":_vm.result.size},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("No.")]),_vm._v(" "),_c('th',[_vm._v("Judul")]),_vm._v(" "),_c('th',[_vm._v("Content")]),_vm._v(" "),_c('th',[_vm._v("Tanggal")]),_vm._v(" "),_c('th',[_vm._v("Aksi")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center",attrs:{"colspan":"5"}},[_c('i',{staticClass:"fa fa-spin fa-spinner"}),_vm._v(" Loading data...")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6OBv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_ckeditor2__ = __webpack_require__("42+j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FormLine_vue__ = __webpack_require__("w3AW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_api__ = __webpack_require__("+Btm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone__ = __webpack_require__("KvPw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css__ = __webpack_require__("hCol");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */







/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_1__components_FormLine_vue__["a" /* default */], Ckeditor: __WEBPACK_IMPORTED_MODULE_0_vue_ckeditor2__["a" /* default */], vueDropzone: __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone___default.a },
  name: 'KritikDanSaran',
  data: function data() {
    return {
      categories: [],
      data: {
        jawaban: '',
        nip: '',
        jenisPengajuan: ''
      },
      tanggal: '',
      file: '',
      id: '',
      nama: '',
      tipe: '',
      link: '',
      isLoading: false,
      init: false
    };
  },
  methods: {
    update: function update() {
      var _this = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].post('/sendJawabanPertanyaanKritikdanSaran/' + this.id, this.data).then(function (result) {
        if (result.data.code === 200) {
          _this.$router.replace('/main/Layanan/' + _this.link);
          _this.$toastr.s('Ubah data berhasil');
        }
        _this.isLoading = false;
      }).catch(function (e) {
        var msg = 'Terjadi kesalahan pada server, mohon ulangi';
        if (e.response.data.message) msg = e.response.data.message;
        _this.$toastr.e(msg);
        _this.isLoading = false;
      });
    },
    getDetail: function getDetail() {
      var _this2 = this;

      this.init = true;
      console.log("ini file get data edit", this.filepertanyaanKritikdanSaranId);
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].get('/getPertanyaanKritikdanSaranById/' + this.id).then(function (result) {
        _this2.data = result.data.object;
        _this2.init = false;
      }).catch(function (ex) {
        console.error("Error getDetail:", ex);
        _this2.$toastr.e('Terjadi kesalahan pada server, mohon ulangi');
        _this2.init = false;
      });
    },
    onSubmit: function onSubmit() {
      if (this.id != null) this.update();else this.save();
    },
    checkRoute: function checkRoute(route) {
      console.log(route.name);
      if (route.name === 'TambahKritikDanSaran' || route.name === 'EditKritikDanSaran') {
        this.link = 'KritikDanSaran';
        this.nama = 'Kritik dan Saran';
      }
    },
    delete: function _delete(id) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].delete('//' + id).then(function (result) {
        console.log(result.data.code);
        if (result.data.code === 200) {
          _this3.$toastr.s('Foto berhasil dihapus');
          _this3.$swal.close();
        } else {
          _this3.$toastr.e('Gagal menghapus foto');
          _this3.$swal.close();
        }
      }).catch(function (e) {
        _this3.$swal.close();
      });
    }
  },
  mounted: function mounted() {
    this.checkRoute(this.$route);
    this.id = this.$route.params.id;
    if (this.id != null) {
      this.getDetail();
    }
  },

  watch: {
    $route: function $route(to, from) {
      this.checkRoute(to);
    }
  }
});

/***/ }),

/***/ "6Z9i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListMajalah_vue__ = __webpack_require__("QVsv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55de4ab7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListMajalah_vue__ = __webpack_require__("AWJW");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListMajalah_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55de4ab7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListMajalah_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6pp+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6vGM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"block-header"},[_c('h2',[_vm._v(_vm._s(_vm.nama))])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            List "+_vm._s(_vm.nama)+"\n                        ")]),_vm._v(" "),_c('ul',{staticClass:"header-dropdown m-r--5 m-t--10"},[_c('router-link',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect waves-button",attrs:{"to":'/main/pengumuman/' + _vm.link + '/tambah',"type":"button"}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#fff"}},[_vm._v("add_box")]),_vm._v(" "),_c('span',[_vm._v("Tambah")])])],1)]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"dataTables_wrapper form-inline dt-bootstrap",attrs:{"id":"DataTables_Table_0_wrapper"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_length",attrs:{"id":"DataTables_Table_0_length"}},[_c('label',[_vm._v("Show "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.perPage),expression:"perPage"}],staticClass:"form-control input-sm",attrs:{"name":"DataTables_Table_0_length","aria-controls":"DataTables_Table_0"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.perPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_c('option',{attrs:{"value":"100"}},[_vm._v("100")])]),_vm._v(" entries")])])]),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_filter",attrs:{"id":"DataTables_Table_0_filter"}},[_c('label',[_vm._v("Search:"),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control input-sm",attrs:{"type":"search","placeholder":"","aria-controls":"DataTables_Table_0"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])])])]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped table-hover js-basic-example dataTable"},[_vm._m(0),_vm._v(" "),_c('tbody',[(_vm.isLoading)?_c('tr',[_vm._m(1)]):_vm._e(),_vm._v(" "),(_vm.list == '')?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"5"}},[_vm._v("Data tidak ditemukan")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(item,index){return (!_vm.isLoading)?_c('tr',[_c('td',[_vm._v(_vm._s(++index + ((_vm.currentPage-1)*_vm.perPage)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.judul))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getKategoriText(item.kategori)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.tanggalMulai ? _vm.$moment(item.tanggalMulai, 'YYYY-MM-DD').format("Do MMMM YYYY") : '-'))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.tanggalAkhir ? _vm.$moment(item.tanggalAkhir, 'YYYY-MM-DD').format("Do MMMM YYYY") : '-'))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn bg-green waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.push('/main/pengumuman/pengumuman/edit/' + item.id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("create")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmDelete(item.id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")])])])]):_vm._e()})],2)])]),_vm._v(" "),_c('pagination',{attrs:{"total-rows":_vm.result.totalElements,"per-page":_vm.result.size},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("No.")]),_vm._v(" "),_c('th',[_vm._v("Judul")]),_vm._v(" "),_c('th',[_vm._v("Jenis Pengumuman")]),_vm._v(" "),_c('th',[_vm._v("Tanggal Berlaku")]),_vm._v(" "),_c('th',[_vm._v("Tanggal Berakhir")]),_vm._v(" "),_c('th',[_vm._v("Aksi")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center",attrs:{"colspan":"5"}},[_c('i',{staticClass:"fa fa-spin fa-spinner"}),_vm._v(" Loading data...")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7CBn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"block-header"},[_c('h2',[_vm._v(_vm._s(_vm.nama))])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            List "+_vm._s(_vm.nama)+"\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"dataTables_wrapper form-inline dt-bootstrap",attrs:{"id":"DataTables_Table_0_wrapper"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_length",attrs:{"id":"DataTables_Table_0_length"}},[_c('label',[_vm._v("Show "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.perPage),expression:"perPage"}],staticClass:"form-control input-sm",attrs:{"name":"DataTables_Table_0_length","aria-controls":"DataTables_Table_0"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.perPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_c('option',{attrs:{"value":"100"}},[_vm._v("100")])]),_vm._v(" entries")])])]),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_filter",attrs:{"id":"DataTables_Table_0_filter"}},[_c('label',[_vm._v("Search:"),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control input-sm",attrs:{"type":"search","placeholder":"","aria-controls":"DataTables_Table_0"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])])])]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped table-hover js-basic-example dataTable"},[_vm._m(0),_vm._v(" "),_c('tbody',[(_vm.isLoading)?_c('tr',[_vm._m(1)]):_vm._e(),_vm._v(" "),(_vm.list == '')?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"5"}},[_vm._v("Data tidak ditemukan")])]):_vm._e(),_vm._v(" "),(!_vm.isLoading)?_vm._l((_vm.list),function(item,index){return _c('tr',{key:item.id},[_c('td',[_vm._v(_vm._s(++index + ((_vm.currentPage-1)*_vm.perPage)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.nip))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.nama))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.createdAt ? _vm.$moment(item.createdAt).format("Do MMMM YYYY, HH:mm:ss") : '-'))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.stripTags(item.deskripsi)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.emailOrWAinReq))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.emailOrWAinTable))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn bg-green waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.approveRequest(item.id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("check")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.rejectRequest(item.id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")])])])])}):_vm._e()],2)])]),_vm._v(" "),_c('pagination',{attrs:{"total-rows":_vm.result.totalElements,"per-page":_vm.result.size},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("No.")]),_vm._v(" "),_c('th',[_vm._v("Nip")]),_vm._v(" "),_c('th',[_vm._v("nama")]),_vm._v(" "),_c('th',[_vm._v("Tanggal")]),_vm._v(" "),_c('th',[_vm._v("deskripsi")]),_vm._v(" "),_c('th',[_vm._v("email/wa request")]),_vm._v(" "),_c('th',[_vm._v("email/wa system")]),_vm._v(" "),_c('th',[_vm._v("Aksi")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center",attrs:{"colspan":"5"}},[_c('i',{staticClass:"fa fa-spin fa-spinner"}),_vm._v(" Loading data...")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7JO+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_ckeditor2__ = __webpack_require__("42+j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__ = __webpack_require__("w3AW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_api__ = __webpack_require__("+Btm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone__ = __webpack_require__("KvPw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_dropzone_dist_vue2Dropzone_css__ = __webpack_require__("hCol");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_dropzone_dist_vue2Dropzone_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_dropzone_dist_vue2Dropzone_css__);


var _watch;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */







/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__["a" /* default */], Ckeditor: __WEBPACK_IMPORTED_MODULE_1_vue_ckeditor2__["a" /* default */], vueDropzone: __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone___default.a },
  name: 'PintasanInfo',
  data: function data() {
    var _ref;

    return _ref = {
      dropzoneOptionsBakground: {
        url: __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.baseURL + '/upload_image_dropzone?tipe=THUMBNAIL_IMAGE',
        thumbnailWidth: 150,
        addRemoveLinks: true,
        maxFiles: 1,
        maxFilesize: 2,
        dictRemoveFileConfirmation: 'Anda yakin ingin menghapus file ini?',
        headers: { Authorization: 'Bearer ' + localStorage.getItem('_token') }
      },
      dropzoneOptionsGif: {
        url: __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.baseURL + '/upload_image_dropzone?tipe=PENULIS_IMAGE',
        thumbnailWidth: 150,
        addRemoveLinks: true,
        maxFiles: 1,
        maxFilesize: 2,
        dictRemoveFileConfirmation: 'Anda yakin ingin menghapus file ini?',
        headers: { Authorization: 'Bearer ' + localStorage.getItem('_token') }
      },
      data: {
        icon: '',
        isauth: '',
        link: '',
        title: '',
        decription: '',
        gif: ''
      },
      gif: '',
      link: '',
      tanggal: '',
      file: '',
      nama: ''
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'link', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'isLoading', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'init', false), _ref;
  },
  methods: {
    save: function save() {
      var _this = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].post('/insert_artikel', this.data).then(function (result) {
        if (result.data.code === 200) {
          _this.$toastr.s('Tambah data berhasil');
          _this.$router.replace('/main/informasi/' + _this.link);
        } else {
          var msg = 'Tambah data gagal';
          if (result.data.message !== '') msg = result.data.message;
          _this.$toastr.e(msg);
        }
        _this.isLoading = false;
      }).catch(function (e) {
        var msg = 'Terjadi kesalahan pada server, mohon ulangi';
        if (e.response.data.message) msg = e.response.data.message;
        _this.$toastr.e(msg);
        _this.isLoading = false;
      });
    },
    update: function update() {
      var _this2 = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].post('/update_artikel/' + this.id_pintasan, this.data).then(function (result) {
        if (result.data.code === 200) {
          _this2.$router.replace('/main/informasi/' + _this2.link);
          _this2.$toastr.s('Ubah data berhasil');
        }
        _this2.isLoading = false;
      }).catch(function (e) {
        var msg = 'Terjadi kesalahan pada server, mohon ulangi';
        if (e.response.data.message) msg = e.response.data.message;
        _this2.$toastr.e(msg);
        _this2.isLoading = false;
      });
    },
    getCategories: function getCategories() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].get('/getAllCategories').then(function (res) {
        _this3.categories = res.data.object;
      }).catch(function (err) {
        _this3.$toastr.e('Gagal mengambil data kategori');
        console.error(err);
      });
    },
    onUploadSuccess: function onUploadSuccess(file, response) {
      console.log("iniresponse dari dropzone", response);
      var idFile = response && response.object ? response.object.id : null;
      console.log("ini idfile", idFile);
      if (idFile) {
        this.data.fileArtikelId.push(idFile);
      }
      console.log("ini fileArtikel", this.data.fileArtikelId);
    },
    getDetail: function getDetail() {
      var _this4 = this;

      this.init = true;
      console.log("ini file get data edit", this.fileArtikelId);
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].get('/get_artikel/' + this.id_pintasan).then(function (result) {
        _this4.data = result.data.object;
        if (!_this4.data.fileArtikelId) {
          _this4.data.fileArtikelId = [];
        }
        _this4.data.kategori = result.data.object.category;
        for (var i = 0; i < _this4.data.files.length; i++) {
          var fileItem = _this4.data.files[i];
          if (fileItem.fileType === 'THUMBNAIL_IMAGE') {
            _this4.$refs.dropzoneThumnail.manuallyAddFile({ name: fileItem, size: fileItem.size, type: 'image/jpeg' }, fileItem.file);
          } else if (fileItem.fileType === 'PENULIS_IMAGE') {
            _this4.$refs.dropzonePenulis.manuallyAddFile({ name: fileItem, size: fileItem.size, type: 'image/jpeg' }, fileItem.file);
          }
        }
        _this4.init = false;
      }).catch(function (ex) {
        console.error("Error getDetail:", ex);
        _this4.$toastr.e('Terjadi kesalahan pada server, mohon ulangi');
        _this4.init = false;
      });
    },
    sendingEvent: function sendingEvent(file, xhr, formData) {
      formData.append('id_pintasan', parseInt(this.id_pintasan));

      // Cek dropzone mana yang sedang mengirim file
      if (this.$refs.dropzoneArtikel.dropzone.files.includes(file)) {
        formData.append('tipe', 'artikel');
      } else if (this.$refs.dropzonePenulis.dropzone.files.includes(file)) {
        formData.append('tipe', 'penulis');
      }
      console.log(this.id_pintasan);
      formData.append('id_pintasan', parseInt(this.id_pintasan));
    },
    onSubmit: function onSubmit() {
      if (this.id_pintasan != null) this.update();else this.save();
    },
    checkRoute: function checkRoute(route) {
      console.log(route.name);
      if (route.name === 'TambahArtikel' || route.name === 'EditArtikel') {
        this.link = 'artikel';
        this.nama = 'Artikel';
      }
    },
    vremoved: function vremoved(file, xhr, error) {
      console.log("ini filenya", file);
      if (!this.init) this.delete(file.name.id);
    },
    delete: function _delete(id) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].delete('/delete_file_artikel/' + id).then(function (result) {
        console.log(result.data.code);
        if (result.data.code === 200) {
          _this5.$toastr.s('Foto berhasil dihapus');
          _this5.$swal.close();
        } else {
          _this5.$toastr.e('Gagal menghapus foto');
          _this5.$swal.close();
        }
      }).catch(function (e) {
        _this5.$swal.close();
      });
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    this.checkRoute(this.$route);
    this.id_pintasan = this.$route.params.id;
    if (this.id_pintasan != null) {
      this.getDetail();
    }
    this.getCategories();
    // Tunggu CKEditor siap (delay kecil)
    this.$nextTick(function () {
      var editorInstance = _this6.$refs.ckeditor.instance;

      if (editorInstance) {
        editorInstance.on('fileUploadResponse', function (evt) {
          var data = evt.data;
          var xhr = data.fileLoader.xhr;

          console.log('File upload response:', xhr.responseText); // <-- Ini akan muncul sekarang
          var response = JSON.parse(xhr.responseText);

          console.log('Upload response:', response); // <-- Ini akan muncul sekarang
          _this6.data.fileArtikelId.push(response.id_file);
        });
      } else {
        console.warn('CKEditor instance belum tersedia');
      }
    });
  },

  watch: (_watch = {
    $route: function $route(to, from) {
      this.checkRoute(to);
    },
    'data.judul': function dataJudul(newVal) {
      console.log('Isi judul sekarang:', newVal);
    },
    'data.kategori': function dataKategori(newVal) {
      console.log('Kategori dipilih:', newVal);
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_watch, 'data.kategori', function dataKategori(newVal) {
    console.log(this.fileArtikelId, newVal);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_watch, 'data.content', function dataContent(newVal) {
    console.log('Konten artikel berubah');
  }), _watch)
});

/***/ }),

/***/ "7Otq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.2ab7047.png";

/***/ }),

/***/ "7XIS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Artikel_vue__ = __webpack_require__("VS04");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d1816dda_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Artikel_vue__ = __webpack_require__("LVEG");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Artikel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d1816dda_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Artikel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7YVk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_api__ = __webpack_require__("+Btm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__ = __webpack_require__("w3AW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__["a" /* default */] },
  name: 'ListVisiMisi',
  data: function data() {
    return {
      result: {},
      list: [],
      currentPage: 1,
      perPage: 10,
      search: '',
      modal: null,
      isLoading: true,
      link: '',
      nama: ''
    };
  },
  methods: {
    getData: function getData() {
      var _this = this;

      var params = [];
      params.search = this.search;
      params.page = this.currentPage - 1;
      params.size = this.perPage;

      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].get('/get_Artikel?' + __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(params)).then(function (result) {
        _this.result = result.data;
        _this.list = result.data.content;
        _this.isLoading = false;
      }).catch(function (ex) {
        _this.isLoading = false;
        _this.$toastr.e('Gagal terhubung dengan server.');
      });
    },
    confirmDelete: function confirmDelete(id) {
      var _this2 = this;

      this.$swal({
        title: 'Konfirmasi',
        text: 'Anda yakin ingin menghapus data ini?',
        icon: 'warning',
        buttons: [true, {
          text: 'Ok',
          closeModal: false
        }],
        dangerMode: true
      }).then(function (result) {
        if (result) _this2.delete(id);
      });
    },
    delete: function _delete(id) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].delete('/delete_artikel/' + id).then(function (result) {
        if (result.data.code === 200) _this3.$toastr.s('Data berhasil dihapus.');else _this3.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this3.$swal.close();
        _this3.getData();
      }).catch(function (e) {
        _this3.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this3.$swal.close();
      });
    },
    checkRoute: function checkRoute(route) {
      this.list = [];
      console.log(route.name);
      if (route.name === 'ListArtikel') {
        this.link = 'artikel';
        this.nama = 'Informasi Artikel';
      }
    }
  },
  mounted: function mounted() {
    this.checkRoute(this.$route);
    this.getData();
  },
  watch: {
    currentPage: function currentPage(e) {
      this.getData();
    },
    perPage: function perPage(e) {
      this.getData();
    },
    search: function search(e) {
      this.getData();
    },
    '$route': function $route(to, from) {
      this.checkRoute(to);
      this.getData();
    }
  }
});

/***/ }),

/***/ "7jcm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListAnakPerusahaan_vue__ = __webpack_require__("Qn4I");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0880fe06_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListAnakPerusahaan_vue__ = __webpack_require__("RXyA");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListAnakPerusahaan_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0880fe06_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListAnakPerusahaan_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7v+Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_ckeditor2__ = __webpack_require__("42+j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__ = __webpack_require__("w3AW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_api__ = __webpack_require__("+Btm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone__ = __webpack_require__("KvPw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_dropzone_dist_vue2Dropzone_css__ = __webpack_require__("hCol");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_dropzone_dist_vue2Dropzone_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_dropzone_dist_vue2Dropzone_css__);


var _watch;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */







/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__["a" /* default */], Ckeditor: __WEBPACK_IMPORTED_MODULE_1_vue_ckeditor2__["a" /* default */], vueDropzone: __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone___default.a },
  name: 'Pengumuman',
  data: function data() {
    return {
      date: {
        dateFormat: 'd-m-Y',
        allowInput: true
      },
      config: {
        height: 300,
        filebrowserUploadUrl: __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.baseURL + '/upload_image_pengumuman',
        filebrowserUploadMethod: 'xhr',
        extraPlugins: 'uploadimage,image2',
        removePlugins: 'image',
        toolbar: [{ name: 'document', items: ['Source', '-', 'Preview'] }, { name: 'clipboard', items: ['Undo', 'Redo'] }, { name: 'styles', items: ['Format', 'Font', 'FontSize'] }, {
          name: 'basicstyles',
          items: ['Bold', 'Italic', 'Underline', '-', 'RemoveFormat']
        }, {
          name: 'paragraph',
          items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent']
        }, {
          name: 'insert',
          items: ['Image', 'Table', 'HorizontalRule', 'SpecialChar']
        }]
      },
      data: {
        judul: '',
        isi: '',
        kategori: '',
        file: [],
        tanggalMulai: '',
        tanggalAkhir: ''
      },
      tanggalMulai: '',
      tanggalAkhir: '',
      file: '',
      id_Pengumuman: '',
      nama: '',
      tipe: '',
      link: '',
      isLoading: false,
      init: false
    };
  },
  methods: {
    save: function save() {
      var _this = this;

      console.log("ini datanya", this.data);
      if (this.data.kategori === null || this.data.kategori === '') {
        this.$toastr.e('Kategori tidak boleh kosong!');
        return;
      }
      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].post('/cretePengumuman', this.data).then(function (result) {
        if (result.data.code === 200) {
          _this.$toastr.s('Tambah data berhasil');
          _this.$router.replace('/main/Pengumuman/Pengumuman');
        } else {
          var msg = 'Tambah data gagal';
          if (result.data.message !== '') msg = result.data.message;
          _this.$toastr.e(msg);
        }
        _this.isLoading = false;
      }).catch(function (e) {
        var msg = 'Terjadi kesalahan pada server, mohon ulangi';
        if (e.response.data.message) msg = e.response.data.message;
        _this.$toastr.e(msg);
        _this.isLoading = false;
      });
    },
    update: function update() {
      var _this2 = this;

      this.isLoading = true;
      console.log(this.data);
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].post('/updatePengumuman/' + this.id_Pengumuman, this.data).then(function (result) {
        if (result.data.code === 200) {
          _this2.$router.replace('/main/pengumuman/pengumuman' + _this2.link);
          _this2.$toastr.s('Ubah data berhasil');
        }
        _this2.isLoading = false;
      }).catch(function (e) {
        var msg = 'Terjadi kesalahan pada server, mohon ulangi';
        if (e.response.data.message) msg = e.response.data.message;
        _this2.$toastr.e(msg);
        console.log(msg);
        _this2.isLoading = false;
      });
    },
    onUploadSuccess: function onUploadSuccess(file, response) {
      console.log("iniresponse dari dropzone", response);
      var idFile = response && response.object ? response.object.id : null;
      console.log("ini idfile", idFile);
      if (idFile) {
        this.data.filePengumuman.push(idFile);
      }
      console.log("ini pengumuman", this.data.filePengumuman);
    },
    getDetail: function getDetail() {
      var _this3 = this;

      this.init = true;
      console.log("ini file get data edit", this.filePengumuman);
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].get('/get_pengumuman/' + this.id_Pengumuman).then(function (result) {
        console.log("ini hasil get data", result);
        _this3.data = result.data.object;
        _this3.data.file = (result.data.object.file || []).map(function (item) {
          return item.id_file;
        });
        console.log("inir resultnya", result.data.object.file);
        _this3.data.kategori = result.data.object.kategori;
        _this3.init = false;
        _this3.data.tanggalMulai = _this3.$moment(result.data.object.tanggalMulai, 'YYYY-MM-DD').format('DD-MM-YYYY');
        _this3.data.tanggalAkhir = _this3.$moment(result.data.object.tanggalAkhir, 'YYYY-MM-DD').format('DD-MM-YYYY');
      }).catch(function (ex) {
        console.error("Error getDetail:", ex);
        _this3.$toastr.e('Terjadi kesalahan pada server, mohon ulangi');
        _this3.init = false;
      });
    },
    sendingEvent: function sendingEvent(file, xhr, formData) {
      formData.append('id_Pengumuman', parseInt(this.id_Pengumuman));
      console.log(this.id_Pengumuman);
      formData.append('id_Pengumuman', parseInt(this.id_Pengumuman));
    },
    onSubmit: function onSubmit() {
      if (this.id_Pengumuman != null) this.update();else this.save();
    },
    checkRoute: function checkRoute(route) {
      console.log(route.name);
      if (route.name === 'TambahArtikel' || route.name === 'EditArtikel') {
        this.link = 'pengumuman';
        this.nama = 'Pengumuman';
      }
    },
    vremoved: function vremoved(file, xhr, error) {
      console.log("ini filenya", file);
      if (!this.init) this.delete(file.name.id);
    },
    delete: function _delete(id) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].delete('/delete_file_artikel/' + id).then(function (result) {
        console.log(result.data.code);
        if (result.data.code === 200) {
          _this4.$toastr.s('Foto berhasil dihapus');
          _this4.$swal.close();
        } else {
          _this4.$toastr.e('Gagal menghapus foto');
          _this4.$swal.close();
        }
      }).catch(function (e) {
        _this4.$swal.close();
      });
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    this.checkRoute(this.$route);
    this.id_Pengumuman = this.$route.params.id;
    if (this.id_Pengumuman != null) {
      this.getDetail();
    }
    // Tunggu CKEditor siap (delay kecil)
    this.$nextTick(function () {
      var editorInstance = _this5.$refs.ckeditor.instance;

      if (editorInstance) {
        editorInstance.on('fileUploadResponse', function (evt) {
          var data = evt.data;
          var xhr = data.fileLoader.xhr;

          console.log('File upload response:', xhr.responseText); // <-- Ini akan muncul sekarang
          var response = JSON.parse(xhr.responseText);

          console.log('Upload response:', response); // <-- Ini akan muncul sekarang
          _this5.data.file.push(response.id_file);
        });
      } else {
        console.warn('CKEditor instance belum tersedia');
      }
    });
  },

  watch: (_watch = {
    $route: function $route(to, from) {
      this.checkRoute(to);
    },
    'data.judul': function dataJudul(newVal) {
      console.log('Isi judul sekarang:', newVal);
    },
    'data.kategori': function dataKategori(newVal) {
      console.log('Kategori dipilih:', newVal);
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_watch, 'data.kategori', function dataKategori(newVal) {
    console.log(this.fileArtikelId, newVal);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_watch, 'data.content', function dataContent(newVal) {
    console.log('Konten artikel berubah');
  }), _watch)
});

/***/ }),

/***/ "88/t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"block-header"},[_c('h2',[_vm._v(_vm._s(_vm.nama))])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            "+_vm._s(_vm.id_informasi_download != null ? 'Edit' : 'Tambah')+" "+_vm._s(_vm.nama)+"\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit.apply(null, arguments)}}},[_c('div',{staticClass:"row clearfix"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"judul","type":"text"},model:{value:(_vm.content.judul),callback:function ($$v) {_vm.$set(_vm.content, "judul", $$v)},expression:"content.judul"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(1),_vm._v(" "),(_vm.content.file != null)?_c('div',{staticClass:"col-lg-2"},[_c('a',{staticClass:"btn btn-sm btn-info",attrs:{"target":"_blank","href":_vm.content.file}},[_c('i',{staticClass:"fa fa-paperclip"}),_vm._v(" File")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"id":"icon","type":"file","name":"icon"},on:{"change":function($event){return _vm.handleFile($event)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[(_vm.id_informasi_download != null)?_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-warning waves-effect waves-button",attrs:{"type":"button","disabled":_vm.isLoading},on:{"click":_vm.update}},[(_vm.isLoading)?_c('i',{staticClass:"fa fa-spin fa-spinner"}):_vm._e(),(!_vm.isLoading)?_c('i',{staticClass:"material-icons"},[_vm._v("save")]):_vm._e(),_vm._v(" Edit")]):_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect waves-button",attrs:{"type":"button","disabled":_vm.isLoading},on:{"click":_vm.save}},[(_vm.isLoading)?_c('i',{staticClass:"fa fa-spin fa-spinner"}):_vm._e(),(!_vm.isLoading)?_c('i',{staticClass:"material-icons"},[_vm._v("save")]):_vm._e(),_vm._v(" Simpan")]),_vm._v(" "),_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-danger waves-effect waves-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")]),_vm._v(" Batal")])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"judul"}},[_vm._v("Judul")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"icon"}},[_vm._v("File")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8NxD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',[_c('ul',{staticClass:"pagination"},[_c('li',{class:{ disabled: _vm.currentPage == 1 }},[_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.update(_vm.currentPage-1)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("chevron_left")])])]),_vm._v(" "),_c('li',{class:{ disabled: _vm.currentPage == 1 }},[_c('a',{staticClass:"waves-effect",on:{"click":function($event){return _vm.update(1)}}},[_vm._v("1")])]),_vm._v(" "),_vm._l((_vm.offset),function(items,index){return (index != 0 && _vm.currentPage < _vm.offset)?_c('li',{class:{ disabled: _vm.currentPage == items }},[_c('a',{staticClass:"waves-effect",on:{"click":function($event){return _vm.update(items)}}},[_vm._v(_vm._s(items))])]):_vm._e()}),_vm._v(" "),(_vm.maxPage > _vm.maxOffset && _vm.currentPage >= _vm.offset)?_c('li',{staticClass:"disabled"},[_c('a',[_vm._v("...")])]):_vm._e(),_vm._v(" "),(_vm.currentPage >= _vm.offset && _vm.currentPage <= _vm.maxPage - _vm.maxOffset + 1)?_c('li',[_c('a',{staticClass:"waves-effect",on:{"click":function($event){return _vm.update(_vm.currentPage-1)}}},[_vm._v(_vm._s(_vm.currentPage-1))])]):_vm._e(),_vm._v(" "),(_vm.currentPage >= _vm.offset && _vm.currentPage <= _vm.maxPage - _vm.maxOffset + 1)?_c('li',{staticClass:"disabled"},[_c('a',{staticClass:"waves-effect",on:{"click":function($event){return _vm.update(_vm.currentPage)}}},[_vm._v(_vm._s(_vm.currentPage))])]):_vm._e(),_vm._v(" "),(_vm.currentPage >= _vm.offset && _vm.currentPage <= _vm.maxPage - _vm.maxOffset + 1)?_c('li',[_c('a',{staticClass:"waves-effect",on:{"click":function($event){return _vm.update(_vm.currentPage+1)}}},[_vm._v(_vm._s(_vm.currentPage+1))])]):_vm._e(),_vm._v(" "),(_vm.maxPage > _vm.maxOffset && _vm.currentPage <= _vm.maxPage - _vm.maxOffset + 1)?_c('li',{staticClass:"disabled"},[_c('a',[_vm._v("...")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.offset),function(items,index){return (_vm.maxPage > _vm.maxOffset && index != _vm.maxOffset-1  && _vm.currentPage >= (_vm.maxPage - _vm.maxOffset+2))?_c('li',{class:{ disabled: _vm.currentPage == items+_vm.maxPage-_vm.maxOffset }},[_c('a',{staticClass:"waves-effect",on:{"click":function($event){return _vm.update(items+_vm.maxPage-_vm.maxOffset)}}},[_vm._v(_vm._s(items+_vm.maxPage-_vm.maxOffset))])]):_vm._e()}),_vm._v(" "),(_vm.maxPage > _vm.maxOffset)?_c('li',{class:{ disabled: _vm.currentPage == _vm.maxPage }},[_c('a',{staticClass:"waves-effect",on:{"click":function($event){return _vm.update(_vm.maxPage)}}},[_vm._v(_vm._s(_vm.maxPage))])]):_vm._e(),_vm._v(" "),_c('li',{class:{ disabled: _vm.currentPage == _vm.maxPage }},[_c('a',{staticClass:"waves-effect",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.update(_vm.currentPage+1)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("chevron_right")])])])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8Sv/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pengaduan_vue__ = __webpack_require__("fXLv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_458505b7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pengaduan_vue__ = __webpack_require__("kWW5");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pengaduan_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_458505b7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pengaduan_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8a7Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"page-loader-wrapper",class:{ 'hide': _vm.loaded === true }},[_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"overlay"}),_vm._v(" "),_c('Header'),_vm._v(" "),_c('Sidebar'),_vm._v(" "),_c('router-view',{staticClass:"animated fadeIn"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('div',{staticClass:"preloader"},[_c('div',{staticClass:"spinner-layer pl-red"},[_c('div',{staticClass:"circle-clipper left"},[_c('div',{staticClass:"circle"})]),_vm._v(" "),_c('div',{staticClass:"circle-clipper right"},[_c('div',{staticClass:"circle"})])])]),_vm._v(" "),_c('p',[_vm._v("Please wait...")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8bOl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListIdentitasPemotong_vue__ = __webpack_require__("BRJf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1db818bf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListIdentitasPemotong_vue__ = __webpack_require__("Q0Mv");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListIdentitasPemotong_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1db818bf_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListIdentitasPemotong_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8kuy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListAnggota_vue__ = __webpack_require__("gbDD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50148912_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListAnggota_vue__ = __webpack_require__("HTPo");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListAnggota_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50148912_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListAnggota_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8tHC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/user.e48ac6d.png";

/***/ }),

/***/ "8xNV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9OFn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"block-header"},[_c('h2',[_vm._v(_vm._s(_vm.nama))])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            List "+_vm._s(_vm.nama)+"\n                        ")]),_vm._v(" "),_c('ul',{staticClass:"header-dropdown m-r--5 m-t--10"},[_c('router-link',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect",attrs:{"to":'/main/profile/' + _vm.link + '/tambah',"type":"button"}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#fff"}},[_vm._v("add_box")]),_vm._v(" "),_c('span',[_vm._v("Tambah")])])],1)]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"dataTables_wrapper form-inline dt-bootstrap",attrs:{"id":"DataTables_Table_0_wrapper"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_length",attrs:{"id":"DataTables_Table_0_length"}},[_c('label',[_vm._v("Show "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.perPage),expression:"perPage"}],staticClass:"form-control input-sm",attrs:{"name":"DataTables_Table_0_length","aria-controls":"DataTables_Table_0"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.perPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_c('option',{attrs:{"value":"100"}},[_vm._v("100")])]),_vm._v(" entries")])])]),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_filter",attrs:{"id":"DataTables_Table_0_filter"}},[_c('label',[_vm._v("Search:"),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control input-sm",attrs:{"type":"search","placeholder":"","aria-controls":"DataTables_Table_0"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])])])]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped table-hover js-basic-example dataTable"},[_vm._m(0),_vm._v(" "),_c('tbody',[(_vm.isLoading)?_c('tr',[_vm._m(1)]):_vm._e(),_vm._v(" "),(_vm.list == '')?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"5"}},[_vm._v("Data tidak ditemukan")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(item,index){return (!_vm.isLoading)?_c('tr',[_c('td',[_vm._v(_vm._s(++index + ((_vm.currentPage-1)*_vm.perPage)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.judul))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.stripTags(item.deskripsi)))]),_vm._v(" "),_c('td',[(item.icon != null)?_c('img',{attrs:{"src":item.icon,"alt":"Icon","width":"98px"}}):_vm._e()]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn bg-green waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.push('/main/profile/' + _vm.link + '/edit/' + item.id_content)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("create")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmDelete(item.id_content)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")])])])]):_vm._e()})],2)])]),_vm._v(" "),_c('pagination',{attrs:{"total-rows":_vm.result.totalElements,"per-page":_vm.result.size},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("No.")]),_vm._v(" "),_c('th',[_vm._v("Judul")]),_vm._v(" "),_c('th',[_vm._v("Deskripsi")]),_vm._v(" "),_c('th',[_vm._v("Gambar")]),_vm._v(" "),_c('th',[_vm._v("Aksi")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center",attrs:{"colspan":"5"}},[_c('i',{staticClass:"fa fa-spin fa-spinner"}),_vm._v(" Loading data...")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9eLg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Upload_vue__ = __webpack_require__("D1z2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b881eae6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Upload_vue__ = __webpack_require__("kKPZ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Upload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b881eae6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Upload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9o4n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormMateriKomunikasi_vue__ = __webpack_require__("Uz7N");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f805b53a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormMateriKomunikasi_vue__ = __webpack_require__("s4+6");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormMateriKomunikasi_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f805b53a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormMateriKomunikasi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "A3ol":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_api__ = __webpack_require__("+Btm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__ = __webpack_require__("w3AW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__["a" /* default */] },
  name: 'ListLog',
  data: function data() {
    return {
      result: {},
      list: [],
      currentPage: 1,
      perPage: 10,
      search: '',
      modal: null,
      isLoading: true,
      link: '',
      tipe: '',
      nama: ''
    };
  },
  methods: {
    getData: function getData() {
      var _this = this;

      var params = [];
      params.search = this.search;
      params.page = this.currentPage - 1;
      params.size = this.perPage;

      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].get('/log?' + __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(params)).then(function (result) {
        _this.result = result.data;
        _this.list = result.data.content;
        _this.isLoading = false;
      }).catch(function (ex) {
        _this.isLoading = false;
      });
    },
    delete: function _delete(id) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].delete('/faq/' + id).then(function (result) {
        if (result.data.code === 200) _this2.$toastr.s('Data berhasil dihapus.');else _this2.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this2.$swal.close();
        _this2.getData();
      }).catch(function (e) {
        _this2.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this2.$swal.close();
      });
    }
  },
  mounted: function mounted() {
    this.getData();
  },
  watch: {
    currentPage: function currentPage(e) {
      this.getData();
    },
    perPage: function perPage(e) {
      this.getData();
    },
    search: function search(e) {
      this.getData();
    }
  }
});

/***/ }),

/***/ "AGFz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            "+_vm._s(_vm.id_master_survey != null ? 'Edit' : 'Tambah')+" Survey\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form-horizontal"},[_c('div',{staticClass:"row clearfix"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"pernyataan","type":"text"},model:{value:(_vm.data.pernyataan),callback:function ($$v) {_vm.$set(_vm.data, "pernyataan", $$v)},expression:"data.pernyataan"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"periode","type":"number"},model:{value:(_vm.data.periode),callback:function ($$v) {_vm.$set(_vm.data, "periode", $$v)},expression:"data.periode"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[(_vm.id_master_survey != null)?_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-warning waves-effect waves-button",attrs:{"disabled":_vm.isLoading,"type":"submit"},on:{"click":_vm.update}},[(!_vm.isLoading)?_c('span',[_c('i',{staticClass:"material-icons"},[_vm._v("save")]),_vm._v(" Edit")]):_c('span',[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" Loading")])]):_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect waves-button",attrs:{"disabled":_vm.isLoading,"type":"submit"},on:{"click":_vm.save}},[(!_vm.isLoading)?_c('span',[_c('i',{staticClass:"material-icons"},[_vm._v("save")]),_vm._v(" Simpan")]):_c('span',[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" Loading")])]),_vm._v(" "),_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")]),_vm._v(" Batal")])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-header"},[_c('h2',[_vm._v("Survey")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"pernyataan"}},[_vm._v("Pernyataan")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"periode"}},[_vm._v("Periode")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AS55":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_ckeditor2__ = __webpack_require__("42+j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FormLine_vue__ = __webpack_require__("w3AW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_api__ = __webpack_require__("+Btm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone__ = __webpack_require__("KvPw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css__ = __webpack_require__("hCol");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_1__components_FormLine_vue__["a" /* default */], Ckeditor: __WEBPACK_IMPORTED_MODULE_0_vue_ckeditor2__["a" /* default */], vueDropzone: __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone___default.a },
  name: 'ListNarasumber',
  data: function data() {
    return {
      dropzoneOptions: {
        url: __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.baseURL + '/upload_galeri',
        thumbnailWidth: 150,
        addRemoveLinks: true,
        maxFilesize: 200,
        dictRemoveFileConfirmation: 'Anda yakin ingin menghapus file ini?',
        headers: { 'Authorization': 'Bearer ' + localStorage.getItem('_token') },
        previewTemplate: this.template()
      },
      galeri: [],
      result: {},
      list: [],
      currentPage: 1,
      perPage: 10,
      search: '',
      isLoading: true
    };
  },
  methods: {
    template: function template() {
      return '<div class="dz-preview dz-file-preview">' + '<div class="dz-image" style="width: 200px;height: 200px">' + '<img data-dz-thumbnail />' + '</div>' + '<div class="dz-details">' + '<div class="dz-size"><span data-dz-size></span></div>' + '<div class="dz-filename"><span data-dz-name></span></div>' + '<div class="dz-extra">' + '<a class="dz-remove dz-add-desc" href="javascript:undefined;" data-dz-description">Add description</a>' + '</div>' + '</div> ' + '<div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>' + '<div class="dz-error-message"><span data-dz-errormessage></span></div>' + '<div class="dz-success-mark"><i class="fa fa-check"></i></div>' + '<div class="dz-error-mark"><i class="fa fa-close"></i></div>' + '</div> ' + '<div class="">' + '<select class="form-control" title="" name="image_type">' + '<options v-for="type in image_type" value="type.value">{{ type.title }}</options>' + '</select>' + '</div>';
    },
    addDescription: function addDescription(file) {
      console.log(file);
    },
    vsuccess: function vsuccess(file, response) {
      var id = response.object.id_galeri;
      var deskripsi = response.object.deskripsi;
      file.previewElement.querySelector('.dz-add-desc').setAttribute('data-dz-id', id);
      file.previewElement.querySelector('.dz-add-desc').setAttribute('data-dz-desc', deskripsi);
    },
    vfileAdded: function vfileAdded(file) {
      var _self = this;
      file.previewElement.querySelector('.dz-add-desc').setAttribute('data-dz-id', file.id);
      file.previewElement.querySelector('.dz-add-desc').setAttribute('data-dz-desc', file.deskripsi);
      file.previewElement.querySelector('.dz-add-desc').addEventListener('click', function () {
        var id = this.getAttribute('data-dz-id');
        var desc = this.getAttribute('data-dz-desc');
        if (desc === 'null') desc = '';

        _self.$swal('Edit description', {
          content: {
            element: 'input',
            attributes: {
              value: desc,
              placeholder: 'Masukkan deskripsi disini'
            }
          }
        }).then(function (result) {
          if (result) {
            var data = {
              deskripsi: result
            };
            __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
            __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].post('/galeri/' + id, data).then(function (result) {
              _self.$toastr.s('Deskripsi berhasil diubah');
              _self.getDetail();
            }).catch(function (ex) {
              _self.$toastr.e('Terjadi kesalahan pada server, mohon ulangi');
            });
          }
        });
      });
    },
    getData: function getData() {
      var _this = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].get('/galeri').then(function (result) {
        _this.list = result.data.content;
        _this.isLoading = false;
      }).catch(function (ex) {
        _this.$toastr.e('Terjadi kesalahan pada server, mohon ulangi');
        _this.isLoading = false;
      });
    },
    getDetail: function getDetail() {
      var _this2 = this;

      this.init = true;
      this.$refs.myVueDropzone.removeAllFiles();
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].get('/galeri/all?tipe=1').then(function (result) {
        _this2.galeri = result.data;
        for (var i = 0; i < _this2.galeri.length; i++) {
          _this2.$refs.myVueDropzone.manuallyAddFile({ name: _this2.galeri[i].deskripsi, id: _this2.galeri[i].id_galeri, deskripsi: _this2.galeri[i].deskripsi, size: _this2.galeri[i].size }, _this2.galeri[i].file);
        }
        _this2.init = false;
      }).catch(function (ex) {
        _this2.$toastr.e('Terjadi kesalahan pada server, mohon ulangi');
        _this2.init = false;
      });

      this.getData();
    },
    vremoved: function vremoved(file, xhr, error) {
      if (!this.init) this.delete(file.id);
    },
    confirmDelete: function confirmDelete(id) {
      var _this3 = this;

      this.$swal({
        title: 'Konfirmasi',
        text: 'Anda yakin ingin menghapus data ini?',
        icon: 'warning',
        buttons: [true, {
          text: 'Ok',
          closeModal: false
        }],
        dangerMode: true
      }).then(function (result) {
        if (result) {
          _this3.delete(id);
        }
      });
    },
    delete: function _delete(id) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].delete('/galeri/' + id).then(function (result) {
        _this4.$toastr.s('Galeri berhasil dihapus');
        _this4.getData();
        _this4.$swal.close();
      }).catch(function (e) {
        _this4.getData();
        _this4.$swal.close();
      });
    }
  },
  mounted: function mounted() {
    this.getDetail();
  },

  watch: {
    currentPage: function currentPage(e) {
      this.getData();
    },
    perPage: function perPage(e) {
      this.getData();
    },
    search: function search(e) {
      this.getData();
    }
  }
});

/***/ }),

/***/ "AWJW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"block-header"},[_c('h2',[_vm._v(_vm._s(_vm.nama))])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            List "+_vm._s(_vm.nama)+"\n                        ")]),_vm._v(" "),_c('ul',{staticClass:"header-dropdown m-r--5 m-t--10"},[_c('router-link',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect",attrs:{"to":'/main/unduh/' + _vm.link + '/tambah',"type":"button"}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#fff"}},[_vm._v("add_box")]),_vm._v(" "),_c('span',[_vm._v("Tambah")])])],1)]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"dataTables_wrapper form-inline dt-bootstrap",attrs:{"id":"DataTables_Table_0_wrapper"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_length",attrs:{"id":"DataTables_Table_0_length"}},[_c('label',[_vm._v("Show "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.perPage),expression:"perPage"}],staticClass:"form-control input-sm",attrs:{"name":"DataTables_Table_0_length","aria-controls":"DataTables_Table_0"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.perPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_c('option',{attrs:{"value":"100"}},[_vm._v("100")])]),_vm._v(" entries")])])]),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_filter",attrs:{"id":"DataTables_Table_0_filter"}},[_c('label',[_vm._v("Search:"),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control input-sm",attrs:{"type":"search","placeholder":"","aria-controls":"DataTables_Table_0"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])])])]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped table-hover js-basic-example dataTable"},[_vm._m(0),_vm._v(" "),_c('tbody',[(_vm.isLoading)?_c('tr',[_vm._m(1)]):_vm._e(),_vm._v(" "),(_vm.list == '')?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"7"}},[_vm._v("Data tidak ditemukan")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(item,index){return (!_vm.isLoading)?_c('tr',[_c('td',[_vm._v(_vm._s(++index + ((_vm.currentPage-1)*_vm.perPage)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.judul))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.edisiTriwulan))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.tahun))]),_vm._v(" "),_c('td',[(item.file != null)?_c('a',{staticClass:"btn btn-info",attrs:{"target":"_blank","href":item.file}},[_c('i',{staticClass:"fa fa-paperclip"}),_vm._v(" File")]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.stripTags(item.tags)))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn bg-green waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.push('/main/unduh/' + _vm.link + '/edit/' + item.id_majalah)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("create")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmDelete(item.id_majalah)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")])]),_vm._v(" "),(index != 1)?_c('button',{staticClass:"btn btn-primary waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.moveUp(index)}}},[_c('i',{staticClass:"fa fa-chevron-up"})]):_vm._e(),_vm._v(" "),(index !== (_vm.list.length))?_c('button',{staticClass:"btn btn-primary waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.moveDown(index)}}},[_c('i',{staticClass:"fa fa-chevron-down"})]):_vm._e()])]):_vm._e()})],2)])]),_vm._v(" "),_c('pagination',{attrs:{"total-rows":_vm.result.totalElements,"per-page":_vm.result.size},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("No.")]),_vm._v(" "),_c('th',[_vm._v("Judul")]),_vm._v(" "),_c('th',[_vm._v("Edisi Triwulan")]),_vm._v(" "),_c('th',[_vm._v("Tahun")]),_vm._v(" "),_c('th',[_vm._v("File")]),_vm._v(" "),_c('th',[_vm._v("Tags")]),_vm._v(" "),_c('th',[_vm._v("Aksi")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center",attrs:{"colspan":"7"}},[_c('i',{staticClass:"fa fa-spin fa-spinner"}),_vm._v(" Loading data...")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "B8VL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListUnduh_vue__ = __webpack_require__("Ro5n");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dacdddea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListUnduh_vue__ = __webpack_require__("gquy");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListUnduh_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dacdddea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListUnduh_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BRJf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_api__ = __webpack_require__("+Btm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__ = __webpack_require__("w3AW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__["a" /* default */] },
  name: 'ListFaq',
  data: function data() {
    return {
      result: {},
      list: [],
      currentPage: 1,
      perPage: 10,
      search: '',
      modal: null,
      isLoading: true,
      link: '',
      tipe: '',
      nama: ''
    };
  },
  methods: {
    getData: function getData() {
      var _this = this;

      var params = [];
      params.search = this.search;
      params.page = this.currentPage - 1;
      params.size = this.perPage;

      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].get('/identitas-pemotong?' + __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(params)).then(function (result) {
        _this.result = result.data;
        _this.list = result.data.content;
        _this.isLoading = false;
      }).catch(function (ex) {
        _this.isLoading = false;
      });
    },
    confirmDelete: function confirmDelete(id) {
      var _this2 = this;

      this.$swal({
        title: 'Konfirmasi',
        text: 'Anda yakin ingin menghapus data ini?',
        icon: 'warning',
        buttons: [true, {
          text: 'Ok',
          closeModal: false
        }],
        dangerMode: true
      }).then(function (result) {
        if (result) _this2.delete(id);
      });
    },
    delete: function _delete(id) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].delete('/identitas-pemotong/' + id).then(function (result) {
        if (result.data.code === 200) _this3.$toastr.s('Data berhasil dihapus.');else _this3.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this3.$swal.close();
        _this3.getData();
      }).catch(function (e) {
        _this3.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this3.$swal.close();
      });
    }
  },
  mounted: function mounted() {
    this.getData();
  },
  watch: {
    currentPage: function currentPage(e) {
      this.getData();
    },
    perPage: function perPage(e) {
      this.getData();
    },
    search: function search(e) {
      this.getData();
    }
  }
});

/***/ }),

/***/ "BeCg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HasilSurvey_vue__ = __webpack_require__("xy5q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91e1595c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HasilSurvey_vue__ = __webpack_require__("FC02");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HasilSurvey_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91e1595c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HasilSurvey_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BfF4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_api__ = __webpack_require__("+Btm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FormLine_vue__ = __webpack_require__("w3AW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_3__components_FormLine_vue__["a" /* default */] },
  name: 'ListSlider',
  data: function data() {
    return {
      result: {},
      list: [],
      currentPage: 1,
      perPage: 10,
      search: '',
      modal: null,
      isLoading: true,
      link: '',
      tipe: '',
      nama: ''
    };
  },
  methods: {
    moveUp: function moveUp(index) {
      var a = this.list[index - 1];
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(this.list, index - 1, this.list[index - 2]);
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(this.list, index - 2, a);

      this.saveUrutan();
    },
    moveDown: function moveDown(index) {
      var a = this.list[index - 1];
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(this.list, index - 1, this.list[index]);
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(this.list, index, a);

      this.saveUrutan();
    },
    saveUrutan: function saveUrutan() {
      var _this = this;

      var data = [];
      for (var i = 0; i < this.list.length; i++) {
        data.push({
          'id': this.list[i].id_slider,
          'urutan': i,
          'tipe': this.tipe
        });
      }

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].post('/slider/move', data).then(function (result) {
        _this.$toastr.s('Urutan berhasil diubah.');
      }).catch(function (ex) {
        _this.$toastr.e('Gagal mengubah urutan, terjadi kesalahan pada server.');
      });
    },
    getData: function getData() {
      var _this2 = this;

      var params = [];
      params.search = this.search;
      params.page = this.currentPage - 1;
      params.size = this.perPage;

      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].get('/slider?' + __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(params)).then(function (result) {
        _this2.result = result.data;
        _this2.list = result.data.content;
        _this2.isLoading = false;
      }).catch(function (ex) {
        _this2.isLoading = false;
      });
    },
    confirmDelete: function confirmDelete(id) {
      var _this3 = this;

      this.$swal({
        title: 'Konfirmasi',
        text: 'Anda yakin ingin menghapus data ini?',
        icon: 'warning',
        buttons: [true, {
          text: 'Ok',
          closeModal: false
        }],
        dangerMode: true
      }).then(function (result) {
        if (result) _this3.delete(id);
      });
    },
    delete: function _delete(id) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].delete('/slider/' + id).then(function (result) {
        if (result.data.code === 200) _this4.$toastr.s('Data berhasil dihapus.');else _this4.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this4.$swal.close();
        _this4.getData();
      }).catch(function (e) {
        _this4.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this4.$swal.close();
      });
    }
  },
  mounted: function mounted() {
    this.getData();
  },
  watch: {
    currentPage: function currentPage(e) {
      this.getData();
    },
    perPage: function perPage(e) {
      this.getData();
    },
    search: function search(e) {
      this.getData();
    }
  }
});

/***/ }),

/***/ "Bif8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-line",class:{ focused: _vm.isFocus }},[(((_vm.$attrs).type)==='checkbox')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.isi),expression:"isi"}],staticClass:"form-control",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.isi)?_vm._i(_vm.isi,null)>-1:(_vm.isi)},on:{"focus":_vm.focus,"blur":_vm.blur,"change":function($event){var $$a=_vm.isi,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isi=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isi=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isi=$$c}}}},'input',_vm.$attrs,false)):(((_vm.$attrs).type)==='radio')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.isi),expression:"isi"}],staticClass:"form-control",attrs:{"type":"radio"},domProps:{"checked":_vm._q(_vm.isi,null)},on:{"focus":_vm.focus,"blur":_vm.blur,"change":function($event){_vm.isi=null}}},'input',_vm.$attrs,false)):_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.isi),expression:"isi"}],staticClass:"form-control",attrs:{"type":(_vm.$attrs).type},domProps:{"value":(_vm.isi)},on:{"focus":_vm.focus,"blur":_vm.blur,"input":function($event){if($event.target.composing){ return; }_vm.isi=$event.target.value}}},'input',_vm.$attrs,false))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "C7es":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LupaPassword_vue__ = __webpack_require__("4GO5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58762d17_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LupaPassword_vue__ = __webpack_require__("EfGY");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LupaPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58762d17_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LupaPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Co0p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_api__ = __webpack_require__("+Btm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FormLine_vue__ = __webpack_require__("w3AW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_3__components_FormLine_vue__["a" /* default */] },
  name: 'ListVisiMisi',
  data: function data() {
    return {
      result: {},
      list: [],
      currentPage: 1,
      perPage: 10,
      search: '',
      modal: null,
      isLoading: true,
      link: '',
      tipe: '',
      nama: ''
    };
  },
  methods: {
    moveUp: function moveUp(index) {
      var a = this.list[index - 1];
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(this.list, index - 1, this.list[index - 2]);
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(this.list, index - 2, a);

      this.saveUrutan();
    },
    moveDown: function moveDown(index) {
      var a = this.list[index - 1];
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(this.list, index - 1, this.list[index]);
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(this.list, index, a);

      this.saveUrutan();
    },
    saveUrutan: function saveUrutan() {
      var _this = this;

      var data = [];
      for (var i = 0; i < this.list.length; i++) {
        data.push({
          'id': this.list[i].id,
          'urutan': i,
          'tipe': this.tipe
        });
      }

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].post('/materikomunikasi/move', data).then(function (result) {
        _this.$toastr.s('Urutan berhasil diubah.');
      }).catch(function (ex) {
        _this.$toastr.e('Gagal mengubah urutan, terjadi kesalahan pada server.');
      });
    },
    getData: function getData() {
      var _this2 = this;

      var params = [];
      params.search = this.search;
      params.page = this.currentPage - 1;
      params.size = this.perPage;

      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].get('/' + this.link + '?' + __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(params)).then(function (result) {
        _this2.result = result.data;
        _this2.list = result.data.content;
        _this2.isLoading = false;
      }).catch(function (ex) {
        _this2.isLoading = false;
      });
    },
    confirmDelete: function confirmDelete(id) {
      var _this3 = this;

      this.$swal({
        title: 'Konfirmasi',
        text: 'Anda yakin ingin menghapus data ini?',
        icon: 'warning',
        buttons: [true, {
          text: 'Ok',
          closeModal: false
        }],
        dangerMode: true
      }).then(function (result) {
        if (result) _this3.delete(id);
      });
    },
    delete: function _delete(id) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].delete('/' + this.link + '/' + id).then(function (result) {
        if (result.data.code === 200) _this4.$toastr.s('Data berhasil dihapus.');else _this4.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this4.$swal.close();
        _this4.getData();
      }).catch(function (e) {
        _this4.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this4.$swal.close();
      });
    },
    checkRoute: function checkRoute(route) {
      this.list = [];
      if (route.name === 'ListMateriKomunikasi') {
        this.link = 'materikomunikasi';
        this.nama = 'Materi Komunikasi';
      }
    }
  },
  mounted: function mounted() {
    this.checkRoute(this.$route);
    this.getData();
  },
  watch: {
    currentPage: function currentPage(e) {
      this.getData();
    },
    perPage: function perPage(e) {
      this.getData();
    },
    search: function search(e) {
      this.getData();
    },
    '$route': function $route(to, from) {
      this.checkRoute(to);
      this.getData();
    }
  }
});

/***/ }),

/***/ "CrcI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListSejarah_vue__ = __webpack_require__("Ma3Y");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a35c9876_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListSejarah_vue__ = __webpack_require__("bKjE");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListSejarah_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a35c9876_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListSejarah_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "D1z2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_ckeditor2__ = __webpack_require__("42+j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FormLine_vue__ = __webpack_require__("w3AW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_api__ = __webpack_require__("+Btm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone__ = __webpack_require__("KvPw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css__ = __webpack_require__("hCol");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_1__components_FormLine_vue__["a" /* default */], Ckeditor: __WEBPACK_IMPORTED_MODULE_0_vue_ckeditor2__["a" /* default */], vueDropzone: __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone___default.a },
  name: 'Upload',
  data: function data() {
    return {
      dropzoneOptions: {
        url: __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.baseURL + '/' + this.link,
        thumbnailWidth: 150,
        maxFilesize: 200,
        headers: { 'Authorization': 'Bearer ' + localStorage.getItem('_token') }
      },
      name: '',
      link: ''
    };
  },
  methods: {
    vsuccess: function vsuccess(file, response) {
      this.success = true;
      console.log(response);
    },
    failed: function failed(file, m, xhr) {
      this.$swal('Perhatian', m.message, 'error');
      this.$refs.myVueDropzone.removeAllFiles();
    },
    checkRoute: function checkRoute() {
      this.$refs.myVueDropzone.removeAllFiles();
      if (this.$route.name === 'CetakStrukMP') {
        this.$refs.myVueDropzone.setOption('url', __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.baseURL + '/import-cetak-mp');
        this.name = 'Cetak Struk MP';
      } else if (this.$route.name === 'CetakStrukUangPembinaan') {
        this.$refs.myVueDropzone.setOption('url', __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.baseURL + '/import-cetak-uang-pembinaan');
        this.name = 'Cetak Struk Uang Pembinaan';
      } else if (this.$route.name === 'CetakStrukRapel') {
        this.$refs.myVueDropzone.setOption('url', __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.baseURL + '/import-cetak-rapel');
        this.name = 'Cetak Struk Rapel Kenaikan';
      } else if (this.$route.name === 'CetakSPT') {
        this.$refs.myVueDropzone.setOption('url', __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.baseURL + '/import-cetak-spt');
        this.name = 'Cetak SPT';
      }
    }
  },
  mounted: function mounted() {
    this.checkRoute();
  },

  watch: {
    '$route': function $route(a, b, c) {
      this.checkRoute();
    }
  }
});

/***/ }),

/***/ "DPvd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_ckeditor2__ = __webpack_require__("42+j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FormLine_vue__ = __webpack_require__("w3AW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_api__ = __webpack_require__("+Btm");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_1__components_FormLine_vue__["a" /* default */], Ckeditor: __WEBPACK_IMPORTED_MODULE_0_vue_ckeditor2__["a" /* default */] },
  name: 'ListNarasumber',
  data: function data() {
    return {
      config: {
        toolbar: [{ name: 'stuff', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] }, { name: 'morestuff', items: ['NumberedList', 'BulletedList'] }, { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Superscript', 'Subscript'] }, { name: 'colors', items: ['TextColor'] }, { name: 'paragraph2', items: ['JustifyLeft', 'JustiftyCenter', 'JustifyRight', 'Outdent', 'Indent'] }, '/', { name: 'document', items: ['Source'] }],
        height: 300
      },
      sejarah: {
        tahun: '',
        deskripsi: ''
      },
      id_sejarah: '',
      isLoading: false
    };
  },
  methods: {
    save: function save() {
      var _this = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.headers.post['Content-Type'] = 'application/json';
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].post('/sejarah-pendirian', this.sejarah).then(function (result) {
        if (result.data.code === 200) {
          _this.$router.replace('/main/profile/sejarah');
          _this.$toastr.s('Tambah data berhasil');
        }
        _this.isLoading = false;
      }).catch(function (ex) {
        _this.$toastr.e('Terjadi kesalahan pada server, mohon ulangi');
        _this.isLoading = false;
      });
    },
    update: function update() {
      var _this2 = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.headers.post['Content-Type'] = 'application/json';
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].post('/sejarah-pendirian/' + this.id_sejarah, this.sejarah).then(function (result) {
        if (result.data.code === 200) {
          _this2.$router.replace('/main/profile/sejarah');
          _this2.$toastr.s('Ubah data berhasil');
        }
        _this2.isLoading = false;
      }).catch(function (e) {
        var msg = 'Terjadi kesalahan pada server, mohon ulangi';
        if (e.response.data.message) msg = e.response.data.message;
        _this2.$toastr.e(msg);
        _this2.isLoading = false;
      });
    },
    getDetail: function getDetail() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].get('/sejarah-pendirian/' + this.id_sejarah).then(function (result) {
        _this3.sejarah = result.data;
      }).catch(function (ex) {
        _this3.$toastr.e('Terjadi kesalahan pada server, mohon ulangi');
      });
    }
  },
  mounted: function mounted() {
    this.id_sejarah = this.$route.params.id;
    if (this.id_sejarah != null) {
      this.getDetail();
    }
  }
});

/***/ }),

/***/ "DY5s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormFaq_vue__ = __webpack_require__("PM1V");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ebfced2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormFaq_vue__ = __webpack_require__("xLWt");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormFaq_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ebfced2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormFaq_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Dflq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_ckeditor2__ = __webpack_require__("42+j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__ = __webpack_require__("w3AW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_api__ = __webpack_require__("+Btm");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__["a" /* default */], Ckeditor: __WEBPACK_IMPORTED_MODULE_1_vue_ckeditor2__["a" /* default */] },
  name: 'FormFaq',
  data: function data() {
    return {
      config: {
        toolbar: [{ name: 'stuff', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] }, { name: 'morestuff', items: ['NumberedList', 'BulletedList'] }, { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Superscript', 'Subscript'] }, { name: 'colors', items: ['TextColor'] }, { name: 'paragraph2', items: ['JustifyLeft', 'JustiftyCenter', 'JustifyRight', 'Outdent', 'Indent'] }, '/', { name: 'document', items: ['Source'] }],
        height: 300
      },
      data: {
        nama: '',
        npwp: '',
        tahun: '',
        npwpPemotong: ''
      },
      gambar: '',
      id_identitas_pemotong: '',
      isLoading: false
    };
  },
  methods: {
    save: function save() {
      var _this = this;

      this.isLoading = true;
      var form = new FormData();
      form.append('file', this.gambar);
      form.append('json', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.data));
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].post('/identitas-pemotong', form).then(function (result) {
        if (result.data.code === 200) {
          _this.$router.replace('/main/identitas-pemotong');
          _this.$toastr.s('Tambah data berhasil');
        } else {
          var msg = 'Tambah data gagal';
          if (result.data.message !== '') msg = result.data.message;
          _this.$toastr.e(msg);
        }
        _this.isLoading = false;
      }).catch(function (e) {
        var msg = 'Terjadi kesalahan pada server, mohon ulangi';
        if (e.response.data.message) msg = e.response.data.message;
        _this.$toastr.e(msg);
        _this.isLoading = false;
      });
    },
    update: function update() {
      var _this2 = this;

      var form = new FormData();
      form.append('file', this.gambar);
      form.append('json', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.data));
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].post('/identitas-pemotong/' + this.id_identitas_pemotong, form).then(function (result) {
        if (result.data.code === 200) {
          _this2.$router.replace('/main/layanan/atur-ip');
          _this2.$toastr.s('Ubah data berhasil');
        }
      }).catch(function (e) {
        var msg = 'Terjadi kesalahan pada server, mohon ulangi';
        if (e.response.data.message) msg = e.response.data.message;
        _this2.$toastr.e(msg);
        _this2.isLoading = false;
      });
    },
    getDetail: function getDetail() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].get('/identitas-pemotong/' + this.id_identitas_pemotong).then(function (result) {
        _this3.data = result.data;
      }).catch(function (ex) {
        _this3.$toastr.e('Terjadi kesalahan pada server, mohon ulangi');
      });
    },
    handleFile: function handleFile(file) {
      this.gambar = file.target.files[0];
    }
  },
  mounted: function mounted() {
    this.id_identitas_pemotong = this.$route.params.id;
    if (this.id_identitas_pemotong != null) {
      this.getDetail();
    }
  }
});

/***/ }),

/***/ "Dkb2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__("i3Ju");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33829760_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__("Oidq");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33829760_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "E8P5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();return _vm.simpan.apply(null, arguments)}}},[_c('div',{staticClass:"row clearfix"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"subjek","type":"text"},model:{value:(_vm.data.message),callback:function ($$v) {_vm.$set(_vm.data, "message", $$v)},expression:"data.message"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect waves-button",attrs:{"disabled":_vm.isLoading,"type":"submit"}},[(!_vm.isLoading)?_c('span',[_c('i',{staticClass:"material-icons"},[_vm._v("save")]),_vm._v(" Simpan")]):_c('span',[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" Loading")])]),_vm._v(" "),_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-danger",attrs:{"disabled":_vm.isLoading,"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")]),_vm._v(" Batal")])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-header"},[_c('h2',[_vm._v("Headline")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            Headline\n                        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"subjek"}},[_vm._v("Pesan")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EQq4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormDownload_vue__ = __webpack_require__("icvh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7afab106_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormDownload_vue__ = __webpack_require__("88/t");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormDownload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7afab106_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormDownload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EY2h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListHakdanKewajiban_vue__ = __webpack_require__("zxJn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_134fdf7a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListHakdanKewajiban_vue__ = __webpack_require__("GIha");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListHakdanKewajiban_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_134fdf7a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListHakdanKewajiban_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EfGY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"login-box"},[_c('div',{staticClass:"card",staticStyle:{"margin-top":"38%"}},[_c('div',{staticClass:"body"},[_c('img',{staticStyle:{"margin":"0 auto","display":"block","z-index":"2","margin-top":"-82px","width":"30%","padding-top":"10px","margin-bottom":"15px"},attrs:{"src":__webpack_require__("7Otq")}}),_vm._v(" "),_c('form',{ref:"form",attrs:{"id":"sign_in","method":"POST"},on:{"submit":function($event){$event.preventDefault();return _vm.lupaPassword.apply(null, arguments)}}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"input-group"},[_vm._m(1),_vm._v(" "),_c('formline',{ref:"email",attrs:{"type":"text","name":"email","placeholder":"Email","required":"","autofocus":""},model:{value:(_vm.user.email),callback:function ($$v) {_vm.$set(_vm.user, "email", $$v)},expression:"user.email"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin":"0 auto","display":"block","text-align":"center"}},[_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn bg-pink btn-block waves-effect",staticStyle:{"color":"#fff"},attrs:{"disabled":_vm.isLoading}},[(!_vm.isLoading)?_c('span',[_vm._v("Reset Password")]):_c('span',[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" Loading")])])]),_vm._v(" "),_c('div',{staticClass:"row m-t-15 m-b--20"},[_c('div',{staticStyle:{"text-align":"center","padding-bottom":"5%"}},[_c('a',{attrs:{"href":""},on:{"click":function($event){return _vm.$router.go('/')}}},[_vm._v("Login")])])])])])])]),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('a',{staticStyle:{"color":"#333","font-size":"28px"},attrs:{"href":"#"}},[_vm._v("Admin"),_c('b',[_vm._v("DAPENBI")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"material-icons"},[_vm._v("email")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center","color":"#fff"}},[_c('p',[_vm._v("copyright 2018 | Dana Pensiun Indonesia")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center","color":"#fff"}},[_c('p',[_vm._v("Designed by "),_c('a',{staticStyle:{"color":"#fff"},attrs:{"href":"http://birutekno.com/"}},[_vm._v("Birutekno Inc")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FBlO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListRegulasi_vue__ = __webpack_require__("mryB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_589317dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListRegulasi_vue__ = __webpack_require__("fUy3");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListRegulasi_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_589317dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListRegulasi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FC02":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"row"},[_c('label',{staticClass:"col-sm-3"},[_vm._v("Pilih Periode")]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tahun),expression:"tahun"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.tahun=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("[ Pilih Periode ]")]),_vm._v(" "),_vm._l((_vm.year),function(n){return _c('option',{domProps:{"value":n}},[_vm._v(_vm._s(n))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[(!_vm.isLoading)?_c('bar-chart',{attrs:{"data":_vm.chartData,"options":_vm.chartOptions,"beginzero":true}}):_vm._e()],1)]),_vm._v(" "),_c('hr')])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"dataTables_wrapper form-inline dt-bootstrap",attrs:{"id":"DataTables_Table_0_wrapper"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_length",attrs:{"id":"DataTables_Table_0_length"}},[_c('label',[_vm._v("Show "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.perPage),expression:"perPage"}],staticClass:"form-control input-sm",attrs:{"name":"DataTables_Table_0_length","aria-controls":"DataTables_Table_0"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.perPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_c('option',{attrs:{"value":"100"}},[_vm._v("100")])]),_vm._v(" entries")])])]),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_filter",attrs:{"id":"DataTables_Table_0_filter"}},[_c('label',[_vm._v("Search:"),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control input-sm",attrs:{"type":"search","placeholder":"","aria-controls":"DataTables_Table_0"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])])])]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped table-hover js-basic-example dataTable"},[_vm._m(3),_vm._v(" "),_c('tbody',[(_vm.isLoading)?_c('tr',[_vm._m(4)]):_vm._e(),_vm._v(" "),(_vm.list == '')?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"5"}},[_vm._v("Data tidak ditemukan")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(item,index){return (!_vm.isLoading)?_c('tr',[_c('td',[_vm._v(_vm._s(++index + ((_vm.currentPage-1)*_vm.perPage)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.masterSurvey.periode))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.peserta.nip))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.peserta.namaPeserta))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.masterSurvey.pernyataan))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.score))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.penjelasan))])]):_vm._e()})],2)])]),_vm._v(" "),_c('pagination',{attrs:{"total-rows":_vm.result.totalElements,"per-page":_vm.result.size},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-header"},[_c('h2',[_vm._v("Hasil Survey")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            Hasil Survey\n                        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            Detail Hasil Survey\n                        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("No.")]),_vm._v(" "),_c('th',[_vm._v("Periode")]),_vm._v(" "),_c('th',[_vm._v("NIP")]),_vm._v(" "),_c('th',[_vm._v("Nama")]),_vm._v(" "),_c('th',[_vm._v("Pernyataan")]),_vm._v(" "),_c('th',[_vm._v("Score")]),_vm._v(" "),_c('th',[_vm._v("Penjelasan")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center",attrs:{"colspan":"5"}},[_c('i',{staticClass:"fa fa-spin fa-spinner"}),_vm._v(" Loading data...")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FqJK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_api__ = __webpack_require__("+Btm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ListAdmin',
  data: function data() {
    return {
      result: {},
      list: [],
      currentPage: 1,
      perPage: 10,
      search: '',
      modal: null,
      isLoading: true,
      link: '',
      tipe: '',
      nama: ''
    };
  },
  methods: {
    getData: function getData() {
      var _this = this;

      var params = [];
      params.search = this.search;
      params.page = this.currentPage - 1;
      params.size = this.perPage;

      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].get('/admin?' + __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(params)).then(function (result) {
        _this.result = result.data;
        _this.list = result.data.content;
        _this.isLoading = false;
      }).catch(function (ex) {
        _this.isLoading = false;
      });
    },
    confirmDelete: function confirmDelete(id) {
      var _this2 = this;

      this.$swal({
        title: 'Konfirmasi',
        text: 'Anda yakin ingin menghapus data ini?',
        icon: 'warning',
        buttons: [true, {
          text: 'Ok',
          closeModal: false
        }],
        dangerMode: true
      }).then(function (result) {
        if (result) _this2.delete(id);
      });
    },
    delete: function _delete(id) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].delete('/admin/' + id).then(function (result) {
        if (result.data.code === 200) _this3.$toastr.s('Data berhasil dihapus.');else _this3.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this3.$swal.close();
        _this3.getData();
      }).catch(function (e) {
        _this3.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this3.$swal.close();
      });
    }
  },
  mounted: function mounted() {
    this.getData();
  },
  watch: {
    currentPage: function currentPage(e) {
      this.getData();
    },
    perPage: function perPage(e) {
      this.getData();
    },
    search: function search(e) {
      this.getData();
    }
  }
});

/***/ }),

/***/ "GIha":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"block-header"},[_c('h2',[_vm._v(_vm._s(_vm.nama))])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            List "+_vm._s(_vm.nama)+"\n                        ")]),_vm._v(" "),_c('ul',{staticClass:"header-dropdown m-r--5 m-t--10"},[_c('router-link',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect waves-button",attrs:{"to":'/main/HakdanWajiban/' + _vm.link + '/tambah',"type":"button"}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#fff"}},[_vm._v("add_box")]),_vm._v(" "),_c('span',[_vm._v("Tambah")])])],1)]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"dataTables_wrapper form-inline dt-bootstrap",attrs:{"id":"DataTables_Table_0_wrapper"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_length",attrs:{"id":"DataTables_Table_0_length"}},[_c('label',[_vm._v("Show "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.perPage),expression:"perPage"}],staticClass:"form-control input-sm",attrs:{"name":"DataTables_Table_0_length","aria-controls":"DataTables_Table_0"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.perPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_c('option',{attrs:{"value":"100"}},[_vm._v("100")])]),_vm._v(" entries")])])]),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_filter",attrs:{"id":"DataTables_Table_0_filter"}},[_c('label',[_vm._v("Search:"),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control input-sm",attrs:{"type":"search","placeholder":"","aria-controls":"DataTables_Table_0"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])])])]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped table-hover js-basic-example dataTable"},[_vm._m(0),_vm._v(" "),_c('tbody',[(_vm.isLoading)?_c('tr',[_vm._m(1)]):_vm._e(),_vm._v(" "),(_vm.list == '')?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"5"}},[_vm._v("Data tidak ditemukan")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(item,index){return (!_vm.isLoading)?_c('tr',[_c('td',[_vm._v(_vm._s(++index + ((_vm.currentPage-1)*_vm.perPage)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.content))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.createdAt ? _vm.$moment(item.createdAt, 'YYYY-MM-DD').format("Do MMMM YYYY") : '-'))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn bg-green waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.push('/main/HakdanWajiban/ListHakdanKewajiban/edit/' + item.id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("create")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmDelete(item.id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")])])])]):_vm._e()})],2)])]),_vm._v(" "),_c('pagination',{attrs:{"total-rows":_vm.result.totalElements,"per-page":_vm.result.size},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("No.")]),_vm._v(" "),_c('th',[_vm._v("Title")]),_vm._v(" "),_c('th',[_vm._v("Content")]),_vm._v(" "),_c('th',[_vm._v("Tanggal di buat")]),_vm._v(" "),_c('th',[_vm._v("Aksi")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center",attrs:{"colspan":"5"}},[_c('i',{staticClass:"fa fa-spin fa-spinner"}),_vm._v(" Loading data...")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GSWY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_api__ = __webpack_require__("+Btm");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ListNarasumber',
  data: function data() {
    return {
      config: {
        toolbar: [{ name: 'stuff', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] }, { name: 'morestuff', items: ['NumberedList', 'BulletedList'] }, { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Superscript', 'Subscript'] }, { name: 'colors', items: ['TextColor'] }, { name: 'paragraph2', items: ['JustifyLeft', 'JustiftyCenter', 'JustifyRight', 'Outdent', 'Indent'] }, '/', { name: 'document', items: ['Source'] }],
        height: 300
      },
      content: {
        judul: 'Struktur Organisasi',
        tipe: 1,
        deskripsi: ''
      },
      icon: '',
      id_content: '',
      isLoading: false
    };
  },
  methods: {
    save: function save() {
      var _this = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      var form = new FormData();
      form.append('file', this.icon);
      form.append('json', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.content));
      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].post('/struktur-organisasi', form).then(function (result) {
        if (result.data.code === 200) {
          _this.$toastr.s('Edit struktur organisasi berhasil');
        } else {
          var msg = 'Edit struktur organisasi gagal';
          if (result.data.message !== '') msg = result.data.message;
          _this.$toastr.e(msg);
        }
        _this.getDetail();
        _this.isLoading = false;
      }).catch(function (e) {
        var msg = 'Terjadi kesalahan pada server, mohon ulangi';
        if (e.response.data.message) msg = e.response.data.message;
        _this.$toastr.e(msg);
        _this.isLoading = false;
      });
    },
    getDetail: function getDetail() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].get('/struktur-organisasi').then(function (result) {
        _this2.content = result.data;
      }).catch(function (ex) {
        _this2.$toastr.e('Terjadi kesalahan pada server, mohon ulangi');
      });
    },
    handleFile: function handleFile(file) {
      this.icon = file.target.files[0];
    }
  },
  mounted: function mounted() {
    this.getDetail();
  }
});

/***/ }),

/***/ "GTHR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListAdmin_vue__ = __webpack_require__("FqJK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c3498fd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListAdmin_vue__ = __webpack_require__("1Wcb");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListAdmin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c3498fd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListAdmin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GY0c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HubungiKami_vue__ = __webpack_require__("TpJO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d5709f1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HubungiKami_vue__ = __webpack_require__("HHRk");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HubungiKami_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d5709f1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HubungiKami_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GbQ1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-6 col-md-6 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"body"},[_c('pie-chart',{attrs:{"data":_vm.chartData,"options":_vm.chartOptions}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-6 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"body"},[_c('bar-chart',{attrs:{"data":_vm.chartData2,"options":_vm.chartOptions}})],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-header"},[_c('h2',[_vm._v("\n                DASHBOARD\n            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-3 col-md-3 col-sm-6 col-xs-12"},[_c('div',{staticClass:"info-box bg-pink hover-expand-effect"},[_c('div',{staticClass:"icon"},[_c('i',{staticClass:"material-icons"},[_vm._v("file_download")])]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"text"},[_vm._v("TOTAL UNDUH")]),_vm._v(" "),_c('div',{staticClass:"number count-to",attrs:{"data-from":"0","data-to":"125","data-speed":"1000","data-fresh-interval":"20"}},[_vm._v("15")])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-3 col-md-3 col-sm-6 col-xs-12"},[_c('div',{staticClass:"info-box bg-cyan hover-expand-effect"},[_c('div',{staticClass:"icon"},[_c('i',{staticClass:"material-icons"},[_vm._v("share")])]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"text"},[_vm._v("TOTAL SHARE")]),_vm._v(" "),_c('div',{staticClass:"number count-to",attrs:{"data-from":"0","data-to":"257","data-speed":"1000","data-fresh-interval":"20"}},[_vm._v("5")])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-3 col-md-3 col-sm-6 col-xs-12"},[_c('div',{staticClass:"info-box bg-light-green hover-expand-effect"},[_c('div',{staticClass:"icon"},[_c('i',{staticClass:"material-icons"},[_vm._v("file_upload")])]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"text"},[_vm._v("TOTAL UPLOAD")]),_vm._v(" "),_c('div',{staticClass:"number count-to",attrs:{"data-from":"0","data-to":"243","data-speed":"1000","data-fresh-interval":"20"}},[_vm._v("24")])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-3 col-md-3 col-sm-6 col-xs-12"},[_c('div',{staticClass:"info-box bg-orange hover-expand-effect"},[_c('div',{staticClass:"icon"},[_c('i',{staticClass:"material-icons"},[_vm._v("person_add")])]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"text"},[_vm._v("TOTAL ANGGOTA")]),_vm._v(" "),_c('div',{staticClass:"number count-to",attrs:{"data-from":"0","data-to":"1225","data-speed":"1000","data-fresh-interval":"20"}},[_vm._v("7820")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row clearfix",attrs:{"hidden":"true"}},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-12 col-lg-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("REAL-TIME CHART")]),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('div',{staticClass:"switch panel-switch-btn"},[_c('span',{staticClass:"m-r-10 font-12"},[_vm._v("REAL TIME")]),_vm._v(" "),_c('label',[_vm._v("OFF"),_c('input',{attrs:{"type":"checkbox","id":"realtime","checked":""}}),_c('span',{staticClass:"lever switch-col-cyan"}),_vm._v("ON")])])]),_vm._v(" "),_c('ul',{staticClass:"header-dropdown m-r--5"},[_c('li',{staticClass:"dropdown"},[_c('a',{staticClass:"dropdown-toggle",attrs:{"href":"javascript:void(0);","data-toggle":"dropdown","role":"button","aria-haspopup":"true","aria-expanded":"false"}},[_c('i',{staticClass:"material-icons"},[_vm._v("more_vert")])]),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu pull-right"},[_c('li',[_c('a',{attrs:{"href":"javascript:void(0);"}},[_vm._v("Action")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0);"}},[_vm._v("Another action")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0);"}},[_vm._v("Something else here")])])])])])]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"flot-chart",attrs:{"id":"real_time_chart"}})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row clearfix",attrs:{"hidden":"true"}},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("MULTIPLE AXIS")]),_vm._v(" "),_c('ul',{staticClass:"header-dropdown m-r--5"},[_c('li',{staticClass:"dropdown"},[_c('a',{staticClass:"dropdown-toggle",attrs:{"href":"javascript:void(0);","data-toggle":"dropdown","role":"button","aria-haspopup":"true","aria-expanded":"false"}},[_c('i',{staticClass:"material-icons"},[_vm._v("more_vert")])]),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu pull-right"},[_c('li',[_c('a',{attrs:{"href":"javascript:void(0);"}},[_vm._v("Action")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0);"}},[_vm._v("Another action")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0);"}},[_vm._v("Something else here")])])])])])]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"flot-chart",attrs:{"id":"multiple_axis_chart"}})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row clearfix",attrs:{"hidden":"true"}},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("TRACKING")]),_vm._v(" "),_c('ul',{staticClass:"header-dropdown m-r--5"},[_c('li',{staticClass:"dropdown"},[_c('a',{staticClass:"dropdown-toggle",attrs:{"href":"javascript:void(0);","data-toggle":"dropdown","role":"button","aria-haspopup":"true","aria-expanded":"false"}},[_c('i',{staticClass:"material-icons"},[_vm._v("more_vert")])]),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu pull-right"},[_c('li',[_c('a',{attrs:{"href":"javascript:void(0);"}},[_vm._v("Action")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0);"}},[_vm._v("Another action")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0);"}},[_vm._v("Something else here")])])])])])]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"flot-chart",attrs:{"id":"tracking_chart"}})])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('h2',[_vm._v("PERSENTASE AKSES")]),_vm._v(" "),_c('ul',{staticClass:"header-dropdown m-r--5"},[_c('li',{staticClass:"dropdown"},[_c('a',{staticClass:"dropdown-toggle",attrs:{"href":"javascript:void(0);","data-toggle":"dropdown","role":"button","aria-haspopup":"true","aria-expanded":"false"}},[_c('i',{staticClass:"material-icons"},[_vm._v("more_vert")])]),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu pull-right"},[_c('li',[_c('a',{attrs:{"href":"javascript:void(0);"}},[_vm._v("Action")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0);"}},[_vm._v("Another action")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:void(0);"}},[_vm._v("Something else here")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('h2',[_vm._v("TRAFFIC VISITOR")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HCTz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Header',
  methods: {
    signOut: function signOut() {
      console.log('logout');
      localStorage.removeItem('_token');
      location.reload();
    }
  }
});

/***/ }),

/***/ "HHRk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_c('div',{staticClass:"row clearfix"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('Ckeditor',{attrs:{"id":"deskripsi","config":_vm.config},model:{value:(_vm.contact.deskripsi),callback:function ($$v) {_vm.$set(_vm.contact, "deskripsi", $$v)},expression:"contact.deskripsi"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"type":"text","name":"alamat","id":"alamat","placeholder":"Masukkan Alamat"},model:{value:(_vm.contact.alamat),callback:function ($$v) {_vm.$set(_vm.contact, "alamat", $$v)},expression:"contact.alamat"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-lg-5 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"type":"text","name":"latitude","id":"embed","placeholder":"Masukkan Latitude"},model:{value:(_vm.contact.latitude),callback:function ($$v) {_vm.$set(_vm.contact, "latitude", $$v)},expression:"contact.latitude"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"col-lg-5 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"type":"text","name":"longitude","id":"longitude","placeholder":"Masukkan Longitude"},model:{value:(_vm.contact.longitude),callback:function ($$v) {_vm.$set(_vm.contact, "longitude", $$v)},expression:"contact.longitude"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"type":"text","name":"telp","id":"telp","placeholder":"Masukkan Nomor Telp"},model:{value:(_vm.contact.telp),callback:function ($$v) {_vm.$set(_vm.contact, "telp", $$v)},expression:"contact.telp"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(7),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"type":"text","name":"email","id":"email","placeholder":"Masukkan Alamat Email"},model:{value:(_vm.contact.email),callback:function ($$v) {_vm.$set(_vm.contact, "email", $$v)},expression:"contact.email"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(8),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"type":"text","name":"fb","id":"fb","placeholder":"Masukkan Link Facebook"},model:{value:(_vm.contact.fb),callback:function ($$v) {_vm.$set(_vm.contact, "fb", $$v)},expression:"contact.fb"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(9),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"type":"text","name":"twitter","id":"twitter","placeholder":"Masukkan Link Twitter"},model:{value:(_vm.contact.twitter),callback:function ($$v) {_vm.$set(_vm.contact, "twitter", $$v)},expression:"contact.twitter"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(10),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"type":"text","name":"ig","id":"ig","placeholder":"Masukkan Link Instagram"},model:{value:(_vm.contact.ig),callback:function ($$v) {_vm.$set(_vm.contact, "ig", $$v)},expression:"contact.ig"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.save}},[_c('i',{staticClass:"material-icons"},[_vm._v("save")]),_vm._v(" Simpan")]),_vm._v(" "),_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")]),_vm._v(" Batal")])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-header"},[_c('h2',[_vm._v("Hubungi Kami")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            Edit Hubungi Kami\n                        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"deskripsi"}},[_vm._v("Deskripsi")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"alamat"}},[_vm._v("Alamat")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"latitude"}},[_vm._v("Latitude")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"longitude"}},[_vm._v("Longitude")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"telp"}},[_vm._v("Telp")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"email"}},[_vm._v("Email")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"fb"}},[_vm._v("Link FB")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"fb"}},[_vm._v("Link Twitter")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"fb"}},[_vm._v("Link Instagram")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HTPo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            Data Anggota\n                        ")]),_vm._v(" "),_c('ul',{staticClass:"header-dropdown m-r--5 m-t--10"},[_c('router-link',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect waves-button",attrs:{"to":'/main/anggota/tambah',"type":"button"}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#fff"}},[_vm._v("add_box")]),_vm._v(" "),_c('span',[_vm._v("Tambah")])])],1)]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"dataTables_wrapper form-inline dt-bootstrap",attrs:{"id":"DataTables_Table_0_wrapper"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_length",attrs:{"id":"DataTables_Table_0_length"}},[_c('label',[_vm._v("Show "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.perPage),expression:"perPage"}],staticClass:"form-control input-sm",attrs:{"name":"DataTables_Table_0_length","aria-controls":"DataTables_Table_0"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.perPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_c('option',{attrs:{"value":"100"}},[_vm._v("100")])]),_vm._v(" entries")])])]),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_filter",attrs:{"id":"DataTables_Table_0_filter"}},[_c('label',[_vm._v("Search:"),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control input-sm",attrs:{"type":"search","placeholder":"","aria-controls":"DataTables_Table_0"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])])])]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped table-hover js-basic-example dataTable"},[_vm._m(1),_vm._v(" "),_c('tbody',[(_vm.isLoading)?_c('tr',[_vm._m(2)]):_vm._e(),_vm._v(" "),(_vm.list == '')?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"9"}},[_vm._v("Data tidak ditemukan")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(item,index){return (!_vm.isLoading)?_c('tr',[_c('td',[_vm._v(_vm._s(++index + ((_vm.currentPage-1)*_vm.perPage)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.nip))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.namaPeserta))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.tglLahir))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.sex))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.tglBekerja))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.tglHenti))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.gol))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn bg-green waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.push('/main/anggota/edit/' + item.nip)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("create")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmDelete(item.nip)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")])])])]):_vm._e()})],2)])]),_vm._v(" "),_c('pagination',{attrs:{"total-rows":_vm.result.totalElements,"per-page":_vm.result.size},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-header"},[_c('h2',[_vm._v("Data Anggota")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("No.")]),_vm._v(" "),_c('th',[_vm._v("NIP")]),_vm._v(" "),_c('th',[_vm._v("Nama Peserta")]),_vm._v(" "),_c('th',[_vm._v("Tanggal Lahir")]),_vm._v(" "),_c('th',[_vm._v("Sex")]),_vm._v(" "),_c('th',[_vm._v("Tanggal Bekerja")]),_vm._v(" "),_c('th',[_vm._v("Tanggal Berhenti")]),_vm._v(" "),_c('th',[_vm._v("Golongan")]),_vm._v(" "),_c('th',[_vm._v("Aksi")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center",attrs:{"colspan":"9"}},[_c('i',{staticClass:"fa fa-spin fa-spinner"}),_vm._v(" Loading data...")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HY1S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_c('div',{staticClass:"row clearfix"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"nip","type":"text","disabled":""},model:{value:(_vm.data.nip),callback:function ($$v) {_vm.$set(_vm.data, "nip", $$v)},expression:"data.nip"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"namaPeserta","type":"text"},model:{value:(_vm.data.namaPeserta),callback:function ($$v) {_vm.$set(_vm.data, "namaPeserta", $$v)},expression:"data.namaPeserta"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.data.sex),expression:"data.sex"}],staticClass:"form-control",attrs:{"name":"sex","id":"sex"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.data, "sex", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"P"}},[_vm._v("Pria")]),_vm._v(" "),_c('option',{attrs:{"value":"W"}},[_vm._v("Wanita")])])])])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"form-line"},[_c('flat-pickr',{staticClass:"form-control",attrs:{"id":"tglBekerja","config":_vm.date},model:{value:(_vm.data.tglBekerja),callback:function ($$v) {_vm.$set(_vm.data, "tglBekerja", $$v)},expression:"data.tglBekerja"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"form-line"},[_c('flat-pickr',{staticClass:"form-control",attrs:{"id":"tglHenti","config":_vm.date},model:{value:(_vm.data.tglHenti),callback:function ($$v) {_vm.$set(_vm.data, "tglHenti", $$v)},expression:"data.tglHenti"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(7),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"golongan","type":"text"},model:{value:(_vm.data.gol),callback:function ($$v) {_vm.$set(_vm.data, "gol", $$v)},expression:"data.gol"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-warning waves-effect waves-button",attrs:{"disabled":_vm.isLoading,"type":"button"},on:{"click":_vm.update}},[(!_vm.isLoading)?_c('span',[_c('i',{staticClass:"material-icons"},[_vm._v("save")]),_vm._v(" Edit")]):_c('span',[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" Loading")])]),_vm._v(" "),_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")]),_vm._v(" Batal")])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-header"},[_c('h2',[_vm._v("Edit Anggota")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            Edit Anggota\n                        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"nip"}},[_vm._v("NIP")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"namaPeserta"}},[_vm._v("Nama Peserta")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"sex"}},[_vm._v("Sex")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"tglBekerja"}},[_vm._v("Tanggal Bekerja")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"tglHenti"}},[_vm._v("Tanggal Berhenti")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"golongan"}},[_vm._v("Golongan")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HcYX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "I1X7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListNarasumber_vue__ = __webpack_require__("zX70");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19106bcc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListNarasumber_vue__ = __webpack_require__("2HTw");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListNarasumber_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19106bcc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListNarasumber_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "I2J/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormUnduh_vue__ = __webpack_require__("XcCb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12fe3d18_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormUnduh_vue__ = __webpack_require__("kMbL");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormUnduh_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12fe3d18_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormUnduh_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IVcU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_c('div',{staticClass:"row clearfix"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[(_vm.content.icon != null)?_c('img',{attrs:{"src":_vm.content.icon,"width":"150px","alt":"Foto"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"id":"icon","type":"file","name":"icon"},on:{"change":function($event){return _vm.handleFile($event)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect waves-button",attrs:{"disabled":_vm.isLoading,"type":"button"},on:{"click":_vm.save}},[(!_vm.isLoading)?_c('span',[_c('i',{staticClass:"material-icons"},[_vm._v("save")]),_vm._v(" Simpan")]):_c('span',[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" Loading")])]),_vm._v(" "),_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")]),_vm._v(" Batal")])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-header"},[_c('h2',[_vm._v("Struktur Organisasi")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            Edit Struktur Organisasi\n                        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"icon"}},[_vm._v("Gambar")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Jmzn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TambahAnggota_vue__ = __webpack_require__("lZjD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eff47ba4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TambahAnggota_vue__ = __webpack_require__("Q/+l");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TambahAnggota_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eff47ba4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TambahAnggota_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "K4gw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KSq6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PensiunTypeList_vue__ = __webpack_require__("cF2T");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0b80e02_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PensiunTypeList_vue__ = __webpack_require__("0Q4w");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PensiunTypeList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0b80e02_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PensiunTypeList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KcQp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calender_vue__ = __webpack_require__("Wg+Q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25cef2b8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Calender_vue__ = __webpack_require__("Y8kw");
function injectStyle (ssrContext) {
  __webpack_require__("yz7T")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calender_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25cef2b8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Calender_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LFEs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormPDP_vue__ = __webpack_require__("aTk2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed94b04a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormPDP_vue__ = __webpack_require__("vigp");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormPDP_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed94b04a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormPDP_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LVEG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"block-header"},[_c('h2',[_vm._v(_vm._s(_vm.nama))])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v(_vm._s(_vm.id_artikel != null ? 'Edit' : 'Tambah')+" "+_vm._s(_vm.nama))])]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit.apply(null, arguments)}}},[_c('div',{staticClass:"row clearfix"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"judul","type":"text"},model:{value:(_vm.data.judul),callback:function ($$v) {_vm.$set(_vm.data, "judul", $$v)},expression:"data.judul"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"penulis","type":"text"},model:{value:(_vm.data.penulis),callback:function ($$v) {_vm.$set(_vm.data, "penulis", $$v)},expression:"data.penulis"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"form-line"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.data.kategori),expression:"data.kategori"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.data, "kategori", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("-- Pilih Kategori --")]),_vm._v(" "),_vm._l((_vm.categories),function(item){return _c('option',{key:item.id,domProps:{"value":item.category}},[_vm._v("\n                          "+_vm._s(item.category)+"\n                        ")])})],2)])])])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('Ckeditor',{ref:"ckeditor",attrs:{"id":"artikel","config":_vm.config},model:{value:(_vm.data.content),callback:function ($$v) {_vm.$set(_vm.data, "content", $$v)},expression:"data.content"}})],1)])]),_vm._v(" "),(true)?_c('div',{staticClass:"row clearfix"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('vue-dropzone',{ref:"dropzoneThumnail",attrs:{"id":"dropzone-thumbnail","destroyDropzone":false,"options":_vm.dropzoneOptionsThumnail},on:{"vdropzone-removed-file":_vm.vremoved,"vdropzone-success":_vm.onUploadSuccess}})],1)])]):_vm._e(),_vm._v(" "),(true)?_c('div',{staticClass:"row clearfix"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('vue-dropzone',{ref:"dropzonePenulis",attrs:{"id":"dropzone-penulis","destroyDropzone":false,"options":_vm.dropzoneOptionsPenulis},on:{"vdropzone-removed-file":_vm.vremoved,"vdropzone-success":_vm.onUploadSuccess}})],1)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[(_vm.id_artikel != null)?_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-warning waves-effect waves-button",attrs:{"type":"button","disabled":_vm.isLoading},on:{"click":_vm.update}},[(_vm.isLoading)?_c('i',{staticClass:"fa fa-spin fa-spinner"}):_vm._e(),(!_vm.isLoading)?_c('i',{staticClass:"material-icons"},[_vm._v("save")]):_vm._e(),_vm._v(" Edit\n                  ")]):_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect waves-button",attrs:{"type":"button","disabled":_vm.isLoading},on:{"click":_vm.save}},[(_vm.isLoading)?_c('i',{staticClass:"fa fa-spin fa-spinner"}):_vm._e(),(!_vm.isLoading)?_c('i',{staticClass:"material-icons"},[_vm._v("save")]):_vm._e(),_vm._v("\n                    Simpan\n                  ")]),_vm._v(" "),_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")]),_vm._v(" Batal\n                  ")])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"judul"}},[_vm._v("Judul")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"penulis"}},[_vm._v("Penulis")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"kategori"}},[_vm._v("Kategori")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"artikel"}},[_vm._v("Artikel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"artikel"}},[_vm._v("Foto Thumbnail Artikel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"artikel"}},[_vm._v("Foto Penulis Artikel")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49f0314a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("N6Ol");
function injectStyle (ssrContext) {
  __webpack_require__("8xNV")
  __webpack_require__("6pp+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49f0314a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ma3Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_api__ = __webpack_require__("+Btm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__ = __webpack_require__("w3AW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__["a" /* default */] },
  name: 'ListSejarah',
  data: function data() {
    return {
      result: {},
      list: [],
      currentPage: 1,
      perPage: 10,
      search: '',
      modal: null,
      isLoading: true
    };
  },
  methods: {
    getData: function getData() {
      var _this = this;

      var params = [];
      params.search = this.search;
      params.page = this.currentPage - 1;
      params.size = this.perPage;

      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].get('/sejarah-pendirian?sort=tahun,asc&' + __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(params)).then(function (result) {
        _this.result = result.data;
        _this.list = result.data.content;
        _this.isLoading = false;
      }).catch(function (ex) {
        _this.isLoading = false;
      });
    },
    confirmDelete: function confirmDelete(id) {
      var _this2 = this;

      this.$swal({
        title: 'Konfirmasi',
        text: 'Anda yakin ingin menghapus data ini?',
        icon: 'warning',
        buttons: [true, {
          text: 'Ok',
          closeModal: false
        }],
        dangerMode: true
      }).then(function (result) {
        if (result) _this2.delete(id);
      });
    },
    delete: function _delete(id) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].delete('/sejarah-pendirian/' + id).then(function (result) {
        if (result.data.code === 200) _this3.$toastr.s('Data berhasil dihapus.');else _this3.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this3.$swal.close();
        _this3.getData();
      }).catch(function (e) {
        _this3.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this3.$swal.close();
      });
    }
  },
  mounted: function mounted() {
    this.getData();
  },
  watch: {
    currentPage: function currentPage(e) {
      this.getData();
    },
    perPage: function perPage(e) {
      this.getData();
    },
    search: function search(e) {
      this.getData();
    }
  }
});

/***/ }),

/***/ "N6Ol":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NBdm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_ckeditor2__ = __webpack_require__("42+j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FormLine_vue__ = __webpack_require__("w3AW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_api__ = __webpack_require__("+Btm");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_1__components_FormLine_vue__["a" /* default */], ckeditor: __WEBPACK_IMPORTED_MODULE_0_vue_ckeditor2__["a" /* default */] },
  data: function data() {
    return {
      id: null,
      isLoading: false,
      contents: {
        category: "",
        documents: [{ title: "", content: "" }]
      },
      config: {
        toolbar: [{
          name: "basicstyles",
          items: ["Bold", "Italic", "Underline", "Strike", "RemoveFormat"]
        }, {
          name: "paragraph",
          items: ["NumberedList", "BulletedList"]
        }, { name: "clipboard", items: ["Undo", "Redo"] }, { name: "insert", items: ["Image", "Table"] }, { name: "document", items: ["Source"] }],
        height: 300
      }
    };
  },

  methods: {
    addDocument: function addDocument() {
      this.contents.documents.push({ title: "", content: "" });
    },
    removeDocument: function removeDocument(index) {
      this.contents.documents.splice(index, 1);
    },
    onSubmit: function onSubmit() {
      this.isLoading = true;

      var docs = this.contents.documents.map(function (doc) {
        return {
          id: doc.id || null, // untuk update
          title: doc.title,
          content: doc.title === "Formulir" ? null : doc.content
        };
      });

      var data = {
        category: this.contents.category,
        documents: docs
      };

      var url = "/saveFormulirRegistrasi"; // backend menangani insert/update dalam satu endpoint

      var self = this;
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("_token");
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].post(url, data).then(function (result) {
        if (result.data.code === 200) {
          self.$toastr.s("Data berhasil disimpan");
          self.$router.replace("/main/pensiunRegistrasi/pensiuntype");
          location.reload();
        } else {
          self.$toastr.e(result.data.message || "Gagal menyimpan data");
        }
      }).catch(function (err) {
        self.$toastr.e("Terjadi kesalahan pada server");
      }).finally(function () {
        self.isLoading = false;
      });
    },
    fetchData: function fetchData() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("_token");
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].get("/getformulir/" + this.id).then(function (result) {
        var data = result.data;

        if (data && data.content && data.content.length > 0 && data.content[0].pensionType && data.content[0].pensionType.name) {
          self.contents.category = data.content[0].pensionType.name;
        }

        self.contents.documents = data.content.map(function (item) {
          return {
            id: item.id, // agar bisa update
            title: item.title,
            content: item.content
          };
        });
      }).catch(function () {
        self.$toastr.e("Gagal mengambil data");
      });
    }
  },
  mounted: function mounted() {
    this.id = this.$route.params.id;
    if (this.id) {
      this.fetchData();
    }
  }
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FormLine__ = __webpack_require__("w3AW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Pagination__ = __webpack_require__("cMGX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_swal__ = __webpack_require__("nUxp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_swal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_swal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_toastr__ = __webpack_require__("fGLG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_striptags__ = __webpack_require__("lmRO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_striptags___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_striptags__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_moment__ = __webpack_require__("mjDs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_flatpickr_component__ = __webpack_require__("QKlT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_flatpickr_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_flatpickr_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_flatpickr_dist_flatpickr_css__ = __webpack_require__("K4gw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_flatpickr_dist_flatpickr_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_flatpickr_dist_flatpickr_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_quill_editor__ = __webpack_require__("G0J2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_quill_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_quill_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_quill_dist_quill_core_css__ = __webpack_require__("3f40");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_quill_dist_quill_core_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_quill_dist_quill_core_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_quill_dist_quill_snow_css__ = __webpack_require__("4qOc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_quill_dist_quill_snow_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_quill_dist_quill_snow_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_quill_dist_quill_bubble_css__ = __webpack_require__("+cgv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_quill_dist_quill_bubble_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_quill_dist_quill_bubble_css__);


















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_12_vue_quill_editor___default.a);

__webpack_require__("2BDT");
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_toastr___default.a);

__webpack_require__("yRTJ");

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_moment___default.a, {
  moment: __WEBPACK_IMPORTED_MODULE_9_moment___default.a
});

var Waves = __webpack_require__("9EXB");
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(Waves);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('formline', __WEBPACK_IMPORTED_MODULE_3__components_FormLine__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('pagination', __WEBPACK_IMPORTED_MODULE_4__components_Pagination__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_swal___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_12_vue_quill_editor___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].mixin({
  methods: {
    stripTags: function stripTags(string) {
      return __WEBPACK_IMPORTED_MODULE_7_striptags___default()(string);
    }
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_vue_flatpickr_component___default.a);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]
  },
  mounted: function mounted() {
    this.$toastr.defaultProgressBar = false;
  }
});

/***/ }),

/***/ "NzVz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FormLine_vue__ = __webpack_require__("w3AW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_api__ = __webpack_require__("+Btm");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_1__components_FormLine_vue__["a" /* default */] },
  name: 'FormAnakPerusahaan',
  data: function data() {
    return {
      data: {
        link: '',
        tipe: '',
        description: '',
        name: ''
      },
      gambar: '',
      id_logo: '',
      isLoading: false
    };
  },
  methods: {
    save: function save() {
      var _this = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      var form = new FormData();
      form.append('file', this.file);
      form.append('json', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.data));
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].post('/anak-perusahaan', form).then(function (result) {
        if (result.data.code === 200) {
          _this.$router.replace('/main/anak-perusahaan');
          _this.$toastr.s('Tambah data berhasil');
        } else {
          var msg = 'Tambah data gagal';
          if (result.data.message !== '') msg = result.data.message;
          _this.$toastr.e(msg);
        }
        _this.isLoading = false;
      }).catch(function (e) {
        var msg = 'Terjadi kesalahan pada server, mohon ulangi';
        if (e.response.data.message) msg = e.response.data.message;
        _this.$toastr.e(msg);
        _this.isLoading = false;
      });
    },
    update: function update() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      var form = new FormData();
      form.append('file', this.file);
      form.append('json', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.data));
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].post('/anak-perusahaan/' + this.id_logo, form).then(function (result) {
        if (result.data.code === 200) {
          _this2.$router.replace('/main/anak-perusahaan');
          _this2.$toastr.s('Ubah data berhasil');
        }
      }).catch(function (ex) {
        _this2.$toastr.e('Terjadi kesalahan pada server, mohon ulangi');
      });
    },
    getDetail: function getDetail() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].get('/anak-perusahaan/' + this.id_logo).then(function (result) {
        _this3.data = result.data;
      }).catch(function (ex) {
        _this3.$toastr.e('Terjadi kesalahan pada server, mohon ulangi');
      });
    },
    handleFile: function handleFile(file) {
      this.file = file.target.files[0];
    }
  },
  mounted: function mounted() {
    this.id_logo = this.$route.params.id;
    if (this.id_logo != null) {
      this.getDetail();
    }
  }
});

/***/ }),

/***/ "ODd4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListCategoryFaq_vue__ = __webpack_require__("+OgC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71ff62a0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListCategoryFaq_vue__ = __webpack_require__("50bq");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListCategoryFaq_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71ff62a0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListCategoryFaq_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OQPl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListSurvey_vue__ = __webpack_require__("0esc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09f79590_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListSurvey_vue__ = __webpack_require__("iH7I");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListSurvey_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09f79590_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListSurvey_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Oidq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"block-header"},[_c('h2',[_vm._v(_vm._s(_vm.name))])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            Ubah "+_vm._s(_vm.name)+"\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_c('div',{staticClass:"row clearfix"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('Ckeditor',{attrs:{"id":"deskripsi","config":_vm.config},model:{value:(_vm.data.deskripsi),callback:function ($$v) {_vm.$set(_vm.data, "deskripsi", $$v)},expression:"data.deskripsi"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary",attrs:{"disabled":_vm.isLoading,"type":"submit"}},[(!_vm.isLoading)?_c('span',[_c('i',{staticClass:"material-icons"},[_vm._v("save")]),_vm._v(" Kirim")]):_c('span',[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" Loading")])]),_vm._v(" "),_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-danger",attrs:{"disabled":_vm.isLoading,"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")]),_vm._v(" Batal")])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"deskripsi"}},[_vm._v("Deskripsi")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OngF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            "+_vm._s(_vm.id_slider != null ? 'Edit' : 'Tambah')+" Slider\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_c('div',{staticClass:"row clearfix"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[(_vm.data.file != null)?_c('img',{attrs:{"src":_vm.data.file,"width":"150px","alt":"Foto"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"id":"icon","type":"file","name":"icon"},on:{"change":function($event){return _vm.handleFile($event)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"text1","type":"text"},model:{value:(_vm.data.text1),callback:function ($$v) {_vm.$set(_vm.data, "text1", $$v)},expression:"data.text1"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"text2","type":"text"},model:{value:(_vm.data.text2),callback:function ($$v) {_vm.$set(_vm.data, "text2", $$v)},expression:"data.text2"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[(_vm.id_slider != null)?_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-warning waves-effect waves-button",attrs:{"disabled":_vm.isLoading,"type":"button"},on:{"click":_vm.update}},[(!_vm.isLoading)?_c('span',[_c('i',{staticClass:"material-icons"},[_vm._v("save")]),_vm._v(" Edit")]):_c('span',[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" Loading")])]):_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect waves-button",attrs:{"disabled":_vm.isLoading,"type":"button"},on:{"click":_vm.save}},[(!_vm.isLoading)?_c('span',[_c('i',{staticClass:"material-icons"},[_vm._v("save")]),_vm._v(" Simpan")]):_c('span',[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" Loading")])]),_vm._v(" "),_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-danger waves-effect waves-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")]),_vm._v(" Batal")])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-header"},[_c('h2',[_vm._v("Slider")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"icon"}},[_vm._v("Foto")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"text1"}},[_vm._v("Text 1")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"text2"}},[_vm._v("Text 2")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Opr+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("List WhistleBlower")]),_vm._v(" "),_c('ul',{staticClass:"header-dropdown m-r--5 m-t--10"},[_c('router-link',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect",attrs:{"to":"/main/whistleblower/tambah"}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#fff"}},[_vm._v("add_box")]),_vm._v(" "),_c('span',[_vm._v("Tambah")])])],1)]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"dataTables_wrapper form-inline dt-bootstrap",attrs:{"id":"DataTables_Table_0_wrapper"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_length"},[_c('label',[_vm._v("\n                      Show\n                      "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.perPage),expression:"perPage"}],staticClass:"form-control input-sm",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.perPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("100")])]),_vm._v("\n                      entries\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_filter"},[_c('label',[_vm._v("\n                      Search:\n                      "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control input-sm",attrs:{"type":"search","placeholder":""},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])])])]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped table-hover js-basic-example dataTable"},[_vm._m(1),_vm._v(" "),_c('tbody',[(_vm.isLoading)?_c('tr',[_vm._m(2)]):_vm._e(),_vm._v(" "),(!_vm.isLoading && _vm.list.length === 0)?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"5"}},[_vm._v("Data tidak ditemukan")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(item,index){return _c('tr',{key:item.id},[_c('td',[_vm._v(_vm._s(index + 1 + ((_vm.currentPage - 1) * _vm.perPage)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.namaPelapor || '-'))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.email))]),_vm._v(" "),_c('td',[(item.pelakuList && item.pelakuList.length > 0)?_c('ul',_vm._l((item.pelakuList),function(pelaku){return _c('li',{key:pelaku.id},[_vm._v("\n                          "+_vm._s(pelaku.namaPelaku)+" - "+_vm._s(pelaku.subjekPelakuPelanggaran)+"\n                        ")])}),0):_c('span',[_vm._v("-")])]),_vm._v(" "),_c('td',[(item.pelakuList && item.pelakuList.length > 0)?_c('ul',_vm._l((item.pelakuList),function(pelaku){return _c('li',{key:pelaku.id},[_vm._v("\n                          "+_vm._s(pelaku.jenisPelanggaran)+"\n                        ")])}),0):_c('span',[_vm._v("-")])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn bg-green waves-effect",staticStyle:{"padding":"4px 8px"},on:{"click":function($event){return _vm.$router.push('/main/whistleblower/edit/' + item.id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("create")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger waves-effect",staticStyle:{"padding":"4px 8px"},on:{"click":function($event){return _vm.confirmDelete(item.id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")])])])])})],2)]),_vm._v(" "),_c('pagination',{attrs:{"total-rows":_vm.result.totalElements,"per-page":_vm.result.size},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-header"},[_c('h2',[_vm._v("WhistleBlower")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("No.")]),_vm._v(" "),_c('th',[_vm._v("Nama Pelapor")]),_vm._v(" "),_c('th',[_vm._v("Email")]),_vm._v(" "),_c('th',[_vm._v("Pelaku")]),_vm._v(" "),_c('th',[_vm._v("Jenis Pelangaran")]),_vm._v(" "),_c('th',[_vm._v("Aksi")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center",attrs:{"colspan":"5"}},[_c('i',{staticClass:"fa fa-spin fa-spinner"}),_vm._v(" Loading data...")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "P5iR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notifikasi_vue__ = __webpack_require__("4Tob");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dcdd374_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notifikasi_vue__ = __webpack_require__("h4SG");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notifikasi_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dcdd374_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notifikasi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PM1V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_ckeditor2__ = __webpack_require__("42+j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FormLine_vue__ = __webpack_require__("w3AW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_api__ = __webpack_require__("+Btm");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_1__components_FormLine_vue__["a" /* default */], Ckeditor: __WEBPACK_IMPORTED_MODULE_0_vue_ckeditor2__["a" /* default */] },
  name: 'FormFaq',
  data: function data() {
    return {
      config: {
        toolbar: [{ name: 'stuff', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] }, { name: 'morestuff', items: ['NumberedList', 'BulletedList'] }, { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Superscript', 'Subscript'] }, { name: 'colors', items: ['TextColor'] }, { name: 'paragraph2', items: ['JustifyLeft', 'JustiftyCenter', 'JustifyRight', 'Outdent', 'Indent'] }, '/', { name: 'document', items: ['Source'] }],
        height: 300
      },
      data: {
        kategori: '',
        pertanyaan: '',
        jawaban: ''
      },
      categories: '',
      gambar: '',
      id_faq: '',
      isLoading: false
    };
  },
  methods: {
    save: function save() {
      var _this = this;

      this.isLoading = true;
      var payload = {
        pertanyaan: this.data.pertanyaan,
        jawaban: this.data.jawaban,
        faqCategoryId: this.data.kategori
      };
      console.log(payload);
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].post('/saveFaq', payload).then(function (result) {
        if (result.data.code === 200) {
          _this.$router.replace('/main/faq');
          _this.$toastr.s('Tambah data berhasil');
        } else {
          var msg = 'Tambah data gagal';
          if (result.data.message !== '') msg = result.data.message;
          _this.$toastr.e(msg);
        }
        _this.isLoading = false;
      }).catch(function (e) {
        var msg = 'Terjadi kesalahan pada server, mohon ulangi';
        if (e.response.data.message) msg = e.response.data.message;
        _this.$toastr.e(msg);
        _this.isLoading = false;
      });
    },
    update: function update() {
      var _this2 = this;

      var payload = {
        idFaq: this.id_faq,
        pertanyaan: this.data.pertanyaan,
        jawaban: this.data.jawaban,
        faqCategoryId: this.data.kategori
      };
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].post('/updateFaq/' + this.id_faq, payload).then(function (result) {
        if (result.status === 200) {
          _this2.$router.replace('/main/faq');
          _this2.$toastr.s('Ubah data berhasil');
        }
      }).catch(function (ex) {
        _this2.$toastr.e('Terjadi kesalahan pada server, mohon ulangi');
      });
    },
    getDetail: function getDetail() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].get('/faq/' + this.id_faq).then(function (result) {
        var res = result.data;

        _this3.data = {
          kategori: res.faqCategory.id,
          pertanyaan: res.pertanyaan,
          jawaban: res.jawaban
        };
      }).catch(function (ex) {
        _this3.$toastr.e('Terjadi kesalahan pada server, mohon ulangi');
      });
    },
    getCategories: function getCategories() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].get('/getALLFaqCategory').then(function (res) {
        _this4.categories = res.data.content;
        console.log("ini categories", _this4.categories);
      }).catch(function (err) {
        _this4.$toastr.e('Gagal mengambil data kategori');
        console.error(err);
      });
    },
    handleFile: function handleFile(file) {
      this.file = file.target.files[0];
    }
  },
  mounted: function mounted() {
    this.id_faq = this.$route.params.id;
    this.getCategories();

    if (this.id_faq != null) {
      this.getDetail();
    }
  }
});

/***/ }),

/***/ "PXrT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            List FAQ\n                        ")]),_vm._v(" "),_c('ul',{staticClass:"header-dropdown m-r--5 m-t--10"},[_c('router-link',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect waves-button",attrs:{"to":'/main/faq/tambah',"type":"button"}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#fff"}},[_vm._v("add_box")]),_vm._v(" "),_c('span',[_vm._v("Tambah")])])],1)]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"dataTables_wrapper form-inline dt-bootstrap",attrs:{"id":"DataTables_Table_0_wrapper"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_length",attrs:{"id":"DataTables_Table_0_length"}},[_c('label',[_vm._v("Show "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.perPage),expression:"perPage"}],staticClass:"form-control input-sm",attrs:{"name":"DataTables_Table_0_length","aria-controls":"DataTables_Table_0"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.perPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_c('option',{attrs:{"value":"100"}},[_vm._v("100")])]),_vm._v(" entries")])])]),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_filter",attrs:{"id":"DataTables_Table_0_filter"}},[_c('label',[_vm._v("Search:"),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control input-sm",attrs:{"type":"search","placeholder":"","aria-controls":"DataTables_Table_0"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])])])]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped table-hover js-basic-example dataTable"},[_vm._m(1),_vm._v(" "),_c('tbody',[(_vm.isLoading)?_c('tr',[_vm._m(2)]):_vm._e(),_vm._v(" "),(_vm.list == '')?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"5"}},[_vm._v("Data tidak ditemukan")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(item,index){return (!_vm.isLoading)?_c('tr',[_c('td',[_vm._v(_vm._s(++index + ((_vm.currentPage-1)*_vm.perPage)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.faqCategory ? item.faqCategory.category : '-'))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.pertanyaan))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.stripTags(item.jawaban)))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn bg-green waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.push('/main/faq/edit/' + item.id_faq)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("create")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmDelete(item.id_faq)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")])]),_vm._v(" "),(index != 1)?_c('button',{staticClass:"btn btn-primary waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.moveUp(index)}}},[_c('i',{staticClass:"fa fa-chevron-up"})]):_vm._e(),_vm._v(" "),(index !== (_vm.list.length))?_c('button',{staticClass:"btn btn-primary waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.moveDown(index)}}},[_c('i',{staticClass:"fa fa-chevron-down"})]):_vm._e()])]):_vm._e()})],2)])]),_vm._v(" "),_c('pagination',{attrs:{"total-rows":_vm.result.totalElements,"per-page":_vm.result.size},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-header"},[_c('h2',[_vm._v("FAQ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("No.")]),_vm._v(" "),_c('th',[_vm._v("Kategori")]),_vm._v(" "),_c('th',[_vm._v("Pertanyaan")]),_vm._v(" "),_c('th',[_vm._v("Jawaban")]),_vm._v(" "),_c('th',[_vm._v("Aksi")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center",attrs:{"colspan":"5"}},[_c('i',{staticClass:"fa fa-spin fa-spinner"}),_vm._v(" Loading data...")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Q/+l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit.apply(null, arguments)}}},[_c('div',{staticClass:"col-12"},[_c('vue-dropzone',{ref:"myVueDropzone",attrs:{"id":"dropzone","options":_vm.dropzoneOptions},on:{"vdropzone-error":_vm.failed,"vdropzone-success":_vm.vsuccess}})],1)])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-header"},[_c('h2',[_vm._v("Tambah Anggota")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            Import Data Anggota\n                        ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Q0Mv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            List Identitas Pemotong\n                        ")]),_vm._v(" "),_c('ul',{staticClass:"header-dropdown m-r--5 m-t--10"},[_c('router-link',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect waves-button",attrs:{"to":'/main/layanan/atur-ip/tambah',"type":"button"}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#fff"}},[_vm._v("add_box")]),_vm._v(" "),_c('span',[_vm._v("Tambah")])])],1)]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"dataTables_wrapper form-inline dt-bootstrap",attrs:{"id":"DataTables_Table_0_wrapper"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_length",attrs:{"id":"DataTables_Table_0_length"}},[_c('label',[_vm._v("Show "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.perPage),expression:"perPage"}],staticClass:"form-control input-sm",attrs:{"name":"DataTables_Table_0_length","aria-controls":"DataTables_Table_0"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.perPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_c('option',{attrs:{"value":"100"}},[_vm._v("100")])]),_vm._v(" entries")])])]),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_filter",attrs:{"id":"DataTables_Table_0_filter"}},[_c('label',[_vm._v("Search:"),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control input-sm",attrs:{"type":"search","placeholder":"","aria-controls":"DataTables_Table_0"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])])])]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped table-hover js-basic-example dataTable"},[_vm._m(1),_vm._v(" "),_c('tbody',[(_vm.isLoading)?_c('tr',[_vm._m(2)]):_vm._e(),_vm._v(" "),(_vm.list == '')?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"7"}},[_vm._v("Data tidak ditemukan")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(item,index){return (!_vm.isLoading)?_c('tr',[_c('td',[_vm._v(_vm._s(++index + ((_vm.currentPage-1)*_vm.perPage)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.tahun))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.npwp))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.nama))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.npwpPemotong))]),_vm._v(" "),_c('td',[_c('img',{attrs:{"src":item.gambar,"alt":"","width":"100px"}})]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn bg-green waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.push('/main/layanan/atur-ip/edit/' + item.idPemotong)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("create")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmDelete(item.idPemotong)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")])])])]):_vm._e()})],2)])]),_vm._v(" "),_c('pagination',{attrs:{"total-rows":_vm.result.totalElements,"per-page":_vm.result.size},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-header"},[_c('h2',[_vm._v("Identitas Pemotong")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("No.")]),_vm._v(" "),_c('th',[_vm._v("Tahun")]),_vm._v(" "),_c('th',[_vm._v("NPWP")]),_vm._v(" "),_c('th',[_vm._v("Nama")]),_vm._v(" "),_c('th',[_vm._v("NPWP Pemotong")]),_vm._v(" "),_c('th',[_vm._v("Gambar")]),_vm._v(" "),_c('th',[_vm._v("Aksi")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center",attrs:{"colspan":"7"}},[_c('i',{staticClass:"fa fa-spin fa-spinner"}),_vm._v(" Loading data...")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Q8/M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FormLine_vue__ = __webpack_require__("w3AW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_api__ = __webpack_require__("+Btm");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_0__components_FormLine_vue__["a" /* default */] },
  name: 'Login',
  data: function data() {
    return {
      login: {
        email: '',
        password: '',
        repassword: '',
        token: ''
      },
      isLoading: false
    };
  },
  mounted: function mounted() {
    this.login.token = this.$route.params.token;
  },

  methods: {
    doReset: function doReset() {
      var _this = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].post('/reset-password-admin', this.login).then(function (result) {
        _this.$swal('Perhatian', 'Reset Password Berhasil.', 'success').then(function () {
          _this.$router.replace('/');
          location.reload();
          _this.isLoading = false;
        });
      }).catch(function (e) {
        if (e.response != null) _this.$swal('Perhatian', e.response.data.message, 'error');else _this.$swal('Perhatian', 'Terjadi kesalahan pada server, mohon merefresh halaman.', 'error');
        _this.isLoading = false;
      });
    }
  }
});

/***/ }),

/***/ "QVsv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_api__ = __webpack_require__("+Btm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FormLine_vue__ = __webpack_require__("w3AW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_3__components_FormLine_vue__["a" /* default */] },
  name: 'ListVisiMisi',
  data: function data() {
    return {
      result: {},
      list: [],
      currentPage: 1,
      perPage: 10,
      search: '',
      modal: null,
      isLoading: true,
      link: '',
      tipe: '',
      nama: ''
    };
  },
  methods: {
    moveUp: function moveUp(index) {
      var a = this.list[index - 1];
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(this.list, index - 1, this.list[index - 2]);
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(this.list, index - 2, a);

      this.saveUrutan();
    },
    moveDown: function moveDown(index) {
      var a = this.list[index - 1];
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(this.list, index - 1, this.list[index]);
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(this.list, index, a);

      this.saveUrutan();
    },
    saveUrutan: function saveUrutan() {
      var _this = this;

      var data = [];
      for (var i = 0; i < this.list.length; i++) {
        data.push({
          'id': this.list[i].id_majalah,
          'urutan': i,
          'tipe': this.tipe
        });
      }

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].post('/majalah/move', data).then(function (result) {
        _this.$toastr.s('Urutan berhasil diubah.');
      }).catch(function (ex) {
        _this.$toastr.e('Gagal mengubah urutan, terjadi kesalahan pada server.');
      });
    },
    getData: function getData() {
      var _this2 = this;

      var params = [];
      params.search = this.search;
      params.page = this.currentPage - 1;
      params.size = this.perPage;

      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].get('/' + this.link + '?' + __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(params)).then(function (result) {
        _this2.result = result.data;
        _this2.list = result.data.content;
        _this2.isLoading = false;
      }).catch(function (ex) {
        _this2.isLoading = false;
      });
    },
    confirmDelete: function confirmDelete(id) {
      var _this3 = this;

      this.$swal({
        title: 'Konfirmasi',
        text: 'Anda yakin ingin menghapus data ini?',
        icon: 'warning',
        buttons: [true, {
          text: 'Ok',
          closeModal: false
        }],
        dangerMode: true
      }).then(function (result) {
        if (result) _this3.delete(id);
      });
    },
    delete: function _delete(id) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].delete('/' + this.link + '/' + id).then(function (result) {
        if (result.data.code === 200) _this4.$toastr.s('Data berhasil dihapus.');else _this4.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this4.$swal.close();
        _this4.getData();
      }).catch(function (e) {
        _this4.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this4.$swal.close();
      });
    },
    checkRoute: function checkRoute(route) {
      this.list = [];
      if (route.name === 'ListMajalah') {
        this.link = 'majalah';
        this.nama = 'Majalah';
      }
    }
  },
  mounted: function mounted() {
    this.checkRoute(this.$route);
    this.getData();
  },
  watch: {
    currentPage: function currentPage(e) {
      this.getData();
    },
    perPage: function perPage(e) {
      this.getData();
    },
    search: function search(e) {
      this.getData();
    },
    '$route': function $route(to, from) {
      this.checkRoute(to);
      this.getData();
    }
  }
});

/***/ }),

/***/ "Qn4I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_api__ = __webpack_require__("+Btm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__ = __webpack_require__("w3AW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__["a" /* default */] },
  name: 'ListAnakPerusahaan',
  data: function data() {
    return {
      result: {},
      list: [],
      currentPage: 1,
      perPage: 10,
      search: '',
      modal: null,
      isLoading: true,
      link: '',
      tipe: '',
      nama: '',
      description: '',
      name: ''

    };
  },
  methods: {
    moveUp: function moveUp(index) {
      var a = this.list[index - 1];
      __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].set(this.list, index - 1, this.list[index - 2]);
      __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].set(this.list, index - 2, a);

      this.saveUrutan();
    },
    moveDown: function moveDown(index) {
      var a = this.list[index - 1];
      __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].set(this.list, index - 1, this.list[index]);
      __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].set(this.list, index, a);

      this.saveUrutan();
    },
    saveUrutan: function saveUrutan() {
      var _this = this;

      var data = [];
      for (var i = 0; i < this.list.length; i++) {
        data.push({
          'id': this.list[i].id_logo,
          'urutan': i,
          'tipe': this.tipe
        });
      }

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].post('/anak_perusahaan/move', data).then(function (result) {
        _this.$toastr.s('Urutan berhasil diubah.');
      }).catch(function (ex) {
        _this.$toastr.e('Gagal mengubah urutan, terjadi kesalahan pada server.');
      });
    },
    getData: function getData() {
      var _this2 = this;

      var params = [];
      params.search = this.search;
      params.page = this.currentPage - 1;
      params.size = this.perPage;

      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].get('/anak-perusahaan?' + __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(params)).then(function (result) {
        _this2.result = result.data;
        _this2.list = result.data.content;
        _this2.isLoading = false;
      }).catch(function (ex) {
        _this2.isLoading = false;
      });
    },
    confirmDelete: function confirmDelete(id) {
      var _this3 = this;

      this.$swal({
        title: 'Konfirmasi',
        text: 'Anda yakin ingin menghapus data ini?',
        icon: 'warning',
        buttons: [true, {
          text: 'Ok',
          closeModal: false
        }],
        dangerMode: true
      }).then(function (result) {
        if (result) _this3.delete(id);
      });
    },
    delete: function _delete(id) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].delete('/anak-perusahaan/' + id).then(function (result) {
        if (result.data.code === 200) _this4.$toastr.s('Data berhasil dihapus.');else _this4.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this4.$swal.close();
        _this4.getData();
      }).catch(function (e) {
        _this4.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this4.$swal.close();
      });
    }
  },
  mounted: function mounted() {
    this.getData();
  },
  watch: {
    currentPage: function currentPage(e) {
      this.getData();
    },
    perPage: function perPage(e) {
      this.getData();
    },
    search: function search(e) {
      this.getData();
    }
  }
});

/***/ }),

/***/ "RDUd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_c('div',{staticClass:"row clearfix"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"type":"text","id":"nama","placeholder":"Masukkan Nama Narasumber"},model:{value:(_vm.data.nama),callback:function ($$v) {_vm.$set(_vm.data, "nama", $$v)},expression:"data.nama"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"type":"text","id":"singkatan","placeholder":"Masukkan Singkatan"},model:{value:(_vm.data.singkatan),callback:function ($$v) {_vm.$set(_vm.data, "singkatan", $$v)},expression:"data.singkatan"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[(_vm.id_narasumber != null)?_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-warning waves-effect waves-button",attrs:{"disabled":_vm.isLoading,"type":"button"},on:{"click":_vm.update}},[(!_vm.isLoading)?_c('span',[_c('i',{staticClass:"material-icons"},[_vm._v("save")]),_vm._v(" Edit")]):_c('span',[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" Loading")])]):_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect waves-button",attrs:{"disabled":_vm.isLoading,"type":"button"},on:{"click":_vm.save}},[(!_vm.isLoading)?_c('span',[_c('i',{staticClass:"material-icons"},[_vm._v("save")]),_vm._v(" Simpan")]):_c('span',[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" Loading")])]),_vm._v(" "),_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")]),_vm._v(" Batal")])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-header"},[_c('h2',[_vm._v("NARASUMBER")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            Tambah Narasumber\n                        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"nama"}},[_vm._v("Nama Narasumber")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"singkatan"}},[_vm._v("Singkatan")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RXyA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            List Anak Perusahaan\n                        ")]),_vm._v(" "),_c('ul',{staticClass:"header-dropdown m-r--5 m-t--10"},[_c('router-link',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect",attrs:{"to":'/main/anak-perusahaan/tambah',"type":"button"}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#fff"}},[_vm._v("add_box")]),_vm._v(" "),_c('span',[_vm._v("Tambah")])])],1)]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"dataTables_wrapper form-inline dt-bootstrap",attrs:{"id":"DataTables_Table_0_wrapper"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_length",attrs:{"id":"DataTables_Table_0_length"}},[_c('label',[_vm._v("Show "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.perPage),expression:"perPage"}],staticClass:"form-control input-sm",attrs:{"name":"DataTables_Table_0_length","aria-controls":"DataTables_Table_0"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.perPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_c('option',{attrs:{"value":"100"}},[_vm._v("100")])]),_vm._v(" entries")])])]),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_filter",attrs:{"id":"DataTables_Table_0_filter"}},[_c('label',[_vm._v("Search:"),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control input-sm",attrs:{"type":"search","placeholder":"","aria-controls":"DataTables_Table_0"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])])])]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped table-hover js-basic-example dataTable"},[_vm._m(1),_vm._v(" "),_c('tbody',[(_vm.isLoading)?_c('tr',[_vm._m(2)]):_vm._e(),_vm._v(" "),(_vm.list == '')?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"5"}},[_vm._v("Data tidak ditemukan")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(item,index){return (!_vm.isLoading)?_c('tr',[_c('td',[_vm._v(_vm._s(++index + ((_vm.currentPage-1)*_vm.perPage)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.tipe == 2 ? 'Anak Perusahaan' : 'Company Link'))]),_vm._v(" "),_c('td',[_c('img',{attrs:{"src":item.gambar,"width":"100px"}})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.description))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.link))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn bg-green waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.push('/main/anak-perusahaan/edit/' + item.id_logo)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("create")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmDelete(item.id_logo)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")])]),_vm._v(" "),(index != 1)?_c('button',{staticClass:"btn btn-primary waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.moveUp(index)}}},[_c('i',{staticClass:"fa fa-chevron-up"})]):_vm._e(),_vm._v(" "),(index !== (_vm.list.length))?_c('button',{staticClass:"btn btn-primary waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.moveDown(index)}}},[_c('i',{staticClass:"fa fa-chevron-down"})]):_vm._e()])]):_vm._e()})],2)])]),_vm._v(" "),_c('pagination',{attrs:{"total-rows":_vm.result.totalElements,"per-page":_vm.result.size},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-header"},[_c('h2',[_vm._v("Anak Perusahaan")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("No.")]),_vm._v(" "),_c('th',[_vm._v("Tipe")]),_vm._v(" "),_c('th',[_vm._v("Gambar")]),_vm._v(" "),_c('th',[_vm._v("Name")]),_vm._v(" "),_c('th',[_vm._v("Description")]),_vm._v(" "),_c('th',[_vm._v("Link")]),_vm._v(" "),_c('th',[_vm._v("Aksi")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center",attrs:{"colspan":"5"}},[_c('i',{staticClass:"fa fa-spin fa-spinner"}),_vm._v(" Loading data...")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RePM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__("UlOv");


/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Pie */],
  props: ['data', 'options'],
  mounted: function mounted() {
    this.renderChart(this.data, this.options);
  }
});

/***/ }),

/***/ "Ro5n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_api__ = __webpack_require__("+Btm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FormLine_vue__ = __webpack_require__("w3AW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_3__components_FormLine_vue__["a" /* default */] },
  name: 'ListVisiMisi',
  data: function data() {
    return {
      result: {},
      list: [],
      currentPage: 1,
      perPage: 10,
      search: '',
      modal: null,
      isLoading: true,
      link: '',
      nama: '',
      tipe: ''
    };
  },
  methods: {
    moveUp: function moveUp(index) {
      var a = this.list[index - 1];
      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(this.list, index - 1, this.list[index - 2]);
      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(this.list, index - 2, a);

      this.saveUrutan();
    },
    moveDown: function moveDown(index) {
      var a = this.list[index - 1];
      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(this.list, index - 1, this.list[index]);
      __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(this.list, index, a);

      this.saveUrutan();
    },
    saveUrutan: function saveUrutan() {
      var _this = this;

      var data = [];
      for (var i = 0; i < this.list.length; i++) {
        data.push({
          'id': this.list[i].id_unduh,
          'urutan': i
        });
      }

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].post('/unduh/move', data).then(function (result) {
        _this.$toastr.s('Urutan berhasil diubah.');
      }).catch(function (ex) {
        _this.$toastr.e('Gagal mengubah urutan, terjadi kesalahan pada server.');
      });
    },
    getData: function getData() {
      var _this2 = this;

      var params = [];
      params.search = this.search;
      params.page = this.currentPage - 1;
      params.size = this.perPage;
      params.tipe = this.tipe;

      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].get('/unduh?' + __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(params)).then(function (result) {
        _this2.result = result.data;
        _this2.list = result.data.content;
        _this2.isLoading = false;
      }).catch(function (ex) {
        _this2.isLoading = false;
      });
    },
    confirmDelete: function confirmDelete(id) {
      var _this3 = this;

      this.$swal({
        title: 'Konfirmasi',
        text: 'Anda yakin ingin menghapus data ini?',
        icon: 'warning',
        buttons: [true, {
          text: 'Ok',
          closeModal: false
        }],
        dangerMode: true
      }).then(function (result) {
        if (result) _this3.delete(id);
      });
    },
    delete: function _delete(id) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].delete('/unduh/' + id).then(function (result) {
        if (result.data.code === 200) _this4.$toastr.s('Data berhasil dihapus.');else _this4.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this4.$swal.close();
        _this4.getData();
      }).catch(function (e) {
        _this4.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this4.$swal.close();
      });
    },
    checkRoute: function checkRoute(route) {
      this.list = [];
      if (route.name === 'ListLaporan') {
        this.link = 'laporan';
        this.nama = 'Laporan';
        this.tipe = '1,2';
      }
      if (route.name === 'ListFormulir') {
        this.link = 'formulir';
        this.nama = 'Formulir';
        this.tipe = '3,4,5,6,7,8,9';
      }
    },
    tipeName: function tipeName(tipe) {
      if (tipe === 1) return 'Laporan Keuangan';
      if (tipe === 2) return 'Laporan Pengawasan';
      if (tipe === 3) return 'Formulir Kepersertaan';
      if (tipe === 4) return 'Formulir Her Registrasi';
      if (tipe === 5) return 'Formulir Pensiun Normal';
      if (tipe === 6) return 'Pensiun Dipercepat';
      if (tipe === 7) return 'Pensiun Ditunda';
      if (tipe === 8) return 'Pensiun Cacat';
      if (tipe === 9) return 'Pensiun Meninggal';
    }
  },
  mounted: function mounted() {
    this.checkRoute(this.$route);
    this.getData();
  },
  watch: {
    currentPage: function currentPage(e) {
      this.getData();
    },
    perPage: function perPage(e) {
      this.getData();
    },
    search: function search(e) {
      this.getData();
    },
    '$route': function $route(to, from) {
      this.checkRoute(to);
      this.getData();
    }
  }
});

/***/ }),

/***/ "Rrzt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormAnakPerusahaan_vue__ = __webpack_require__("NzVz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3f9da1a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormAnakPerusahaan_vue__ = __webpack_require__("i1Zw");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormAnakPerusahaan_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3f9da1a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormAnakPerusahaan_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SDXa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"block-header"},[_c('h2',[_vm._v(_vm._s(_vm.nama))])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            "+_vm._s(_vm.id_pdp_arahan != null ? 'Edit' : 'Tambah')+" "+_vm._s(_vm.nama)+"\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_c('div',{staticClass:"row clearfix"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"judul","type":"text"},model:{value:(_vm.content.judul),callback:function ($$v) {_vm.$set(_vm.content, "judul", $$v)},expression:"content.judul"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"jenisRegulasi","type":"text"},model:{value:(_vm.content.jenisRegulasi),callback:function ($$v) {_vm.$set(_vm.content, "jenisRegulasi", $$v)},expression:"content.jenisRegulasi"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"bidang","type":"text"},model:{value:(_vm.content.bidang),callback:function ($$v) {_vm.$set(_vm.content, "bidang", $$v)},expression:"content.bidang"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(3),_vm._v(" "),(_vm.content.file != null)?_c('div',{staticClass:"col-lg-2"},[_c('a',{staticClass:"btn btn-sm btn-info",attrs:{"target":"_blank","href":_vm.content.file}},[_c('i',{staticClass:"fa fa-paperclip"}),_vm._v(" File")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"id":"icon","type":"file","name":"icon"},on:{"change":function($event){return _vm.handleFile($event)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"type":"text","id":"tags","config":_vm.config},model:{value:(_vm.content.tags),callback:function ($$v) {_vm.$set(_vm.content, "tags", $$v)},expression:"content.tags"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"form-line"},[_c('flat-pickr',{staticClass:"form-control",attrs:{"id":"tglBerlaku","config":_vm.date},model:{value:(_vm.content.tglBerlaku),callback:function ($$v) {_vm.$set(_vm.content, "tglBerlaku", $$v)},expression:"content.tglBerlaku"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[(_vm.id_pdp_arahan != null)?_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-warning waves-effect waves-button",attrs:{"type":"button"},on:{"click":_vm.update}},[_c('i',{staticClass:"material-icons"},[_vm._v("save")]),_vm._v(" Edit")]):_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect waves-button",attrs:{"type":"button"},on:{"click":_vm.save}},[_c('i',{staticClass:"material-icons"},[_vm._v("save")]),_vm._v(" Simpan")]),_vm._v(" "),_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")]),_vm._v(" Batal")])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"judul"}},[_vm._v("Judul")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"jenisRegulasi"}},[_vm._v("Jenis Regulasi")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"bidang"}},[_vm._v("Bidang")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"icon"}},[_vm._v("File")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"tags"}},[_vm._v("Tags")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"tglBerlaku"}},[_vm._v("Berlaku Sampai")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SoQG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_api__ = __webpack_require__("+Btm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__ = __webpack_require__("w3AW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__["a" /* default */] },
  name: 'ListKelengkapan',
  data: function data() {
    return {
      result: {},
      list: [],
      currentPage: 1,
      perPage: 10,
      search: '',
      modal: null,
      isLoading: true,
      link: '',
      tipe: '',
      nama: ''
    };
  },
  methods: {
    getData: function getData() {
      var _this = this;

      var params = [];
      params.search = this.search;
      params.page = this.currentPage - 1;
      params.size = this.perPage;

      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].get('/kelengkapan/all?' + __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(params)).then(function (result) {
        _this.result = result.data;
        _this.list = result.data.content;
        _this.isLoading = false;
      }).catch(function (ex) {
        _this.isLoading = false;
      });
    },
    confirmDelete: function confirmDelete(id) {
      var _this2 = this;

      this.$swal({
        title: 'Konfirmasi',
        text: 'Anda yakin ingin menghapus data ini?',
        icon: 'warning',
        buttons: [true, {
          text: 'Ok',
          closeModal: false
        }],
        dangerMode: true
      }).then(function (result) {
        if (result) _this2.delete(id);
      });
    },
    delete: function _delete(id) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].delete('/kelengkapan/' + id).then(function (result) {
        if (result.data.code === 200) _this3.$toastr.s('Data berhasil dihapus.');else _this3.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this3.$swal.close();
        _this3.getData();
      }).catch(function (e) {
        _this3.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this3.$swal.close();
      });
    }
  },
  mounted: function mounted() {
    this.getData();
  },
  watch: {
    currentPage: function currentPage(e) {
      this.getData();
    },
    perPage: function perPage(e) {
      this.getData();
    },
    search: function search(e) {
      this.getData();
    }
  }
});

/***/ }),

/***/ "SvOM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListMateriKomunikasi_vue__ = __webpack_require__("Co0p");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3adc28ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListMateriKomunikasi_vue__ = __webpack_require__("pXdC");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListMateriKomunikasi_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3adc28ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListMateriKomunikasi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TRSD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListDownload_vue__ = __webpack_require__("bY2w");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d7b929a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListDownload_vue__ = __webpack_require__("+7az");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListDownload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d7b929a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListDownload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TSBr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form-horizontal"},[_c('div',{staticClass:"row clearfix"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.idNarasumber),expression:"idNarasumber"}],staticClass:"form-control",attrs:{"id":"id_narasumber"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.idNarasumber=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("[ Pilih Narasumber ]")]),_vm._v(" "),_vm._l((_vm.list_narasumber),function(option){return _c('option',{domProps:{"value":option.idNarasumber}},[_vm._v("\n                                                "+_vm._s(option.nama)+" ("+_vm._s(option.singkatan)+")\n                                            ")])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"type":"text","id":"namaLengkap","placeholder":"Masukkan Nama Lengkap"},model:{value:(_vm.namaLengkap),callback:function ($$v) {_vm.namaLengkap=$$v},expression:"namaLengkap"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"type":"email","id":"email","placeholder":"Masukkan Email"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"type":"text","id":"username","placeholder":"Masukkan Username"},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"type":"password","id":"password","placeholder":"Masukkan Password (Alfanumerik a-z A-Z 0-9)"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(7),_vm._v(" "),_c('div',{staticClass:"col-lg-10"},[_c('div',{staticClass:"col-lg-6"},[_c('div',{staticClass:"panel-group",attrs:{"role":"tablist","aria-multiselectable":"true"}},[_c('div',{staticClass:"panel-group",attrs:{"id":"accordion_1","role":"tablist","aria-multiselectable":"true"}},[_c('div',{staticClass:"panel"},[_c('div',{staticClass:"panel-heading",attrs:{"role":"tab"}},[_c('h4',{staticClass:"panel-title"},[_c('a',{attrs:{"role":"button"}},[_vm._v("\n                                                                Profile\n                                                                "),_c('div',{staticClass:"pull-right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.profileAll),expression:"profileAll"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"profile","value":"1"},domProps:{"checked":Array.isArray(_vm.profileAll)?_vm._i(_vm.profileAll,"1")>-1:(_vm.profileAll)},on:{"change":function($event){var $$a=_vm.profileAll,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.profileAll=$$a.concat([$$v]))}else{$$i>-1&&(_vm.profileAll=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.profileAll=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":"profile"}})])])])]),_vm._v(" "),_c('div',{staticClass:"panel-collapse collapse in",attrs:{"id":"collapseOne_1","role":"tabpanel","aria-labelledby":"headingOne_1"}},[_c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.akses.profile.visi_misi),expression:"akses.profile.visi_misi"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"visi_misi","value":"1"},domProps:{"checked":Array.isArray(_vm.akses.profile.visi_misi)?_vm._i(_vm.akses.profile.visi_misi,"1")>-1:(_vm.akses.profile.visi_misi)},on:{"change":function($event){var $$a=_vm.akses.profile.visi_misi,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.akses.profile, "visi_misi", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.akses.profile, "visi_misi", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.akses.profile, "visi_misi", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"visi_misi"}},[_vm._v("Visi Misi")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.akses.profile.sejarah_pendirian),expression:"akses.profile.sejarah_pendirian"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"sejarah_pendirian","value":"1"},domProps:{"checked":Array.isArray(_vm.akses.profile.sejarah_pendirian)?_vm._i(_vm.akses.profile.sejarah_pendirian,"1")>-1:(_vm.akses.profile.sejarah_pendirian)},on:{"change":function($event){var $$a=_vm.akses.profile.sejarah_pendirian,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.akses.profile, "sejarah_pendirian", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.akses.profile, "sejarah_pendirian", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.akses.profile, "sejarah_pendirian", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"sejarah_pendirian"}},[_vm._v("Sejarah Pendirian")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.akses.profile.pendiri),expression:"akses.profile.pendiri"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"pendiri","value":"1"},domProps:{"checked":Array.isArray(_vm.akses.profile.pendiri)?_vm._i(_vm.akses.profile.pendiri,"1")>-1:(_vm.akses.profile.pendiri)},on:{"change":function($event){var $$a=_vm.akses.profile.pendiri,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.akses.profile, "pendiri", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.akses.profile, "pendiri", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.akses.profile, "pendiri", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"pendiri"}},[_vm._v("Pendiri")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.akses.profile.dewan_pengawas),expression:"akses.profile.dewan_pengawas"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"dewan_pengawas","value":"1"},domProps:{"checked":Array.isArray(_vm.akses.profile.dewan_pengawas)?_vm._i(_vm.akses.profile.dewan_pengawas,"1")>-1:(_vm.akses.profile.dewan_pengawas)},on:{"change":function($event){var $$a=_vm.akses.profile.dewan_pengawas,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.akses.profile, "dewan_pengawas", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.akses.profile, "dewan_pengawas", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.akses.profile, "dewan_pengawas", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"dewan_pengawas"}},[_vm._v("Dewan Pengawas")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.akses.profile.pengurus),expression:"akses.profile.pengurus"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"pengurus","value":"1"},domProps:{"checked":Array.isArray(_vm.akses.profile.pengurus)?_vm._i(_vm.akses.profile.pengurus,"1")>-1:(_vm.akses.profile.pengurus)},on:{"change":function($event){var $$a=_vm.akses.profile.pengurus,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.akses.profile, "pengurus", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.akses.profile, "pengurus", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.akses.profile, "pengurus", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"pengurus"}},[_vm._v("Pengurus")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.akses.profile.struktur_organisasi),expression:"akses.profile.struktur_organisasi"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"struktur_organisasi","value":"1"},domProps:{"checked":Array.isArray(_vm.akses.profile.struktur_organisasi)?_vm._i(_vm.akses.profile.struktur_organisasi,"1")>-1:(_vm.akses.profile.struktur_organisasi)},on:{"change":function($event){var $$a=_vm.akses.profile.struktur_organisasi,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.akses.profile, "struktur_organisasi", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.akses.profile, "struktur_organisasi", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.akses.profile, "struktur_organisasi", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"struktur_organisasi"}},[_vm._v("Struktur Organisasi")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.akses.profile.budaya_kerja),expression:"akses.profile.budaya_kerja"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"budaya_kerja","value":"1"},domProps:{"checked":Array.isArray(_vm.akses.profile.budaya_kerja)?_vm._i(_vm.akses.profile.budaya_kerja,"1")>-1:(_vm.akses.profile.budaya_kerja)},on:{"change":function($event){var $$a=_vm.akses.profile.budaya_kerja,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.akses.profile, "budaya_kerja", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.akses.profile, "budaya_kerja", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.akses.profile, "budaya_kerja", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"budaya_kerja"}},[_vm._v("Budaya Kerja")])])])])]),_vm._v(" "),_c('div',{staticClass:"panel"},[_c('div',{staticClass:"panel-heading",attrs:{"role":"tab","id":"headingOne_1"}},[_c('h4',{staticClass:"panel-title"},[_c('a',{attrs:{"role":"button","data-toggle":"collapse"}},[_vm._v("\n                                                                Layanan\n                                                                "),_c('div',{staticClass:"pull-right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.layananAll),expression:"layananAll"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"layanan","value":"1"},domProps:{"checked":Array.isArray(_vm.layananAll)?_vm._i(_vm.layananAll,"1")>-1:(_vm.layananAll)},on:{"change":function($event){var $$a=_vm.layananAll,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.layananAll=$$a.concat([$$v]))}else{$$i>-1&&(_vm.layananAll=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.layananAll=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":"layanan"}})])])])]),_vm._v(" "),_c('div',{staticClass:"panel-collapse collapse in"},[_c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.akses.layanan.cetak_mp),expression:"akses.layanan.cetak_mp"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"cetak-mp","value":"1"},domProps:{"checked":Array.isArray(_vm.akses.layanan.cetak_mp)?_vm._i(_vm.akses.layanan.cetak_mp,"1")>-1:(_vm.akses.layanan.cetak_mp)},on:{"change":function($event){var $$a=_vm.akses.layanan.cetak_mp,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.akses.layanan, "cetak_mp", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.akses.layanan, "cetak_mp", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.akses.layanan, "cetak_mp", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"cetak-mp"}},[_vm._v("Cetak StrukMP/Pph21")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.akses.layanan.cetak_up),expression:"akses.layanan.cetak_up"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"cetak-up","value":"1"},domProps:{"checked":Array.isArray(_vm.akses.layanan.cetak_up)?_vm._i(_vm.akses.layanan.cetak_up,"1")>-1:(_vm.akses.layanan.cetak_up)},on:{"change":function($event){var $$a=_vm.akses.layanan.cetak_up,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.akses.layanan, "cetak_up", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.akses.layanan, "cetak_up", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.akses.layanan, "cetak_up", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"cetak-up"}},[_vm._v("Cetak Struk Uang Pembinaan")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.akses.layanan.cetak_rapel),expression:"akses.layanan.cetak_rapel"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"cetak-rapel","value":"1"},domProps:{"checked":Array.isArray(_vm.akses.layanan.cetak_rapel)?_vm._i(_vm.akses.layanan.cetak_rapel,"1")>-1:(_vm.akses.layanan.cetak_rapel)},on:{"change":function($event){var $$a=_vm.akses.layanan.cetak_rapel,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.akses.layanan, "cetak_rapel", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.akses.layanan, "cetak_rapel", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.akses.layanan, "cetak_rapel", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"cetak-rapel"}},[_vm._v("Cetak Struk Rapel Kenaikan")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.akses.layanan.cetak_spt),expression:"akses.layanan.cetak_spt"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"cetak-spt","value":"1"},domProps:{"checked":Array.isArray(_vm.akses.layanan.cetak_spt)?_vm._i(_vm.akses.layanan.cetak_spt,"1")>-1:(_vm.akses.layanan.cetak_spt)},on:{"change":function($event){var $$a=_vm.akses.layanan.cetak_spt,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.akses.layanan, "cetak_spt", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.akses.layanan, "cetak_spt", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.akses.layanan, "cetak_spt", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"cetak-spt"}},[_vm._v("Cetak SPT")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.akses.layanan.atur_ip),expression:"akses.layanan.atur_ip"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"identitas-pemotong","value":"1"},domProps:{"checked":Array.isArray(_vm.akses.layanan.atur_ip)?_vm._i(_vm.akses.layanan.atur_ip,"1")>-1:(_vm.akses.layanan.atur_ip)},on:{"change":function($event){var $$a=_vm.akses.layanan.atur_ip,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.akses.layanan, "atur_ip", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.akses.layanan, "atur_ip", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.akses.layanan, "atur_ip", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"identitas-pemotong"}},[_vm._v("Atur Identitas Pemotong")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.akses.layanan.survey),expression:"akses.layanan.survey"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"survey","value":"1"},domProps:{"checked":Array.isArray(_vm.akses.layanan.survey)?_vm._i(_vm.akses.layanan.survey,"1")>-1:(_vm.akses.layanan.survey)},on:{"change":function($event){var $$a=_vm.akses.layanan.survey,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.akses.layanan, "survey", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.akses.layanan, "survey", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.akses.layanan, "survey", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"survey"}},[_vm._v("Survey Pelayanan Pensiun")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.akses.layanan.hasil_survey),expression:"akses.layanan.hasil_survey"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"hasil-survey","value":"1"},domProps:{"checked":Array.isArray(_vm.akses.layanan.hasil_survey)?_vm._i(_vm.akses.layanan.hasil_survey,"1")>-1:(_vm.akses.layanan.hasil_survey)},on:{"change":function($event){var $$a=_vm.akses.layanan.hasil_survey,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.akses.layanan, "hasil_survey", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.akses.layanan, "hasil_survey", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.akses.layanan, "hasil_survey", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"hasil-survey"}},[_vm._v("Hasil Survey Pelayanan Pensiun")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.akses.layanan.data_kelengkapan),expression:"akses.layanan.data_kelengkapan"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"data-kelengkapan","value":"1"},domProps:{"checked":Array.isArray(_vm.akses.layanan.data_kelengkapan)?_vm._i(_vm.akses.layanan.data_kelengkapan,"1")>-1:(_vm.akses.layanan.data_kelengkapan)},on:{"change":function($event){var $$a=_vm.akses.layanan.data_kelengkapan,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.akses.layanan, "data_kelengkapan", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.akses.layanan, "data_kelengkapan", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.akses.layanan, "data_kelengkapan", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"data-kelengkapan"}},[_vm._v("Data Kelengkapan")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.akses.layanan.pengaduan),expression:"akses.layanan.pengaduan"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"data-kelengkapan","value":"1"},domProps:{"checked":Array.isArray(_vm.akses.layanan.pengaduan)?_vm._i(_vm.akses.layanan.pengaduan,"1")>-1:(_vm.akses.layanan.pengaduan)},on:{"change":function($event){var $$a=_vm.akses.layanan.pengaduan,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.akses.layanan, "pengaduan", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.akses.layanan, "pengaduan", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.akses.layanan, "pengaduan", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"data-kelengkapan"}},[_vm._v("Pengaduan")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.akses.layanan.kritik),expression:"akses.layanan.kritik"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"data-kelengkapan","value":"1"},domProps:{"checked":Array.isArray(_vm.akses.layanan.kritik)?_vm._i(_vm.akses.layanan.kritik,"1")>-1:(_vm.akses.layanan.kritik)},on:{"change":function($event){var $$a=_vm.akses.layanan.kritik,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.akses.layanan, "kritik", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.akses.layanan, "kritik", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.akses.layanan, "kritik", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"data-kelengkapan"}},[_vm._v("Kritik")])])])])]),_vm._v(" "),_c('div',{staticClass:"panel"},[_c('div',{staticClass:"panel-heading",attrs:{"role":"tab"}},[_c('h4',{staticClass:"panel-title"},[_c('a',{attrs:{"role":"button"}},[_vm._v("\n                                                                Informasi\n                                                                "),_c('div',{staticClass:"pull-right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.informasiAll),expression:"informasiAll"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"informasi","value":"1"},domProps:{"checked":Array.isArray(_vm.informasiAll)?_vm._i(_vm.informasiAll,"1")>-1:(_vm.informasiAll)},on:{"change":function($event){var $$a=_vm.informasiAll,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.informasiAll=$$a.concat([$$v]))}else{$$i>-1&&(_vm.informasiAll=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.informasiAll=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":"informasi"}})])])])]),_vm._v(" "),_c('div',{staticClass:"panel-collapse collapse in"},[_c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.akses.informasi.kegiatan),expression:"akses.informasi.kegiatan"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"kegiatan","value":"1"},domProps:{"checked":Array.isArray(_vm.akses.informasi.kegiatan)?_vm._i(_vm.akses.informasi.kegiatan,"1")>-1:(_vm.akses.informasi.kegiatan)},on:{"change":function($event){var $$a=_vm.akses.informasi.kegiatan,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.akses.informasi, "kegiatan", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.akses.informasi, "kegiatan", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.akses.informasi, "kegiatan", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"kegiatan"}},[_vm._v("Kegiatan")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.akses.informasi.artikel),expression:"akses.informasi.artikel"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"Artikel","value":"1"},domProps:{"checked":Array.isArray(_vm.akses.informasi.artikel)?_vm._i(_vm.akses.informasi.artikel,"1")>-1:(_vm.akses.informasi.artikel)},on:{"change":function($event){var $$a=_vm.akses.informasi.artikel,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.akses.informasi, "artikel", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.akses.informasi, "artikel", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.akses.informasi, "artikel", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"Artikel"}},[_vm._v("Artikel")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.akses.informasi.perkembangan),expression:"akses.informasi.perkembangan"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"perkembangan","value":"1"},domProps:{"checked":Array.isArray(_vm.akses.informasi.perkembangan)?_vm._i(_vm.akses.informasi.perkembangan,"1")>-1:(_vm.akses.informasi.perkembangan)},on:{"change":function($event){var $$a=_vm.akses.informasi.perkembangan,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.akses.informasi, "perkembangan", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.akses.informasi, "perkembangan", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.akses.informasi, "perkembangan", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"perkembangan"}},[_vm._v("Perkembangan Investasi Semesteran")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.akses.informasi.tahunan),expression:"akses.informasi.tahunan"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"tahunan","value":"1"},domProps:{"checked":Array.isArray(_vm.akses.informasi.tahunan)?_vm._i(_vm.akses.informasi.tahunan,"1")>-1:(_vm.akses.informasi.tahunan)},on:{"change":function($event){var $$a=_vm.akses.informasi.tahunan,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.akses.informasi, "tahunan", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.akses.informasi, "tahunan", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.akses.informasi, "tahunan", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"tahunan"}},[_vm._v("Laporan Keuangan")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.akses.informasi.lowongan),expression:"akses.informasi.lowongan"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"lowongan","value":"1"},domProps:{"checked":Array.isArray(_vm.akses.informasi.lowongan)?_vm._i(_vm.akses.informasi.lowongan,"1")>-1:(_vm.akses.informasi.lowongan)},on:{"change":function($event){var $$a=_vm.akses.informasi.lowongan,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.akses.informasi, "lowongan", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.akses.informasi, "lowongan", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.akses.informasi, "lowongan", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"lowongan"}},[_vm._v("Lowongan")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.akses.informasi.galeri),expression:"akses.informasi.galeri"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"galeri","value":"1"},domProps:{"checked":Array.isArray(_vm.akses.informasi.galeri)?_vm._i(_vm.akses.informasi.galeri,"1")>-1:(_vm.akses.informasi.galeri)},on:{"change":function($event){var $$a=_vm.akses.informasi.galeri,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.akses.informasi, "galeri", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.akses.informasi, "galeri", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.akses.informasi, "galeri", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"galeri"}},[_vm._v("Galeri")])])])])]),_vm._v(" "),_c('div',{staticClass:"panel"},[_c('div',{staticClass:"panel-heading",attrs:{"role":"tab"}},[_c('h4',{staticClass:"panel-title"},[_c('a',{attrs:{"role":"button"}},[_vm._v("\n                                                                Unduh\n                                                                "),_c('div',{staticClass:"pull-right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.unduhAll),expression:"unduhAll"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"unduh","value":"1"},domProps:{"checked":Array.isArray(_vm.unduhAll)?_vm._i(_vm.unduhAll,"1")>-1:(_vm.unduhAll)},on:{"change":function($event){var $$a=_vm.unduhAll,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.unduhAll=$$a.concat([$$v]))}else{$$i>-1&&(_vm.unduhAll=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.unduhAll=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":"unduh"}})])])])]),_vm._v(" "),_c('div',{staticClass:"panel-collapse collapse in"},[_c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.akses.unduh.pdp),expression:"akses.unduh.pdp"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"pdp","value":"1"},domProps:{"checked":Array.isArray(_vm.akses.unduh.pdp)?_vm._i(_vm.akses.unduh.pdp,"1")>-1:(_vm.akses.unduh.pdp)},on:{"change":function($event){var $$a=_vm.akses.unduh.pdp,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.akses.unduh, "pdp", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.akses.unduh, "pdp", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.akses.unduh, "pdp", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"pdp"}},[_vm._v("PDP")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.akses.unduh.arahan),expression:"akses.unduh.arahan"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"arahan","value":"1"},domProps:{"checked":Array.isArray(_vm.akses.unduh.arahan)?_vm._i(_vm.akses.unduh.arahan,"1")>-1:(_vm.akses.unduh.arahan)},on:{"change":function($event){var $$a=_vm.akses.unduh.arahan,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.akses.unduh, "arahan", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.akses.unduh, "arahan", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.akses.unduh, "arahan", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"arahan"}},[_vm._v("Arahan")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.akses.unduh.regulasi),expression:"akses.unduh.regulasi"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"regulasi","value":"1"},domProps:{"checked":Array.isArray(_vm.akses.unduh.regulasi)?_vm._i(_vm.akses.unduh.regulasi,"1")>-1:(_vm.akses.unduh.regulasi)},on:{"change":function($event){var $$a=_vm.akses.unduh.regulasi,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.akses.unduh, "regulasi", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.akses.unduh, "regulasi", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.akses.unduh, "regulasi", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"regulasi"}},[_vm._v("Regulasi Dana Pensiun")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.akses.unduh.majalah),expression:"akses.unduh.majalah"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"majalah","value":"1"},domProps:{"checked":Array.isArray(_vm.akses.unduh.majalah)?_vm._i(_vm.akses.unduh.majalah,"1")>-1:(_vm.akses.unduh.majalah)},on:{"change":function($event){var $$a=_vm.akses.unduh.majalah,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.akses.unduh, "majalah", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.akses.unduh, "majalah", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.akses.unduh, "majalah", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"majalah"}},[_vm._v("Majalah DAPENBI")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.akses.unduh.materikomunikasi),expression:"akses.unduh.materikomunikasi"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"materikomunikasi","value":"1"},domProps:{"checked":Array.isArray(_vm.akses.unduh.materikomunikasi)?_vm._i(_vm.akses.unduh.materikomunikasi,"1")>-1:(_vm.akses.unduh.materikomunikasi)},on:{"change":function($event){var $$a=_vm.akses.unduh.materikomunikasi,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.akses.unduh, "materikomunikasi", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.akses.unduh, "materikomunikasi", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.akses.unduh, "materikomunikasi", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"materikomunikasi"}},[_vm._v("Materi Komunikasi")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.akses.unduh.laporan),expression:"akses.unduh.laporan"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"laporan","value":"1"},domProps:{"checked":Array.isArray(_vm.akses.unduh.laporan)?_vm._i(_vm.akses.unduh.laporan,"1")>-1:(_vm.akses.unduh.laporan)},on:{"change":function($event){var $$a=_vm.akses.unduh.laporan,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.akses.unduh, "laporan", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.akses.unduh, "laporan", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.akses.unduh, "laporan", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"laporan"}},[_vm._v("Laporan")])]),_vm._v(" "),_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.akses.unduh.formulir),expression:"akses.unduh.formulir"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"formulir","value":"1"},domProps:{"checked":Array.isArray(_vm.akses.unduh.formulir)?_vm._i(_vm.akses.unduh.formulir,"1")>-1:(_vm.akses.unduh.formulir)},on:{"change":function($event){var $$a=_vm.akses.unduh.formulir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.akses.unduh, "formulir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.akses.unduh, "formulir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.akses.unduh, "formulir", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"formulir"}},[_vm._v("Formulir")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('div',{staticClass:"panel"},[_c('div',{staticClass:"panel-heading",attrs:{"role":"tab"}},[_c('h4',{staticClass:"panel-title"},[_c('a',{attrs:{"role":"button"}},[_vm._v("\n                                                        Master Narasumber\n                                                        "),_c('div',{staticClass:"pull-right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.akses.masterNarasumber),expression:"akses.masterNarasumber"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"masterNarasumber","value":"1"},domProps:{"checked":Array.isArray(_vm.akses.masterNarasumber)?_vm._i(_vm.akses.masterNarasumber,"1")>-1:(_vm.akses.masterNarasumber)},on:{"change":function($event){var $$a=_vm.akses.masterNarasumber,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.akses, "masterNarasumber", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.akses, "masterNarasumber", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.akses, "masterNarasumber", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"masterNarasumber"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"panel"},[_c('div',{staticClass:"panel-heading",attrs:{"role":"tab"}},[_c('h4',{staticClass:"panel-title"},[_c('a',{attrs:{"role":"button"}},[_vm._v("\n                                                        User Level\n                                                        "),_c('div',{staticClass:"pull-right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.akses.userLevel),expression:"akses.userLevel"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"userLevel","value":"1"},domProps:{"checked":Array.isArray(_vm.akses.userLevel)?_vm._i(_vm.akses.userLevel,"1")>-1:(_vm.akses.userLevel)},on:{"change":function($event){var $$a=_vm.akses.userLevel,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.akses, "userLevel", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.akses, "userLevel", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.akses, "userLevel", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"userLevel"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"panel"},[_c('div',{staticClass:"panel-heading",attrs:{"role":"tab"}},[_c('h4',{staticClass:"panel-title"},[_c('a',{attrs:{"role":"button"}},[_vm._v("\n                                                        Data Anggota\n                                                        "),_c('div',{staticClass:"pull-right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.akses.anggota),expression:"akses.anggota"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"anggota","value":"1"},domProps:{"checked":Array.isArray(_vm.akses.anggota)?_vm._i(_vm.akses.anggota,"1")>-1:(_vm.akses.anggota)},on:{"change":function($event){var $$a=_vm.akses.anggota,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.akses, "anggota", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.akses, "anggota", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.akses, "anggota", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"anggota"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"panel"},[_c('div',{staticClass:"panel-heading",attrs:{"role":"tab"}},[_c('h4',{staticClass:"panel-title"},[_c('a',{attrs:{"role":"button"}},[_vm._v("\n                                                        Log\n                                                        "),_c('div',{staticClass:"pull-right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.akses.log),expression:"akses.log"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"log","value":"1"},domProps:{"checked":Array.isArray(_vm.akses.log)?_vm._i(_vm.akses.log,"1")>-1:(_vm.akses.log)},on:{"change":function($event){var $$a=_vm.akses.log,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.akses, "log", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.akses, "log", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.akses, "log", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"log"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"panel"},[_c('div',{staticClass:"panel-heading",attrs:{"role":"tab"}},[_c('h4',{staticClass:"panel-title"},[_c('a',{attrs:{"role":"button"}},[_vm._v("\n                                                        FAQ\n                                                        "),_c('div',{staticClass:"pull-right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.akses.faq),expression:"akses.faq"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"faq","value":"1"},domProps:{"checked":Array.isArray(_vm.akses.faq)?_vm._i(_vm.akses.faq,"1")>-1:(_vm.akses.faq)},on:{"change":function($event){var $$a=_vm.akses.faq,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.akses, "faq", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.akses, "faq", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.akses, "faq", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"faq"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"panel"},[_c('div',{staticClass:"panel-heading",attrs:{"role":"tab"}},[_c('h4',{staticClass:"panel-title"},[_c('a',{attrs:{"role":"button"}},[_vm._v("\n                                                        Syarat Kepesertaan\n                                                        "),_c('div',{staticClass:"pull-right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.akses.syarat),expression:"akses.syarat"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"syarat","value":"1"},domProps:{"checked":Array.isArray(_vm.akses.syarat)?_vm._i(_vm.akses.syarat,"1")>-1:(_vm.akses.syarat)},on:{"change":function($event){var $$a=_vm.akses.syarat,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.akses, "syarat", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.akses, "syarat", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.akses, "syarat", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"syarat"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"panel"},[_c('div',{staticClass:"panel-heading",attrs:{"role":"tab"}},[_c('h4',{staticClass:"panel-title"},[_c('a',{attrs:{"role":"button"}},[_vm._v("\n                                                        Cara Mendaftar\n                                                        "),_c('div',{staticClass:"pull-right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.akses.cara),expression:"akses.cara"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"cara","value":"1"},domProps:{"checked":Array.isArray(_vm.akses.cara)?_vm._i(_vm.akses.cara,"1")>-1:(_vm.akses.cara)},on:{"change":function($event){var $$a=_vm.akses.cara,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.akses, "cara", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.akses, "cara", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.akses, "cara", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"cara"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"panel"},[_c('div',{staticClass:"panel-heading",attrs:{"role":"tab"}},[_c('h4',{staticClass:"panel-title"},[_c('a',{attrs:{"role":"button"}},[_vm._v("\n                                                        Slider\n                                                        "),_c('div',{staticClass:"pull-right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.akses.slider),expression:"akses.slider"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"slider","value":"1"},domProps:{"checked":Array.isArray(_vm.akses.slider)?_vm._i(_vm.akses.slider,"1")>-1:(_vm.akses.slider)},on:{"change":function($event){var $$a=_vm.akses.slider,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.akses, "slider", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.akses, "slider", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.akses, "slider", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"slider"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"panel"},[_c('div',{staticClass:"panel-heading",attrs:{"role":"tab"}},[_c('h4',{staticClass:"panel-title"},[_c('a',{attrs:{"role":"button"}},[_vm._v("\n                                                        Kirim Notifikasi\n                                                        "),_c('div',{staticClass:"pull-right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.akses.kirimNotifikasi),expression:"akses.kirimNotifikasi"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"kirimNotifikasi","value":"1"},domProps:{"checked":Array.isArray(_vm.akses.kirimNotifikasi)?_vm._i(_vm.akses.kirimNotifikasi,"1")>-1:(_vm.akses.kirimNotifikasi)},on:{"change":function($event){var $$a=_vm.akses.kirimNotifikasi,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.akses, "kirimNotifikasi", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.akses, "kirimNotifikasi", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.akses, "kirimNotifikasi", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"kirimNotifikasi"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"panel"},[_c('div',{staticClass:"panel-heading",attrs:{"role":"tab"}},[_c('h4',{staticClass:"panel-title"},[_c('a',{attrs:{"role":"button"}},[_vm._v("\n                                                        Headline\n                                                        "),_c('div',{staticClass:"pull-right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.akses.headline),expression:"akses.headline"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"headline","value":"1"},domProps:{"checked":Array.isArray(_vm.akses.headline)?_vm._i(_vm.akses.headline,"1")>-1:(_vm.akses.headline)},on:{"change":function($event){var $$a=_vm.akses.headline,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.akses, "headline", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.akses, "headline", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.akses, "headline", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"headline"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"panel"},[_c('div',{staticClass:"panel-heading",attrs:{"role":"tab"}},[_c('h4',{staticClass:"panel-title"},[_c('a',{attrs:{"role":"button"}},[_vm._v("\n                                                        WhistleBlower\n                                                        "),_c('div',{staticClass:"pull-right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.akses.whistleBlower),expression:"akses.whistleBlower"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"whistleBlower","value":"1"},domProps:{"checked":Array.isArray(_vm.akses.whistleBlower)?_vm._i(_vm.akses.whistleBlower,"1")>-1:(_vm.akses.whistleBlower)},on:{"change":function($event){var $$a=_vm.akses.whistleBlower,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.akses, "whistleBlower", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.akses, "whistleBlower", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.akses, "whistleBlower", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"whistleBlower"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"panel"},[_c('div',{staticClass:"panel-heading",attrs:{"role":"tab"}},[_c('h4',{staticClass:"panel-title"},[_c('a',{attrs:{"role":"button"}},[_vm._v("\n                                                        Anak Perusahaan\n                                                        "),_c('div',{staticClass:"pull-right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.akses.anakPerusahaan),expression:"akses.anakPerusahaan"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"anakPerusahaan","value":"1"},domProps:{"checked":Array.isArray(_vm.akses.anakPerusahaan)?_vm._i(_vm.akses.anakPerusahaan,"1")>-1:(_vm.akses.anakPerusahaan)},on:{"change":function($event){var $$a=_vm.akses.anakPerusahaan,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.akses, "anakPerusahaan", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.akses, "anakPerusahaan", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.akses, "anakPerusahaan", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"anakPerusahaan"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"panel"},[_c('div',{staticClass:"panel-heading",attrs:{"role":"tab"}},[_c('h4',{staticClass:"panel-title"},[_c('a',{attrs:{"role":"button"}},[_vm._v("\n                                                        Pengumuman\n                                                        "),_c('div',{staticClass:"pull-right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.akses.Pengumuman),expression:"akses.Pengumuman"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"Pengumuman","value":"1"},domProps:{"checked":Array.isArray(_vm.akses.Pengumuman)?_vm._i(_vm.akses.Pengumuman,"1")>-1:(_vm.akses.Pengumuman)},on:{"change":function($event){var $$a=_vm.akses.Pengumuman,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.akses, "Pengumuman", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.akses, "Pengumuman", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.akses, "Pengumuman", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"Pengumuman"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"panel"},[_c('div',{staticClass:"panel-heading",attrs:{"role":"tab"}},[_c('h4',{staticClass:"panel-title"},[_c('a',{attrs:{"role":"button"}},[_vm._v("\n                                                        Kalender\n                                                        "),_c('div',{staticClass:"pull-right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.akses.Kalender),expression:"akses.Kalender"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"Kalender","value":"1"},domProps:{"checked":Array.isArray(_vm.akses.Kalender)?_vm._i(_vm.akses.Kalender,"1")>-1:(_vm.akses.Kalender)},on:{"change":function($event){var $$a=_vm.akses.Kalender,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.akses, "Kalender", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.akses, "Kalender", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.akses, "Kalender", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"Kalender"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"panel"},[_c('div',{staticClass:"panel-heading",attrs:{"role":"tab"}},[_c('h4',{staticClass:"panel-title"},[_c('a',{attrs:{"role":"button"}},[_vm._v("\n                                                        Hak dan Kewajiabn Peserta\n                                                        "),_c('div',{staticClass:"pull-right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.akses.Hak_dan_Kewajiban_Peserta),expression:"akses.Hak_dan_Kewajiban_Peserta"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"Hak_dan_kewajiban_peserta","value":"1"},domProps:{"checked":Array.isArray(_vm.akses.Hak_dan_Kewajiban_Peserta)?_vm._i(_vm.akses.Hak_dan_Kewajiban_Peserta,"1")>-1:(_vm.akses.Hak_dan_Kewajiban_Peserta)},on:{"change":function($event){var $$a=_vm.akses.Hak_dan_Kewajiban_Peserta,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.akses, "Hak_dan_Kewajiban_Peserta", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.akses, "Hak_dan_Kewajiban_Peserta", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.akses, "Hak_dan_Kewajiban_Peserta", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"Hak_dan_Kewajiban_Peserta"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"panel"},[_c('div',{staticClass:"panel-heading",attrs:{"role":"tab"}},[_c('h4',{staticClass:"panel-title"},[_c('a',{attrs:{"role":"button"}},[_vm._v("\n                                                        Banner\n                                                        "),_c('div',{staticClass:"pull-right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.akses.Banner),expression:"akses.Banner"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"Banner","value":"1"},domProps:{"checked":Array.isArray(_vm.akses.Banner)?_vm._i(_vm.akses.Banner,"1")>-1:(_vm.akses.Banner)},on:{"change":function($event){var $$a=_vm.akses.Banner,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.akses, "Banner", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.akses, "Banner", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.akses, "Banner", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"Banner"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"panel"},[_c('div',{staticClass:"panel-heading",attrs:{"role":"tab"}},[_c('h4',{staticClass:"panel-title"},[_c('a',{attrs:{"role":"button"}},[_vm._v("\n                                                        Hubungi Kami\n                                                        "),_c('div',{staticClass:"pull-right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.akses.hubungiKami),expression:"akses.hubungiKami"}],staticClass:"filled-in",attrs:{"type":"checkbox","id":"hubungiKami","value":"1"},domProps:{"checked":Array.isArray(_vm.akses.hubungiKami)?_vm._i(_vm.akses.hubungiKami,"1")>-1:(_vm.akses.hubungiKami)},on:{"change":function($event){var $$a=_vm.akses.hubungiKami,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.akses, "hubungiKami", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.akses, "hubungiKami", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.akses, "hubungiKami", $$c)}}}}),_vm._v(" "),_c('label',{attrs:{"for":"hubungiKami"}})])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[(_vm.id_user != null)?_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-warning waves-effect waves-button",attrs:{"disabled":_vm.isLoading,"type":"button"},on:{"click":_vm.update}},[(!_vm.isLoading)?_c('span',[_c('i',{staticClass:"material-icons"},[_vm._v("save")]),_vm._v(" Edit")]):_c('span',[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" Loading")])]):_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect waves-button",attrs:{"disabled":_vm.isLoading,"type":"button"},on:{"click":_vm.save}},[(!_vm.isLoading)?_c('span',[_c('i',{staticClass:"material-icons"},[_vm._v("save")]),_vm._v(" Simpan")]):_c('span',[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" Loading")])]),_vm._v(" "),_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")]),_vm._v(" Batal")])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-header"},[_c('h2',[_vm._v("User Level")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            Tambah User Level\n                        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"id_narasumber"}},[_vm._v("Narasumber")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"namaLengkap"}},[_vm._v("Nama Lengkap")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"email"}},[_vm._v("Email")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"username"}},[_vm._v("Username")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"password"}},[_vm._v("Password")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"username"}},[_vm._v("Akses Menu")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TpJO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_ckeditor2__ = __webpack_require__("42+j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FormLine_vue__ = __webpack_require__("w3AW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_api__ = __webpack_require__("+Btm");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_1__components_FormLine_vue__["a" /* default */], Ckeditor: __WEBPACK_IMPORTED_MODULE_0_vue_ckeditor2__["a" /* default */] },
  name: 'HubungiKami',
  data: function data() {
    return {
      config: {
        toolbar: [{ name: 'stuff', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] }, { name: 'morestuff', items: ['NumberedList', 'BulletedList'] }, { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Superscript', 'Subscript'] }, { name: 'colors', items: ['TextColor'] }, { name: 'paragraph2', items: ['JustifyLeft', 'JustiftyCenter', 'JustifyRight', 'Outdent', 'Indent'] }, '/', { name: 'document', items: ['Source'] }],
        height: 300
      },
      contact: {
        deskripsi: '',
        telp: '',
        alamat: '',
        email: '',
        latitude: 0,
        longitude: 0,
        fb: '',
        ig: '',
        twitter: ''
      }
    };
  },
  methods: {
    save: function save() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].post('/hubungi-kami', this.contact).then(function (result) {
        if (result.data.code === 200) {
          _this.$toastr.s('Edit Hubungi Kami berhasil');
        } else {
          var msg = 'Edit hubungi kami gagal';
          if (result.data.message !== '') msg = result.data.message;
          _this.$toastr.e(msg);
        }
        _this.getDetail();
      }).catch(function (e) {
        var msg = 'Terjadi kesalahan pada server, mohon ulangi';
        if (e.response.data.message) msg = e.response.data.message;
        _this.$toastr.e(msg);
      });
    },
    getDetail: function getDetail() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].get('/hubungi-kami').then(function (result) {
        _this2.contact = result.data;
      }).catch(function (ex) {
        _this2.$toastr.e('Terjadi kesalahan pada server, mohon ulangi');
      });
    }
  },
  mounted: function mounted() {
    this.getDetail();
  }
});

/***/ }),

/***/ "TyQI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_api__ = __webpack_require__("+Btm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__ = __webpack_require__("w3AW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__["a" /* default */] },
  name: 'ListVisiMisi',
  data: function data() {
    return {
      result: {},
      list: [],
      currentPage: 1,
      perPage: 10,
      search: '',
      modal: null,
      isLoading: true,
      link: '',
      tipe: '',
      nama: ''
    };
  },
  methods: {
    getData: function getData() {
      var _this = this;

      var params = [];
      params.search = this.search;
      params.page = this.currentPage - 1;
      params.size = this.perPage;
      params.tipe = this.tipe;

      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].get('/informasi_kegiatan?' + __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(params)).then(function (result) {
        _this.result = result.data;
        _this.list = result.data.content;
        _this.isLoading = false;
      }).catch(function (ex) {
        _this.isLoading = false;
        _this.$toastr.e('Gagal terhubung dengan server.');
      });
    },
    confirmDelete: function confirmDelete(id) {
      var _this2 = this;

      this.$swal({
        title: 'Konfirmasi',
        text: 'Anda yakin ingin menghapus data ini?',
        icon: 'warning',
        buttons: [true, {
          text: 'Ok',
          closeModal: false
        }],
        dangerMode: true
      }).then(function (result) {
        if (result) _this2.delete(id);
      });
    },
    delete: function _delete(id) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].delete('/informasi_kegiatan/' + id).then(function (result) {
        if (result.data.code === 200) _this3.$toastr.s('Data berhasil dihapus.');else _this3.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this3.$swal.close();
        _this3.getData();
      }).catch(function (e) {
        _this3.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this3.$swal.close();
      });
    },
    checkRoute: function checkRoute(route) {
      this.list = [];
      if (route.name === 'ListKegiatan') {
        this.link = 'kegiatan';
        this.nama = 'Informasi Kegiatan';
      }
    }
  },
  mounted: function mounted() {
    this.checkRoute(this.$route);
    this.getData();
  },
  watch: {
    currentPage: function currentPage(e) {
      this.getData();
    },
    perPage: function perPage(e) {
      this.getData();
    },
    search: function search(e) {
      this.getData();
    },
    '$route': function $route(to, from) {
      this.checkRoute(to);
      this.getData();
    }
  }
});

/***/ }),

/***/ "U2rS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PengumumanList_vue__ = __webpack_require__("npw4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3c85aac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PengumumanList_vue__ = __webpack_require__("6vGM");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PengumumanList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3c85aac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PengumumanList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UFg6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit.apply(null, arguments)}}},[_c('div',{staticClass:"row clearfix"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('vue-dropzone',{ref:"myVueDropzone",attrs:{"destroyDropzone":false,"id":"dropzone","options":_vm.dropzoneOptions},on:{"vdropzone-success":_vm.vsuccess,"vdropzone-file-added":_vm.vfileAdded,"vdropzone-removed-file":_vm.vremoved}})],1)])])])])])])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            Video\n                        ")]),_vm._v(" "),_c('ul',{staticClass:"header-dropdown m-r--5 m-t--10"},[_c('router-link',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect waves-button",attrs:{"to":'/main/informasi/galeri/tambah',"type":"button"}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#fff"}},[_vm._v("add_box")]),_vm._v(" "),_c('span',[_vm._v("Tambah")])])],1)]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"dataTables_wrapper form-inline dt-bootstrap",attrs:{"id":"DataTables_Table_0_wrapper"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_length",attrs:{"id":"DataTables_Table_0_length"}},[_c('label',[_vm._v("Show "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.perPage),expression:"perPage"}],staticClass:"form-control input-sm",attrs:{"name":"DataTables_Table_0_length","aria-controls":"DataTables_Table_0"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.perPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_c('option',{attrs:{"value":"100"}},[_vm._v("100")])]),_vm._v(" entries")])])]),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_filter",attrs:{"id":"DataTables_Table_0_filter"}},[_c('label',[_vm._v("Search:"),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control input-sm",attrs:{"type":"search","placeholder":"","aria-controls":"DataTables_Table_0"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])])])]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped table-hover js-basic-example dataTable"},[_vm._m(3),_vm._v(" "),_c('tbody',[(_vm.isLoading)?_c('tr',[_vm._m(4)]):_vm._e(),_vm._v(" "),(_vm.list == '')?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"5"}},[_vm._v("Data tidak ditemukan")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(item,index){return (!_vm.isLoading)?_c('tr',[_c('td',[_vm._v(_vm._s(++index + ((_vm.currentPage-1)*_vm.perPage)))]),_vm._v(" "),_c('td',[_c('iframe',{staticStyle:{"border":"0","width":"300px","heigh":"250px"},attrs:{"src":item.file}})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.file))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.deskripsi))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn bg-green waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.push('/main/informasi/galeri/edit/' + item.id_galeri)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("create")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmDelete(item.id_galeri)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")])])])]):_vm._e()})],2)])]),_vm._v(" "),_c('pagination',{attrs:{"total-rows":_vm.result.totalElements,"per-page":_vm.result.size},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-header"},[_c('h2',[_vm._v("Galeri")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            Foto\n                        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"dropzone"}},[_vm._v("Foto")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("No.")]),_vm._v(" "),_c('th',[_vm._v("Thumb")]),_vm._v(" "),_c('th',[_vm._v("Link")]),_vm._v(" "),_c('th',[_vm._v("Deskripsi")]),_vm._v(" "),_c('th',[_vm._v("Aksi")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center",attrs:{"colspan":"5"}},[_c('i',{staticClass:"fa fa-spin fa-spinner"}),_vm._v(" Loading data...")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UPJt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('nav',{staticClass:"navbar"},[_c('div',{staticClass:"container-fluid"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"navbar-collapse"}},[_c('ul',{staticClass:"nav navbar-nav navbar-right"},[_c('li',{staticClass:"pull-right"},[_c('a',{staticClass:"js-right-sidebar",attrs:{"href":"javascript:void(0);","data-close":"true"},on:{"click":_vm.signOut}},[_vm._v("Sign Out")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-bar"},[_c('div',{staticClass:"search-icon"},[_c('i',{staticClass:"material-icons"},[_vm._v("search")])]),_vm._v(" "),_c('input',{attrs:{"type":"text","placeholder":"START TYPING..."}}),_vm._v(" "),_c('div',{staticClass:"close-search"},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar-header"},[_c('a',{staticClass:"navbar-toggle collapsed",attrs:{"href":"javascript:void(0);","data-toggle":"collapse","data-target":"#navbar-collapse","aria-expanded":"false"}}),_vm._v(" "),_c('a',{staticClass:"bars",attrs:{"href":"javascript:void(0);"}}),_vm._v(" "),_c('a',{staticClass:"navbar-brand",attrs:{"href":"index.html"}},[_vm._v("ADMIN - DAPENBI")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Uhku":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header_vue__ = __webpack_require__("teIl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Sidebar_vue__ = __webpack_require__("lZ5c");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import FormLine from '../components/FormLine.vue'



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Main',
  components: {
    Header: __WEBPACK_IMPORTED_MODULE_0__components_Header_vue__["a" /* default */],
    Sidebar: __WEBPACK_IMPORTED_MODULE_1__components_Sidebar_vue__["a" /* default */]
  },
  data: function data() {
    return {
      loaded: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.loaded = true;
    }, 1000);
  }
});

/***/ }),

/***/ "Umoi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_api__ = __webpack_require__("+Btm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qs__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ListBanner',
  data: function data() {
    return {
      result: {},
      list: [],
      currentPage: 1,
      perPage: 10,
      search: '',
      isLoading: true,
      link: '',
      nama: 'Banner'
    };
  },

  methods: {
    getData: function getData() {
      var _this = this;

      this.isLoading = true;
      var params = {
        search: this.search,
        page: this.currentPage - 1, // Server biasanya 0-based
        size: this.perPage
      };

      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');

      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].get('/getAllNavbar?' + __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(params)).then(function (response) {
        _this.result = response.data;
        _this.list = _this.flattenSubmenus(response.data.content);
        _this.isLoading = false;
      }).catch(function () {
        _this.isLoading = false;
        _this.$toastr.e('Gagal mengambil data.');
      });
    },
    flattenSubmenus: function flattenSubmenus(menuList) {
      var flattened = [];

      var recurse = function recurse(submenus, parentName) {
        submenus.forEach(function (sub) {
          flattened.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, sub, {
            parentName: parentName || 'Menu Utama'
          }));

          if (sub.submenu && sub.submenu.length > 0) {
            recurse(sub.submenu, sub.title);
          }
        });
      };

      recurse(menuList);
      return flattened;
    },
    changePage: function changePage(page) {
      if (page !== this.currentPage) {
        this.currentPage = page;
        this.getData();
      }
    },
    checkRoute: function checkRoute(route) {
      if (route.name === 'ListBanner') {
        console.log("ini routenyar", route.name);
        this.link = 'banner';
      }
    }
  },
  mounted: function mounted() {
    this.checkRoute(this.$route); // ← WAJIB DIPANGGIL

    this.getData();
  },

  watch: {
    perPage: function perPage() {
      this.currentPage = 1;
      this.getData();
    },
    search: function search() {
      this.currentPage = 1;
      this.getData();
    }
  }
});

/***/ }),

/***/ "Ux2e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormNarasumber_vue__ = __webpack_require__("5nV0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b333928_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormNarasumber_vue__ = __webpack_require__("RDUd");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormNarasumber_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b333928_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormNarasumber_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Uz7N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_ckeditor2__ = __webpack_require__("42+j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__ = __webpack_require__("w3AW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_api__ = __webpack_require__("+Btm");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FormLine: __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__["a" /* default */],
    Ckeditor: __WEBPACK_IMPORTED_MODULE_1_vue_ckeditor2__["a" /* default */]
  },
  name: 'ListNarasumber',
  data: function data() {
    return {
      date: {
        dateFormat: 'Y-m-d',
        allowInput: true
      },
      config: {
        toolbar: [{ name: 'stuff', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] }, { name: 'morestuff', items: ['NumberedList', 'BulletedList'] }, { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Superscript', 'Subscript'] }, { name: 'colors', items: ['TextColor'] }, { name: 'paragraph2', items: ['JustifyLeft', 'JustiftyCenter', 'JustifyRight', 'Outdent', 'Indent'] }, '/', { name: 'document', items: ['Source'] }],
        height: 300
      },
      content: {
        judul: '',
        edisiTriwulan: '',
        tahun: '',
        tags: ''
      },
      file: '',
      id_regulasi_dana_pensiun: '',
      nama: '',
      tipe: '',
      link: ''
    };
  },
  methods: {
    save: function save() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      var form = new FormData();
      form.append('file', this.file);
      form.append('json', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.content));
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].post('/' + this.link, form).then(function (result) {
        if (result.data.code === 200) {
          _this.$router.replace('/main/unduh/' + _this.link);
          _this.$toastr.s('Tambah data berhasil');
        } else {
          var msg = 'Tambah data gagal';
          if (result.data.message !== '') msg = result.data.message;
          _this.$toastr.e(msg);
        }
      }).catch(function (e) {
        var msg = 'Terjadi kesalahan pada server, mohon ulangi';
        if (e.response.data.message) msg = e.response.data.message;
        _this.$toastr.e(msg);
      });
    },
    update: function update() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      var form = new FormData();
      form.append('file', this.file);
      form.append('json', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.content));
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].post('/' + this.link + '/' + this.id_materi_komunikasi, form).then(function (result) {
        if (result.data.code === 200) {
          _this2.$router.replace('/main/unduh/' + _this2.link);
          _this2.$toastr.s('Ubah data berhasil');
        }
      }).catch(function (ex) {
        var msg = 'Terjadi kesalahan pada server, mohon ulangi';
        if (ex.response.data.message) msg = ex.response.data.message;
        _this2.$toastr.e(msg);
      });
    },
    getDetail: function getDetail() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].get('/' + this.link + '/' + this.id_materi_komunikasi).then(function (result) {
        _this3.content = result.data;
      }).catch(function (ex) {
        _this3.$toastr.e('Terjadi kesalahan pada server, mohon ulangi');
      });
    },
    handleFile: function handleFile(file) {
      this.file = file.target.files[0];
    },
    checkRoute: function checkRoute(route) {
      if (route.name === 'TambahMateriKomunikasi' || route.name === 'EditMateriKomunikasi') {
        this.link = 'materikomunikasi';
        this.nama = 'Materi Komunikasi';
      }
    }
  },
  mounted: function mounted() {
    this.checkRoute(this.$route);
    this.id_materi_komunikasi = this.$route.params.id;
    if (this.id_materi_komunikasi != null) {
      this.getDetail();
    }
  },
  '$route': function $route(to, from) {
    this.checkRoute(to);
    this.getData();
  }
});

/***/ }),

/***/ "VS04":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_ckeditor2__ = __webpack_require__("42+j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__ = __webpack_require__("w3AW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_api__ = __webpack_require__("+Btm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone__ = __webpack_require__("KvPw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_dropzone_dist_vue2Dropzone_css__ = __webpack_require__("hCol");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_dropzone_dist_vue2Dropzone_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_dropzone_dist_vue2Dropzone_css__);


var _watch;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */







/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__["a" /* default */], Ckeditor: __WEBPACK_IMPORTED_MODULE_1_vue_ckeditor2__["a" /* default */], vueDropzone: __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone___default.a },
  name: 'Artikel',
  data: function data() {
    return {
      dropzoneOptionsThumnail: {
        url: __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.baseURL + '/upload_image_dropzone?tipe=THUMBNAIL_IMAGE',
        thumbnailWidth: 150,
        addRemoveLinks: true,
        maxFiles: 1,
        maxFilesize: 2,
        dictRemoveFileConfirmation: 'Anda yakin ingin menghapus file ini?',
        headers: { Authorization: 'Bearer ' + localStorage.getItem('_token') }
      },
      dropzoneOptionsPenulis: {
        url: __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.baseURL + '/upload_image_dropzone?tipe=PENULIS_IMAGE',
        thumbnailWidth: 150,
        addRemoveLinks: true,
        maxFiles: 1,
        maxFilesize: 2,
        dictRemoveFileConfirmation: 'Anda yakin ingin menghapus file ini?',
        headers: { Authorization: 'Bearer ' + localStorage.getItem('_token') }
      },
      config: {
        height: 300,
        filebrowserUploadUrl: __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.baseURL + '/upload_image_editor?tipe=CONTENT_IMAGE',
        filebrowserUploadMethod: 'xhr',
        extraPlugins: 'uploadimage,image2',
        removePlugins: 'image',
        toolbar: [{ name: 'document', items: ['Source', '-', 'Preview'] }, { name: 'clipboard', items: ['Undo', 'Redo'] }, { name: 'styles', items: ['Format', 'Font', 'FontSize'] }, {
          name: 'basicstyles',
          items: ['Bold', 'Italic', 'Underline', '-', 'RemoveFormat']
        }, {
          name: 'paragraph',
          items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent']
        }, {
          name: 'insert',
          items: ['Image', 'Table', 'HorizontalRule', 'SpecialChar']
        }]
      },
      categories: [],
      data: {
        judul: '',
        penulis: '',
        kategori: '',
        fileArtikelId: []
      },
      tanggal: '',
      file: '',
      id_artikel: '',
      nama: '',
      tipe: '',
      link: '',
      isLoading: false,
      init: false
    };
  },
  methods: {
    save: function save() {
      var _this = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].post('/insert_artikel', this.data).then(function (result) {
        if (result.data.code === 200) {
          _this.$toastr.s('Tambah data berhasil');
          _this.$router.replace('/main/informasi/' + _this.link);
        } else {
          var msg = 'Tambah data gagal';
          if (result.data.message !== '') msg = result.data.message;
          _this.$toastr.e(msg);
        }
        _this.isLoading = false;
      }).catch(function (e) {
        var msg = 'Terjadi kesalahan pada server, mohon ulangi';
        if (e.response.data.message) msg = e.response.data.message;
        _this.$toastr.e(msg);
        _this.isLoading = false;
      });
    },
    update: function update() {
      var _this2 = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].post('/update_artikel/' + this.id_artikel, this.data).then(function (result) {
        if (result.data.code === 200) {
          _this2.$router.replace('/main/informasi/' + _this2.link);
          _this2.$toastr.s('Ubah data berhasil');
        }
        _this2.isLoading = false;
      }).catch(function (e) {
        var msg = 'Terjadi kesalahan pada server, mohon ulangi';
        if (e.response.data.message) msg = e.response.data.message;
        _this2.$toastr.e(msg);
        _this2.isLoading = false;
      });
    },
    getCategories: function getCategories() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].get('/getAllCategories').then(function (res) {
        _this3.categories = res.data.object;
      }).catch(function (err) {
        _this3.$toastr.e('Gagal mengambil data kategori');
        console.error(err);
      });
    },
    onUploadSuccess: function onUploadSuccess(file, response) {
      console.log("iniresponse dari dropzone", response);
      var idFile = response && response.object ? response.object.id : null;
      console.log("ini idfile", idFile);
      if (idFile) {
        this.data.fileArtikelId.push(idFile);
      }
      console.log("ini fileArtikel", this.data.fileArtikelId);
    },
    getDetail: function getDetail() {
      var _this4 = this;

      this.init = true;
      console.log("ini file get data edit", this.fileArtikelId);
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].get('/get_artikel/' + this.id_artikel).then(function (result) {
        _this4.data = result.data.object;
        if (!_this4.data.fileArtikelId) {
          _this4.data.fileArtikelId = [];
        }
        _this4.data.kategori = result.data.object.category;
        for (var i = 0; i < _this4.data.files.length; i++) {
          var fileItem = _this4.data.files[i];
          if (fileItem.fileType === 'THUMBNAIL_IMAGE') {
            _this4.$refs.dropzoneThumnail.manuallyAddFile({ name: fileItem, size: fileItem.size, type: 'image/jpeg' }, fileItem.file);
          } else if (fileItem.fileType === 'PENULIS_IMAGE') {
            _this4.$refs.dropzonePenulis.manuallyAddFile({ name: fileItem, size: fileItem.size, type: 'image/jpeg' }, fileItem.file);
          }
        }
        _this4.init = false;
      }).catch(function (ex) {
        console.error("Error getDetail:", ex);
        _this4.$toastr.e('Terjadi kesalahan pada server, mohon ulangi');
        _this4.init = false;
      });
    },
    sendingEvent: function sendingEvent(file, xhr, formData) {
      formData.append('id_artikel', parseInt(this.id_artikel));

      // Cek dropzone mana yang sedang mengirim file
      if (this.$refs.dropzoneArtikel.dropzone.files.includes(file)) {
        formData.append('tipe', 'artikel');
      } else if (this.$refs.dropzonePenulis.dropzone.files.includes(file)) {
        formData.append('tipe', 'penulis');
      }
      console.log(this.id_artikel);
      formData.append('id_artikel', parseInt(this.id_artikel));
    },
    onSubmit: function onSubmit() {
      if (this.id_artikel != null) this.update();else this.save();
    },
    checkRoute: function checkRoute(route) {
      console.log(route.name);
      if (route.name === 'TambahArtikel' || route.name === 'EditArtikel') {
        this.link = 'artikel';
        this.nama = 'Artikel';
      }
    },
    vremoved: function vremoved(file, xhr, error) {
      console.log("ini filenya", file);
      if (!this.init) this.delete(file.name.id);
    },
    delete: function _delete(id) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].delete('/delete_file_artikel/' + id).then(function (result) {
        console.log(result.data.code);
        if (result.data.code === 200) {
          _this5.$toastr.s('Foto berhasil dihapus');
          _this5.$swal.close();
        } else {
          _this5.$toastr.e('Gagal menghapus foto');
          _this5.$swal.close();
        }
      }).catch(function (e) {
        _this5.$swal.close();
      });
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    this.checkRoute(this.$route);
    this.id_artikel = this.$route.params.id;
    if (this.id_artikel != null) {
      this.getDetail();
    }
    this.getCategories();
    // Tunggu CKEditor siap (delay kecil)
    this.$nextTick(function () {
      var editorInstance = _this6.$refs.ckeditor.instance;

      if (editorInstance) {
        editorInstance.on('fileUploadResponse', function (evt) {
          var data = evt.data;
          var xhr = data.fileLoader.xhr;

          console.log('File upload response:', xhr.responseText);
          var response = JSON.parse(xhr.responseText);

          console.log('Upload response:', response);
          _this6.data.fileArtikelId.push(response.id_file);
        });
      } else {
        console.warn('CKEditor instance belum tersedia');
      }
    });
  },

  watch: (_watch = {
    $route: function $route(to, from) {
      this.checkRoute(to);
    },
    'data.judul': function dataJudul(newVal) {
      console.log('Isi judul sekarang:', newVal);
    },
    'data.kategori': function dataKategori(newVal) {
      console.log('Kategori dipilih:', newVal);
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_watch, 'data.kategori', function dataKategori(newVal) {
    console.log(this.fileArtikelId, newVal);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_watch, 'data.content', function dataContent(newVal) {
    console.log('Konten artikel berubah');
  }), _watch)
});

/***/ }),

/***/ "VaXm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FormLine',
  props: ['value', 'col'],
  data: function data() {
    return {
      isFocus: false,
      isi: this.value
    };
  },
  methods: {
    focus: function focus() {
      this.isFocus = true;
    },
    blur: function blur() {
      this.isFocus = false;
    }
  },
  mounted: function mounted() {},
  watch: {
    isi: function isi(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.isi = val;
    }
  }
});

/***/ }),

/***/ "VnPW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListBanner_vue__ = __webpack_require__("Umoi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57794e3a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListBanner_vue__ = __webpack_require__("bD83");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListBanner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57794e3a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListBanner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WcS9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListSlider_vue__ = __webpack_require__("BfF4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e253f38c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListSlider_vue__ = __webpack_require__("xzck");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListSlider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e253f38c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListSlider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Wg+Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_api__ = __webpack_require__("+Btm");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "CalendarView",
  data: function data() {
    return {
      selectedEvent: null,
      editEventTitle: '',
      showModal: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    var calendarEl = document.getElementById("calendar");
    var calendar = new window.FullCalendar.Calendar(calendarEl, {
      initialView: "dayGridMonth",
      selectable: true, // ini penting untuk multiple select
      eventClick: function eventClick(info) {
        return _this.handleEventClick(info);
      }, // Handle event click for update/delete
      select: function select(info) {
        var _this2 = this;

        var title = prompt('Masukkan judul event dari ' + info.startStr + ' ke ' + info.endStr + ':');
        if (title) {
          // Menambahkan event ke kalender lokal
          calendar.addEvent({
            title: title,
            start: info.startStr,
            end: info.endStr,
            allDay: true
          });

          // Data yang akan dikirim ke backend
          var eventData = {
            title: title,
            start: info.startStr,
            end: info.endStr
          };

          // Mengatur header Authorization dengan token
          __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("_token");

          // Mengirim data event ke backend
          __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].post("/insertEvent", eventData).then(function (result) {
            if (result.data.code === 200) {
              _this2.$toastr.s("Tambah data berhasil");
            } else {
              var msg = "Tambah data gagal";
              if (result.data.message !== "") msg = result.data.message;
              _this2.$toastr.e(msg);
            }
            _this2.isLoading = false;
          }).catch(function (e) {
            var msg = "Terjadi kesalahan pada server, mohon ulangi";
            // if (e.response.data.message) msg = e.response.data.message;
            _this2.$toastr.e(msg);
            _this2.isLoading = false;
          });
        }
      }
    });
    calendar.render();

    __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("_token");
    __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].get("/getallKalender").then(function (response) {
      var serverEvents = response.data.content; // sesuaikan dengan struktur datamu
      serverEvents.forEach(function (evt) {
        calendar.addEvent({
          id: evt.id,
          title: evt.title,
          start: evt.start,
          end: evt.end,
          allDay: true
        });
      });
      calendar.render();
    }).catch(function (e) {
      _this.$toastr.e("Gagal memuat data event dari server");
      calendar.render();
    });
  },


  methods: {
    handleEventClick: function handleEventClick(info) {
      this.selectedEvent = info.event;
      this.editEventTitle = info.event.title;
      this.showModal = true;
    },
    updateEvent: function updateEvent() {
      var _this3 = this;

      if (!this.selectedEvent || !this.editEventTitle) return;

      this.selectedEvent.setProp('title', this.editEventTitle);

      var updatedEvent = {
        id: this.selectedEvent.id,
        title: this.editEventTitle,
        start: this.selectedEvent.startStr,
        end: this.selectedEvent.endStr
      };

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].post('/updateEvent/' + updatedEvent.id, updatedEvent).then(function (result) {
        if (result.status === 200) {
          _this3.$toastr.s('Update data berhasil');
        } else {
          _this3.$toastr.e('Update data gagal');
        }
      }).catch(function () {
        _this3.$toastr.e('Terjadi kesalahan saat update');
      });

      this.showModal = false;
    },
    deleteEvent: function deleteEvent() {
      var _this4 = this;

      if (!this.selectedEvent) return;

      var id = this.selectedEvent.id;
      this.selectedEvent.remove();

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].delete('/deleteEvent/' + id).then(function (result) {
        if (result.status === 200) {
          _this4.$toastr.s('Event berhasil dihapus');
        } else {
          _this4.$toastr.e('Gagal menghapus event');
        }
      }).catch(function () {
        _this4.$toastr.e('Terjadi kesalahan saat hapus');
      });

      this.showModal = false;
    }
  }
});

/***/ }),

/***/ "WoKI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListArtikel_vue__ = __webpack_require__("7YVk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_738bc022_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListArtikel_vue__ = __webpack_require__("62fL");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListArtikel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_738bc022_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListArtikel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Wzew":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_ckeditor2__ = __webpack_require__("42+j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__ = __webpack_require__("w3AW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_api__ = __webpack_require__("+Btm");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__["a" /* default */], Ckeditor: __WEBPACK_IMPORTED_MODULE_1_vue_ckeditor2__["a" /* default */] },
  name: 'ListNarasumber',
  data: function data() {
    return {
      config: {
        toolbar: [{ name: 'stuff', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] }, { name: 'morestuff', items: ['NumberedList', 'BulletedList'] }, { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Superscript', 'Subscript'] }, { name: 'colors', items: ['TextColor'] }, { name: 'paragraph2', items: ['JustifyLeft', 'JustiftyCenter', 'JustifyRight', 'Outdent', 'Indent'] }, '/', { name: 'document', items: ['Source'] }],
        height: 300
      },
      officer: {
        deskripsi: '',
        tipe: ''
      },
      icon: '',
      id_officer: '',
      link: '',
      nama: '',
      isLoading: false
    };
  },
  methods: {
    save: function save() {
      var _this = this;

      console.log("ini tipe", this.tipe);
      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      var form = new FormData();
      form.append('file', this.icon);
      form.append('json', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.officer));
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].post('/officer', form).then(function (result) {
        if (result.data.code === 200) {
          _this.$router.replace('/main/profile/' + _this.link);
          _this.$toastr.s('Tambah data berhasil');
        } else {
          var msg = 'Tambah data gagal';
          if (result.data.message !== '') msg = result.data.message;
          _this.$toastr.e(msg);
        }
        _this.isLoading = false;
      }).catch(function (e) {
        var msg = 'Terjadi kesalahan pada server, mohon ulangi';
        if (e.response.data.message) msg = e.response.data.message;
        _this.$toastr.e(msg);
        _this.isLoading = false;
      });
    },
    update: function update() {
      var _this2 = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      var form = new FormData();
      form.append('file', this.icon);
      form.append('json', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.officer));
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].post('/officer/' + this.id_officer, form).then(function (result) {
        if (result.data.code === 200) {
          _this2.$router.replace('/main/profile/' + _this2.link);
          _this2.$toastr.s('Ubah data berhasil');
        }
        _this2.isLoading = false;
      }).catch(function (ex) {
        _this2.$toastr.e('Terjadi kesalahan pada server, mohon ulangi');
        _this2.isLoading = false;
      });
    },
    getDetail: function getDetail() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].get('/officer/' + this.id_officer).then(function (result) {
        _this3.officer = result.data;
      }).catch(function (ex) {
        _this3.$toastr.e('Terjadi kesalahan pada server, mohon ulangi');
      });
    },
    handleFile: function handleFile(file) {
      this.icon = file.target.files[0];
    },
    checkRoute: function checkRoute(route) {
      console.log(route.name);
      if (route.name === 'TambahPendiri' || route.name === 'EditPendiri') {
        this.officer.tipe = 1;
        this.link = 'pendiri';
        this.nama = 'Pendiri';
      }
      if (route.name === 'TambahDewanPengawas' || route.name === 'EditDewanPengawas') {
        this.officer.tipe = 2;
        this.link = 'dewan-pengawas';
        this.nama = 'Dewan Pengawas';
      }
      if (route.name === 'TambahPengurus' || route.name === 'EditPengurus') {
        this.officer.tipe = 3;
        this.link = 'pengurus';
        this.nama = 'Pengurus';
      }
    }
  },
  mounted: function mounted() {
    this.checkRoute(this.$route);
    this.id_officer = this.$route.params.id;
    if (this.id_officer != null) {
      this.getDetail();
    }
  },
  '$route': function $route(to, from) {
    this.checkRoute(to);
    this.getData();
  }
});

/***/ }),

/***/ "XFI6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_api__ = __webpack_require__("+Btm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ListWhistleBlower',
  data: function data() {
    return {
      result: {},
      list: [],
      currentPage: 1,
      perPage: 10,
      search: '',
      isLoading: true
    };
  },

  methods: {
    getData: function getData() {
      var _this = this;

      var params = {
        search: this.search,
        page: this.currentPage - 1,
        size: this.perPage
      };

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].get('/getAllWhistleblower?' + __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(params)).then(function (res) {
        _this.result = res.data;
        _this.list = res.data.content;
        _this.isLoading = false;
      }).catch(function () {
        _this.isLoading = false;
      });
    },
    confirmDelete: function confirmDelete(id) {
      var _this2 = this;

      this.$swal({
        title: 'Konfirmasi',
        text: 'Anda yakin ingin menghapus data ini?',
        icon: 'warning',
        buttons: [true, { text: 'Ok', closeModal: false }],
        dangerMode: true
      }).then(function (result) {
        if (result) _this2.delete(id);
      });
    },
    delete: function _delete(id) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].delete('/whistleblower/' + id).then(function (res) {
        if (res.data.code === 200) {
          _this3.$toastr.s('Data berhasil dihapus.');
          _this3.getData();
        } else {
          _this3.$toastr.e('Gagal menghapus data.');
        }
        _this3.$swal.close();
      }).catch(function () {
        _this3.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this3.$swal.close();
      });
    }
  },
  mounted: function mounted() {
    this.getData();
  },

  watch: {
    currentPage: function currentPage() {
      this.getData();
    },
    perPage: function perPage() {
      this.getData();
    },
    search: function search() {
      this.getData();
    }
  }
});

/***/ }),

/***/ "XcCb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_ckeditor2__ = __webpack_require__("42+j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__ = __webpack_require__("w3AW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_api__ = __webpack_require__("+Btm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone__ = __webpack_require__("KvPw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_dropzone_dist_vue2Dropzone_css__ = __webpack_require__("hCol");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_dropzone_dist_vue2Dropzone_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_dropzone_dist_vue2Dropzone_css__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FormLine: __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__["a" /* default */],
    Ckeditor: __WEBPACK_IMPORTED_MODULE_1_vue_ckeditor2__["a" /* default */],
    vueDropzone: __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone___default.a
  },
  name: 'ListNarasumber',
  data: function data() {
    return {
      date: {
        dateFormat: 'Y-m-d',
        allowInput: true
      },
      config: {
        toolbar: [{ name: 'stuff', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] }, { name: 'morestuff', items: ['NumberedList', 'BulletedList'] }, { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Superscript', 'Subscript'] }, { name: 'colors', items: ['TextColor'] }, { name: 'paragraph2', items: ['JustifyLeft', 'JustiftyCenter', 'JustifyRight', 'Outdent', 'Indent'] }, '/', { name: 'document', items: ['Source'] }],
        height: 300
      },
      content: {
        judul: '',
        tipe: '',
        tahun: '',
        tags: '',
        thumbnail: '',
        bermaterai: false
      },
      file: '',
      id_unduh: '',
      nama: '',
      tipe: '',
      link: '',
      thumbnailUrl: ''
    };
  },
  computed: {
    dropzoneOptionsFormulir: function dropzoneOptionsFormulir() {
      if (this.id_unduh != null) {
        return {
          url: __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.baseURL + '/upload_image_dropzoneUnduhFormulir?id=' + this.id_unduh,
          thumbnailWidth: 150,
          addRemoveLinks: true,
          maxFiles: 1,
          maxFilesize: 2,
          dictRemoveFileConfirmation: 'Anda yakin ingin menghapus file ini?',
          headers: { Authorization: 'Bearer ' + localStorage.getItem('_token') },
          params: { id_unduh: this.id_unduh }
        };
      }
    }
  },
  methods: {
    save: function save() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      var form = new FormData();
      form.append('file', this.file);
      form.append('json', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.content));
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].post('/unduh', form).then(function (result) {
        if (result.data.code === 200) {
          if (_this.link === 'laporan') {
            _this.$router.replace('/main/unduh/laporan/' + result.data.object.id_unduh);
          } else if (_this.link === 'formulir') {
            _this.$router.replace('/main/unduh/formulir/');
          }
          _this.$toastr.s('Tambah data berhasil');
        } else {
          var msg = 'Tambah data gagal';
          if (result.data.message !== '') msg = result.data.message;
          _this.$toastr.e(msg);
        }
      }).catch(function (e) {
        var msg = 'Terjadi kesalahan pada server, mohon ulangi';
        if (e.response.data.message) msg = e.response.data.message;
        _this.$toastr.e(msg);
      });
    },
    update: function update() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      var form = new FormData();
      form.append('file', this.file);
      form.append('json', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.content));
      console.log('ini form', form);
      console.log('ini form content', this.content);
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].post('/unduh/' + this.id_unduh, form).then(function (result) {
        if (result.data.code === 200) {
          _this2.$router.replace('/main/unduh/' + _this2.link);
          _this2.$toastr.s('Ubah data berhasil');
        }
      }).catch(function (ex) {
        var msg = 'Terjadi kesalahan pada server, mohon ulangi';
        if (ex.response.data.message) msg = ex.response.data.message;
        _this2.$toastr.e(msg);
      });
    },
    getDetail: function getDetail() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].get('/unduh/' + this.id_unduh).then(function (result) {
        _this3.content = result.data;
        if (_this3.content.thumbnail) {
          var mockFile = {
            name: 'Thumbnail Laporan',
            size: 123456,
            type: 'image/jpeg'
          };
          _this3.$refs.thumbnailFormulir.manuallyAddFile(mockFile, _this3.content.thumbnail);
        }
        console.log("ini hasil datanya: " + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this3.content, null, 2));
      }).catch(function (ex) {
        _this3.$toastr.e('Terjadi kesalahan pada server, mohon ulangi');
      });
    },
    onUploadSuccess: function onUploadSuccess(file, response) {
      // response.url berasal dari Spring Boot
      this.thumbnailUrl = response.url;
      this.content.thumbnail = response.fileName;
      console.log('Thumbnail uploaded to:', this.content.thumbnailUrl);
    },
    vremoved: function vremoved(file, xhr, error) {
      console.log("ini filenya", file);
      this.delete(file.name.id);
    },
    handleFile: function handleFile(file) {
      this.file = file.target.files[0];
    },
    checkRoute: function checkRoute(route) {
      console.log(route.name);
      if (route.name === 'TambahLaporan' || route.name === 'EditLaporan') {
        this.link = 'laporan';
        this.nama = 'Laporan';
      }
      if (route.name === 'TambahFormulir' || route.name === 'EditFormulir') {
        this.link = 'formulir';
        this.nama = 'Formulir';
      }
    }
  },
  mounted: function mounted() {
    this.checkRoute(this.$route);
    this.id_unduh = this.$route.params.id;
    if (this.id_unduh != null) {
      this.getDetail();
    }
  },

  watch: {
    '$route': function $route(to, from) {
      this.checkRoute(to);
      this.id_unduh = to.params.id;
      if (this.id_unduh) {
        this.getDetail();
      }
    }
  }
});

/***/ }),

/***/ "Xj5W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"login-box"},[_c('div',{staticClass:"card",staticStyle:{"margin-top":"38%"}},[_c('div',{staticClass:"body"},[_c('img',{staticStyle:{"margin":"0 auto","display":"block","z-index":"2","margin-top":"-82px","width":"30%","padding-top":"10px","margin-bottom":"15px"},attrs:{"src":__webpack_require__("7Otq")}}),_vm._v(" "),_c('form',{ref:"form",attrs:{"id":"sign_in","method":"POST"},on:{"submit":function($event){$event.preventDefault();return _vm.login.apply(null, arguments)}}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"input-group"},[_vm._m(1),_vm._v(" "),_c('formline',{ref:"username",attrs:{"type":"text","name":"username","placeholder":"Username","required":"","autofocus":""},model:{value:(_vm.user.username),callback:function ($$v) {_vm.$set(_vm.user, "username", $$v)},expression:"user.username"}})],1),_vm._v(" "),_c('div',{staticClass:"input-group"},[_vm._m(2),_vm._v(" "),_c('form-line',{attrs:{"type":"password","name":"password","placeholder":"Password","required":""},model:{value:(_vm.user.password),callback:function ($$v) {_vm.$set(_vm.user, "password", $$v)},expression:"user.password"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin":"0 auto","display":"block","text-align":"center"}},[_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect",staticStyle:{"color":"#fff"},attrs:{"disabled":_vm.isLoading}},[(!_vm.isLoading)?_c('span',[_vm._v("MASUK")]):_c('span',[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" Loading")])])]),_vm._v(" "),_c('div',{staticClass:"row m-t-15 m-b--20"},[_c('div',{staticStyle:{"text-align":"center","padding-bottom":"5%"}},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.$router.push('lupa-password')}}},[_vm._v("Lupa Password?")])])])])])])]),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('a',{staticStyle:{"color":"#333","font-size":"28px"},attrs:{"href":"#"}},[_vm._v("Admin"),_c('b',[_vm._v("DAPENBI")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"material-icons"},[_vm._v("person")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"material-icons"},[_vm._v("lock")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center","color":"#fff"}},[_c('p',[_vm._v("copyright 2018 | Dana Pensiun Indonesia")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center","color":"#fff"}},[_c('p',[_vm._v("Designed by "),_c('a',{staticStyle:{"color":"#fff"},attrs:{"href":"http://birutekno.com/"}},[_vm._v("Birutekno Inc")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Y8kw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{attrs:{"id":"calendar"}}),_vm._v(" "),(_vm.showModal)?_c('div',{staticClass:"modal-overlay"},[_c('div',{staticClass:"modal-box"},[_c('h5',[_vm._v("Edit Event")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editEventTitle),expression:"editEventTitle"}],staticClass:"form-input",attrs:{"placeholder":"Judul Event Baru"},domProps:{"value":(_vm.editEventTitle)},on:{"input":function($event){if($event.target.composing){ return; }_vm.editEventTitle=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"modal-actions"},[_c('button',{staticClass:"btn btn-danger",on:{"click":_vm.deleteEvent}},[_vm._v("Hapus")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.updateEvent}},[_vm._v("Simpan")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary",on:{"click":function($event){_vm.showModal = false}}},[_vm._v("Batal")])])])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YJoP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FormLine_vue__ = __webpack_require__("w3AW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_api__ = __webpack_require__("+Btm");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_0__components_FormLine_vue__["a" /* default */] },
  name: 'FormSurvey',
  data: function data() {
    return {
      data: {
        pernyataan: '',
        periode: ''
      },
      id_master_survey: '',
      isLoading: false
    };
  },
  methods: {
    save: function save() {
      var _this = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].post('/survey', this.data).then(function (result) {
        if (result.data.code === 200) {
          _this.$router.replace('/main/layanan/survey');
          _this.$toastr.s('Tambah data berhasil');
        } else {
          var msg = 'Tambah data gagal';
          if (result.data.message !== '') msg = result.data.message;
          _this.$toastr.e(msg);
        }
        _this.isLoading = false;
      }).catch(function (e) {
        var msg = 'Terjadi kesalahan pada server, mohon ulangi';
        if (e.response.data.message) msg = e.response.data.message;
        _this.$toastr.e(msg);
        _this.isLoading = false;
      });
    },
    update: function update() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].post('/survey/' + this.id_master_survey, this.data).then(function (result) {
        if (result.data.code === 200) {
          _this2.$router.replace('/main/layanan/survey');
          _this2.$toastr.s('Ubah data berhasil');
        }
      }).catch(function (ex) {
        _this2.$toastr.e('Terjadi kesalahan pada server, mohon ulangi');
      });
    },
    getDetail: function getDetail() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].get('/survey/' + this.id_master_survey).then(function (result) {
        _this3.data = result.data;
      }).catch(function (ex) {
        _this3.$toastr.e('Terjadi kesalahan pada server, mohon ulangi');
      });
    }
  },
  beforeMount: function beforeMount() {
    this.id_master_survey = this.$route.params.id;
    if (this.id_master_survey != null) {
      this.getDetail();
    }
  }
});

/***/ }),

/***/ "YNmZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormRegulasi_vue__ = __webpack_require__("dDaf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_716094de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormRegulasi_vue__ = __webpack_require__("SDXa");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormRegulasi_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_716094de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormRegulasi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Login__ = __webpack_require__("xJsL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Main__ = __webpack_require__("s6+2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__view_Dashboard__ = __webpack_require__("pRQ6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__view_Narasumber_ListNarasumber__ = __webpack_require__("I1X7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__view_Narasumber_FormNarasumber__ = __webpack_require__("Ux2e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__view_Profile_Sejarah_ListSejarah__ = __webpack_require__("CrcI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__view_Profile_Sejarah_FormSejarah__ = __webpack_require__("un2g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__view_Profile_VisiMisi_ListVisiMisi__ = __webpack_require__("w4cZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__view_Profile_VisiMisi_FormVisiMisi__ = __webpack_require__("t8bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__view_Profile_Pendiri_ListPendiri__ = __webpack_require__("bOEj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__view_Profile_Pendiri_FormPendiri__ = __webpack_require__("bsbE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__view_Profile_StrukturOrganisasi_FormStrukturOrganisasi__ = __webpack_require__("hAd8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__view_Unduh_PDP_ListPDP__ = __webpack_require__("twRk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__view_Unduh_PDP_FormPDP__ = __webpack_require__("LFEs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__view_Unduh_Regulasi_ListRegulasi__ = __webpack_require__("FBlO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__view_Unduh_Regulasi_FormRegulasi__ = __webpack_require__("YNmZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__view_Unduh_Majalah_ListMajalah__ = __webpack_require__("6Z9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__view_Unduh_Majalah_FormMajalah__ = __webpack_require__("qJtc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__view_Unduh_MateriKomunikasi_ListMateriKomunikasi__ = __webpack_require__("SvOM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__view_Unduh_MateriKomunikasi_FormMateriKomunikasi__ = __webpack_require__("9o4n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__view_Unduh_Unduh_ListUnduh__ = __webpack_require__("B8VL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__view_Unduh_Unduh_FormUnduh__ = __webpack_require__("I2J/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__view_Informasi_Download_ListDownload__ = __webpack_require__("TRSD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__view_Informasi_Download_FormDownload__ = __webpack_require__("EQq4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__view_Informasi_Kegiatan_ListKegiatan__ = __webpack_require__("rVHH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__view_Informasi_Kegiatan_FormKegiatan__ = __webpack_require__("2obV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__view_Informasi_HubungiKami__ = __webpack_require__("GY0c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__view_Informasi_Galeri__ = __webpack_require__("e4lX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__view_Informasi_FormGaleri__ = __webpack_require__("5KM7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__view_ListWhistleBlower__ = __webpack_require__("wlFM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__view_FormWhistleBlower__ = __webpack_require__("vle0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__view_Notifikasi__ = __webpack_require__("P5iR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__view_Headline__ = __webpack_require__("1TRU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__view_ListSlider__ = __webpack_require__("WcS9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__view_FormSlider__ = __webpack_require__("zt+8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__view_ListAnakPerusahaan__ = __webpack_require__("7jcm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__view_FormAnakPerusahaan__ = __webpack_require__("Rrzt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__view_Faq_ListFaq__ = __webpack_require__("hERV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__view_Faq_FormFaq__ = __webpack_require__("DY5s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__view_Survey_ListSurvey__ = __webpack_require__("OQPl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__view_Survey_FormSurvey__ = __webpack_require__("aTK2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__view_Survey_HasilSurvey__ = __webpack_require__("BeCg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__view_IdentitasPemotong_ListIdentitasPemotong__ = __webpack_require__("8bOl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__view_IdentitasPemotong_FormIdentitasPemotong__ = __webpack_require__("aqMw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__view_Upload__ = __webpack_require__("9eLg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_LupaPassword__ = __webpack_require__("C7es");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_ResetPassword__ = __webpack_require__("yiqP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__view_ListKelengkapan__ = __webpack_require__("g3uV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__view_Anggota_ListAnggota__ = __webpack_require__("8kuy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__view_Anggota_TambahAnggota__ = __webpack_require__("Jmzn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__view_Anggota_EditAnggota__ = __webpack_require__("b5g7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__view_Admin_ListAdmin__ = __webpack_require__("GTHR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__view_Admin_FormAdmin__ = __webpack_require__("uzGR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__view_ListLog__ = __webpack_require__("aXOa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__view_Form__ = __webpack_require__("Dkb2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_vue_body_class__ = __webpack_require__("yfhv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_vue_body_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57_vue_body_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__view_Informasi_Artikel_Artikel_vue__ = __webpack_require__("7XIS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__view_Informasi_Artikel_ListArtikel_vue__ = __webpack_require__("WoKI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__view_KritikdanSaran_KritikDanSaranList_vue__ = __webpack_require__("yf5h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__view_KritikdanSaran_KritikDanSaran_vue__ = __webpack_require__("Z0YD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__view_Pengaduan_Pengaduan_vue__ = __webpack_require__("8Sv/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__view_Pengaduan_PengaduanList_vue__ = __webpack_require__("o1lT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__view_Pengumuman_PengumumanList_vue__ = __webpack_require__("U2rS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__view_Pengumuman_Pengumuman_vue__ = __webpack_require__("y/qq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__view_PintasanInformasi_PintasanInformasi_vue__ = __webpack_require__("aWiB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__view_PintasanInformasi_ListPintasanInformasi_vue__ = __webpack_require__("y8rx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__view_Banners_ListBanner_vue__ = __webpack_require__("VnPW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__view_Banners_Banner_vue__ = __webpack_require__("fCMu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__view_Kalender_Calender_vue__ = __webpack_require__("KcQp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__view_CetakApprove_vue__ = __webpack_require__("5Hvf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__view_HakdanKewajiban_ListHakdanKewajiban_vue__ = __webpack_require__("EY2h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__view_HakdanKewajiban_FormHakdanKewajiban_vue__ = __webpack_require__("ozmR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__view_PensiunRegistrasi_PensiunTypeList_vue__ = __webpack_require__("KSq6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__view_PensiunRegistrasi_FormPensiunType_vue__ = __webpack_require__("pJTr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__view_Faq_CategoryFaq_vue__ = __webpack_require__("o9k4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__view_Faq_ListCategoryFaq_vue__ = __webpack_require__("ODd4");







































































// import ListBanner from '../view/Banners/ListBanner.vue'













__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{ path: '/login', name: 'Login', component: __WEBPACK_IMPORTED_MODULE_2__components_Login__["a" /* default */], meta: { bodyClass: 'login-page', noRequiredAuth: true } }, { path: '/lupa-password', name: 'LupaPassword', component: __WEBPACK_IMPORTED_MODULE_47__components_LupaPassword__["a" /* default */], meta: { bodyClass: 'login-page', noRequiredAuth: true } }, { path: '/reset-password/:token', name: 'ResetPassword', component: __WEBPACK_IMPORTED_MODULE_48__components_ResetPassword__["a" /* default */], meta: { bodyClass: 'login-page', noRequiredAuth: true } }, { path: '/', redirect: '/login', meta: { noRequiredAuth: true } }, { path: '*', redirect: '/', meta: { noRequiredAuth: true } }, {
    path: '/main',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Main__["a" /* default */],
    meta: {
      bodyClass: 'theme-red'
    },
    children: [{ path: 'dashboard', name: 'Dashboard', component: __WEBPACK_IMPORTED_MODULE_4__view_Dashboard__["a" /* default */] },
    // Narasumber
    { path: 'narasumber', name: 'ListNarasumber', component: __WEBPACK_IMPORTED_MODULE_5__view_Narasumber_ListNarasumber__["a" /* default */] }, { path: 'narasumber/tambah', name: 'TambahNarasumber', component: __WEBPACK_IMPORTED_MODULE_6__view_Narasumber_FormNarasumber__["a" /* default */] }, { path: 'narasumber/edit/:id', name: 'EditNarasumber', component: __WEBPACK_IMPORTED_MODULE_6__view_Narasumber_FormNarasumber__["a" /* default */] },
    // Visi Misi
    { path: 'profile/visi-misi', name: 'ListVisiMisi', component: __WEBPACK_IMPORTED_MODULE_9__view_Profile_VisiMisi_ListVisiMisi__["a" /* default */] }, { path: 'profile/visi-misi/tambah', name: 'TambahVisiMisi', component: __WEBPACK_IMPORTED_MODULE_10__view_Profile_VisiMisi_FormVisiMisi__["a" /* default */] }, { path: 'profile/visi-misi/edit/:id', name: 'EditVisiMisi', component: __WEBPACK_IMPORTED_MODULE_10__view_Profile_VisiMisi_FormVisiMisi__["a" /* default */] },
    // Pendiri
    { path: 'profile/pendiri', name: 'ListPendiri', component: __WEBPACK_IMPORTED_MODULE_11__view_Profile_Pendiri_ListPendiri__["a" /* default */] }, { path: 'profile/pendiri/tambah', name: 'TambahPendiri', component: __WEBPACK_IMPORTED_MODULE_12__view_Profile_Pendiri_FormPendiri__["a" /* default */] }, { path: 'profile/pendiri/edit/:id', name: 'EditPendiri', component: __WEBPACK_IMPORTED_MODULE_12__view_Profile_Pendiri_FormPendiri__["a" /* default */] },
    // Dewan Pengawas
    { path: 'profile/dewan-pengawas', name: 'ListDewanPengawas', component: __WEBPACK_IMPORTED_MODULE_11__view_Profile_Pendiri_ListPendiri__["a" /* default */] }, { path: 'profile/dewan-pengawas/tambah', name: 'TambahDewanPengawas', component: __WEBPACK_IMPORTED_MODULE_12__view_Profile_Pendiri_FormPendiri__["a" /* default */] }, { path: 'profile/dewan-pengawas/edit/:id', name: 'EditDewanPengawas', component: __WEBPACK_IMPORTED_MODULE_12__view_Profile_Pendiri_FormPendiri__["a" /* default */] },
    // Pengurus
    { path: 'profile/pengurus', name: 'ListPengurus', component: __WEBPACK_IMPORTED_MODULE_11__view_Profile_Pendiri_ListPendiri__["a" /* default */] }, { path: 'profile/pengurus/tambah', name: 'TambahPengurus', component: __WEBPACK_IMPORTED_MODULE_12__view_Profile_Pendiri_FormPendiri__["a" /* default */] }, { path: 'profile/pengurus/edit/:id', name: 'EditPengurus', component: __WEBPACK_IMPORTED_MODULE_12__view_Profile_Pendiri_FormPendiri__["a" /* default */] },
    // Sejarah
    { path: 'profile/sejarah', name: 'ListSejarah', component: __WEBPACK_IMPORTED_MODULE_7__view_Profile_Sejarah_ListSejarah__["a" /* default */] }, { path: 'profile/sejarah/tambah', name: 'TambahSejarah', component: __WEBPACK_IMPORTED_MODULE_8__view_Profile_Sejarah_FormSejarah__["a" /* default */] }, { path: 'profile/sejarah/edit/:id', name: 'EditSejarah', component: __WEBPACK_IMPORTED_MODULE_8__view_Profile_Sejarah_FormSejarah__["a" /* default */] },
    // Struktur Organisasi
    { path: 'profile/struktur-organisasi', name: 'StrukturOrganisasi', component: __WEBPACK_IMPORTED_MODULE_13__view_Profile_StrukturOrganisasi_FormStrukturOrganisasi__["a" /* default */] },
    // Budaya Kerja
    { path: 'profile/budaya-kerja', name: 'ListBudayaKerja', component: __WEBPACK_IMPORTED_MODULE_9__view_Profile_VisiMisi_ListVisiMisi__["a" /* default */] }, { path: 'profile/budaya-kerja/tambah', name: 'TambahBudayaKerja', component: __WEBPACK_IMPORTED_MODULE_10__view_Profile_VisiMisi_FormVisiMisi__["a" /* default */] }, { path: 'profile/budaya-kerja/edit/:id', name: 'EditBudayaKerja', component: __WEBPACK_IMPORTED_MODULE_10__view_Profile_VisiMisi_FormVisiMisi__["a" /* default */] },
    // Informasi Kegiatan
    { path: 'informasi/kegiatan', name: 'ListKegiatan', component: __WEBPACK_IMPORTED_MODULE_26__view_Informasi_Kegiatan_ListKegiatan__["a" /* default */] }, { path: 'informasi/kegiatan/tambah', name: 'TambahKegiatan', component: __WEBPACK_IMPORTED_MODULE_27__view_Informasi_Kegiatan_FormKegiatan__["a" /* default */] }, { path: 'informasi/kegiatan/edit/:id', name: 'EditKegiatan', component: __WEBPACK_IMPORTED_MODULE_27__view_Informasi_Kegiatan_FormKegiatan__["a" /* default */] },
    // Informasi artikel
    { path: 'informasi/artikel', name: 'ListArtikel', component: __WEBPACK_IMPORTED_MODULE_59__view_Informasi_Artikel_ListArtikel_vue__["a" /* default */] }, { path: 'informasi/artikel/tambah', name: 'TambahArtikel', component: __WEBPACK_IMPORTED_MODULE_58__view_Informasi_Artikel_Artikel_vue__["a" /* default */] }, { path: 'informasi/artikel/edit/:id', name: 'EditArtikel', component: __WEBPACK_IMPORTED_MODULE_58__view_Informasi_Artikel_Artikel_vue__["a" /* default */] }, { path: 'informasi/perkembangan', name: 'ListPerkembangan', component: __WEBPACK_IMPORTED_MODULE_24__view_Informasi_Download_ListDownload__["a" /* default */] }, { path: 'informasi/perkembangan/tambah', name: 'TambahPerkembangan', component: __WEBPACK_IMPORTED_MODULE_25__view_Informasi_Download_FormDownload__["a" /* default */] }, { path: 'informasi/perkembangan/edit/:id', name: 'EditPerkembangan', component: __WEBPACK_IMPORTED_MODULE_25__view_Informasi_Download_FormDownload__["a" /* default */] },
    // Galeri
    { path: 'informasi/galeri', name: 'Galeri', component: __WEBPACK_IMPORTED_MODULE_29__view_Informasi_Galeri__["a" /* default */] }, { path: 'informasi/galeri/tambah', name: 'TambahGaleri', component: __WEBPACK_IMPORTED_MODULE_30__view_Informasi_FormGaleri__["a" /* default */] }, { path: 'informasi/galeri/edit/:id', name: 'EditGaleri', component: __WEBPACK_IMPORTED_MODULE_30__view_Informasi_FormGaleri__["a" /* default */] },
    // Informasi Tahunan
    { path: 'informasi/tahunan', name: 'ListTahunan', component: __WEBPACK_IMPORTED_MODULE_24__view_Informasi_Download_ListDownload__["a" /* default */] }, { path: 'informasi/tahunan/tambah', name: 'TambahTahunan', component: __WEBPACK_IMPORTED_MODULE_25__view_Informasi_Download_FormDownload__["a" /* default */] }, { path: 'informasi/tahunan/edit/:id', name: 'EditTahunan', component: __WEBPACK_IMPORTED_MODULE_25__view_Informasi_Download_FormDownload__["a" /* default */] },
    // Informasi Lowongan
    { path: 'informasi/lowongan', name: 'ListLowongan', component: __WEBPACK_IMPORTED_MODULE_24__view_Informasi_Download_ListDownload__["a" /* default */] }, { path: 'informasi/lowongan/tambah', name: 'TambahLowongan', component: __WEBPACK_IMPORTED_MODULE_25__view_Informasi_Download_FormDownload__["a" /* default */] }, { path: 'informasi/lowongan/edit/:id', name: 'EditLowongan', component: __WEBPACK_IMPORTED_MODULE_25__view_Informasi_Download_FormDownload__["a" /* default */] },
    // PDP
    { path: 'unduh/pdp', name: 'ListPDP', component: __WEBPACK_IMPORTED_MODULE_14__view_Unduh_PDP_ListPDP__["a" /* default */] }, { path: 'unduh/pdp/tambah', name: 'TambahPDP', component: __WEBPACK_IMPORTED_MODULE_15__view_Unduh_PDP_FormPDP__["a" /* default */] }, { path: 'unduh/pdp/edit/:id', name: 'EditPDP', component: __WEBPACK_IMPORTED_MODULE_15__view_Unduh_PDP_FormPDP__["a" /* default */] },
    // Arahan
    { path: 'unduh/arahan', name: 'ListArahan', component: __WEBPACK_IMPORTED_MODULE_14__view_Unduh_PDP_ListPDP__["a" /* default */] }, { path: 'unduh/arahan/tambah', name: 'TambahArahan', component: __WEBPACK_IMPORTED_MODULE_15__view_Unduh_PDP_FormPDP__["a" /* default */] }, { path: 'unduh/arahan/edit/:id', name: 'EditArahan', component: __WEBPACK_IMPORTED_MODULE_15__view_Unduh_PDP_FormPDP__["a" /* default */] },
    // Regulasi
    { path: 'unduh/regulasi', name: 'ListRegulasi', component: __WEBPACK_IMPORTED_MODULE_16__view_Unduh_Regulasi_ListRegulasi__["a" /* default */] }, { path: 'unduh/regulasi/tambah', name: 'TambahRegulasi', component: __WEBPACK_IMPORTED_MODULE_17__view_Unduh_Regulasi_FormRegulasi__["a" /* default */] }, { path: 'unduh/regulasi/edit/:id', name: 'EditRegulasi', component: __WEBPACK_IMPORTED_MODULE_17__view_Unduh_Regulasi_FormRegulasi__["a" /* default */] },
    // Majalah
    { path: 'unduh/majalah', name: 'ListMajalah', component: __WEBPACK_IMPORTED_MODULE_18__view_Unduh_Majalah_ListMajalah__["a" /* default */] }, { path: 'unduh/majalah/tambah', name: 'TambahMajalah', component: __WEBPACK_IMPORTED_MODULE_19__view_Unduh_Majalah_FormMajalah__["a" /* default */] }, { path: 'unduh/majalah/edit/:id', name: 'EditMajalah', component: __WEBPACK_IMPORTED_MODULE_19__view_Unduh_Majalah_FormMajalah__["a" /* default */] },
    // MateriKomunikasi
    { path: 'unduh/materiKomunikasi', name: 'ListMateriKomunikasi', component: __WEBPACK_IMPORTED_MODULE_20__view_Unduh_MateriKomunikasi_ListMateriKomunikasi__["a" /* default */] }, { path: 'unduh/materiKomunikasi/tambah', name: 'TambahMateriKomunikasi', component: __WEBPACK_IMPORTED_MODULE_21__view_Unduh_MateriKomunikasi_FormMateriKomunikasi__["a" /* default */] }, { path: 'unduh/materiKomunikasi/edit/:id', name: 'EditMateriKomunikasi', component: __WEBPACK_IMPORTED_MODULE_21__view_Unduh_MateriKomunikasi_FormMateriKomunikasi__["a" /* default */] },
    // Laporan
    { path: 'unduh/laporan', name: 'ListLaporan', component: __WEBPACK_IMPORTED_MODULE_22__view_Unduh_Unduh_ListUnduh__["a" /* default */] }, { path: 'unduh/laporan/tambah', name: 'TambahLaporan', component: __WEBPACK_IMPORTED_MODULE_23__view_Unduh_Unduh_FormUnduh__["a" /* default */] }, { path: 'unduh/laporan/edit/:id', name: 'EditLaporan', component: __WEBPACK_IMPORTED_MODULE_23__view_Unduh_Unduh_FormUnduh__["a" /* default */] },
    // Formulir
    { path: 'unduh/formulir', name: 'ListFormulir', component: __WEBPACK_IMPORTED_MODULE_22__view_Unduh_Unduh_ListUnduh__["a" /* default */] }, { path: 'unduh/formulir/tambah', name: 'TambahFormulir', component: __WEBPACK_IMPORTED_MODULE_23__view_Unduh_Unduh_FormUnduh__["a" /* default */] }, { path: 'unduh/formulir/edit/:id', name: 'EditFormulir', component: __WEBPACK_IMPORTED_MODULE_23__view_Unduh_Unduh_FormUnduh__["a" /* default */] },
    // HubungiKami
    { path: 'whistleblower', name: 'ListWhistleBlower', component: __WEBPACK_IMPORTED_MODULE_31__view_ListWhistleBlower__["a" /* default */] }, { path: 'whistleblower/tambah', name: 'TambahWhistleBlower', component: __WEBPACK_IMPORTED_MODULE_32__view_FormWhistleBlower__["a" /* default */] }, { path: 'whistleblower/edit/:id', name: 'EditWhistleBlowern', component: __WEBPACK_IMPORTED_MODULE_32__view_FormWhistleBlower__["a" /* default */] },
    // Slider
    { path: 'slider', name: 'ListSlider', component: __WEBPACK_IMPORTED_MODULE_35__view_ListSlider__["a" /* default */] }, { path: 'slider/tambah', name: 'TambahSlider', component: __WEBPACK_IMPORTED_MODULE_36__view_FormSlider__["a" /* default */] }, { path: 'slider/edit/:id', name: 'EditSlider', component: __WEBPACK_IMPORTED_MODULE_36__view_FormSlider__["a" /* default */] },
    // Anak Perusahaan
    { path: 'anak-perusahaan', name: 'ListAnakPerusahaan', component: __WEBPACK_IMPORTED_MODULE_37__view_ListAnakPerusahaan__["a" /* default */] }, { path: 'anak-perusahaan/tambah', name: 'TambahAnakPerusahaan', component: __WEBPACK_IMPORTED_MODULE_38__view_FormAnakPerusahaan__["a" /* default */] }, { path: 'anak-perusahaan/edit/:id', name: 'EditAnakPerusahaan', component: __WEBPACK_IMPORTED_MODULE_38__view_FormAnakPerusahaan__["a" /* default */] },
    // FaQ
    { path: 'faq', name: 'ListFaq', component: __WEBPACK_IMPORTED_MODULE_39__view_Faq_ListFaq__["a" /* default */] }, { path: 'faq/tambah', name: 'TambahFaq', component: __WEBPACK_IMPORTED_MODULE_40__view_Faq_FormFaq__["a" /* default */] }, { path: 'faq/TambahFaqCategory', name: 'TambahFaqCategory', component: __WEBPACK_IMPORTED_MODULE_76__view_Faq_CategoryFaq_vue__["a" /* default */] }, { path: 'faq/Categoryfaq', name: 'ListCategoryFaq', component: __WEBPACK_IMPORTED_MODULE_77__view_Faq_ListCategoryFaq_vue__["a" /* default */] }, { path: 'faq/editCategory/:id', name: 'EditFaqCategory', component: __WEBPACK_IMPORTED_MODULE_76__view_Faq_CategoryFaq_vue__["a" /* default */] },
    // LOG
    { path: 'log', name: 'ListLog', component: __WEBPACK_IMPORTED_MODULE_55__view_ListLog__["a" /* default */] },
    // Kelengkapan
    { path: 'layanan/kelengkapan', name: 'ListKelengkapan', component: __WEBPACK_IMPORTED_MODULE_49__view_ListKelengkapan__["a" /* default */] },
    // Survey
    { path: 'syarat', name: 'SyaratKepesertaan', component: __WEBPACK_IMPORTED_MODULE_56__view_Form__["a" /* default */] }, { path: 'cara', name: 'CaraMendaftar', component: __WEBPACK_IMPORTED_MODULE_56__view_Form__["a" /* default */] }, { path: 'faq/edit/:id', name: 'EditFaq', component: __WEBPACK_IMPORTED_MODULE_40__view_Faq_FormFaq__["a" /* default */] }, { path: 'layanan/survey', name: 'ListSurvey', component: __WEBPACK_IMPORTED_MODULE_41__view_Survey_ListSurvey__["a" /* default */] }, { path: 'layanan/survey/tambah', name: 'TambahSurvey', component: __WEBPACK_IMPORTED_MODULE_42__view_Survey_FormSurvey__["a" /* default */] }, { path: 'layanan/survey/edit/:id', name: 'EditSurvey', component: __WEBPACK_IMPORTED_MODULE_42__view_Survey_FormSurvey__["a" /* default */] }, { path: 'layanan/survey/hasil', name: 'HasilSurvey', component: __WEBPACK_IMPORTED_MODULE_43__view_Survey_HasilSurvey__["a" /* default */] }, { path: 'layanan/KritikDanSaran', name: 'KritikDanSaran', component: __WEBPACK_IMPORTED_MODULE_60__view_KritikdanSaran_KritikDanSaranList_vue__["a" /* default */] }, { path: 'layanan/KritikDanSaran/:id', name: 'EditKritikDanSaran', component: __WEBPACK_IMPORTED_MODULE_61__view_KritikdanSaran_KritikDanSaran_vue__["a" /* default */] }, { path: 'layanan/Pengaduan/', name: 'Pengaduan', component: __WEBPACK_IMPORTED_MODULE_63__view_Pengaduan_PengaduanList_vue__["a" /* default */] }, { path: 'layanan/Pengaduan/edit/:id', name: 'EditPengaduan', component: __WEBPACK_IMPORTED_MODULE_62__view_Pengaduan_Pengaduan_vue__["a" /* default */] },
    // Informasi Perkembangan
    // cetak Approve
    { path: 'layanan/cetakMP/', name: 'cetakMP', component: __WEBPACK_IMPORTED_MODULE_71__view_CetakApprove_vue__["a" /* default */] },

    // pengumuman
    { path: 'pengumuman/pengumuman', name: 'ListPengumuman', component: __WEBPACK_IMPORTED_MODULE_64__view_Pengumuman_PengumumanList_vue__["a" /* default */] }, { path: 'pengumuman/pengumuman/tambah', name: 'TambahPengumuman', component: __WEBPACK_IMPORTED_MODULE_65__view_Pengumuman_Pengumuman_vue__["a" /* default */] }, { path: 'pengumuman/pengumuman/edit/:id', name: 'EditPengumuman', component: __WEBPACK_IMPORTED_MODULE_65__view_Pengumuman_Pengumuman_vue__["a" /* default */] },

    // pensiunType
    { path: 'pensiunRegistrasi/pensiuntype', name: 'ListPensiuntype', component: __WEBPACK_IMPORTED_MODULE_74__view_PensiunRegistrasi_PensiunTypeList_vue__["a" /* default */] }, { path: 'pensiunRegistrasi/pensiuntype/tambah', name: 'TambahPensiunType', component: __WEBPACK_IMPORTED_MODULE_75__view_PensiunRegistrasi_FormPensiunType_vue__["a" /* default */] }, { path: 'pensiunRegistrasi/pensiuntype/edit/:id', name: 'EditPensiunType', component: __WEBPACK_IMPORTED_MODULE_75__view_PensiunRegistrasi_FormPensiunType_vue__["a" /* default */] },
    // hak dan kewajiban
    { path: 'HakdanWajiban/ListHakdanKewajiban', name: 'ListHakKewajiban', component: __WEBPACK_IMPORTED_MODULE_72__view_HakdanKewajiban_ListHakdanKewajiban_vue__["a" /* default */] }, { path: 'HakdanWajiban/ListHakdanKewajiban/tambah', name: 'TambahHakKewajiabn', component: __WEBPACK_IMPORTED_MODULE_73__view_HakdanKewajiban_FormHakdanKewajiban_vue__["a" /* default */] }, { path: 'HakdanWajiban/ListHakdanKewajiban/edit/:id', name: 'EditHakKewajiban', component: __WEBPACK_IMPORTED_MODULE_73__view_HakdanKewajiban_FormHakdanKewajiban_vue__["a" /* default */] },
    // Banner
    { path: 'banner', name: 'ListBanner', component: __WEBPACK_IMPORTED_MODULE_68__view_Banners_ListBanner_vue__["a" /* default */] }, { path: 'banner/tambah', name: 'TambahBanner', component: __WEBPACK_IMPORTED_MODULE_69__view_Banners_Banner_vue__["a" /* default */] }, { path: 'banner/edit/:id', name: 'EditBanner', component: __WEBPACK_IMPORTED_MODULE_69__view_Banners_Banner_vue__["a" /* default */] },

    // kalender
    { path: 'calender', name: 'calender', component: __WEBPACK_IMPORTED_MODULE_70__view_Kalender_Calender_vue__["a" /* default */] }, { path: 'pintasanInformasi', name: 'ListPintasInfromasi', component: __WEBPACK_IMPORTED_MODULE_67__view_PintasanInformasi_ListPintasanInformasi_vue__["a" /* default */] }, { path: 'pintasanInformasi/edit/:id', name: 'EditPintasInformasi', component: __WEBPACK_IMPORTED_MODULE_66__view_PintasanInformasi_PintasanInformasi_vue__["a" /* default */] },
    // IP
    { path: 'layanan/atur-ip', name: 'ListIdentitasPemotong', component: __WEBPACK_IMPORTED_MODULE_44__view_IdentitasPemotong_ListIdentitasPemotong__["a" /* default */] }, { path: 'layanan/atur-ip/tambah', name: 'TambahIdentitasPemotong', component: __WEBPACK_IMPORTED_MODULE_45__view_IdentitasPemotong_FormIdentitasPemotong__["a" /* default */] }, { path: 'layanan/atur-ip/edit/:id', name: 'EditIdentitasPemotong', component: __WEBPACK_IMPORTED_MODULE_45__view_IdentitasPemotong_FormIdentitasPemotong__["a" /* default */] },
    // HubungiKami
    { path: 'hubungi-kami', name: 'HubungiKami', component: __WEBPACK_IMPORTED_MODULE_28__view_Informasi_HubungiKami__["a" /* default */] },
    // Other
    { path: 'notification', name: 'Notification', component: __WEBPACK_IMPORTED_MODULE_33__view_Notifikasi__["a" /* default */] }, { path: 'headline', name: 'Headline', component: __WEBPACK_IMPORTED_MODULE_34__view_Headline__["a" /* default */] }, { path: 'layanan/cetak-struk-mp', name: 'CetakStrukMP', component: __WEBPACK_IMPORTED_MODULE_46__view_Upload__["a" /* default */] }, { path: 'layanan/cetak-struk-uang-pembinaan', name: 'CetakStrukUangPembinaan', component: __WEBPACK_IMPORTED_MODULE_46__view_Upload__["a" /* default */] }, { path: 'layanan/cetak-struk-rapel', name: 'CetakStrukRapel', component: __WEBPACK_IMPORTED_MODULE_46__view_Upload__["a" /* default */] }, { path: 'layanan/cetak-spt', name: 'CetakSPT', component: __WEBPACK_IMPORTED_MODULE_46__view_Upload__["a" /* default */] },
    // Anggota
    { path: 'anggota', name: 'ListAnggota', component: __WEBPACK_IMPORTED_MODULE_50__view_Anggota_ListAnggota__["a" /* default */] }, { path: 'anggota/tambah', name: 'TambahAnggota', component: __WEBPACK_IMPORTED_MODULE_51__view_Anggota_TambahAnggota__["a" /* default */] }, { path: 'anggota/edit/:id', name: 'EditAnggota', component: __WEBPACK_IMPORTED_MODULE_52__view_Anggota_EditAnggota__["a" /* default */] },
    // Admin
    { path: 'admin', name: 'ListAdmin', component: __WEBPACK_IMPORTED_MODULE_53__view_Admin_ListAdmin__["a" /* default */] }, { path: 'admin/tambah', name: 'TambahAdmin', component: __WEBPACK_IMPORTED_MODULE_54__view_Admin_FormAdmin__["a" /* default */] }, { path: 'admin/edit/:id', name: 'EditAdmin', component: __WEBPACK_IMPORTED_MODULE_54__view_Admin_FormAdmin__["a" /* default */] }]
  }]
});

router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.noRequiredAuth;
  })) {
    next();
  } else {
    var token = localStorage.getItem('_token');
    if (token === null || token === '') {
      next({
        path: '/login'
      });
    } else {
      next();
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].router = router;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_57_vue_body_class___default.a, router);

/***/ }),

/***/ "Yvti":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_ckeditor2__ = __webpack_require__("42+j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FormLine_vue__ = __webpack_require__("w3AW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_api__ = __webpack_require__("+Btm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone__ = __webpack_require__("KvPw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css__ = __webpack_require__("hCol");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_1__components_FormLine_vue__["a" /* default */], Ckeditor: __WEBPACK_IMPORTED_MODULE_0_vue_ckeditor2__["a" /* default */], vueDropzone: __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone___default.a },
  name: 'ListNarasumber',
  data: function data() {
    return {
      dropzoneOptions: {
        url: __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.baseURL + '/upload_file',
        thumbnailWidth: 150,
        addRemoveLinks: true,
        maxFilesize: 2,
        dictRemoveFileConfirmation: 'Anda yakin ingin menghapus file ini?',
        headers: { 'Authorization': 'Bearer ' + localStorage.getItem('_token') }
      },
      date: {
        dateFormat: 'd-m-Y',
        allowInput: true
      },
      config: {
        toolbar: [{ name: 'stuff', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] }, { name: 'morestuff', items: ['NumberedList', 'BulletedList'] }, { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Superscript', 'Subscript'] }, { name: 'colors', items: ['TextColor'] }, { name: 'paragraph2', items: ['JustifyLeft', 'JustiftyCenter', 'JustifyRight', 'Outdent', 'Indent'] }, '/', { name: 'document', items: ['Source'] }],
        height: 300
      },
      content: {
        judul: '',
        deskripsi: '',
        tanggal: ''
      },
      tanggal: '',
      file: '',
      id_informasi_kegiatan: '',
      nama: '',
      tipe: '',
      link: '',
      isLoading: false,
      init: false
    };
  },
  methods: {
    save: function save() {
      var _this = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].post('/informasi_kegiatan', this.content).then(function (result) {
        if (result.data.code === 200) {
          _this.$toastr.s('Tambah data berhasil');
          _this.$router.replace('/main/informasi/kegiatan/edit/' + result.data.object.id_informasi_kegiatan);
          location.reload();
        } else {
          var msg = 'Tambah data gagal';
          if (result.data.message !== '') msg = result.data.message;
          _this.$toastr.e(msg);
        }
        _this.isLoading = false;
      }).catch(function (e) {
        var msg = 'Terjadi kesalahan pada server, mohon ulangi';
        if (e.response.data.message) msg = e.response.data.message;
        _this.$toastr.e(msg);
        _this.isLoading = false;
      });
    },
    update: function update() {
      var _this2 = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].post('/informasi_kegiatan/' + this.id_informasi_kegiatan, this.content).then(function (result) {
        if (result.data.code === 200) {
          _this2.$router.replace('/main/informasi/' + _this2.link);
          _this2.$toastr.s('Ubah data berhasil');
        }
        _this2.isLoading = false;
      }).catch(function (e) {
        var msg = 'Terjadi kesalahan pada server, mohon ulangi';
        if (e.response.data.message) msg = e.response.data.message;
        _this2.$toastr.e(msg);
        _this2.isLoading = false;
      });
    },
    getDetail: function getDetail() {
      var _this3 = this;

      this.init = true;
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].get('/informasi_kegiatan/edit/' + this.id_informasi_kegiatan).then(function (result) {
        _this3.content = result.data;
        for (var i = 0; i < _this3.content.file.length; i++) {
          _this3.$refs.myVueDropzone.manuallyAddFile({ name: 'Foto', id: _this3.content.file[i].id_file }, _this3.content.file[i].file);
        }
        _this3.tanggal = _this3.$moment(_this3.content.tanggal, 'YYYY-MM-DD').format('DD-MM-YYYY');
        _this3.init = false;
      }).catch(function (ex) {
        _this3.$toastr.e('Terjadi kesalahan pada server, mohon ulangi');
        _this3.init = false;
      });
    },
    sendingEvent: function sendingEvent(file, xhr, formData) {
      console.log(this.id_informasi_kegiatan);
      formData.append('id_informasi_kegiatan', parseInt(this.id_informasi_kegiatan));
    },
    onSubmit: function onSubmit() {
      if (this.id_informasi_kegiatan != null) this.update();else this.save();
    },
    checkRoute: function checkRoute(route) {
      console.log(route.name);
      if (route.name === 'TambahKegiatan' || route.name === 'EditKegiatan') {
        this.link = 'kegiatan';
        this.nama = 'Informasi Kegiatan';
      }
    },
    vremoved: function vremoved(file, xhr, error) {
      console.log(file);
      if (!this.init) this.delete(file.id);
    },
    delete: function _delete(id) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].delete('/informasi_kegiatan/delete/' + id).then(function (result) {
        _this4.$toastr.s('Foto berhasil dihapus');
        _this4.getData();
        _this4.$swal.close();
      }).catch(function (e) {
        _this4.getData();
        _this4.$swal.close();
      });
    }
  },
  mounted: function mounted() {
    this.checkRoute(this.$route);
    this.id_informasi_kegiatan = this.$route.params.id;
    if (this.id_informasi_kegiatan != null) {
      this.getDetail();
    }
  },

  watch: {
    '$route': function $route(to, from) {
      this.checkRoute(to);
      this.getData();
    },

    tanggal: function tanggal(val) {
      this.content.tanggal = this.$moment(val, 'DD-MM-YYYY').format('YYYY-MM-DD');
    }
  }
});

/***/ }),

/***/ "Z0YD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KritikDanSaran_vue__ = __webpack_require__("6OBv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73189ca3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KritikDanSaran_vue__ = __webpack_require__("+aAy");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KritikDanSaran_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73189ca3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KritikDanSaran_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZlMZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            "+_vm._s(_vm.id_identitas_pemotong != null ? 'Edit' : 'Tambah')+" Identitas Pemotong\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_c('div',{staticClass:"row clearfix"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"tahun","type":"number"},model:{value:(_vm.data.tahun),callback:function ($$v) {_vm.$set(_vm.data, "tahun", $$v)},expression:"data.tahun"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"npwp","type":"text"},model:{value:(_vm.data.npwp),callback:function ($$v) {_vm.$set(_vm.data, "npwp", $$v)},expression:"data.npwp"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"nama","type":"text"},model:{value:(_vm.data.nama),callback:function ($$v) {_vm.$set(_vm.data, "nama", $$v)},expression:"data.nama"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"npwpPemotong","type":"text"},model:{value:(_vm.data.npwpPemotong),callback:function ($$v) {_vm.$set(_vm.data, "npwpPemotong", $$v)},expression:"data.npwpPemotong"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[(_vm.data.gambar != null)?_c('img',{attrs:{"src":_vm.data.gambar,"width":"150px","alt":"Foto"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"id":"gambar","type":"file","name":"gambar"},on:{"change":function($event){return _vm.handleFile($event)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[(_vm.id_identitas_pemotong != null)?_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-warning waves-effect waves-button",attrs:{"disabled":_vm.isLoading,"type":"button"},on:{"click":_vm.update}},[(!_vm.isLoading)?_c('span',[_c('i',{staticClass:"material-icons"},[_vm._v("save")]),_vm._v(" Edit")]):_c('span',[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" Loading")])]):_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect waves-button",attrs:{"disabled":_vm.isLoading,"type":"button"},on:{"click":_vm.save}},[(!_vm.isLoading)?_c('span',[_c('i',{staticClass:"material-icons"},[_vm._v("save")]),_vm._v(" Simpan")]):_c('span',[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" Loading")])]),_vm._v(" "),_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")]),_vm._v(" Batal")])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-header"},[_c('h2',[_vm._v("Identitas Pemotong")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"tahun"}},[_vm._v("Tahun")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"npwp"}},[_vm._v("NPWP")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"nama"}},[_vm._v("Nama")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"npwpPemotong"}},[_vm._v("NPWP Pemotong")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"gambar"}},[_vm._v("Gambar TTD")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "a/Of":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_api__ = __webpack_require__("+Btm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FormLine_vue__ = __webpack_require__("w3AW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_3__components_FormLine_vue__["a" /* default */] },
  name: 'ListPendiri',
  data: function data() {
    return {
      result: {},
      list: [],
      currentPage: 1,
      perPage: 10,
      search: '',
      modal: null,
      isLoading: true,
      tipe: '',
      nama: '',
      link: ''
    };
  },
  methods: {
    moveUp: function moveUp(index) {
      var a = this.list[index - 1];
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(this.list, index - 1, this.list[index - 2]);
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(this.list, index - 2, a);

      this.saveUrutan();
    },
    moveDown: function moveDown(index) {
      var a = this.list[index - 1];
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(this.list, index - 1, this.list[index]);
      __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(this.list, index, a);

      this.saveUrutan();
    },
    saveUrutan: function saveUrutan() {
      var _this = this;

      var data = [];
      for (var i = 0; i < this.list.length; i++) {
        data.push({
          'id': this.list[i].id_officer,
          'urutan': i,
          'tipe': this.tipe
        });
      }

      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].post('/officer/move', data).then(function (result) {
        _this.$toastr.s('Urutan berhasil diubah.');
      }).catch(function (ex) {
        _this.$toastr.e('Gagal mengubah urutan, terjadi kesalahan pada server.');
      });
    },
    getData: function getData() {
      var _this2 = this;

      this.list = [];
      this.result = [];
      var params = [];
      params.search = this.search;
      params.page = this.currentPage - 1;
      params.size = this.perPage;
      params.tipe = this.tipe;

      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].get('/officer?' + __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(params)).then(function (result) {
        _this2.result = result.data;
        _this2.list = result.data.content;
        _this2.isLoading = false;
      }).catch(function (ex) {
        _this2.isLoading = false;
      });
    },
    confirmDelete: function confirmDelete(id) {
      var _this3 = this;

      this.$swal({
        title: 'Konfirmasi',
        text: 'Anda yakin ingin menghapus data ini?',
        icon: 'warning',
        buttons: [true, {
          text: 'Ok',
          closeModal: false
        }],
        dangerMode: true
      }).then(function (result) {
        if (result) _this3.delete(id);
      });
    },
    delete: function _delete(id) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].delete('/officer/' + id).then(function (result) {
        if (result.data.code === 200) _this4.$toastr.s('Data berhasil dihapus.');else _this4.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this4.$swal.close();
        _this4.getData();
      }).catch(function (e) {
        _this4.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this4.$swal.close();
      });
    },
    checkRoute: function checkRoute(route) {
      if (route.name === 'ListPendiri') {
        this.tipe = 1;
        this.link = 'pendiri';
        this.nama = 'Pendiri';
      }
      if (route.name === 'ListDewanPengawas') {
        this.tipe = 2;
        this.link = 'dewan-pengawas';
        this.nama = 'Dewan Pengawas';
      }
      if (route.name === 'ListPengurus') {
        this.tipe = 3;
        this.link = 'pengurus';
        this.nama = 'Pengurus';
      }
    }
  },
  mounted: function mounted() {
    this.checkRoute(this.$route);
    this.getData();
  },
  watch: {
    currentPage: function currentPage(e) {
      this.getData();
    },
    perPage: function perPage(e) {
      this.getData();
    },
    search: function search(e) {
      this.getData();
    },
    '$route': function $route(to, from) {
      this.checkRoute(to);
      this.getData();
    }
  }
});

/***/ }),

/***/ "aTK2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormSurvey_vue__ = __webpack_require__("YJoP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4eff7790_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSurvey_vue__ = __webpack_require__("AGFz");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormSurvey_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4eff7790_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSurvey_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aTk2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_ckeditor2__ = __webpack_require__("42+j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__ = __webpack_require__("w3AW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_api__ = __webpack_require__("+Btm");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FormLine: __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__["a" /* default */],
    Ckeditor: __WEBPACK_IMPORTED_MODULE_1_vue_ckeditor2__["a" /* default */]
  },
  name: 'ListNarasumber',
  data: function data() {
    return {
      date: {
        dateFormat: 'Y-m-d',
        allowInput: true
      },
      config: {
        toolbar: [{ name: 'stuff', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] }, { name: 'morestuff', items: ['NumberedList', 'BulletedList'] }, { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Superscript', 'Subscript'] }, { name: 'colors', items: ['TextColor'] }, { name: 'paragraph2', items: ['JustifyLeft', 'JustiftyCenter', 'JustifyRight', 'Outdent', 'Indent'] }, '/', { name: 'document', items: ['Source'] }],
        height: 300
      },
      content: {
        judul: '',
        konten: '',
        tags: '',
        tglBerlaku: ''
      },
      file: '',
      id_pdp_arahan: '',
      nama: '',
      tipe: '',
      link: '',
      isLoading: false
    };
  },
  methods: {
    save: function save() {
      var _this = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      var form = new FormData();
      form.append('file', this.file);
      form.append('json', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.content));
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].post('/pdp', form).then(function (result) {
        if (result.data.code === 200) {
          _this.$router.replace('/main/unduh/' + _this.link);
          _this.$toastr.s('Tambah data berhasil');
        } else {
          var msg = 'Tambah data gagal';
          if (result.data.message !== '') msg = result.data.message;
          _this.$toastr.e(msg);
        }
        _this.isLoading = false;
      }).catch(function (e) {
        var msg = 'Terjadi kesalahan pada server, mohon ulangi';
        if (e.response.data.message) msg = e.response.data.message;
        _this.$toastr.e(msg);
        _this.isLoading = false;
      });
    },
    update: function update() {
      var _this2 = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      var form = new FormData();
      form.append('file', this.file);
      form.append('json', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.content));
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].post('/pdp/' + this.id_pdp_arahan, form).then(function (result) {
        if (result.data.code === 200) {
          _this2.$router.replace('/main/unduh/' + _this2.link);
          _this2.$toastr.s('Ubah data berhasil');
        }
        _this2.isLoading = false;
      }).catch(function (ex) {
        var msg = 'Terjadi kesalahan pada server, mohon ulangi';
        if (ex.response.data.message) msg = ex.response.data.message;
        _this2.$toastr.e(msg);
        _this2.isLoading = false;
      });
    },
    getDetail: function getDetail() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].get('/pdp/' + this.id_pdp_arahan).then(function (result) {
        _this3.content = result.data;
      }).catch(function (ex) {
        _this3.$toastr.e('Terjadi kesalahan pada server, mohon ulangi');
      });
    },
    handleFile: function handleFile(file) {
      this.file = file.target.files[0];
    },
    checkRoute: function checkRoute(route) {
      console.log(route.name);
      if (route.name === 'TambahPDP' || route.name === 'EditPDP') {
        this.link = 'pdp';
        this.nama = 'PDP';
        this.content.tipe = 1;
      }

      if (route.name === 'TambahArahan' || route.name === 'EditArahan') {
        this.link = 'arahan';
        this.nama = 'Arahan';
        this.content.tipe = 2;
      }
    }
  },
  mounted: function mounted() {
    this.checkRoute(this.$route);
    this.id_pdp_arahan = this.$route.params.id;
    if (this.id_pdp_arahan != null) {
      this.getDetail();
    }
  },
  '$route': function $route(to, from) {
    this.checkRoute(to);
    this.getData();
  }
});

/***/ }),

/***/ "aWiB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PintasanInformasi_vue__ = __webpack_require__("7JO+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cf3ddfa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PintasanInformasi_vue__ = __webpack_require__("v3Jx");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PintasanInformasi_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cf3ddfa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PintasanInformasi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aXOa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListLog_vue__ = __webpack_require__("A3ol");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71eed83a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListLog_vue__ = __webpack_require__("udtj");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListLog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71eed83a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListLog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ap8S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"block-header"},[_c('h2',[_vm._v(_vm._s(_vm.nama))])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            List "+_vm._s(_vm.nama)+"\n                        ")]),_vm._v(" "),_c('ul',{staticClass:"header-dropdown m-r--5 m-t--10"},[_c('router-link',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect waves-button",attrs:{"to":'/main/profile/' + this.link + '/tambah',"type":"button"}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#fff"}},[_vm._v("add_box")]),_vm._v(" "),_c('span',[_vm._v("Tambah")])])],1)]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"dataTables_wrapper form-inline dt-bootstrap",attrs:{"id":"DataTables_Table_0_wrapper"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_length",attrs:{"id":"DataTables_Table_0_length"}},[_c('label',[_vm._v("Show "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.perPage),expression:"perPage"}],staticClass:"form-control input-sm",attrs:{"name":"DataTables_Table_0_length","aria-controls":"DataTables_Table_0"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.perPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_c('option',{attrs:{"value":"100"}},[_vm._v("100")])]),_vm._v(" entries")])])]),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_filter",attrs:{"id":"DataTables_Table_0_filter"}},[_c('label',[_vm._v("Search:"),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control input-sm",attrs:{"type":"search","placeholder":"","aria-controls":"DataTables_Table_0"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])])])]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped table-hover js-basic-example dataTable"},[_vm._m(0),_vm._v(" "),_c('tbody',[(_vm.isLoading)?_c('tr',[_vm._m(1)]):_vm._e(),_vm._v(" "),(_vm.list == '')?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"7"}},[_vm._v("Data tidak ditemukan")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(item,index){return (!_vm.isLoading)?_c('tr',[_c('td',[_vm._v("\n                                                "+_vm._s(++index + ((_vm.currentPage-1)*_vm.perPage))+"\n                                            ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.stripTags(item.deskripsi)))]),_vm._v(" "),_c('td',[(item.foto != null)?_c('img',{attrs:{"src":item.foto,"alt":"Icon","width":"98px"}}):_vm._e()]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn bg-green waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.push('/main/profile/'+_vm.link+'/edit/' + item.id_officer)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("create")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmDelete(item.id_officer)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")])]),_c('br'),_c('br'),_vm._v(" "),(index != 1)?_c('button',{staticClass:"btn btn-primary waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.moveUp(index)}}},[_c('i',{staticClass:"fa fa-chevron-up"})]):_vm._e(),_vm._v(" "),(index !== (_vm.list.length))?_c('button',{staticClass:"btn btn-primary waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.moveDown(index)}}},[_c('i',{staticClass:"fa fa-chevron-down"})]):_vm._e()])]):_vm._e()})],2)])]),_vm._v(" "),_c('pagination',{attrs:{"total-rows":_vm.result.totalElements,"per-page":_vm.result.size},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Urutan")]),_vm._v(" "),_c('th',[_vm._v("Deskripsi")]),_vm._v(" "),_c('th',[_vm._v("Foto")]),_vm._v(" "),_c('th',[_vm._v("Aksi")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center",attrs:{"colspan":"7"}},[_c('i',{staticClass:"fa fa-spin fa-spinner"}),_vm._v(" Loading data...")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aqMw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormIdentitasPemotong_vue__ = __webpack_require__("Dflq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c09b828e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormIdentitasPemotong_vue__ = __webpack_require__("ZlMZ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormIdentitasPemotong_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c09b828e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormIdentitasPemotong_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "b5g7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditAnggota_vue__ = __webpack_require__("knDp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61cc8d23_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditAnggota_vue__ = __webpack_require__("HY1S");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditAnggota_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61cc8d23_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditAnggota_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bD83":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"block-header"},[_c('h2',[_vm._v(_vm._s(_vm.nama))])]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("List "+_vm._s(_vm.nama))]),_vm._v(" "),_c('ul',{staticClass:"header-dropdown m-r--5 m-t--10"},[_c('router-link',{directives:[{name:"waves",rawName:"v-waves"}],staticClass:"btn btn-primary waves-effect",attrs:{"to":'/main/' + _vm.link + '/tambah'}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#fff"}},[_vm._v("add_box")]),_vm._v(" "),_c('span',[_vm._v("Tambah")])])],1)]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"dataTables_wrapper"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('label',[_vm._v("\n                Show\n                "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.perPage),expression:"perPage"}],staticClass:"form-control input-sm",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.perPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("50")])]),_vm._v("\n                entries\n              ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('label',[_vm._v("\n                Search:\n                "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control input-sm",attrs:{"type":"search"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])])]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped table-hover"},[_vm._m(0),_vm._v(" "),_c('tbody',[(_vm.isLoading)?_c('tr',[_vm._m(1)]):_vm._e(),_vm._v(" "),(!_vm.isLoading && _vm.list.length === 0)?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"5"}},[_vm._v("Data tidak ditemukan")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(sub,index){return _c('tr',{key:sub.id},[_c('td',[_vm._v(_vm._s(index + 1 + ((_vm.currentPage - 1) * _vm.perPage)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(sub.parentName))]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(sub.name))])]),_vm._v(" "),_c('td',[(sub.backgroundImage)?_c('img',{staticStyle:{"width":"100px"},attrs:{"src":sub.backgroundImage,"alt":"gambar"}}):_vm._e()]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn bg-green waves-effect",on:{"click":function($event){return _vm.$router.push('/main/' + _vm.link + '/edit/' + sub.id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("create")])])])])})],2)]),_vm._v(" "),(_vm.result.totalPages > 1)?_c('div',{staticClass:"text-center"},[_c('ul',{staticClass:"pagination"},[_c('li',{class:{ disabled: _vm.currentPage === 1 }},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.currentPage > 1 && (_vm.currentPage--, _vm.getData())}}},[_vm._v("«")])]),_vm._v(" "),_vm._l((_vm.result.totalPages),function(page){return _c('li',{key:page,class:{ active: _vm.currentPage === page }},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.changePage(page)}}},[_vm._v(_vm._s(page))])])}),_vm._v(" "),_c('li',{class:{ disabled: _vm.currentPage === _vm.result.totalPages }},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.currentPage < _vm.result.totalPages && (_vm.currentPage++, _vm.getData())}}},[_vm._v("»")])])],2)]):_vm._e()])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("No.")]),_vm._v(" "),_c('th',[_vm._v("Menu Induk")]),_vm._v(" "),_c('th',[_vm._v("Submenu")]),_vm._v(" "),_c('th',[_vm._v("Gambar")]),_vm._v(" "),_c('th',[_vm._v("Aksi")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center",attrs:{"colspan":"5"}},[_c('i',{staticClass:"fa fa-spin fa-spinner"}),_vm._v(" Loading...\n                ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bKjE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            List Sejarah Pendirian\n                        ")]),_vm._v(" "),_c('ul',{staticClass:"header-dropdown m-r--5 m-t--10"},[_c('router-link',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect waves-button",attrs:{"to":"/main/profile/sejarah/tambah","type":"button"}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#fff"}},[_vm._v("add_box")]),_vm._v(" "),_c('span',[_vm._v("Tambah")])])],1)]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"dataTables_wrapper form-inline dt-bootstrap",attrs:{"id":"DataTables_Table_0_wrapper"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_length",attrs:{"id":"DataTables_Table_0_length"}},[_c('label',[_vm._v("Show "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.perPage),expression:"perPage"}],staticClass:"form-control input-sm",attrs:{"name":"DataTables_Table_0_length","aria-controls":"DataTables_Table_0"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.perPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_c('option',{attrs:{"value":"100"}},[_vm._v("100")])]),_vm._v(" entries")])])]),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_filter",attrs:{"id":"DataTables_Table_0_filter"}},[_c('label',[_vm._v("Search:"),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control input-sm",attrs:{"type":"search","placeholder":"","aria-controls":"DataTables_Table_0"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])])])]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped table-hover js-basic-example dataTable"},[_vm._m(1),_vm._v(" "),_c('tbody',[(_vm.isLoading)?_c('tr',[_vm._m(2)]):_vm._e(),_vm._v(" "),(_vm.list == '')?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"4"}},[_vm._v("Data tidak ditemukan")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(item,index){return (!_vm.isLoading)?_c('tr',[_c('td',[_vm._v(_vm._s(++index + ((_vm.currentPage-1)*_vm.perPage)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.tahun))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.stripTags(item.deskripsi)))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn bg-green waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.push('/main/profile/sejarah/edit/' + item.id_sejarah)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("create")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmDelete(item.id_sejarah)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")])])])]):_vm._e()})],2)])]),_vm._v(" "),_c('pagination',{attrs:{"total-rows":_vm.result.totalElements,"per-page":_vm.result.size},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-header"},[_c('h2',[_vm._v("SEJARAH PENDIRIAN")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("No.")]),_vm._v(" "),_c('th',[_vm._v("Tahun")]),_vm._v(" "),_c('th',[_vm._v("Deskripsi")]),_vm._v(" "),_c('th',[_vm._v("Aksi")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center",attrs:{"colspan":"4"}},[_c('i',{staticClass:"fa fa-spin fa-spinner"}),_vm._v(" Loading data...")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bOEj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListPendiri_vue__ = __webpack_require__("a/Of");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_507edd5d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListPendiri_vue__ = __webpack_require__("ap8S");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListPendiri_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_507edd5d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListPendiri_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bY2w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_api__ = __webpack_require__("+Btm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FormLine_vue__ = __webpack_require__("w3AW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_3__components_FormLine_vue__["a" /* default */] },
  name: 'ListVisiMisi',
  data: function data() {
    return {
      result: {},
      list: [],
      currentPage: 1,
      perPage: 10,
      search: '',
      modal: null,
      isLoading: true,
      link: '',
      tipe: '',
      nama: ''
    };
  },
  methods: {
    moveUp: function moveUp(index) {
      var a = this.list[index - 1];
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(this.list, index - 1, this.list[index - 2]);
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(this.list, index - 2, a);

      this.saveUrutan();
    },
    moveDown: function moveDown(index) {
      var a = this.list[index - 1];
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(this.list, index - 1, this.list[index]);
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(this.list, index, a);

      this.saveUrutan();
    },
    saveUrutan: function saveUrutan() {
      var _this = this;

      var data = [];
      for (var i = 0; i < this.list.length; i++) {
        data.push({
          'id': this.list[i].id_informasi_download,
          'urutan': i,
          'tipe': this.tipe
        });
      }

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].post('/informasi_download/move', data).then(function (result) {
        _this.$toastr.s('Urutan berhasil diubah.');
      }).catch(function (ex) {
        _this.$toastr.e('Gagal mengubah urutan, terjadi kesalahan pada server.');
      });
    },
    getData: function getData() {
      var _this2 = this;

      var params = [];
      params.search = this.search;
      params.page = this.currentPage - 1;
      params.size = this.perPage;
      params.tipe = this.tipe;

      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].get('/informasi_download?' + __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(params)).then(function (result) {
        _this2.result = result.data;
        _this2.list = result.data.content;
        _this2.isLoading = false;
      }).catch(function (ex) {
        _this2.isLoading = false;
        _this2.$toastr.e('Gagal terhubung dengan server.');
      });
    },
    confirmDelete: function confirmDelete(id) {
      var _this3 = this;

      this.$swal({
        title: 'Konfirmasi',
        text: 'Anda yakin ingin menghapus data ini?',
        icon: 'warning',
        buttons: [true, {
          text: 'Ok',
          closeModal: false
        }],
        dangerMode: true
      }).then(function (result) {
        if (result) _this3.delete(id);
      });
    },
    delete: function _delete(id) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].delete('/informasi_download/' + id).then(function (result) {
        if (result.data.code === 200) _this4.$toastr.s('Data berhasil dihapus.');else _this4.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this4.$swal.close();
        _this4.getData();
      }).catch(function (e) {
        _this4.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this4.$swal.close();
      });
    },
    checkRoute: function checkRoute(route) {
      this.list = [];
      if (route.name === 'ListPerkembangan') {
        this.tipe = 1;
        this.link = 'perkembangan';
        this.nama = 'Laporan Perkembangan';
      }
      if (route.name === 'ListTahunan') {
        this.tipe = 2;
        this.link = 'tahunan';
        this.nama = 'Laporan Keuangan';
      }
      if (route.name === 'ListLowongan') {
        this.tipe = 3;
        this.link = 'lowongan';
        this.nama = 'Informasi Lowongan';
      }
    }
  },
  mounted: function mounted() {
    this.checkRoute(this.$route);
    this.getData();
  },
  watch: {
    currentPage: function currentPage(e) {
      this.getData();
    },
    perPage: function perPage(e) {
      this.getData();
    },
    search: function search(e) {
      this.getData();
    },
    '$route': function $route(to, from) {
      this.checkRoute(to);
      this.getData();
    }
  }
});

/***/ }),

/***/ "bsbE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormPendiri_vue__ = __webpack_require__("Wzew");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79d4d084_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormPendiri_vue__ = __webpack_require__("4GXZ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormPendiri_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79d4d084_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormPendiri_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cF2T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_api__ = __webpack_require__("+Btm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__ = __webpack_require__("w3AW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__["a" /* default */] },
  name: 'HakDanKewajiban',
  data: function data() {
    return {
      result: {},
      list: [],
      currentPage: 1,
      perPage: 10,
      search: '',
      modal: null,
      isLoading: true,
      link: '',
      nama: ''
    };
  },
  methods: {
    getData: function getData() {
      var _this = this;

      var params = [];
      params.search = this.search;
      params.page = this.currentPage - 1;
      params.size = this.perPage;

      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].get('/getPensiunType?' + __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(params)).then(function (result) {
        _this.result = result.data;
        _this.list = result.data.content;
        _this.isLoading = false;
      }).catch(function (ex) {
        _this.isLoading = false;
        _this.$toastr.e('Gagal terhubung dengan server.');
      });
    },
    confirmDelete: function confirmDelete(id) {
      var _this2 = this;

      this.$swal({
        title: 'Konfirmasi',
        text: 'Anda yakin ingin menghapus data ini?',
        icon: 'warning',
        buttons: [true, {
          text: 'Ok',
          closeModal: false
        }],
        dangerMode: true
      }).then(function (result) {
        if (result) _this2.delete(id);
      });
    },
    delete: function _delete(id) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].delete('deleteFormulir/' + id).then(function (result) {
        console.log(result);
        if (result.data.code === 200 || result.status === 200) _this3.$toastr.s('Data berhasil dihapus.');else _this3.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this3.$swal.close();
        _this3.getData();
      }).catch(function (e) {
        _this3.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this3.$swal.close();
      });
    },
    checkRoute: function checkRoute(route) {
      console.log("ini routenya", route);
      this.list = [];
      if (route.name === 'ListPensiuntype') {
        console.log('masuk sin');
        this.link = 'pensiuntype';
        this.nama = 'pensiuntype';
      }
    }
  },
  mounted: function mounted() {
    this.checkRoute(this.$route);
    this.getData();
  },
  watch: {
    currentPage: function currentPage(e) {
      this.getData();
    },
    perPage: function perPage(e) {
      this.getData();
    },
    search: function search(e) {
      this.getData();
    },
    '$route': function $route(to, from) {
      this.checkRoute(to);
      this.getData();
    }
  }
});

/***/ }),

/***/ "cMGX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pagination_vue__ = __webpack_require__("xJvq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25340d3e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pagination_vue__ = __webpack_require__("8NxD");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pagination_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25340d3e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pagination_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cicr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__("UlOv");


/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Bar */],
  props: ['data', 'options'],
  mounted: function mounted() {
    this.renderChart(this.data, this.options);
  }
});

/***/ }),

/***/ "dBSi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"block-header"},[_c('h2',[_vm._v(_vm._s(_vm.id ? 'Edit' : 'Tambah')+" Dokumen Pensiun")])]),_vm._v(" "),_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"body"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit.apply(null, arguments)}}},[_c('div',{staticClass:"row clearfix"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-lg-10"},[_c('form-line',{attrs:{"type":"text","placeholder":"Contoh: Pensiun Normal"},model:{value:(_vm.contents.category),callback:function ($$v) {_vm.$set(_vm.contents, "category", $$v)},expression:"contents.category"}})],1)]),_vm._v(" "),_vm._l((_vm.contents.documents),function(doc,dIndex){return _c('div',{key:dIndex,staticClass:"mb-4"},[_c('div',{staticClass:"row clearfix"},[_vm._m(2,true),_vm._v(" "),_c('div',{staticClass:"col-lg-10"},[_c('form-line',{attrs:{"type":"text","placeholder":"Contoh: Pensiun Normal"},model:{value:(doc.title),callback:function ($$v) {_vm.$set(doc, "title", $$v)},expression:"doc.title"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row clearfix mt-2"},[_vm._m(3,true),_vm._v(" "),_c('div',{staticClass:"col-lg-10"},[_c('ckeditor',{attrs:{"config":_vm.config},model:{value:(doc.content),callback:function ($$v) {_vm.$set(doc, "content", $$v)},expression:"doc.content"}})],1)]),_vm._v(" "),_c('div',{staticClass:"text-right mt-2"},[_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){$event.preventDefault();return _vm.removeDocument(dIndex)}}},[_vm._v("\n                Hapus Dokumen\n              ")])]),_vm._v(" "),_c('hr')])}),_vm._v(" "),_c('button',{staticClass:"btn btn-success mb-3",attrs:{"type":"button"},on:{"click":_vm.addDocument}},[_vm._v("\n            Tambah Dokumen\n          ")]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.isLoading,"type":"submit"}},[_c('i',{staticClass:"material-icons"},[_vm._v("save")]),_vm._v(" Simpan\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")]),_vm._v(" Batal\n              ")])])])],2)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('h2',[_vm._v("Form Dokumen Pensiun")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 form-control-label"},[_c('label',[_vm._v("Nama kategori")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 form-control-label"},[_c('label',[_vm._v("Judul Dokumen")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 form-control-label"},[_c('label',[_vm._v("Konten")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dDaf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_ckeditor2__ = __webpack_require__("42+j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__ = __webpack_require__("w3AW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_api__ = __webpack_require__("+Btm");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FormLine: __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__["a" /* default */],
    Ckeditor: __WEBPACK_IMPORTED_MODULE_1_vue_ckeditor2__["a" /* default */]
  },
  name: 'ListNarasumber',
  data: function data() {
    return {
      date: {
        dateFormat: 'Y-m-d',
        allowInput: true
      },
      config: {
        toolbar: [['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript']],
        height: 300
      },
      content: {
        judul: '',
        jenisRegulasi: '',
        bidang: '',
        tags: '',
        tglBerlaku: ''
      },
      file: '',
      id_regulasi_dana_pensiun: '',
      nama: '',
      tipe: '',
      link: ''
    };
  },
  methods: {
    save: function save() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      var form = new FormData();
      form.append('file', this.file);
      form.append('json', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.content));
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].post('/' + this.link, form).then(function (result) {
        if (result.data.code === 200) {
          _this.$router.replace('/main/unduh/' + _this.link);
          _this.$toastr.s('Tambah data berhasil');
        } else {
          var msg = 'Tambah data gagal';
          if (result.data.message !== '') msg = result.data.message;
          _this.$toastr.e(msg);
        }
      }).catch(function (e) {
        var msg = 'Terjadi kesalahan pada server, mohon ulangi';
        if (e.response.data.message) msg = e.response.data.message;
        _this.$toastr.e(msg);
      });
    },
    update: function update() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      var form = new FormData();
      form.append('file', this.file);
      form.append('json', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.content));
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].post('/' + this.link + '/' + this.id_pdp_arahan, form).then(function (result) {
        if (result.data.code === 200) {
          _this2.$router.replace('/main/unduh/' + _this2.link);
          _this2.$toastr.s('Ubah data berhasil');
        }
      }).catch(function (ex) {
        var msg = 'Terjadi kesalahan pada server, mohon ulangi';
        if (ex.response.data.message) msg = ex.response.data.message;
        _this2.$toastr.e(msg);
      });
    },
    getDetail: function getDetail() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].get('/' + this.link + '/' + this.id_pdp_arahan).then(function (result) {
        _this3.content = result.data;
      }).catch(function (ex) {
        _this3.$toastr.e('Terjadi kesalahan pada server, mohon ulangi');
      });
    },
    handleFile: function handleFile(file) {
      this.file = file.target.files[0];
    },
    checkRoute: function checkRoute(route) {
      console.log(route.name);
      if (route.name === 'TambahRegulasi' || route.name === 'EditRegulasi') {
        this.link = 'regulasi';
        this.nama = 'Regulasi';
      }
    }
  },
  mounted: function mounted() {
    this.checkRoute(this.$route);
    this.id_pdp_arahan = this.$route.params.id;
    if (this.id_pdp_arahan != null) {
      this.getDetail();
    }
  },
  '$route': function $route(to, from) {
    this.checkRoute(to);
    this.getData();
  }
});

/***/ }),

/***/ "dz20":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_api__ = __webpack_require__("+Btm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__ = __webpack_require__("w3AW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__["a" /* default */] },
  name: 'ListVisiMisi',
  data: function data() {
    return {
      result: {},
      list: [],
      currentPage: 1,
      perPage: 10,
      search: '',
      modal: null,
      isLoading: true,
      link: '',
      tipe: '',
      nama: ''
    };
  },
  methods: {
    getData: function getData() {
      var _this = this;

      var params = [];
      params.search = this.search;
      params.page = this.currentPage - 1;
      params.size = this.perPage;

      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].get('/' + this.link + '?' + __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(params)).then(function (result) {
        _this.result = result.data;
        _this.list = result.data.content;
        _this.isLoading = false;
      }).catch(function (ex) {
        _this.isLoading = false;
      });
    },
    confirmDelete: function confirmDelete(id) {
      var _this2 = this;

      this.$swal({
        title: 'Konfirmasi',
        text: 'Anda yakin ingin menghapus data ini?',
        icon: 'warning',
        buttons: [true, {
          text: 'Ok',
          closeModal: false
        }],
        dangerMode: true
      }).then(function (result) {
        if (result) _this2.delete(id);
      });
    },
    delete: function _delete(id) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].delete('/' + this.link + '/' + id).then(function (result) {
        if (result.data.code === 200) _this3.$toastr.s('Data berhasil dihapus.');else _this3.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this3.$swal.close();
        _this3.getData();
      }).catch(function (e) {
        _this3.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this3.$swal.close();
      });
    },
    checkRoute: function checkRoute(route) {
      this.list = [];
      if (route.name === 'ListVisiMisi') {
        this.tipe = 1;
        this.link = 'visi-misi';
        this.nama = 'Visi Misi';
      }
      if (route.name === 'ListBudayaKerja') {
        this.tipe = 4;
        this.link = 'budaya-kerja';
        this.nama = 'Budaya Kerja';
      }
    }
  },
  mounted: function mounted() {
    this.checkRoute(this.$route);
    this.getData();
  },
  watch: {
    currentPage: function currentPage(e) {
      this.getData();
    },
    perPage: function perPage(e) {
      this.getData();
    },
    search: function search(e) {
      this.getData();
    },
    '$route': function $route(to, from) {
      this.checkRoute(to);
      this.getData();
    }
  }
});

/***/ }),

/***/ "e1SM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FormLine_vue__ = __webpack_require__("w3AW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_api__ = __webpack_require__("+Btm");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_0__components_FormLine_vue__["a" /* default */] },
  name: 'Notifikasi',
  data: function data() {
    return {
      data: {
        message: ''
      },
      isLoading: false
    };
  },
  mounted: function mounted() {
    this.getData();
  },
  methods: {
    getData: function getData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].get('/hubungi-kami').then(function (r) {
        _this.data.message = r.data.headline;
      });
    },
    simpan: function simpan() {
      var _this2 = this;

      this.isLoading = true;
      var form = new FormData();
      form.append('message', this.data.message);
      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].post('/headline', form).then(function (result) {
        if (result.data.code === 200) {
          _this2.$toastr.s('Headline berhasil dimasukan');
        } else {
          var msg = 'Headline gagal disimpan, silahkan coba kembali';
          if (result.data.message !== '') msg = result.data.message;
          _this2.$toastr.e(msg);
        }
        _this2.isLoading = false;
      }).catch(function (e) {
        var msg = 'Terjadi kesalahan pada server, mohon ulangi';
        if (e.response.data.message) msg = e.response.data.message;
        _this2.$toastr.e(msg);
        _this2.isLoading = false;
      });
    }
  }
});

/***/ }),

/***/ "e1ih":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__ = __webpack_require__("w3AW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_api__ = __webpack_require__("+Btm");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__["a" /* default */] },
  name: 'Banner',
  data: function data() {
    return {
      data: {
        name: '',
        link: '',
        titleBanner: '',
        subtitleBanner: '',
        description: '',
        auth: '',
        backgroundImage: '',
        parentId: '',
        halamanId: ''
      },
      gambar: '',
      // backgroundImage:'',
      id_logo: '',
      isLoading: false
    };
  },
  methods: {
    update: function update() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      var form = new FormData();
      form.append('file', this.file);
      form.append('json', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.data));
      console.log(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.data));
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].post('/submenu/' + this.id_logo, form).then(function (result) {
        if (result.data.code === 200) {
          _this.$router.replace('/main/banner');
          _this.$toastr.s('Ubah data berhasil');
        }
      }).catch(function (ex) {
        _this.$toastr.e('Terjadi kesalahan pada server, mohon ulangi');
      });
    },
    getDetail: function getDetail() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].get('/getNavbar').then(function (result) {
        var data = result.data;
        var found = _this2.findSubmenuById(data, parseInt(_this2.id_logo));
        if (found) {
          _this2.data = found;
        } else {
          _this2.$toastr.e('Submenu tidak ditemukan');
        }
      }).catch(function (ex) {
        _this2.$toastr.e('Terjadi kesalahan pada server, mohon ulangi');
      });
    },
    findSubmenuById: function findSubmenuById(menuList, targetId) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(menuList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var menu = _step.value;

          if (menu.submenu && menu.submenu.length > 0) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(menu.submenu), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var submenu = _step2.value;

                if (submenu.id === targetId) {
                  return submenu;
                }
                // Cek submenu bersarang
                if (submenu.submenu && submenu.submenu.length > 0) {
                  var found = this.findSubmenuById([submenu], targetId);
                  if (found) return found;
                }
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return null;
    },
    handleFile: function handleFile(file) {
      this.file = file.target.files[0];
    }
  },
  mounted: function mounted() {
    this.id_logo = this.$route.params.id;
    if (this.id_logo != null) {
      this.getDetail();
    }
  }
});

/***/ }),

/***/ "e4lX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Galeri_vue__ = __webpack_require__("AS55");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63339f54_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Galeri_vue__ = __webpack_require__("UFg6");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Galeri_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63339f54_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Galeri_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eWIM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FormLine_vue__ = __webpack_require__("w3AW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper_api__ = __webpack_require__("+Btm");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_3__components_FormLine_vue__["a" /* default */] },
  name: 'FormAdmin',
  watch: {
    profileAll: function profileAll(val) {
      var _this = this;

      if (val === true) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(this.akses.profile).forEach(function (_ref) {
          var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
              key = _ref2[0],
              value = _ref2[1];

          _this.akses.profile[key] = true;
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(this.akses.profile).forEach(function (_ref3) {
          var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
              key = _ref4[0],
              value = _ref4[1];

          _this.akses.profile[key] = false;
        });
      }
    },
    layananAll: function layananAll(val) {
      var _this2 = this;

      if (val === true) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(this.akses.layanan).forEach(function (_ref5) {
          var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref5, 2),
              key = _ref6[0],
              value = _ref6[1];

          _this2.akses.layanan[key] = true;
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(this.akses.layanan).forEach(function (_ref7) {
          var _ref8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref7, 2),
              key = _ref8[0],
              value = _ref8[1];

          _this2.akses.layanan[key] = false;
        });
      }
    },
    informasiAll: function informasiAll(val) {
      var _this3 = this;

      if (val === true) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(this.akses.informasi).forEach(function (_ref9) {
          var _ref10 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref9, 2),
              key = _ref10[0],
              value = _ref10[1];

          _this3.akses.informasi[key] = true;
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(this.akses.informasi).forEach(function (_ref11) {
          var _ref12 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref11, 2),
              key = _ref12[0],
              value = _ref12[1];

          _this3.akses.informasi[key] = false;
        });
      }
    },
    unduhAll: function unduhAll(val) {
      var _this4 = this;

      if (val === true) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(this.akses.unduh).forEach(function (_ref13) {
          var _ref14 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref13, 2),
              key = _ref14[0],
              value = _ref14[1];

          _this4.akses.unduh[key] = true;
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(this.akses.unduh).forEach(function (_ref15) {
          var _ref16 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref15, 2),
              key = _ref16[0],
              value = _ref16[1];

          _this4.akses.unduh[key] = false;
        });
      }
    }
  },
  data: function data() {
    return {
      username: '',
      password: '',
      email: '',
      namaLengkap: '',
      profileAll: false,
      layananAll: false,
      informasiAll: false,
      unduhAll: false,
      idNarasumber: '',
      akses: {
        masterNarasumber: false,
        userLevel: false,
        anggota: false,
        profile: {
          visi_misi: false,
          sejarah_pendirian: false,
          pendiri: false,
          dewan_pengawas: false,
          pengurus: false,
          struktur_organisasi: false,
          budaya_kerja: false
        },
        layanan: {
          cetak_mp: false,
          cetak_up: false,
          cetak_rapel: false,
          cetak_spt: false,
          atur_ip: false,
          survey: false,
          hasil_survey: false,
          data_kelengkapan: false,
          pengaduan: false,
          kritik: false
        },
        informasi: {
          kegiatan: false,
          artikel: false,
          perkembangan: false,
          tahunan: false,
          lowongan: false,
          galeri: false
        },
        unduh: {
          pdp: false,
          arahan: false,
          regulasi: false,
          majalah: false,
          laporan: false,
          formulir: false,
          materikomunikasi: false
        },
        log: false,
        faq: false,
        syarat: false,
        cara: false,
        slider: false,
        kirimNotifikasi: false,
        headline: false,
        whistleBlower: false,
        anakPerusahaan: false,
        hubungiKami: false,
        Kalender: false,
        Banner: false,
        Pengumuman: false,
        Hak_dan_Kewajiban_Peserta: false
      },
      id_user: '',
      isLoading: false,
      list_narasumber: []
    };
  },
  methods: {
    getData: function getData() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_4__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_4__helper_api__["a" /* default */].get('/narasumber/all').then(function (result) {
        _this5.list_narasumber = result.data;
      });
    },
    save: function save() {
      var _this6 = this;

      this.isLoading = true;

      var data = {
        id_narasumber: this.idNarasumber,
        namaLengkap: this.namaLengkap,
        username: this.username,
        password: this.password,
        email: this.email,
        akses_menu: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.akses)
      };

      var pattern = /^[a-zA-Z0-9]*$/;
      if (!this.password.match(pattern)) {
        this.$toastr.e('Password tidak valid, hanya boleh alfanumerik (a-z atau A-Z dan 0-9)');
        this.isLoading = false;
        return false;
      }

      __WEBPACK_IMPORTED_MODULE_4__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_4__helper_api__["a" /* default */].post('/admin', data).then(function (result) {
        if (result.data.code === 200) {
          _this6.$router.replace('/main/admin');
          _this6.$toastr.s('Tambah data berhasil');
        } else {
          var msg = 'Tambah data gagal';
          if (result.data.message !== '') msg = result.data.message;
          _this6.$toastr.e(msg);
        }
        _this6.isLoading = false;
      }).catch(function (e) {
        var msg = 'Terjadi kesalahan pada server, mohon ulangi';
        if (e.response.data.message) msg = e.response.data.message;
        _this6.$toastr.e(msg);
        _this6.isLoading = false;
      });
    },
    update: function update() {
      var _this7 = this;

      var data = {
        id_narasumber: this.idNarasumber,
        namaLengkap: this.namaLengkap,
        username: this.username,
        password: this.password,
        email: this.email,
        akses_menu: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.akses)
      };

      __WEBPACK_IMPORTED_MODULE_4__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_4__helper_api__["a" /* default */].post('/admin/' + this.id_user, data).then(function (result) {
        if (result.data.code === 200) {
          _this7.$router.replace('/main/admin');
          _this7.$toastr.s('Ubah data berhasil');
        }
      }).catch(function (e) {
        var msg = 'Terjadi kesalahan pada server, mohon ulangi';
        if (e.response.data.message) msg = e.response.data.message;
        _this7.$toastr.e(msg);
        _this7.isLoading = false;
      });
    },
    getDetail: function getDetail() {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_4__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_4__helper_api__["a" /* default */].get('/admin/' + this.id_user).then(function (result) {
        var data = result.data;
        _this8.username = data.registrasi.username;
        _this8.email = data.registrasi.email;
        _this8.namaLengkap = data.namaLengkap;
        _this8.akses = JSON.parse(data.akses_menu);
        _this8.idNarasumber = JSON.parse(data.narasumber.idNarasumber);
      }).catch(function (ex) {
        _this8.$toastr.e('Terjadi kesalahan pada server, mohon ulangi');
      });
    },
    handleFile: function handleFile(file) {
      this.file = file.target.files[0];
    }
  },
  mounted: function mounted() {
    this.getData();
    this.id_user = this.$route.params.id;
    if (this.id_user != null) {
      this.getDetail();
    }
  }
});

/***/ }),

/***/ "eiXj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_api__ = __webpack_require__("+Btm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__ = __webpack_require__("w3AW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__["a" /* default */] },
  name: 'PendapatList',
  data: function data() {
    return {
      result: {},
      list: [],
      currentPage: 1,
      perPage: 10,
      search: '',
      modal: null,
      isLoading: true,
      link: '',
      nama: ''
    };
  },
  methods: {
    getData: function getData() {
      var _this = this;

      var params = [];
      params.search = this.search;
      params.page = this.currentPage - 1;
      params.size = this.perPage;

      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].get('/request-cetak/all?' + __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(params)).then(function (result) {
        _this.result = result.data;
        console.log("ini datanya", result.data);
        _this.list = result.data.content;
        _this.isLoading = false;
      }).catch(function (ex) {
        _this.isLoading = false;
        _this.$toastr.e('Gagal terhubung dengan server.');
      });
    },
    approveRequest: function approveRequest(id) {
      var _this2 = this;

      this.$swal({
        title: 'Konfirmasi',
        text: 'Setujui permintaan cetak ini?',
        icon: 'info',
        buttons: [true, 'Ya, Setujui']
      }).then(function (result) {
        if (result) {
          __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
          __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].post('/approve', {
            requestId: id,
            keputusan: 'DISETUJUI',
            catatanAdmin: ''
          }).then(function () {
            _this2.$toastr.s('Permintaan berhasil disetujui.');
            _this2.getData();
          }).catch(function () {
            _this2.$toastr.e('Gagal menyetujui permintaan.');
          });
        }
      });
    },
    rejectRequest: function rejectRequest(id) {
      var _this3 = this;

      this.$swal({
        title: 'Konfirmasi',
        text: 'Tolak permintaan cetak ini?',
        icon: 'warning',
        buttons: [true, 'Ya, Tolak']
      }).then(function (result) {
        if (result) {
          __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
          __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].post('/approve', {
            requestId: id,
            keputusan: 'DITOLAK',
            catatanAdmin: ''
          }).then(function () {
            _this3.$toastr.s('Permintaan berhasil ditolak.');
            _this3.getData();
          }).catch(function () {
            _this3.$toastr.e('Gagal menolak permintaan.');
          });
        }
      });
    },
    checkRoute: function checkRoute(route) {
      console.log("ini routenamenya", route.name);
      if (route.name === 'cetakMP') {
        // this.link = 'Pengaduan'
        this.nama = 'Request Cetak Mp';
        console.log(this.link);
      }
    }
  },
  mounted: function mounted() {
    this.checkRoute(this.$route);
    this.getData();
  },
  watch: {
    currentPage: function currentPage(e) {
      this.getData();
    },
    perPage: function perPage(e) {
      this.getData();
    },
    search: function search(e) {
      this.getData();
    },
    '$route': function $route(to, from) {
      this.checkRoute(to);
      this.getData();
    }
  }
});

/***/ }),

/***/ "f3NK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Sidebar',
  data: function data() {
    return {
      modal: false,
      isProfile: false,
      isLayanan: false,
      isInformasi: false,
      isUnduh: false,
      isPensiunRegistrasi: false,
      isFaq: false,
      namaLengkap: localStorage.getItem('namaLengkap'),
      akses: {}
    };
  },
  beforeMount: function beforeMount() {
    this.akses = JSON.parse(localStorage.getItem('akses'));
  },

  computed: {
    aksesProfile: function aksesProfile() {
      var t = 0;
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(this.akses.profile).forEach(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        value ? t++ : 0;
      });
      return t > 0;
    },
    aksesLayanan: function aksesLayanan() {
      var t = 0;
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(this.akses.layanan).forEach(function (_ref3) {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
            key = _ref4[0],
            value = _ref4[1];

        value ? t++ : 0;
      });
      return t > 0;
    },
    aksesInformasi: function aksesInformasi() {
      var t = 0;
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(this.akses.informasi).forEach(function (_ref5) {
        var _ref6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref5, 2),
            key = _ref6[0],
            value = _ref6[1];

        value ? t++ : 0;
      });
      return t > 0;
    },
    aksesUnduh: function aksesUnduh() {
      var t = 0;
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(this.akses.unduh).forEach(function (_ref7) {
        var _ref8 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref7, 2),
            key = _ref8[0],
            value = _ref8[1];

        value ? t++ : 0;
      });
      return t > 0;
    },
    link: function link() {
      var link = this.$route.path.toString().split('/');
      var l = link[1] + '/' + link[2];

      if (l === 'main/profile') this.isProfile = true;
      if (l === 'main/informasi') this.isInformasi = true;
      if (l === 'main/unduh') this.isUnduh = true;
      if (l === 'main/layanan') this.isLayanan = true;
      if (l === 'main/pensiunRegistrasi') this.isPensiunRegistrasi = true;
      if (l === 'main/faq') this.isFaq = true;

      console.log(l);

      return l;
    },
    fullLink: function fullLink() {
      var link = this.$route.path.toString().split('/');
      link.shift();
      return link.join('/');
    }
  }
});

/***/ }),

/***/ "f837":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_ckeditor2__ = __webpack_require__("42+j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__ = __webpack_require__("w3AW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_api__ = __webpack_require__("+Btm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone__ = __webpack_require__("KvPw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_dropzone_dist_vue2Dropzone_css__ = __webpack_require__("hCol");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_dropzone_dist_vue2Dropzone_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_dropzone_dist_vue2Dropzone_css__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FormLine: __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__["a" /* default */],
    Ckeditor: __WEBPACK_IMPORTED_MODULE_1_vue_ckeditor2__["a" /* default */],
    vueDropzone: __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone___default.a
  },
  name: 'ListNarasumber',
  data: function data() {
    return {
      date: {
        dateFormat: 'Y-m-d',
        allowInput: true
      },
      config: {
        toolbar: [{ name: 'stuff', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] }, { name: 'morestuff', items: ['NumberedList', 'BulletedList'] }, { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Superscript', 'Subscript'] }, { name: 'colors', items: ['TextColor'] }, { name: 'paragraph2', items: ['JustifyLeft', 'JustiftyCenter', 'JustifyRight', 'Outdent', 'Indent'] }, '/', { name: 'document', items: ['Source'] }]
      },
      content: {
        judul: '',
        edisiTriwulan: '',
        tahun: '',
        tags: '',
        thumbnail: ''
      },
      file: '',
      id_majalah: '',
      nama: '',
      tipe: '',
      link: '',
      thumbnail: ''
    };
  },
  computed: {
    dropzoneOptionsThumbnail: function dropzoneOptionsThumbnail() {
      if (!this.id_majalah) {
        return {};
      }
      return {
        url: __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.baseURL + '/upload_image_dropzoneMajalah?id=' + this.id_majalah,
        thumbnailWidth: 150,
        addRemoveLinks: true,
        maxFiles: 1,
        maxFilesize: 2,
        dictRemoveFileConfirmation: 'Anda yakin ingin menghapus file ini?',
        headers: { Authorization: 'Bearer ' + localStorage.getItem('_token') }
      };
    }
  },
  methods: {
    save: function save() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      var form = new FormData();
      form.append('file', this.file);
      form.append('json', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.content));
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].post('/' + this.link, form).then(function (result) {
        if (result.data.code === 200) {
          _this.$router.replace('/main/unduh/majalah/edit/' + result.data.object.id_majalah);
          _this.$toastr.s('Tambah data berhasil');
        } else {
          var msg = 'Tambah data gagal';
          if (result.data.message !== '') msg = result.data.message;
          _this.$toastr.e(msg);
        }
      }).catch(function (e) {
        var msg = 'Terjadi kesalahan pada server, mohon ulangi';
        if (e.response.data.message) msg = e.response.data.message;
        _this.$toastr.e(msg);
      });
    },
    update: function update() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      var form = new FormData();
      form.append('file', this.file);
      form.append('json', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.content));
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].post('/' + this.link + '/' + this.id_majalah, form).then(function (result) {
        if (result.data.code === 200) {
          _this2.$router.replace('/main/unduh/' + _this2.link);
          _this2.$toastr.s('Ubah data berhasil');
        }
      }).catch(function (ex) {
        var msg = 'Terjadi kesalahan pada server, mohon ulangi';
        if (ex.response.data.message) msg = ex.response.data.message;
        _this2.$toastr.e(msg);
      });
    },
    onUploadSuccess: function onUploadSuccess(file, response) {
      console.log("iniresponse dari dropzone", response);
      var idFile = response && response.object ? response.object.id : null;
      console.log("ini idfile", idFile);
      if (idFile) {
        this.data.fileMajalahId.push(idFile);
      }
    },
    getDetail: function getDetail() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].get('/' + this.link + '/' + this.id_majalah).then(function (result) {
        _this3.content = result.data;
        if (_this3.content.thumbnail) {
          var mockFile = {
            name: 'Thumbnail Majalah',
            size: 123456,
            type: 'image/jpeg'
          };
          _this3.$refs.dropzoneThumnailMajalah.manuallyAddFile(mockFile, _this3.content.thumbnail);
        }
      }).catch(function (ex) {
        _this3.$toastr.e('Terjadi kesalahan pada server, mohon ulangi');
      });
    },
    handleFile: function handleFile(file) {
      this.file = file.target.files[0];
    },
    vremoved: function vremoved(file, xhr, error) {
      console.log("ini filenya", file);
      this.delete(file.name.id);
    },
    checkRoute: function checkRoute(route) {
      console.log(route.name);
      if (route.name === 'TambahMajalah' || route.name === 'EditMajalah') {
        this.link = 'majalah';
        this.nama = 'Majalah';
      }
    }
  },
  mounted: function mounted() {
    this.checkRoute(this.$route);
    this.id_majalah = this.$route.params.id;
    console.log(this.id_majalah);
    if (this.id_majalah != null) {
      this.getDetail();
    }
  },

  watch: {
    '$route': function $route(to, from) {
      this.checkRoute(to);
      this.id_majalah = to.params.id;
      if (this.id_majalah) {
        this.getDetail();
      }
    }
  }
});

/***/ }),

/***/ "fCMu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Banner_vue__ = __webpack_require__("e1ih");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70b457aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Banner_vue__ = __webpack_require__("xlJt");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Banner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70b457aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Banner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fUy3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"block-header"},[_c('h2',[_vm._v(_vm._s(_vm.nama))])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            List "+_vm._s(_vm.nama)+"\n                        ")]),_vm._v(" "),_c('ul',{staticClass:"header-dropdown m-r--5 m-t--10"},[_c('router-link',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect",attrs:{"to":'/main/unduh/' + _vm.link + '/tambah',"type":"button"}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#fff"}},[_vm._v("add_box")]),_vm._v(" "),_c('span',[_vm._v("Tambah")])])],1)]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"dataTables_wrapper form-inline dt-bootstrap",attrs:{"id":"DataTables_Table_0_wrapper"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_length",attrs:{"id":"DataTables_Table_0_length"}},[_c('label',[_vm._v("Show "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.perPage),expression:"perPage"}],staticClass:"form-control input-sm",attrs:{"name":"DataTables_Table_0_length","aria-controls":"DataTables_Table_0"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.perPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_c('option',{attrs:{"value":"100"}},[_vm._v("100")])]),_vm._v(" entries")])])]),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_filter",attrs:{"id":"DataTables_Table_0_filter"}},[_c('label',[_vm._v("Search:"),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control input-sm",attrs:{"type":"search","placeholder":"","aria-controls":"DataTables_Table_0"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])])])]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped table-hover js-basic-example dataTable"},[_vm._m(0),_vm._v(" "),_c('tbody',[(_vm.isLoading)?_c('tr',[_vm._m(1)]):_vm._e(),_vm._v(" "),(_vm.list == '')?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"7"}},[_vm._v("Data tidak ditemukan")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(item,index){return (!_vm.isLoading)?_c('tr',[_c('td',[_vm._v(_vm._s(++index + ((_vm.currentPage-1)*_vm.perPage)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.judul))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.jenisRegulasi))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.bidang))]),_vm._v(" "),_c('td',[(item.file != null)?_c('a',{staticClass:"btn btn-info",attrs:{"target":"_blank","href":item.file}},[_c('i',{staticClass:"fa fa-paperclip"}),_vm._v(" File")]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.stripTags(item.tags)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.tglBerlaku))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn bg-green waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.push('/main/unduh/' + _vm.link + '/edit/' + item.id_regulasi_dana_pensiun)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("create")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmDelete(item.id_regulasi_dana_pensiun)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")])]),_vm._v(" "),(index != 1)?_c('button',{staticClass:"btn btn-primary waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.moveUp(index)}}},[_c('i',{staticClass:"fa fa-chevron-up"})]):_vm._e(),_vm._v(" "),(index !== (_vm.list.length))?_c('button',{staticClass:"btn btn-primary waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.moveDown(index)}}},[_c('i',{staticClass:"fa fa-chevron-down"})]):_vm._e()])]):_vm._e()})],2)])]),_vm._v(" "),_c('pagination',{attrs:{"total-rows":_vm.result.totalElements,"per-page":_vm.result.size},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("No.")]),_vm._v(" "),_c('th',[_vm._v("Judul")]),_vm._v(" "),_c('th',[_vm._v("Jenis Regulasi")]),_vm._v(" "),_c('th',[_vm._v("Bidang")]),_vm._v(" "),_c('th',[_vm._v("File")]),_vm._v(" "),_c('th',[_vm._v("Tags")]),_vm._v(" "),_c('th',[_vm._v("Berlaku Sampai")]),_vm._v(" "),_c('th',[_vm._v("Aksi")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center",attrs:{"colspan":"7"}},[_c('i',{staticClass:"fa fa-spin fa-spinner"}),_vm._v(" Loading data...")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fXLv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_ckeditor2__ = __webpack_require__("42+j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FormLine_vue__ = __webpack_require__("w3AW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_api__ = __webpack_require__("+Btm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone__ = __webpack_require__("KvPw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css__ = __webpack_require__("hCol");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */







/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_1__components_FormLine_vue__["a" /* default */], Ckeditor: __WEBPACK_IMPORTED_MODULE_0_vue_ckeditor2__["a" /* default */], vueDropzone: __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone___default.a },
  name: 'Pengaduan',
  data: function data() {
    return {
      data: {
        deskripsi: '',
        nama: '',
        nip: '',
        keterangan: '',
        statusTiket: 'Pengajuan selesai',
        jawaban: ''
      },
      tanggal: '',
      id_Pengaduan: '',
      nama: '',
      link: '',
      isLoading: false,
      init: false
    };
  },
  methods: {
    update: function update() {
      var _this = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      console.log("ini datanya", this.data);
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].post('/updateTiket/' + this.id_Pengaduan, this.data).then(function (result) {
        if (result.data.code === 200) {
          _this.$router.replace('/main/informasi/' + _this.link);
          _this.$toastr.s('Ubah data berhasil');
        }
        _this.isLoading = false;
      }).catch(function (e) {
        var msg = 'Terjadi kesalahan pada server, mohon ulangi';
        if (e.response.data.message) msg = e.response.data.message;
        _this.$toastr.e(msg);
        _this.isLoading = false;
      });
    },
    getDetail: function getDetail() {
      var _this2 = this;

      this.init = true;
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');

      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].get('/pengaduanGetbyId/' + this.id_Pengaduan).then(function (result) {
        var res = result.data.object;
        _this2.data.deskripsi = res.deskripsi || '';
        _this2.data.nama = res.nama || '';
        _this2.data.nip = res.nip || '';
        _this2.data.noTiket = res.noTiket || '';
        _this2.data.keterangan = res.keterangan || '';
        _this2.data.topik = res.topik || '';
        _this2.data.jawaban = res.jawaban || '';
        _this2.data.topikId = res.topikId || '';
      }).catch(function (ex) {
        console.error("Error getDetail:", ex);
        _this2.$toastr.e('Terjadi kesalahan pada server, mohon ulangi');
        _this2.init = false;
      });
    },
    onSubmit: function onSubmit() {
      if (this.id_Pengaduan != null) this.update();else this.save();
    },
    checkRoute: function checkRoute(route) {
      console.log(route.name);
      if (route.name === 'EditPengaduan' || route.name === 'EditPengaduan') {
        this.link = 'Pengaduan';
        this.nama = 'Pengaduan';
      }
    },
    vremoved: function vremoved(file, xhr, error) {
      console.log("ini filenya", file);
      if (!this.init) this.delete(file.name.id);
    },
    delete: function _delete(id) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].delete('/delete_file_Pengaduan/' + id).then(function (result) {
        console.log(result.data.code);
        if (result.data.code === 200) {
          _this3.$toastr.s('Foto berhasil dihapus');
          _this3.$swal.close();
        } else {
          _this3.$toastr.e('Gagal menghapus foto');
          _this3.$swal.close();
        }
      }).catch(function (e) {
        _this3.$swal.close();
      });
    }
  },
  mounted: function mounted() {
    this.checkRoute(this.$route);
    this.id_Pengaduan = this.$route.params.id;
    if (this.id_Pengaduan != null) {
      this.getDetail();
    }
  },

  watch: {
    $route: function $route(to, from) {
      this.checkRoute(to);
    },
    'data.content': function dataContent(newVal) {
      console.log('Konten Pengaduan berubah');
    }
  }
});

/***/ }),

/***/ "fhXe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_api__ = __webpack_require__("+Btm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FormLine_vue__ = __webpack_require__("w3AW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_3__components_FormLine_vue__["a" /* default */] },
  name: 'ListVisiMisi',
  data: function data() {
    return {
      result: {},
      list: [],
      currentPage: 1,
      perPage: 10,
      search: '',
      modal: null,
      isLoading: true,
      link: '',
      tipe: [1, 2],
      nama: ''
    };
  },
  methods: {
    moveUp: function moveUp(index) {
      var a = this.list[index - 1];
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(this.list, index - 1, this.list[index - 2]);
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(this.list, index - 2, a);

      this.saveUrutan();
    },
    moveDown: function moveDown(index) {
      var a = this.list[index - 1];
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(this.list, index - 1, this.list[index]);
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(this.list, index, a);

      this.saveUrutan();
    },
    saveUrutan: function saveUrutan() {
      var _this = this;

      var data = [];
      for (var i = 0; i < this.list.length; i++) {
        data.push({
          'id': this.list[i].id_pdp_arahan,
          'urutan': i,
          'tipe': this.tipe
        });
      }

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].post('/pdp_arahan/move', data).then(function (result) {
        _this.$toastr.s('Urutan berhasil diubah.');
      }).catch(function (ex) {
        _this.$toastr.e('Gagal mengubah urutan, terjadi kesalahan pada server.');
      });
    },
    getData: function getData() {
      var _this2 = this;

      var params = [];
      params.search = this.search;
      params.page = this.currentPage - 1;
      params.size = this.perPage;
      params.tipe = this.tipe;

      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].get('/pdp-arahan?' + __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(params)).then(function (result) {
        _this2.result = result.data;
        _this2.list = result.data.content;
        _this2.isLoading = false;
      }).catch(function (ex) {
        _this2.isLoading = false;
      });
    },
    confirmDelete: function confirmDelete(id) {
      var _this3 = this;

      this.$swal({
        title: 'Konfirmasi',
        text: 'Anda yakin ingin menghapus data ini?',
        icon: 'warning',
        buttons: [true, {
          text: 'Ok',
          closeModal: false
        }],
        dangerMode: true
      }).then(function (result) {
        if (result) _this3.delete(id);
      });
    },
    delete: function _delete(id) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].delete('/pdp/' + id).then(function (result) {
        if (result.data.code === 200) _this4.$toastr.s('Data berhasil dihapus.');else _this4.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this4.$swal.close();
        _this4.getData();
      }).catch(function (e) {
        _this4.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this4.$swal.close();
      });
    },
    checkRoute: function checkRoute(route) {
      this.list = [];
      if (route.name === 'ListPDP') {
        this.nama = 'PDP';
        this.tipe = 1;
        this.link = 'pdp';
      }
      if (route.name === 'ListArahan') {
        this.nama = 'Arahan';
        this.tipe = 2;
        this.link = 'arahan';
      }
    }
  },
  mounted: function mounted() {
    this.checkRoute(this.$route);
    this.getData();
  },
  watch: {
    currentPage: function currentPage(e) {
      this.getData();
    },
    perPage: function perPage(e) {
      this.getData();
    },
    search: function search(e) {
      this.getData();
    },
    '$route': function $route(to, from) {
      this.checkRoute(to);
      this.getData();
    }
  }
});

/***/ }),

/***/ "fn37":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"block-header"},[_c('h2',[_vm._v(_vm._s(_vm.nama))])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v(_vm._s(_vm.id_Pengumuman != null ? 'Edit' : 'Tambah')+" "+_vm._s(_vm.nama))])]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit.apply(null, arguments)}}},[_c('div',{staticClass:"row clearfix"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"judul","type":"text"},model:{value:(_vm.data.judul),callback:function ($$v) {_vm.$set(_vm.data, "judul", $$v)},expression:"data.judul"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"form-line"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.data.kategori),expression:"data.kategori"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.data, "kategori", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("-- Pilih Kategori --")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Umum")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Pegawai")])])])])])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"form-line"},[_c('flat-pickr',{staticClass:"form-control",attrs:{"id":"tanggalMulai","config":_vm.date},model:{value:(_vm.data.tanggalMulai),callback:function ($$v) {_vm.$set(_vm.data, "tanggalMulai", $$v)},expression:"data.tanggalMulai"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"form-line"},[_c('flat-pickr',{staticClass:"form-control",attrs:{"id":"tanggalAkhir","config":_vm.date},model:{value:(_vm.data.tanggalAkhir),callback:function ($$v) {_vm.$set(_vm.data, "tanggalAkhir", $$v)},expression:"data.tanggalAkhir"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('Ckeditor',{ref:"ckeditor",attrs:{"id":"pengumuman","config":_vm.config},model:{value:(_vm.data.isi),callback:function ($$v) {_vm.$set(_vm.data, "isi", $$v)},expression:"data.isi"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[(_vm.id_Pengumuman != null)?_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-warning waves-effect waves-button",attrs:{"type":"button","disabled":_vm.isLoading},on:{"click":_vm.update}},[(_vm.isLoading)?_c('i',{staticClass:"fa fa-spin fa-spinner"}):_vm._e(),(!_vm.isLoading)?_c('i',{staticClass:"material-icons"},[_vm._v("save")]):_vm._e(),_vm._v(" Edit\n                  ")]):_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect waves-button",attrs:{"type":"button","disabled":_vm.isLoading},on:{"click":_vm.save}},[(_vm.isLoading)?_c('i',{staticClass:"fa fa-spin fa-spinner"}):_vm._e(),(!_vm.isLoading)?_c('i',{staticClass:"material-icons"},[_vm._v("save")]):_vm._e(),_vm._v("\n                    Simpan\n                  ")]),_vm._v(" "),_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")]),_vm._v(" Batal\n                  ")])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"judul"}},[_vm._v("Judul")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"kategori"}},[_vm._v("Kategori")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"tanggalMulai"}},[_vm._v("Tanggal Mulai")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"tanggalAkhir"}},[_vm._v("Tanggal Akhir")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"pengumuman"}},[_vm._v("Pengumuman")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "g3uV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListKelengkapan_vue__ = __webpack_require__("SoQG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31d97fd5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListKelengkapan_vue__ = __webpack_require__("jnqy");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListKelengkapan_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31d97fd5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListKelengkapan_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gZlT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"block-header"},[_c('h2',[_vm._v(_vm._s(_vm.nama))])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            "+_vm._s(_vm.id_informasi_kegiatan != null ? 'Edit' : 'Tambah')+" "+_vm._s(_vm.nama)+"\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit.apply(null, arguments)}}},[_c('div',{staticClass:"row clearfix"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"judul","type":"text"},model:{value:(_vm.content.judul),callback:function ($$v) {_vm.$set(_vm.content, "judul", $$v)},expression:"content.judul"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"form-line"},[_c('flat-pickr',{staticClass:"form-control",attrs:{"id":"tanggal","config":_vm.date},model:{value:(_vm.tanggal),callback:function ($$v) {_vm.tanggal=$$v},expression:"tanggal"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('Ckeditor',{attrs:{"id":"deskripsi","config":_vm.config},model:{value:(_vm.content.deskripsi),callback:function ($$v) {_vm.$set(_vm.content, "deskripsi", $$v)},expression:"content.deskripsi"}})],1)])]),_vm._v(" "),(_vm.id_informasi_kegiatan)?_c('div',{staticClass:"row clearfix"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('vue-dropzone',{ref:"myVueDropzone",attrs:{"id":"dropzone","destroyDropzone":false,"options":_vm.dropzoneOptions},on:{"vdropzone-removed-file":_vm.vremoved,"vdropzone-sending":_vm.sendingEvent}})],1)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[(_vm.id_informasi_kegiatan != null)?_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-warning waves-effect waves-button",attrs:{"type":"button","disabled":_vm.isLoading},on:{"click":_vm.update}},[(_vm.isLoading)?_c('i',{staticClass:"fa fa-spin fa-spinner"}):_vm._e(),(!_vm.isLoading)?_c('i',{staticClass:"material-icons"},[_vm._v("save")]):_vm._e(),_vm._v(" Edit")]):_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect waves-button",attrs:{"type":"button","disabled":_vm.isLoading},on:{"click":_vm.save}},[(_vm.isLoading)?_c('i',{staticClass:"fa fa-spin fa-spinner"}):_vm._e(),(!_vm.isLoading)?_c('i',{staticClass:"material-icons"},[_vm._v("save")]):_vm._e(),_vm._v(" Simpan")]),_vm._v(" "),_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")]),_vm._v(" Batal")])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"judul"}},[_vm._v("Judul")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"tanggal"}},[_vm._v("Tanggal")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"deskripsi"}},[_vm._v("Deskripsi")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"deskripsi"}},[_vm._v("Foto Kegiatan")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gbDD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_api__ = __webpack_require__("+Btm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__ = __webpack_require__("w3AW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__["a" /* default */] },
  name: 'ListFaq',
  data: function data() {
    return {
      result: {},
      list: [],
      currentPage: 1,
      perPage: 10,
      search: '',
      modal: null,
      isLoading: true,
      link: '',
      tipe: '',
      nama: ''
    };
  },
  methods: {
    getData: function getData() {
      var _this = this;

      var params = [];
      params.search = this.search;
      params.page = this.currentPage - 1;
      params.size = this.perPage;

      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].get('/anggota?' + __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(params)).then(function (result) {
        _this.result = result.data;
        _this.list = result.data.content;
        _this.isLoading = false;
      }).catch(function (ex) {
        _this.isLoading = false;
      });
    },
    confirmDelete: function confirmDelete(id) {
      var _this2 = this;

      this.$swal({
        title: 'Konfirmasi',
        text: 'Anda yakin ingin menghapus data ini?',
        icon: 'warning',
        buttons: [true, {
          text: 'Ok',
          closeModal: false
        }],
        dangerMode: true
      }).then(function (result) {
        if (result) _this2.delete(id);
      });
    },
    delete: function _delete(id) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].delete('/anggota/' + id).then(function (result) {
        if (result.data.code === 200) _this3.$toastr.s('Data berhasil dihapus.');else _this3.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this3.$swal.close();
        _this3.getData();
      }).catch(function (e) {
        _this3.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this3.$swal.close();
      });
    }
  },
  mounted: function mounted() {
    this.getData();
  },
  watch: {
    currentPage: function currentPage(e) {
      this.getData();
    },
    perPage: function perPage(e) {
      this.getData();
    },
    search: function search(e) {
      this.getData();
    }
  }
});

/***/ }),

/***/ "glWS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            "+_vm._s(_vm.id_sejarah != '' ? 'Edit' : 'Tambah')+" Sejarah Pendirian\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_c('div',{staticClass:"row clearfix"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"type":"number","name":"tahun","id":"tahun","placeholder":"Masukkan Tahun"},model:{value:(_vm.sejarah.tahun),callback:function ($$v) {_vm.$set(_vm.sejarah, "tahun", $$v)},expression:"sejarah.tahun"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('Ckeditor',{attrs:{"config":_vm.config},model:{value:(_vm.sejarah.deskripsi),callback:function ($$v) {_vm.$set(_vm.sejarah, "deskripsi", $$v)},expression:"sejarah.deskripsi"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[(_vm.id_sejarah != null)?_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-warning waves-effect waves-button",attrs:{"disabled":_vm.isLoading,"type":"button"},on:{"click":_vm.update}},[(!_vm.isLoading)?_c('span',[_c('i',{staticClass:"material-icons"},[_vm._v("save")]),_vm._v(" Edit")]):_c('span',[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" Loading")])]):_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect waves-button",attrs:{"disabled":_vm.isLoading,"type":"button"},on:{"click":_vm.save}},[(!_vm.isLoading)?_c('span',[_c('i',{staticClass:"material-icons"},[_vm._v("save")]),_vm._v(" Simpan")]):_c('span',[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" Loading")])]),_vm._v(" "),_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")]),_vm._v(" Batal")])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-header"},[_c('h2',[_vm._v("Sejarah Pendirian")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"tahun"}},[_vm._v("Tahun")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"singkatan"}},[_vm._v("Deskripsi")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gquy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"block-header"},[_c('h2',[_vm._v(_vm._s(_vm.nama))])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            List "+_vm._s(_vm.nama)+"\n                        ")]),_vm._v(" "),_c('ul',{staticClass:"header-dropdown m-r--5 m-t--10"},[_c('router-link',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect",attrs:{"to":'/main/unduh/' + _vm.link + '/tambah',"type":"button"}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#fff"}},[_vm._v("add_box")]),_vm._v(" "),_c('span',[_vm._v("Tambah")])])],1)]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"dataTables_wrapper form-inline dt-bootstrap",attrs:{"id":"DataTables_Table_0_wrapper"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_length",attrs:{"id":"DataTables_Table_0_length"}},[_c('label',[_vm._v("Show "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.perPage),expression:"perPage"}],staticClass:"form-control input-sm",attrs:{"name":"DataTables_Table_0_length","aria-controls":"DataTables_Table_0"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.perPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_c('option',{attrs:{"value":"100"}},[_vm._v("100")])]),_vm._v(" entries")])])]),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_filter",attrs:{"id":"DataTables_Table_0_filter"}},[_c('label',[_vm._v("Search:"),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control input-sm",attrs:{"type":"search","placeholder":"","aria-controls":"DataTables_Table_0"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])])])]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped table-hover js-basic-example dataTable"},[_vm._m(0),_vm._v(" "),_c('tbody',[(_vm.isLoading)?_c('tr',[_vm._m(1)]):_vm._e(),_vm._v(" "),(_vm.list == '')?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"7"}},[_vm._v("Data tidak ditemukan")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(item,index){return (!_vm.isLoading)?_c('tr',[_c('td',[_vm._v(_vm._s(++index + ((_vm.currentPage-1)*_vm.perPage)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.tipeName(item.tipe)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.judul))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.tahun))]),_vm._v(" "),_c('td',[(item.file != null)?_c('a',{staticClass:"btn btn-info",attrs:{"target":"_blank","href":item.file}},[_c('i',{staticClass:"fa fa-paperclip"}),_vm._v(" File")]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.stripTags(item.tags)))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn bg-green waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.push('/main/unduh/' + _vm.link + '/edit/' + item.id_unduh)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("create")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmDelete(item.id_unduh)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")])]),_vm._v(" "),(index != 1)?_c('button',{staticClass:"btn btn-primary waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.moveUp(index)}}},[_c('i',{staticClass:"fa fa-chevron-up"})]):_vm._e(),_vm._v(" "),(index !== (_vm.list.length))?_c('button',{staticClass:"btn btn-primary waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.moveDown(index)}}},[_c('i',{staticClass:"fa fa-chevron-down"})]):_vm._e()])]):_vm._e()})],2)])]),_vm._v(" "),_c('pagination',{attrs:{"total-rows":_vm.result.totalElements,"per-page":_vm.result.size},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("No.")]),_vm._v(" "),_c('th',[_vm._v("Tipe")]),_vm._v(" "),_c('th',[_vm._v("Judul")]),_vm._v(" "),_c('th',[_vm._v("Tahun")]),_vm._v(" "),_c('th',[_vm._v("File")]),_vm._v(" "),_c('th',[_vm._v("Tags")]),_vm._v(" "),_c('th',[_vm._v("Aksi")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center",attrs:{"colspan":"7"}},[_c('i',{staticClass:"fa fa-spin fa-spinner"}),_vm._v(" Loading data...")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "h4SG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();return _vm.kirim.apply(null, arguments)}}},[_c('div',{staticClass:"row clearfix"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"subjek","type":"text"},model:{value:(_vm.send.message),callback:function ($$v) {_vm.$set(_vm.send, "message", $$v)},expression:"send.message"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect waves-button",attrs:{"disabled":_vm.isLoading,"type":"submit"}},[(!_vm.isLoading)?_c('span',[_c('i',{staticClass:"material-icons"},[_vm._v("save")]),_vm._v(" Kirim")]):_c('span',[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" Loading")])]),_vm._v(" "),_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-danger",attrs:{"disabled":_vm.isLoading,"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")]),_vm._v(" Batal")])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-header"},[_c('h2',[_vm._v("Notifikasi")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            Kirim Notifikasi\n                        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"subjek"}},[_vm._v("Pesan")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hAd8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormStrukturOrganisasi_vue__ = __webpack_require__("GSWY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05275e8e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormStrukturOrganisasi_vue__ = __webpack_require__("IVcU");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormStrukturOrganisasi_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05275e8e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormStrukturOrganisasi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hCol":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hERV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListFaq_vue__ = __webpack_require__("5fFZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4464e521_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListFaq_vue__ = __webpack_require__("PXrT");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListFaq_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4464e521_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListFaq_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "i1Zw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            "+_vm._s(_vm.id_logo != null ? 'Edit' : 'Tambah')+" Slider\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_c('div',{staticClass:"row clearfix"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.data.tipe),expression:"data.tipe"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.data, "tipe", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("[ Pilih Tipe ]")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Company Link")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Anak Perusahaan")])])])])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[(_vm.data.gambar != null)?_c('img',{attrs:{"src":_vm.data.gambar,"width":"150px","alt":"Foto"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"id":"icon","type":"file","name":"icon"},on:{"change":function($event){return _vm.handleFile($event)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"text1","type":"text"},model:{value:(_vm.data.link),callback:function ($$v) {_vm.$set(_vm.data, "link", $$v)},expression:"data.link"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"text1","type":"text"},model:{value:(_vm.data.description),callback:function ($$v) {_vm.$set(_vm.data, "description", $$v)},expression:"data.description"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"text1","type":"text"},model:{value:(_vm.data.name),callback:function ($$v) {_vm.$set(_vm.data, "name", $$v)},expression:"data.name"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[(_vm.id_logo != null)?_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-warning waves-effect waves-button",attrs:{"disabled":_vm.isLoading,"type":"button"},on:{"click":_vm.update}},[(!_vm.isLoading)?_c('span',[_c('i',{staticClass:"material-icons"},[_vm._v("save")]),_vm._v(" Edit")]):_c('span',[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" Loading")])]):_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect waves-button",attrs:{"disabled":_vm.isLoading,"type":"button"},on:{"click":_vm.save}},[(!_vm.isLoading)?_c('span',[_c('i',{staticClass:"material-icons"},[_vm._v("save")]),_vm._v(" Simpan")]):_c('span',[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" Loading")])]),_vm._v(" "),_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-danger waves-effect waves-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")]),_vm._v(" Batal")])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-header"},[_c('h2',[_vm._v("Anak Perusahaan")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"text1"}},[_vm._v("Tipe")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"icon"}},[_vm._v("Gambar")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"text1"}},[_vm._v("Link")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"text1"}},[_vm._v("Description")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"text1"}},[_vm._v("Name")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "i3Ju":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_ckeditor2__ = __webpack_require__("42+j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FormLine_vue__ = __webpack_require__("w3AW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_api__ = __webpack_require__("+Btm");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_1__components_FormLine_vue__["a" /* default */], Ckeditor: __WEBPACK_IMPORTED_MODULE_0_vue_ckeditor2__["a" /* default */] },
  name: 'Form',
  data: function data() {
    return {
      config: {
        toolbar: [{ name: 'stuff', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] }, { name: 'morestuff', items: ['NumberedList', 'BulletedList'] }, { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Superscript', 'Subscript'] }, { name: 'colors', items: ['TextColor'] }, { name: 'paragraph2', items: ['JustifyLeft', 'JustiftyCenter', 'JustifyRight', 'Outdent', 'Indent'] }, '/', { name: 'document', items: ['Source'] }],
        height: 300
      },
      data: {
        judul: '',
        tipe: 0,
        deskripsi: ''
      },
      isLoading: false,
      link: '',
      name: ''
    };
  },
  mounted: function mounted() {
    this.checkRoute();
  },

  methods: {
    checkRoute: function checkRoute() {
      if (this.$route.name === 'SyaratKepesertaan') {
        this.link = 'syarat';
        this.name = 'Syarat Kepesertaan';
        this.data.tipe = 9;
      }

      if (this.$route.name === 'CaraMendaftar') {
        this.link = 'cara';
        this.name = 'Cara Mendaftar';
        this.data.tipe = 10;
      }
      this.getData();
    },
    getData: function getData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].get('/content-only?tipe=' + this.data.tipe).then(function (result) {
        if (result.status === 200 && result.data) _this.data = result.data;
        _this.data.judul = _this.name;
      }).catch(function (e) {
        var msg = 'Terjadi kesalahan pada server, mohon ulangi';
        if (e.response.data.message) msg = e.response.data.message;
        _this.$toastr.e(msg);
        _this.isLoading = false;
      });
    },
    save: function save() {
      var _this2 = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].post('/content-only', this.data).then(function (result) {
        if (result.data.code === 200) {
          _this2.$toastr.s('Data berhasil disimpan');
        } else {
          var msg = 'Data gagal disimpan, silahkan coba kembali';
          if (result.data.message !== '') msg = result.data.message;
          _this2.$toastr.e(msg);
        }
        _this2.isLoading = false;
      }).catch(function (e) {
        var msg = 'Terjadi kesalahan pada server, mohon ulangi';
        if (e.response.data.message) msg = e.response.data.message;
        _this2.$toastr.e(msg);
        _this2.isLoading = false;
      });
    }
  },
  watch: {
    '$route': function $route(to, from) {
      this.checkRoute();
    }
  }
});

/***/ }),

/***/ "iH7I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            List Survey\n                        ")]),_vm._v(" "),_c('ul',{staticClass:"header-dropdown m-r--5 m-t--10"},[_c('router-link',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect waves-button",attrs:{"to":'/main/layanan/survey/tambah',"type":"button"}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#fff"}},[_vm._v("add_box")]),_vm._v(" "),_c('span',[_vm._v("Tambah")])])],1)]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"dataTables_wrapper form-inline dt-bootstrap",attrs:{"id":"DataTables_Table_0_wrapper"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_length",attrs:{"id":"DataTables_Table_0_length"}},[_c('label',[_vm._v("Show "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.perPage),expression:"perPage"}],staticClass:"form-control input-sm",attrs:{"name":"DataTables_Table_0_length","aria-controls":"DataTables_Table_0"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.perPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_c('option',{attrs:{"value":"100"}},[_vm._v("100")])]),_vm._v(" entries")])])]),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_filter",attrs:{"id":"DataTables_Table_0_filter"}},[_c('label',[_vm._v("Search:"),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control input-sm",attrs:{"type":"search","placeholder":"","aria-controls":"DataTables_Table_0"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])])])]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped table-hover js-basic-example dataTable"},[_vm._m(1),_vm._v(" "),_c('tbody',[(_vm.isLoading)?_c('tr',[_vm._m(2)]):_vm._e(),_vm._v(" "),(_vm.list == '')?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"5"}},[_vm._v("Data tidak ditemukan")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(item,index){return (!_vm.isLoading)?_c('tr',[_c('td',[_vm._v(_vm._s(++index + ((_vm.currentPage-1)*_vm.perPage)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.periode))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.pernyataan))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn bg-green waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.push('/main/layanan/survey/edit/' + item.idMasterSurvey)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("create")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmDelete(item.idMasterSurvey)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")])]),_vm._v(" "),(index != 1)?_c('button',{staticClass:"btn btn-primary waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.moveUp(index)}}},[_c('i',{staticClass:"fa fa-chevron-up"})]):_vm._e(),_vm._v(" "),(index !== (_vm.list.length))?_c('button',{staticClass:"btn btn-primary waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.moveDown(index)}}},[_c('i',{staticClass:"fa fa-chevron-down"})]):_vm._e()])]):_vm._e()})],2)])]),_vm._v(" "),_c('pagination',{attrs:{"total-rows":_vm.result.totalElements,"per-page":_vm.result.size},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-header"},[_c('h2',[_vm._v("Survey")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("No.")]),_vm._v(" "),_c('th',[_vm._v("Periode")]),_vm._v(" "),_c('th',[_vm._v("Pernyataan")]),_vm._v(" "),_c('th',[_vm._v("Aksi")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center",attrs:{"colspan":"5"}},[_c('i',{staticClass:"fa fa-spin fa-spinner"}),_vm._v(" Loading data...")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "icvh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_ckeditor2__ = __webpack_require__("42+j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__ = __webpack_require__("w3AW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_api__ = __webpack_require__("+Btm");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__["a" /* default */], Ckeditor: __WEBPACK_IMPORTED_MODULE_1_vue_ckeditor2__["a" /* default */] },
  name: 'ListNarasumber',
  data: function data() {
    return {
      config: {
        toolbar: [{ name: 'stuff', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] }, { name: 'morestuff', items: ['NumberedList', 'BulletedList'] }, { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Superscript', 'Subscript'] }, { name: 'colors', items: ['TextColor'] }, { name: 'paragraph2', items: ['JustifyLeft', 'JustiftyCenter', 'JustifyRight', 'Outdent', 'Indent'] }, '/', { name: 'document', items: ['Source'] }],
        height: 300
      },
      content: {
        judul: ''
      },
      file: '',
      id_informasi_download: '',
      nama: '',
      tipe: '',
      link: '',
      isLoading: false
    };
  },
  methods: {
    save: function save() {
      var _this = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      var form = new FormData();
      form.append('file', this.file);
      form.append('json', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.content));
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].post('/informasi_download', form).then(function (result) {
        if (result.data.code === 200) {
          _this.$router.replace('/main/informasi/' + _this.link);
          _this.$toastr.s('Tambah data berhasil');
        } else {
          var msg = 'Tambah data gagal';
          if (result.data.message !== '') msg = result.data.message;
          _this.$toastr.e(msg);
        }
        _this.isLoading = false;
      }).catch(function (e) {
        var msg = 'Terjadi kesalahan pada server, mohon ulangi';
        if (e.response.data.message) msg = e.response.data.message;
        _this.$toastr.e(msg);
        _this.isLoading = false;
      });
    },
    update: function update() {
      var _this2 = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      var form = new FormData();
      form.append('file', this.file);
      form.append('json', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.content));
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].post('/informasi_download/' + this.id_informasi_download, form).then(function (result) {
        if (result.data.code === 200) {
          _this2.$router.replace('/main/informasi/' + _this2.link);
          _this2.$toastr.s('Ubah data berhasil');
        }
        _this2.isLoading = false;
      }).catch(function (e) {
        var msg = 'Terjadi kesalahan pada server, mohon ulangi';
        if (e.response.data.message) msg = e.response.data.message;
        _this2.$toastr.e(msg);
        _this2.isLoading = false;
      });
    },
    getDetail: function getDetail() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].get('/informasi_download/' + this.id_informasi_download).then(function (result) {
        _this3.content = result.data;
      }).catch(function (ex) {
        _this3.$toastr.e('Terjadi kesalahan pada server, mohon ulangi');
        _this3.$router.replace('/main/informasi/' + _this3.link);
      });
    },
    handleFile: function handleFile(file) {
      this.file = file.target.files[0];
    },
    onSubmit: function onSubmit() {
      if (this.id_informasi_download != null) this.update();else this.save();
    },
    checkRoute: function checkRoute(route) {
      console.log(route.name);
      if (route.name === 'TambahPerkembangan' || route.name === 'EditPerkembangan') {
        this.content.tipe = 1;
        this.link = 'perkembangan';
        this.nama = 'Laporan Perkembangan';
      }
      if (route.name === 'TambahTahunan' || route.name === 'EditTahunan') {
        this.content.tipe = 2;
        this.link = 'tahunan';
        this.nama = 'Laporan Keuangan';
      }
      if (route.name === 'TambahLowongan' || route.name === 'EditLowongan') {
        this.content.tipe = 3;
        this.link = 'lowongan';
        this.nama = 'Laporan Lowongan';
      }
    }
  },
  mounted: function mounted() {
    this.checkRoute(this.$route);
    this.id_informasi_download = this.$route.params.id;
    if (this.id_informasi_download != null) {
      this.getDetail();
    }
  },
  '$route': function $route(to, from) {
    this.checkRoute(to);
    this.getData();
  }
});

/***/ }),

/***/ "jnqy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"dataTables_wrapper form-inline dt-bootstrap",attrs:{"id":"DataTables_Table_0_wrapper"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_length",attrs:{"id":"DataTables_Table_0_length"}},[_c('label',[_vm._v("Show "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.perPage),expression:"perPage"}],staticClass:"form-control input-sm",attrs:{"name":"DataTables_Table_0_length","aria-controls":"DataTables_Table_0"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.perPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_c('option',{attrs:{"value":"100"}},[_vm._v("100")])]),_vm._v(" entries")])])]),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_filter",attrs:{"id":"DataTables_Table_0_filter"}},[_c('label',[_vm._v("Search:"),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control input-sm",attrs:{"type":"search","placeholder":"","aria-controls":"DataTables_Table_0"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])])])]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped table-hover js-basic-example dataTable"},[_vm._m(2),_vm._v(" "),_c('tbody',[(_vm.isLoading)?_c('tr',[_vm._m(3)]):_vm._e(),_vm._v(" "),(_vm.list == '')?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"5"}},[_vm._v("Data tidak ditemukan")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(item,index){return (!_vm.isLoading)?_c('tr',[_c('td',[_vm._v(_vm._s(++index + ((_vm.currentPage-1)*_vm.perPage)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.nip))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.namaPeserta))]),_vm._v(" "),_c('td',[(item.kk)?_c('a',{staticClass:"btn btn-primary btn-sm",attrs:{"href":item.kk}},[_c('i',{staticClass:"fa fa-paperclip"}),_vm._v(" Fc. KK")]):_vm._e(),_vm._v(" "),(item.suratNikah)?_c('a',{staticClass:"btn btn-primary btn-sm",attrs:{"href":item.suratNikah}},[_c('i',{staticClass:"fa fa-paperclip"}),_vm._v(" Fc. Surat Nikah")]):_vm._e(),_vm._v(" "),(item.ktp)?_c('a',{staticClass:"btn btn-primary btn-sm",attrs:{"href":item.ktp}},[_c('i',{staticClass:"fa fa-paperclip"}),_vm._v(" Fc. KTP Suami Isteri")]):_vm._e(),_vm._v(" "),(item.formulirPermohonanMPS20)?_c('a',{staticClass:"btn btn-primary btn-sm",attrs:{"href":item.formulirPermohonanMPS20}},[_c('i',{staticClass:"fa fa-paperclip"}),_vm._v(" Form Permohonan MPS 20%")]):_vm._e(),_vm._v(" "),(item.formulirPermohonanMPS10)?_c('a',{staticClass:"btn btn-primary btn-sm",attrs:{"href":item.formulirPermohonanMPS10}},[_c('i',{staticClass:"fa fa-paperclip"}),_vm._v(" Form Permohonan MPS 10%")]):_vm._e(),_vm._v(" "),(item.fotokopiRekening)?_c('a',{staticClass:"btn btn-primary btn-sm",attrs:{"href":item.fotokopiRekening}},[_c('i',{staticClass:"fa fa-paperclip"}),_vm._v(" Fc. Rekening")]):_vm._e(),_vm._v(" "),(item.fotokopiNPWP)?_c('a',{staticClass:"btn btn-primary btn-sm",attrs:{"href":item.fotokopiNPWP}},[_c('i',{staticClass:"fa fa-paperclip"}),_vm._v(" Fc. NPWP")]):_vm._e()])]):_vm._e()})],2)])]),_vm._v(" "),_c('pagination',{attrs:{"total-rows":_vm.result.totalElements,"per-page":_vm.result.size},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-header"},[_c('h2',[_vm._v("Kelengkapan")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            List Kelengkapan\n                        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("No.")]),_vm._v(" "),_c('th',[_vm._v("NIP")]),_vm._v(" "),_c('th',[_vm._v("Nama Lengkap")]),_vm._v(" "),_c('th',[_vm._v("File")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center",attrs:{"colspan":"5"}},[_c('i',{staticClass:"fa fa-spin fa-spinner"}),_vm._v(" Loading data...")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kKPZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"block-header"},[_c('h2',[_vm._v(_vm._s(_vm.name))])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            Import Data "+_vm._s(_vm.name)+"\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit.apply(null, arguments)}}},[_c('div',{staticClass:"col-12"},[_c('vue-dropzone',{ref:"myVueDropzone",attrs:{"id":"dropzone","options":_vm.dropzoneOptions},on:{"vdropzone-error":_vm.failed,"vdropzone-success":_vm.vsuccess}})],1)])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kMbL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"block-header"},[_c('h2',[_vm._v(_vm._s(_vm.nama))])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            "+_vm._s(_vm.id_unduh != null ? 'Edit' : 'Tambah')+" "+_vm._s(_vm.nama)+"\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_c('div',{staticClass:"row clearfix"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[(_vm.link == 'laporan')?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.content.tipe),expression:"content.tipe"}],staticClass:"form-control",attrs:{"id":"jenis"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.content, "tipe", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("[ Pilih Jenis Laporan ]")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Laporan Keuangan")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Laporan Pengawasan")])]):_vm._e(),_vm._v(" "),(_vm.link == 'formulir')?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.content.tipe),expression:"content.tipe"}],staticClass:"form-control",attrs:{"id":"jenis"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.content, "tipe", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("[ Pilih Jenis Formulir ]")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Formulir Kepersertaan")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("Formulir Her Registrasi")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("Formulir Pensiun Normal")]),_vm._v(" "),_c('option',{attrs:{"value":"6"}},[_vm._v("Formulir Pensiun Dipercepat")]),_vm._v(" "),_c('option',{attrs:{"value":"7"}},[_vm._v("Formulir Pensiun Ditunda")]),_vm._v(" "),_c('option',{attrs:{"value":"8"}},[_vm._v("Formulir Pensiun Cacat")]),_vm._v(" "),_c('option',{attrs:{"value":"9"}},[_vm._v("Formulir Pensiun Meninggal")])]):_vm._e()])])]),_vm._v(" "),(_vm.link === 'formulir')?_c('div',{staticClass:"row clearfix"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('select',{directives:[{name:"show",rawName:"v-show",value:(_vm.link == 'formulir'),expression:"link == 'formulir'"},{name:"model",rawName:"v-model",value:(_vm.content.bermaterai),expression:"content.bermaterai"}],staticClass:"form-control",attrs:{"id":"bermaterai"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.content, "bermaterai", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":false}},[_vm._v("[ apakah bermaterai ]")]),_vm._v(" "),_c('option',{domProps:{"value":true}},[_vm._v("Bermaterai")]),_vm._v(" "),_c('option',{domProps:{"value":false}},[_vm._v("Tidak Bermaterai")])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"judul","type":"text"},model:{value:(_vm.content.judul),callback:function ($$v) {_vm.$set(_vm.content, "judul", $$v)},expression:"content.judul"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"tahun","type":"number"},model:{value:(_vm.content.tahun),callback:function ($$v) {_vm.$set(_vm.content, "tahun", $$v)},expression:"content.tahun"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(4),_vm._v(" "),(_vm.content.file != null)?_c('div',{staticClass:"col-lg-2"},[_c('a',{staticClass:"btn btn-sm btn-info",attrs:{"target":"_blank","href":_vm.content.file}},[_c('i',{staticClass:"fa fa-paperclip"}),_vm._v(" File")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"id":"icon","type":"file","name":"icon"},on:{"change":function($event){return _vm.handleFile($event)}}})])])]),_vm._v(" "),(_vm.id_unduh != null && _vm.link === "laporan")?_c('div',{staticClass:"row clearfix"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[(_vm.id_unduh)?_c('vue-dropzone',{ref:"thumbnailFormulir",attrs:{"id":"thumbnailFormulir","destroyDropzone":false,"options":_vm.dropzoneOptionsFormulir},on:{"vdropzone-removed-file":_vm.vremoved,"vdropzone-success":_vm.onUploadSuccess}}):_vm._e()],1)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"type":"text","id":"tags","config":_vm.config},model:{value:(_vm.content.tags),callback:function ($$v) {_vm.$set(_vm.content, "tags", $$v)},expression:"content.tags"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[(_vm.id_unduh != null)?_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-warning waves-effect waves-button",attrs:{"type":"button"},on:{"click":_vm.update}},[_c('i',{staticClass:"material-icons"},[_vm._v("save")]),_vm._v(" Edit")]):_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect waves-button",attrs:{"type":"button"},on:{"click":_vm.save}},[_c('i',{staticClass:"material-icons"},[_vm._v("save")]),_vm._v(" Simpan")]),_vm._v(" "),_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-danger waves-effect waves-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")]),_vm._v(" Batal")])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"jenis"}},[_vm._v("Jenis")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"bermaterai"}},[_vm._v("Bermaterai")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"judul"}},[_vm._v("Judul")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"tahun"}},[_vm._v("Tahun")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"icon"}},[_vm._v("File")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"thumbnailFormulir"}},[_vm._v("thumbnailFormulir")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"tags"}},[_vm._v("Tags")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kWW5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"block-header"},[_c('h2',[_vm._v(_vm._s(_vm.nama))])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v(_vm._s(_vm.id_Pengaduan != null ? 'Edit' : 'Tambah')+" "+_vm._s(_vm.nama))])]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit.apply(null, arguments)}}},[_c('div',{staticClass:"row clearfix"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"judul","type":"text","disabled":true},model:{value:(_vm.data.deskripsi),callback:function ($$v) {_vm.$set(_vm.data, "deskripsi", $$v)},expression:"data.deskripsi"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"Topik","type":"text","disabled":true},model:{value:(_vm.data.topik),callback:function ($$v) {_vm.$set(_vm.data, "topik", $$v)},expression:"data.topik"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"penulis","type":"text"},model:{value:(_vm.data.jawaban),callback:function ($$v) {_vm.$set(_vm.data, "jawaban", $$v)},expression:"data.jawaban"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[(_vm.id_Pengaduan != null)?_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-warning waves-effect waves-button",attrs:{"type":"button","disabled":_vm.isLoading},on:{"click":_vm.update}},[(_vm.isLoading)?_c('i',{staticClass:"fa fa-spin fa-spinner"}):_vm._e(),(!_vm.isLoading)?_c('i',{staticClass:"material-icons"},[_vm._v("save")]):_vm._e(),_vm._v(" Edit\n                  ")]):_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect waves-button",attrs:{"type":"button","disabled":_vm.isLoading},on:{"click":_vm.save}},[(_vm.isLoading)?_c('i',{staticClass:"fa fa-spin fa-spinner"}):_vm._e(),(!_vm.isLoading)?_c('i',{staticClass:"material-icons"},[_vm._v("save")]):_vm._e(),_vm._v("\n                    Simpan\n                  ")]),_vm._v(" "),_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")]),_vm._v(" Batal\n                  ")])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"judul"}},[_vm._v("deskripsi")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"Topik"}},[_vm._v("Topik")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"penulis"}},[_vm._v("Jawaban")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "knDp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FormLine_vue__ = __webpack_require__("w3AW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_api__ = __webpack_require__("+Btm");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_0__components_FormLine_vue__["a" /* default */] },
  name: 'EditAnggota',
  data: function data() {
    return {
      date: {
        dateFormat: 'Y-m-d',
        allowInput: true
      },
      data: {},
      nip: '',
      isLoading: false
    };
  },
  methods: {
    update: function update() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].post('/anggota/' + this.nip, this.data).then(function (result) {
        if (result.data.code === 200) {
          _this.$router.replace('/main/anggota');
          _this.$toastr.s('Ubah data berhasil');
        }
      }).catch(function (ex) {
        _this.$toastr.e('Terjadi kesalahan pada server, mohon ulangi');
      });
    },
    getDetail: function getDetail() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].get('/anggota/' + this.nip).then(function (result) {
        _this2.data = result.data;
      }).catch(function (ex) {
        _this2.$toastr.e('Terjadi kesalahan pada server, mohon ulangi');
      });
    },
    handleFile: function handleFile(file) {
      this.file = file.target.files[0];
    }
  },
  mounted: function mounted() {
    this.nip = this.$route.params.id;
    this.getDetail();
  }
});

/***/ }),

/***/ "kvXw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FormLine_vue__ = __webpack_require__("w3AW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_api__ = __webpack_require__("+Btm");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_1__components_FormLine_vue__["a" /* default */] },
  name: 'FormSlider',
  data: function data() {
    return {
      data: {
        text1: '',
        text2: ''
      },
      file: '',
      id_slider: '',
      isLoading: false
    };
  },
  methods: {
    save: function save() {
      var _this = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      var form = new FormData();
      form.append('file', this.file);
      form.append('json', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.data));
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].post('/slider', form).then(function (result) {
        if (result.data.code === 200) {
          _this.$router.replace('/main/slider');
          _this.$toastr.s('Tambah data berhasil');
        } else {
          var msg = 'Tambah data gagal';
          if (result.data.message !== '') msg = result.data.message;
          _this.$toastr.e(msg);
        }
        _this.isLoading = false;
      }).catch(function (e) {
        var msg = 'Terjadi kesalahan pada server, mohon ulangi';
        if (e.response.data.message) msg = e.response.data.message;
        _this.$toastr.e(msg);
        _this.isLoading = false;
      });
    },
    update: function update() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      var form = new FormData();
      form.append('file', this.file);
      form.append('json', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.data));
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].post('/slider/' + this.id_slider, form).then(function (result) {
        if (result.data.code === 200) {
          _this2.$router.replace('/main/slider');
          _this2.$toastr.s('Ubah data berhasil');
        }
      }).catch(function (ex) {
        _this2.$toastr.e('Terjadi kesalahan pada server, mohon ulangi');
      });
    },
    getDetail: function getDetail() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].get('/slider/' + this.id_slider).then(function (result) {
        _this3.data = result.data;
      }).catch(function (ex) {
        _this3.$toastr.e('Terjadi kesalahan pada server, mohon ulangi');
      });
    },
    handleFile: function handleFile(file) {
      this.file = file.target.files[0];
    }
  },
  mounted: function mounted() {
    this.id_slider = this.$route.params.id;
    if (this.id_slider != null) {
      this.getDetail();
    }
  }
});

/***/ }),

/***/ "lZ5c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__("f3NK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2505e6f1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__("qlwT");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2505e6f1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lZjD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_ckeditor2__ = __webpack_require__("42+j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FormLine_vue__ = __webpack_require__("w3AW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_api__ = __webpack_require__("+Btm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone__ = __webpack_require__("KvPw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css__ = __webpack_require__("hCol");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_dropzone_dist_vue2Dropzone_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_1__components_FormLine_vue__["a" /* default */], Ckeditor: __WEBPACK_IMPORTED_MODULE_0_vue_ckeditor2__["a" /* default */], vueDropzone: __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone___default.a },
  name: 'Upload',
  data: function data() {
    return {
      dropzoneOptions: {
        url: __WEBPACK_IMPORTED_MODULE_2__helper_api__["a" /* default */].defaults.baseURL + '/import-peserta',
        thumbnailWidth: 150,
        maxFilesize: 200,
        headers: { 'Authorization': 'Bearer ' + localStorage.getItem('_token') }
      },
      name: '',
      link: ''
    };
  },
  methods: {
    vsuccess: function vsuccess(file, response) {
      this.success = true;
      console.log(response);
    },
    failed: function failed(file, m, xhr) {
      this.$swal('Perhatian', m.message, 'error');
      this.$refs.myVueDropzone.removeAllFiles();
    }
  }
});

/***/ }),

/***/ "lhw5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            "+_vm._s(_vm.id != null ? 'Edit' : 'Tambah')+" CategoryFaq\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_c('div',{staticClass:"row clearfix"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"CategoryFaq","type":"text"},model:{value:(_vm.data.category),callback:function ($$v) {_vm.$set(_vm.data, "category", $$v)},expression:"data.category"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[(_vm.id != null)?_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-warning waves-effect waves-button",attrs:{"disabled":_vm.isLoading,"type":"button"},on:{"click":_vm.update}},[(!_vm.isLoading)?_c('span',[_c('i',{staticClass:"material-icons"},[_vm._v("save")]),_vm._v(" Edit")]):_c('span',[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" Loading")])]):_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect waves-button",attrs:{"disabled":_vm.isLoading,"type":"button"},on:{"click":_vm.save}},[(!_vm.isLoading)?_c('span',[_c('i',{staticClass:"material-icons"},[_vm._v("save")]),_vm._v(" Simpan")]):_c('span',[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" Loading")])]),_vm._v(" "),_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-danger waves-effect waves-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")]),_vm._v(" Batal")])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-header"},[_c('h2',[_vm._v("CategoryFaq")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"CategoryFaq"}},[_vm._v("Category")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mryB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_api__ = __webpack_require__("+Btm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FormLine_vue__ = __webpack_require__("w3AW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_3__components_FormLine_vue__["a" /* default */] },
  name: 'ListVisiMisi',
  data: function data() {
    return {
      result: {},
      list: [],
      currentPage: 1,
      perPage: 10,
      search: '',
      modal: null,
      isLoading: true,
      link: '',
      tipe: '',
      nama: ''
    };
  },
  methods: {
    moveUp: function moveUp(index) {
      var a = this.list[index - 1];
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(this.list, index - 1, this.list[index - 2]);
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(this.list, index - 2, a);

      this.saveUrutan();
    },
    moveDown: function moveDown(index) {
      var a = this.list[index - 1];
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(this.list, index - 1, this.list[index]);
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(this.list, index, a);

      this.saveUrutan();
    },
    saveUrutan: function saveUrutan() {
      var _this = this;

      var data = [];
      for (var i = 0; i < this.list.length; i++) {
        data.push({
          'id': this.list[i].id_regulasi_dana_pensiun,
          'urutan': i,
          'tipe': this.tipe
        });
      }

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].post('/regulasi/move', data).then(function (result) {
        _this.$toastr.s('Urutan berhasil diubah.');
      }).catch(function (ex) {
        _this.$toastr.e('Gagal mengubah urutan, terjadi kesalahan pada server.');
      });
    },
    getData: function getData() {
      var _this2 = this;

      var params = [];
      params.search = this.search;
      params.page = this.currentPage - 1;
      params.size = this.perPage;

      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].get('/' + this.link + '?' + __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(params)).then(function (result) {
        _this2.result = result.data;
        _this2.list = result.data.content;
        _this2.isLoading = false;
      }).catch(function (ex) {
        _this2.isLoading = false;
      });
    },
    confirmDelete: function confirmDelete(id) {
      var _this3 = this;

      this.$swal({
        title: 'Konfirmasi',
        text: 'Anda yakin ingin menghapus data ini?',
        icon: 'warning',
        buttons: [true, {
          text: 'Ok',
          closeModal: false
        }],
        dangerMode: true
      }).then(function (result) {
        if (result) _this3.delete(id);
      });
    },
    delete: function _delete(id) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].delete('/' + this.link + '/' + id).then(function (result) {
        if (result.data.code === 200) _this4.$toastr.s('Data berhasil dihapus.');else _this4.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this4.$swal.close();
        _this4.getData();
      }).catch(function (e) {
        _this4.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this4.$swal.close();
      });
    },
    checkRoute: function checkRoute(route) {
      this.list = [];
      if (route.name === 'ListRegulasi') {
        this.link = 'regulasi';
        this.nama = 'Regulasi';
      }
    }
  },
  mounted: function mounted() {
    this.checkRoute(this.$route);
    this.getData();
  },
  watch: {
    currentPage: function currentPage(e) {
      this.getData();
    },
    perPage: function perPage(e) {
      this.getData();
    },
    search: function search(e) {
      this.getData();
    },
    '$route': function $route(to, from) {
      this.checkRoute(to);
      this.getData();
    }
  }
});

/***/ }),

/***/ "nKb+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FormLine_vue__ = __webpack_require__("w3AW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_api__ = __webpack_require__("+Btm");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_0__components_FormLine_vue__["a" /* default */] },
  name: 'Login',
  data: function data() {
    return {
      user: {
        username: '',
        password: '',
        rememberMe: false,
        isWeb: true
      },
      isLoading: false
    };
  },
  beforeMount: function beforeMount() {
    var log = localStorage.getItem('_token');
    var akses = localStorage.getItem('akses');

    if (log && akses) this.$router.replace('/main/dashboard');
  },

  methods: {
    login: function login() {
      var _this = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].post('/login', this.user).then(function (result) {
        if (result.data._token != null) {
          var token = result.data._token;
          if (!result.data.isAdmin) {
            _this.$swal('Perhatian', 'Username atau password salah', 'error');
          } else {
            localStorage.setItem('_token', token);
            localStorage.setItem('username', result.data.username);
            localStorage.setItem('namaLengkap', result.data.namaLengkap);
            localStorage.setItem('akses', result.data.akses);
            _this.$router.replace('/main/dashboard');
            location.reload();
          }
        } else {
          _this.$swal('Perhatian', result.data.message, 'error');
        }
        _this.isLoading = false;
      }).catch(function (e) {
        _this.$swal('Perhatian', e.response.data.message, 'error');
        _this.isLoading = false;
      });
    }
  }
});

/***/ }),

/***/ "npw4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_api__ = __webpack_require__("+Btm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__ = __webpack_require__("w3AW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__["a" /* default */] },
  name: 'Pengumuman',
  data: function data() {
    return {
      result: {},
      list: [],
      currentPage: 1,
      perPage: 10,
      search: '',
      modal: null,
      isLoading: true,
      link: '',
      nama: ''
    };
  },
  methods: {
    getData: function getData() {
      var _this = this;

      var params = [];
      params.search = this.search;
      params.page = this.currentPage - 1;
      params.size = this.perPage;

      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].get('/getAllPengumuman?' + __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(params)).then(function (result) {
        _this.result = result.data;
        _this.list = result.data.content;
        _this.isLoading = false;
      }).catch(function (ex) {
        _this.isLoading = false;
        _this.$toastr.e('Gagal terhubung dengan server.');
      });
    },
    confirmDelete: function confirmDelete(id) {
      var _this2 = this;

      this.$swal({
        title: 'Konfirmasi',
        text: 'Anda yakin ingin menghapus data ini?',
        icon: 'warning',
        buttons: [true, {
          text: 'Ok',
          closeModal: false
        }],
        dangerMode: true
      }).then(function (result) {
        if (result) _this2.delete(id);
      });
    },
    getKategoriText: function getKategoriText(kategori) {
      if (kategori === 1) {
        return 'Umum';
      } else if (kategori === 2) {
        return 'Pegawai';
      } else {
        return '-';
      }
    },
    delete: function _delete(id) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].delete('/deletePengumuman/' + id).then(function (result) {
        console.log(result);
        if (result.data.code === 200 || result.status === 200) _this3.$toastr.s('Data berhasil dihapus.');else _this3.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this3.$swal.close();
        _this3.getData();
      }).catch(function (e) {
        _this3.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this3.$swal.close();
      });
    },
    checkRoute: function checkRoute(route) {
      console.log(route);
      this.list = [];
      if (route.name === 'ListPengumuman') {
        console.log('masuk sin');
        this.link = 'pengumuman';
        this.nama = 'pengumuman pengumuman';
      }
    }
  },
  mounted: function mounted() {
    this.checkRoute(this.$route);
    this.getData();
  },
  watch: {
    currentPage: function currentPage(e) {
      this.getData();
    },
    perPage: function perPage(e) {
      this.getData();
    },
    search: function search(e) {
      this.getData();
    },
    '$route': function $route(to, from) {
      this.checkRoute(to);
      this.getData();
    }
  }
});

/***/ }),

/***/ "o1lT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PengaduanList_vue__ = __webpack_require__("02jA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2080db55_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PengaduanList_vue__ = __webpack_require__("17LW");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PengaduanList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2080db55_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PengaduanList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "o9k4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryFaq_vue__ = __webpack_require__("3PKr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_019ef048_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryFaq_vue__ = __webpack_require__("lhw5");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CategoryFaq_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_019ef048_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CategoryFaq_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oETZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FormLine_vue__ = __webpack_require__("w3AW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_api__ = __webpack_require__("+Btm");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_0__components_FormLine_vue__["a" /* default */] },
  name: 'FormWhistleBlower',
  data: function data() {
    return {
      whistleblower: {
        subjek: '',
        email: ''
      },
      id_whistleblower: ''
    };
  },
  methods: {
    save: function save() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].post('/whistleblower', this.whistleblower).then(function (result) {
        if (result.data.code === 200) {
          _this.$router.replace('/main/whistleblower');
          _this.$toastr.s('Tambah data berhasil');
        } else {
          var msg = 'Tambah data gagal';
          if (result.data.message !== '') msg = result.data.message;
          _this.$toastr.e(msg);
        }
      }).catch(function (e) {
        var msg = 'Terjadi kesalahan pada server, mohon ulangi';
        if (e.response.data.message) msg = e.response.data.message;
        _this.$toastr.e(msg);
      });
    },
    update: function update() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].post('/whistleblower/' + this.id_whistleblower, this.whistleblower).then(function (result) {
        if (result.data.code === 200) {
          _this2.$router.replace('/main/whistleblower');
          _this2.$toastr.s('Ubah data berhasil');
        }
      }).catch(function (ex) {
        _this2.$toastr.e('Terjadi kesalahan pada server, mohon ulangi');
      });
    },
    getDetail: function getDetail() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].get('/whistleblower/' + this.id_whistleblower).then(function (result) {
        _this3.whistleblower = result.data;
      }).catch(function (ex) {
        _this3.$toastr.e('Terjadi kesalahan pada server, mohon ulangi');
      });
    }
  },
  mounted: function mounted() {
    this.id_whistleblower = this.$route.params.id;
    if (this.id_whistleblower != null) {
      this.getDetail();
    }
  }
});

/***/ }),

/***/ "ozmR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormHakdanKewajiban_vue__ = __webpack_require__("5WHR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70062d16_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormHakdanKewajiban_vue__ = __webpack_require__("3OUF");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormHakdanKewajiban_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70062d16_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormHakdanKewajiban_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pJTr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormPensiunType_vue__ = __webpack_require__("NBdm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13eef358_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormPensiunType_vue__ = __webpack_require__("dBSi");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormPensiunType_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13eef358_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormPensiunType_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pRQ6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__("1MN2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a7848eac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__("GbQ1");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a7848eac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pXdC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"block-header"},[_c('h2',[_vm._v(_vm._s(_vm.nama))])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            List "+_vm._s(_vm.nama)+"\n                        ")]),_vm._v(" "),_c('ul',{staticClass:"header-dropdown m-r--5 m-t--10"},[_c('router-link',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect",attrs:{"to":'/main/unduh/' + _vm.link + '/tambah',"type":"button"}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#fff"}},[_vm._v("add_box")]),_vm._v(" "),_c('span',[_vm._v("Tambah")])])],1)]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"dataTables_wrapper form-inline dt-bootstrap",attrs:{"id":"DataTables_Table_0_wrapper"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_length",attrs:{"id":"DataTables_Table_0_length"}},[_c('label',[_vm._v("Show "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.perPage),expression:"perPage"}],staticClass:"form-control input-sm",attrs:{"name":"DataTables_Table_0_length","aria-controls":"DataTables_Table_0"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.perPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_c('option',{attrs:{"value":"100"}},[_vm._v("100")])]),_vm._v(" entries")])])]),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_filter",attrs:{"id":"DataTables_Table_0_filter"}},[_c('label',[_vm._v("Search:"),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control input-sm",attrs:{"type":"search","placeholder":"","aria-controls":"DataTables_Table_0"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])])])]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped table-hover js-basic-example dataTable"},[_vm._m(0),_vm._v(" "),_c('tbody',[(_vm.isLoading)?_c('tr',[_vm._m(1)]):_vm._e(),_vm._v(" "),(_vm.list == '')?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"7"}},[_vm._v("Data tidak ditemukan")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(item,index){return (!_vm.isLoading)?_c('tr',[_c('td',[_vm._v(_vm._s(++index + ((_vm.currentPage-1)*_vm.perPage)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.judul))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.periode))]),_vm._v(" "),_c('td',[(item.file != null)?_c('a',{staticClass:"btn btn-info",attrs:{"target":"_blank","href":item.file}},[_c('i',{staticClass:"fa fa-paperclip"}),_vm._v(" File")]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.stripTags(item.tags)))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn bg-green waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.push('/main/unduh/' + _vm.link + '/edit/' + item.id_materi_komunikasi)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("create")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmDelete(item.id_materi_komunikasi)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")])]),_vm._v(" "),(index != 1)?_c('button',{staticClass:"btn btn-primary waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.moveUp(index)}}},[_c('i',{staticClass:"fa fa-chevron-up"})]):_vm._e(),_vm._v(" "),(index !== (_vm.list.length))?_c('button',{staticClass:"btn btn-primary waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.moveDown(index)}}},[_c('i',{staticClass:"fa fa-chevron-down"})]):_vm._e()])]):_vm._e()})],2)])]),_vm._v(" "),_c('pagination',{attrs:{"total-rows":_vm.result.totalElements,"per-page":_vm.result.size},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("No.")]),_vm._v(" "),_c('th',[_vm._v("Judul")]),_vm._v(" "),_c('th',[_vm._v("Periode")]),_vm._v(" "),_c('th',[_vm._v("File")]),_vm._v(" "),_c('th',[_vm._v("Tags")]),_vm._v(" "),_c('th',[_vm._v("Aksi")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center",attrs:{"colspan":"7"}},[_c('i',{staticClass:"fa fa-spin fa-spinner"}),_vm._v(" Loading data...")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qJtc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormMajalah_vue__ = __webpack_require__("f837");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_98ec713c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormMajalah_vue__ = __webpack_require__("szt/");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormMajalah_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_98ec713c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormMajalah_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qXxo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_ckeditor2__ = __webpack_require__("42+j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__ = __webpack_require__("w3AW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper_api__ = __webpack_require__("+Btm");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__["a" /* default */], Ckeditor: __WEBPACK_IMPORTED_MODULE_1_vue_ckeditor2__["a" /* default */] },
  name: 'ListNarasumber',
  data: function data() {
    return {
      config: {
        toolbar: [{ name: 'stuff', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] }, { name: 'morestuff', items: ['NumberedList', 'BulletedList'] }, { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Superscript', 'Subscript'] }, { name: 'colors', items: ['TextColor'] }, { name: 'paragraph2', items: ['JustifyLeft', 'JustiftyCenter', 'JustifyRight', 'Outdent', 'Indent'] }, '/', { name: 'document', items: ['Source'] }],
        height: 300
      },
      content: {
        judul: '',
        deskripsi: ''
      },
      icon: '',
      id_content: '',
      nama: '',
      tipe: '',
      link: '',
      isLoading: false
    };
  },
  methods: {
    save: function save() {
      var _this = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      var form = new FormData();
      form.append('file', this.icon);
      form.append('json', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.content));
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].post('/' + this.link, form).then(function (result) {
        if (result.data.code === 200) {
          _this.$router.replace('/main/profile/' + _this.link);
          _this.$toastr.s('Tambah data berhasil');
        } else {
          var msg = 'Tambah data gagal';
          if (result.data.message !== '') msg = result.data.message;
          _this.$toastr.e(msg);
        }
        _this.isLoading = false;
      }).catch(function (e) {
        var msg = 'Terjadi kesalahan pada server, mohon ulangi';
        if (e.response.data.message) msg = e.response.data.message;
        _this.$toastr.e(msg);
        _this.isLoading = false;
      });
    },
    update: function update() {
      var _this2 = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      var form = new FormData();
      form.append('file', this.icon);
      form.append('json', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.content));
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].post('/' + this.link + '/' + this.id_content, form).then(function (result) {
        if (result.data.code === 200) {
          _this2.$router.replace('/main/profile/' + _this2.link);
          _this2.$toastr.s('Ubah data berhasil');
        }
        _this2.isLoading = false;
      }).catch(function (ex) {
        _this2.$toastr.e('Terjadi kesalahan pada server, mohon ulangi');
        _this2.isLoading = false;
      });
    },
    getDetail: function getDetail() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_3__helper_api__["a" /* default */].get('/' + this.link + '/' + this.id_content).then(function (result) {
        _this3.content = result.data;
      }).catch(function (ex) {
        _this3.$toastr.e('Terjadi kesalahan pada server, mohon ulangi');
      });
    },
    handleFile: function handleFile(file) {
      this.icon = file.target.files[0];
    },
    checkRoute: function checkRoute(route) {
      console.log(route.name);
      if (route.name === 'TambahVisiMisi' || route.name === 'EditVisiMisi') {
        this.tipe = 1;
        this.link = 'visi-misi';
        this.nama = 'Visi Misi';
      }
      if (route.name === 'TambahBudayaKerja' || route.name === 'EditBudayaKerja') {
        this.tipe = 4;
        this.link = 'budaya-kerja';
      }
    }
  },
  mounted: function mounted() {
    this.checkRoute(this.$route);
    this.id_content = this.$route.params.id;
    if (this.id_content != null) {
      this.getDetail();
    }
  },

  watch: {
    '$route': function $route(to, from) {
      this.checkRoute(to);
      this.getData();
    }
  }
});

/***/ }),

/***/ "qlwT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',[_c('aside',{staticClass:"sidebar hide-on-large-only",attrs:{"id":"leftsidebar"}},[_c('div',{staticClass:"user-info"},[_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":__webpack_require__("8tHC"),"width":"48","height":"48","alt":"User"}})]),_vm._v(" "),_c('div',{staticClass:"info-container"},[_c('div',{staticClass:"name",attrs:{"data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v(_vm._s(_vm.namaLengkap))]),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"menu"},[_c('ul',{staticClass:"list"},[_c('li',{staticClass:"header"},[_vm._v("MAIN NAVIGATION")]),_vm._v(" "),_c('li',{class:{ active: _vm.link == 'main/dashboard' }},[_c('a',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],attrs:{"href":"#"},on:{"click":function($event){return _vm.$router.push('/main/dashboard')}}},[_c('i',{staticClass:"material-icons"},[_vm._v("home")]),_vm._v(" "),_c('span',[_vm._v("Home")])])]),_vm._v(" "),(_vm.akses.masterNarasumber)?_c('li',{class:{ 'active': _vm.link == 'main/narasumber' }},[_c('a',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],on:{"click":function($event){return _vm.$router.push('/main/narasumber')}}},[_c('i',{staticClass:"material-icons"},[_vm._v("assignment")]),_vm._v(" "),_c('span',[_vm._v("Master Narasumber")])])]):_vm._e(),_vm._v(" "),(_vm.akses.userLevel)?_c('li',{class:{ 'active': _vm.link == 'main/admin' }},[_c('a',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],on:{"click":function($event){return _vm.$router.push('/main/admin')}}},[_c('i',{staticClass:"material-icons"},[_vm._v("https")]),_vm._v(" "),_c('span',[_vm._v("User Level")])])]):_vm._e(),_vm._v(" "),(_vm.akses.anggota)?_c('li',{class:{ active: _vm.fullLink === 'main/anggota' }},[_c('a',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],on:{"click":function($event){return _vm.$router.push('/main/anggota')}}},[_c('i',{staticClass:"material-icons"},[_vm._v("person")]),_c('span',[_vm._v("Data Anggota")])])]):_vm._e(),_vm._v(" "),(_vm.aksesProfile)?_c('li',{class:{ active: _vm.isProfile }},[_c('a',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"menu-toggle",class:{ toggled: _vm.isProfile },attrs:{"href":"javascript:void(0);"},on:{"click":function($event){_vm.isProfile = !_vm.isProfile}}},[_c('i',{staticClass:"material-icons"},[_vm._v("assignment")]),_vm._v(" "),_c('span',[_vm._v("Profile")])]),_vm._v(" "),_c('ul',{staticClass:"ml-menu",class:{ show: _vm.isProfile }},[(_vm.akses.profile.visi_misi)?_c('li',{class:{ active: _vm.fullLink === 'main/profile/visi-misi' }},[_c('a',{class:{ toggled: _vm.fullLink === 'main/profile/visi-misi' },on:{"click":function($event){return _vm.$router.push('/main/profile/visi-misi')}}},[_vm._v("Visi Misi")])]):_vm._e(),_vm._v(" "),(_vm.akses.profile.sejarah_pendirian)?_c('li',{class:{ active: _vm.fullLink === 'main/profile/sejarah' }},[_c('a',{class:{ toggled: _vm.fullLink === 'main/profile/sejarah' },on:{"click":function($event){return _vm.$router.push('/main/profile/sejarah')}}},[_vm._v("Sejarah Pendirian")])]):_vm._e(),_vm._v(" "),(_vm.akses.profile.pendiri)?_c('li',{class:{ active: _vm.fullLink === 'main/profile/pendiri' }},[_c('a',{class:{ toggled: _vm.fullLink === 'main/profile/pendiri' },on:{"click":function($event){return _vm.$router.push('/main/profile/pendiri')}}},[_vm._v("Pendiri")])]):_vm._e(),_vm._v(" "),(_vm.akses.profile.dewan_pengawas)?_c('li',{class:{ active: _vm.fullLink === 'main/profile/dewan-pengawas' }},[_c('a',{class:{ toggled: _vm.fullLink === 'main/profile/dewan-pengawas' },on:{"click":function($event){return _vm.$router.push('/main/profile/dewan-pengawas')}}},[_vm._v("Dewan Pengawas")])]):_vm._e(),_vm._v(" "),(_vm.akses.profile.pengurus)?_c('li',{class:{ active: _vm.fullLink === 'main/profile/pengurus' }},[_c('a',{class:{ toggled: _vm.fullLink === 'main/profile/pengurus' },on:{"click":function($event){return _vm.$router.push('/main/profile/pengurus')}}},[_vm._v("Pengurus")])]):_vm._e(),_vm._v(" "),(_vm.akses.profile.struktur_organisasi)?_c('li',{class:{ active: _vm.fullLink === 'main/profile/struktur-organisasi' }},[_c('a',{class:{ toggled: _vm.fullLink === 'main/profile/struktur-organisasi' },on:{"click":function($event){return _vm.$router.push('/main/profile/struktur-organisasi')}}},[_vm._v("Struktur Organisasi")])]):_vm._e(),_vm._v(" "),(_vm.akses.profile.budaya_kerja)?_c('li',{class:{ active: _vm.fullLink === 'main/profile/budaya-kerja' }},[_c('a',{class:{ toggled: _vm.fullLink === 'main/profile/budaya-kerja' },on:{"click":function($event){return _vm.$router.push('/main/profile/budaya-kerja')}}},[_vm._v("Budaya Kerja")])]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.aksesLayanan)?_c('li',{class:{ active: _vm.isLayanan }},[_c('a',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"menu-toggle",class:{ toggled: _vm.isLayanan },attrs:{"href":"javascript:void(0);"},on:{"click":function($event){_vm.isLayanan = !_vm.isLayanan}}},[_c('i',{staticClass:"material-icons"},[_vm._v("content_copy")]),_vm._v(" "),_c('span',[_vm._v("Layanan")])]),_vm._v(" "),_c('ul',{staticClass:"ml-menu",class:{ show: _vm.isLayanan }},[(_vm.akses.layanan.cetak_mp)?_c('li',{class:{ active: _vm.fullLink === 'main/layanan/cetakMP' }},[_c('a',{class:{ toggled: _vm.fullLink === 'main/layanan/cetakMP' },on:{"click":function($event){return _vm.$router.push('/main/layanan/cetakMP')}}},[_vm._v("Cetak Struk MP/Pajak")])]):_vm._e(),_vm._v(" "),(_vm.akses.layanan.cetak_up)?_c('li',{class:{ active: _vm.fullLink === 'main/layanan/cetak-struk-uang-pembinaan' }},[_c('a',{class:{ toggled: _vm.fullLink === 'main/layanan/cetak-struk-uang-pembinaan' },on:{"click":function($event){return _vm.$router.push('/main/layanan/cetak-struk-uang-pembinaan')}}},[_vm._v("Cetak Struk Uang Pembinaan")])]):_vm._e(),_vm._v(" "),(_vm.akses.layanan.cetak_rapel)?_c('li',{class:{ active: _vm.fullLink === 'main/layanan/cetak-struk-rapel' }},[_c('a',{class:{ toggled: _vm.fullLink === 'main/layanan/cetak-struk-rapel' },on:{"click":function($event){return _vm.$router.push('/main/layanan/cetak-struk-rapel')}}},[_vm._v("Cetak Struk Rapel Kenaikan")])]):_vm._e(),_vm._v(" "),(_vm.akses.layanan.cetak_spt)?_c('li',{class:{ active: _vm.fullLink === 'main/layanan/cetak-spt' }},[_c('a',{class:{ toggled: _vm.fullLink === 'main/layanan/cetak-spt' },on:{"click":function($event){return _vm.$router.push('/main/layanan/cetak-spt')}}},[_vm._v("Cetak SPT")])]):_vm._e(),_vm._v(" "),(_vm.akses.layanan.atur_ip)?_c('li',{class:{ active: _vm.fullLink === 'main/layanan/atur-ip' }},[_c('a',{class:{ toggled: _vm.fullLink === 'main/layanan/atur-ip' },on:{"click":function($event){return _vm.$router.push('/main/layanan/atur-ip')}}},[_vm._v("Atur Identitas Pemotong")])]):_vm._e(),_vm._v(" "),(_vm.akses.layanan.survey)?_c('li',{class:{ active: _vm.fullLink === 'main/layanan/survey' }},[_c('a',{class:{ toggled: _vm.fullLink === 'main/layanan/survey' },on:{"click":function($event){return _vm.$router.push('/main/layanan/survey')}}},[_vm._v("Survey Pelayanan Pensiun")])]):_vm._e(),_vm._v(" "),(_vm.akses.layanan.hasil_survey)?_c('li',{class:{ active: _vm.fullLink === 'main/layanan/survey/hasil' }},[_c('a',{class:{ toggled: _vm.fullLink === 'main/layanan/survey/hasil' },on:{"click":function($event){return _vm.$router.push('/main/layanan/survey/hasil')}}},[_vm._v("Hasil Survey Pelayanan Pensiun")])]):_vm._e(),_vm._v(" "),(_vm.akses.layanan.data_kelengkapan)?_c('li',{class:{ active: _vm.fullLink === 'main/layanan/kelengkapan' }},[_c('a',{class:{ toggled: _vm.fullLink === 'main/layanan/kelengkapan' },on:{"click":function($event){return _vm.$router.push('/main/layanan/kelengkapan')}}},[_vm._v("Data Daftar Kelengkapan")])]):_vm._e(),_vm._v(" "),(_vm.akses.layanan.data_kelengkapan)?_c('li',{class:{ active: _vm.fullLink === 'main/layanan/KritikdanSaran' }},[_c('a',{class:{ toggled: _vm.fullLink === 'main/layanan/KritikDanSaran' },on:{"click":function($event){return _vm.$router.push('/main/layanan/KritikDanSaran')}}},[_vm._v("Kritik")])]):_vm._e(),_vm._v(" "),(_vm.akses.layanan.data_kelengkapan)?_c('li',{class:{ active: _vm.fullLink === 'main/layanan/Pengaduan' }},[_c('a',{class:{ toggled: _vm.fullLink === 'main/layanan/Pengaduan' },on:{"click":function($event){return _vm.$router.push('/main/layanan/Pengaduan/')}}},[_vm._v("Pengaduan")])]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.aksesInformasi)?_c('li',{class:{ active: _vm.isInformasi }},[_c('a',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"menu-toggle",class:{ toggled: _vm.isInformasi },attrs:{"href":"javascript:void(0);"},on:{"click":function($event){_vm.isInformasi = !_vm.isInformasi}}},[_c('i',{staticClass:"material-icons"},[_vm._v("assignment")]),_vm._v(" "),_c('span',[_vm._v("Informasi")])]),_vm._v(" "),_c('ul',{staticClass:"ml-menu",class:{ show: _vm.isInformasi }},[(_vm.akses.informasi.kegiatan)?_c('li',{class:{ active: _vm.fullLink === 'main/informasi/kegiatan' }},[_c('a',{class:{ toggled: _vm.fullLink === 'main/informasi/kegiatan' },on:{"click":function($event){return _vm.$router.push('/main/informasi/kegiatan')}}},[_vm._v("Kegiatan")])]):_vm._e(),_vm._v(" "),(_vm.akses.informasi.artikel)?_c('li',{class:{ active: _vm.fullLink === 'main/informasi/artikel' }},[_c('a',{class:{ toggled: _vm.fullLink === 'main/informasi/artikel' },on:{"click":function($event){return _vm.$router.push('/main/informasi/artikel')}}},[_vm._v("Artikel")])]):_vm._e(),_vm._v(" "),(_vm.akses.informasi.perkembangan)?_c('li',{class:{ active: _vm.fullLink === 'main/informasi/perkembangan' }},[_c('a',{class:{ toggled: _vm.fullLink === 'main/informasi/perkembangan' },on:{"click":function($event){return _vm.$router.push('/main/informasi/perkembangan')}}},[_vm._v("Perkembangan Investasi Semesteran")])]):_vm._e(),_vm._v(" "),(_vm.akses.informasi.tahunan)?_c('li',{class:{ active: _vm.fullLink === 'main/informasi/tahunan' }},[_c('a',{class:{ toggled: _vm.fullLink === 'main/informasi/tahunan' },on:{"click":function($event){return _vm.$router.push('/main/informasi/tahunan')}}},[_vm._v("Laporan Keuangan")])]):_vm._e(),_vm._v(" "),(_vm.akses.informasi.lowongan)?_c('li',{class:{ active: _vm.fullLink === 'main/informasi/lowongan' }},[_c('a',{class:{ toggled: _vm.fullLink === 'main/informasi/lowongan' },on:{"click":function($event){return _vm.$router.push('/main/informasi/lowongan')}}},[_vm._v("Lowongan")])]):_vm._e(),_vm._v(" "),(_vm.akses.informasi.galeri)?_c('li',{class:{ active: _vm.fullLink === 'main/informasi/galeri' }},[_c('a',{class:{ toggled: _vm.fullLink === 'main/informasi/galeri' },on:{"click":function($event){return _vm.$router.push('/main/informasi/galeri')}}},[_vm._v("Galeri")])]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.aksesUnduh)?_c('li',{class:{ active: _vm.isUnduh }},[_c('a',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"menu-toggle",class:{ toggled: _vm.isUnduh },attrs:{"href":"javascript:void(0);"},on:{"click":function($event){_vm.isUnduh = !_vm.isUnduh}}},[_c('i',{staticClass:"material-icons"},[_vm._v("file_download")]),_vm._v(" "),_c('span',[_vm._v("Unduh")])]),_vm._v(" "),_c('ul',{staticClass:"ml-menu",class:{ show: _vm.isUnduh }},[(_vm.akses.unduh.pdp)?_c('li',{class:{ active: _vm.fullLink === 'main/unduh/pdp' }},[_c('a',{class:{ toggled: _vm.fullLink === 'main/unduh/pdp' },on:{"click":function($event){return _vm.$router.push('/main/unduh/pdp')}}},[_vm._v("PDP")])]):_vm._e(),_vm._v(" "),(_vm.akses.unduh.arahan)?_c('li',{class:{ active: _vm.fullLink === 'main/unduh/arahan' }},[_c('a',{class:{ toggled: _vm.fullLink === 'main/unduh/arahan' },on:{"click":function($event){return _vm.$router.push('/main/unduh/arahan')}}},[_vm._v("Arahan")])]):_vm._e(),_vm._v(" "),(_vm.akses.unduh.regulasi)?_c('li',{class:{ active: _vm.fullLink === 'main/unduh/regulasi' }},[_c('a',{class:{ toggled: _vm.fullLink === 'main/unduh/regulasi' },on:{"click":function($event){return _vm.$router.push('/main/unduh/regulasi')}}},[_vm._v("Regulasi Dana Pensiun")])]):_vm._e(),_vm._v(" "),(_vm.akses.unduh.majalah)?_c('li',{class:{ active: _vm.fullLink === 'main/unduh/majalah' }},[_c('a',{class:{ toggled: _vm.fullLink === 'main/unduh/majalah' },on:{"click":function($event){return _vm.$router.push('/main/unduh/majalah')}}},[_vm._v("Booklet Dapenbi")])]):_vm._e(),_vm._v(" "),(_vm.akses.unduh.materikomunikasi)?_c('li',{class:{ active: _vm.fullLink === 'main/unduh/materiKomunikasi' }},[_c('a',{class:{ toggled: _vm.fullLink === 'main/unduh/materiKomunikasi' },on:{"click":function($event){return _vm.$router.push('/main/unduh/materiKomunikasi')}}},[_vm._v("Materi Komunikasi")])]):_vm._e(),_vm._v(" "),(_vm.akses.unduh.laporan)?_c('li',{class:{ active: _vm.fullLink === 'main/unduh/laporan' }},[_c('a',{class:{ toggled: _vm.fullLink === 'main/unduh/laporan' },on:{"click":function($event){return _vm.$router.push('/main/unduh/laporan')}}},[_vm._v("Laporan Tahunan dan Pengawasan")])]):_vm._e(),_vm._v(" "),(_vm.akses.unduh.formulir)?_c('li',{class:{ active: _vm.fullLink === 'main/unduh/formulir' }},[_c('a',{class:{ toggled: _vm.fullLink === 'main/unduh/formulir' },on:{"click":function($event){return _vm.$router.push('/main/unduh/formulir')}}},[_vm._v("Formulir Kepesertaan dan Pelayanan Pensiun")])]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"menu-toggle",class:{ toggled: _vm.isPensiunRegistrasi },attrs:{"href":"javascript:void(0);"},on:{"click":function($event){_vm.isPensiunRegistrasi = !_vm.isPensiunRegistrasi}}},[_c('i',{staticClass:"material-icons"},[_vm._v("file_download")]),_vm._v(" "),_c('span',[_vm._v("Pensiun Registrasi")])]),_vm._v(" "),_c('ul',{staticClass:"ml-menu",class:{ show: _vm.isPensiunRegistrasi }},[_c('li',[_c('a',{on:{"click":function($event){return _vm.$router.push('/main/pensiunRegistrasi/pensiuntype')}}},[_vm._v("ListPensiun type")])])])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"menu-toggle",class:{ toggled: _vm.isFaq },attrs:{"href":"javascript:void(0);"},on:{"click":function($event){_vm.isFaq = !_vm.isFaq}}},[_c('i',{staticClass:"material-icons"},[_vm._v("question_answer")]),_vm._v(" "),_c('span',[_vm._v("FAQ")])]),_vm._v(" "),_c('ul',{staticClass:"ml-menu",class:{ show: _vm.isFaq }},[_c('li',[_c('a',{on:{"click":function($event){return _vm.$router.push('/main/faq')}}},[_vm._v(" FAQ")])]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.$router.push('/main/faq/Categoryfaq')}}},[_vm._v("List FAQ Category")])])])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],on:{"click":function($event){return _vm.$router.push('/main/pengumuman/pengumuman')}}},[_c('i',{staticClass:"material-icons"},[_vm._v("announcement")]),_vm._v(" "),_c('span',[_vm._v("Pengumuman")])])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],on:{"click":function($event){return _vm.$router.push('/main/calender')}}},[_c('i',{staticClass:"material-icons"},[_vm._v("announcement")]),_vm._v(" "),_c('span',[_vm._v("Kalender")])])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],on:{"click":function($event){return _vm.$router.push('/main/banner')}}},[_c('i',{staticClass:"material-icons"},[_vm._v("announcement")]),_vm._v(" "),_c('span',[_vm._v("Banner")])])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],on:{"click":function($event){return _vm.$router.push('/main/HakdanWajiban/ListHakdanKewajiban')}}},[_c('i',{staticClass:"material-icons"},[_vm._v("announcement")]),_vm._v(" "),_c('span',[_vm._v("Hak dan Kewajiban Peserta")])])]),_vm._v(" "),(_vm.akses.log)?_c('li',{class:{ active: _vm.fullLink === 'main/log' }},[_c('a',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],on:{"click":function($event){return _vm.$router.push('/main/log')}}},[_c('i',{staticClass:"material-icons"},[_vm._v("assignment")]),_vm._v(" "),_c('span',[_vm._v("Log")])])]):_vm._e(),_vm._v(" "),(_vm.akses.syarat)?_c('li',{class:{ active: _vm.fullLink === 'main/syarat' }},[_c('a',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],on:{"click":function($event){return _vm.$router.push('/main/syarat')}}},[_c('i',{staticClass:"material-icons"},[_vm._v("collections_bookmark")]),_vm._v(" "),_c('span',[_vm._v("Syarat Kepesertaan")])])]):_vm._e(),_vm._v(" "),(_vm.akses.cara)?_c('li',{class:{ active: _vm.fullLink === 'main/cara' }},[_c('a',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],on:{"click":function($event){return _vm.$router.push('/main/cara')}}},[_c('i',{staticClass:"material-icons"},[_vm._v("accessibility")]),_vm._v(" "),_c('span',[_vm._v("Cara Mendaftar")])])]):_vm._e(),_vm._v(" "),(_vm.akses.slider)?_c('li',{class:{ 'active': _vm.link == 'main/slider' }},[_c('a',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],on:{"click":function($event){return _vm.$router.push('/main/slider')}}},[_c('i',{staticClass:"material-icons"},[_vm._v("photo_library")]),_c('span',[_vm._v("Slider")])])]):_vm._e(),_vm._v(" "),(_vm.akses.kirimNotifikasi)?_c('li',{class:{ 'active': _vm.link == 'main/notification' }},[_c('a',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],on:{"click":function($event){return _vm.$router.push('/main/notification')}}},[_c('i',{staticClass:"material-icons"},[_vm._v("notifications")]),_c('span',[_vm._v("Kirim Notifikasi")])])]):_vm._e(),_vm._v(" "),(_vm.akses.headline)?_c('li',{class:{ 'active': _vm.link == 'main/headline' }},[_c('a',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],on:{"click":function($event){return _vm.$router.push('/main/headline')}}},[_c('i',{staticClass:"material-icons"},[_vm._v("info_outline")]),_c('span',[_vm._v("Headline")])])]):_vm._e(),_vm._v(" "),(_vm.akses.whistleBlower)?_c('li',{class:{ 'active': _vm.link == 'main/whistleblower' }},[_c('a',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],on:{"click":function($event){return _vm.$router.push('/main/whistleblower')}}},[_c('i',{staticClass:"material-icons"},[_vm._v("message")]),_vm._v(" "),_c('span',[_vm._v("WhistleBlower")])])]):_vm._e(),_vm._v(" "),(_vm.akses.anakPerusahaan)?_c('li',{class:{ 'active': _vm.link == 'main/anak-perusahaan' }},[_c('a',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],on:{"click":function($event){return _vm.$router.push('/main/anak-perusahaan')}}},[_c('i',{staticClass:"material-icons"},[_vm._v("library_books")]),_c('span',[_vm._v("Company & Anak Perusahaan")])])]):_vm._e(),_vm._v(" "),(_vm.akses.hubungiKami)?_c('li',{class:{ 'active': _vm.link == 'main/hubungi-kami' }},[_c('a',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],on:{"click":function($event){return _vm.$router.push('/main/hubungi-kami')}}},[_c('i',{staticClass:"material-icons"},[_vm._v("local_phone")]),_vm._v(" "),_c('span',[_vm._v("Hubungi Kami")])])]):_vm._e()])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-group user-helper-dropdown"},[_c('i',{staticClass:"material-icons",attrs:{"data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"true"}},[_vm._v("keyboard_arrow_down")]),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu pull-right"},[_c('li',[_c('a',{attrs:{"href":"javascript:void(0);"}},[_c('i',{staticClass:"material-icons"},[_vm._v("person")]),_vm._v("Profile")])]),_vm._v(" "),_c('li',{staticClass:"divider",attrs:{"role":"seperator"}}),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"material-icons"},[_vm._v("input")]),_vm._v("Sign Out")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rFwy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"block-header"},[_c('h2',[_vm._v(_vm._s(_vm.nama))])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            "+_vm._s(_vm.id_content != null ? 'Edit' : 'Tambah')+" "+_vm._s(_vm.nama)+"\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_c('div',{staticClass:"row clearfix"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[(_vm.link == 'visi-misi')?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.content.judul),expression:"content.judul"}],staticClass:"form-control",attrs:{"id":"judul"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.content, "judul", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}},[_vm._v("[ Pilih Judul ]")]),_vm._v(" "),_c('option',{attrs:{"value":"Visi"}},[_vm._v("Visi")]),_vm._v(" "),_c('option',{attrs:{"value":"Misi"}},[_vm._v("Misi")])]):_c('form-line',{attrs:{"type":"text"},model:{value:(_vm.content.judul),callback:function ($$v) {_vm.$set(_vm.content, "judul", $$v)},expression:"content.judul"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('Ckeditor',{attrs:{"id":"deskripsi","config":_vm.config},model:{value:(_vm.content.deskripsi),callback:function ($$v) {_vm.$set(_vm.content, "deskripsi", $$v)},expression:"content.deskripsi"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[(_vm.content.icon != null)?_c('img',{attrs:{"src":_vm.content.icon,"width":"150px","alt":"Foto"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"id":"icon","type":"file","name":"icon"},on:{"change":function($event){return _vm.handleFile($event)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[(_vm.id_content != null)?_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-warning waves-effect waves-button",attrs:{"disabled":_vm.isLoading,"type":"button"},on:{"click":_vm.update}},[(!_vm.isLoading)?_c('span',[_c('i',{staticClass:"material-icons"},[_vm._v("save")]),_vm._v(" Edit")]):_c('span',[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" Loading")])]):_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect waves-button",attrs:{"disabled":_vm.isLoading,"type":"button"},on:{"click":_vm.save}},[(!_vm.isLoading)?_c('span',[_c('i',{staticClass:"material-icons"},[_vm._v("save")]),_vm._v(" Simpan")]):_c('span',[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" Loading")])]),_vm._v(" "),_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")]),_vm._v(" Batal")])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"judul"}},[_vm._v("Judul")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"deskripsi"}},[_vm._v("Deskripsi")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"icon"}},[_vm._v("Icon")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rVHH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListKegiatan_vue__ = __webpack_require__("TyQI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bce7aaec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListKegiatan_vue__ = __webpack_require__("04IV");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListKegiatan_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bce7aaec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListKegiatan_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rfCF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"block-header"},[_c('h2',[_vm._v(_vm._s(_vm.nama))])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            List "+_vm._s(_vm.nama)+"\n                        ")]),_vm._v(" "),_c('ul',{staticClass:"header-dropdown m-r--5 m-t--10"},[_c('router-link',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect waves-button",attrs:{"to":'/main/informasi/' + _vm.link + '/tambah',"type":"button"}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#fff"}},[_vm._v("add_box")]),_vm._v(" "),_c('span',[_vm._v("Tambah")])])],1)]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"dataTables_wrapper form-inline dt-bootstrap",attrs:{"id":"DataTables_Table_0_wrapper"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_length",attrs:{"id":"DataTables_Table_0_length"}},[_c('label',[_vm._v("Show "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.perPage),expression:"perPage"}],staticClass:"form-control input-sm",attrs:{"name":"DataTables_Table_0_length","aria-controls":"DataTables_Table_0"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.perPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_c('option',{attrs:{"value":"100"}},[_vm._v("100")])]),_vm._v(" entries")])])]),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_filter",attrs:{"id":"DataTables_Table_0_filter"}},[_c('label',[_vm._v("Search:"),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control input-sm",attrs:{"type":"search","placeholder":"","aria-controls":"DataTables_Table_0"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])])])]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped table-hover js-basic-example dataTable"},[_vm._m(0),_vm._v(" "),_c('tbody',[(_vm.isLoading)?_c('tr',[_vm._m(1)]):_vm._e(),_vm._v(" "),(_vm.list == '')?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"5"}},[_vm._v("Data tidak ditemukan")])]):_vm._e(),_vm._v(" "),(!_vm.isLoading)?_vm._l((_vm.list),function(item,index){return _c('tr',{key:item.id},[_c('td',[_vm._v(_vm._s(++index + ((_vm.currentPage-1)*_vm.perPage)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.nip))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.nomorHp))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.jenisPengajuan))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.stripTags(item.pesan)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.createdAt ? _vm.$moment(item.createdAt, 'YYYY-MM-DD').format("Do MMMM YYYY") : '-'))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.jawaban))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn bg-green waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.push('/main/layanan/' + _vm.link + '/' + item.id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("create")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmDelete(item.id)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")])])])])}):_vm._e()],2)])]),_vm._v(" "),_c('pagination',{attrs:{"total-rows":_vm.result.totalElements,"per-page":_vm.result.size},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("No.")]),_vm._v(" "),_c('th',[_vm._v("Nip")]),_vm._v(" "),_c('th',[_vm._v("No Hp")]),_vm._v(" "),_c('th',[_vm._v("Jenis Pengajuan")]),_vm._v(" "),_c('th',[_vm._v("Pertanyaan")]),_vm._v(" "),_c('th',[_vm._v("Tanggal")]),_vm._v(" "),_c('th',[_vm._v("Jawaban")]),_vm._v(" "),_c('th',[_vm._v("Aksi")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center",attrs:{"colspan":"5"}},[_c('i',{staticClass:"fa fa-spin fa-spinner"}),_vm._v(" Loading data...")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "s4+6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"block-header"},[_c('h2',[_vm._v(_vm._s(_vm.nama))])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            "+_vm._s(_vm.id_materi_komunikasi != null ? 'Edit' : 'Tambah')+" "+_vm._s(_vm.nama)+"\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_c('div',{staticClass:"row clearfix"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"judul","type":"text"},model:{value:(_vm.content.judul),callback:function ($$v) {_vm.$set(_vm.content, "judul", $$v)},expression:"content.judul"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"edisiTriwulan","type":"text"},model:{value:(_vm.content.periode),callback:function ($$v) {_vm.$set(_vm.content, "periode", $$v)},expression:"content.periode"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(2),_vm._v(" "),(_vm.content.file != null)?_c('div',{staticClass:"col-lg-2"},[_c('a',{staticClass:"btn btn-sm btn-info",attrs:{"target":"_blank","href":_vm.content.file}},[_c('i',{staticClass:"fa fa-paperclip"}),_vm._v(" File")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"id":"icon","type":"file","name":"icon"},on:{"change":function($event){return _vm.handleFile($event)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"type":"text","id":"tags","config":_vm.config},model:{value:(_vm.content.tags),callback:function ($$v) {_vm.$set(_vm.content, "tags", $$v)},expression:"content.tags"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[(_vm.id_materi_komunikasi != null)?_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-warning waves-effect waves-button",attrs:{"type":"button"},on:{"click":_vm.update}},[_c('i',{staticClass:"material-icons"},[_vm._v("save")]),_vm._v(" Edit")]):_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect waves-button",attrs:{"type":"button"},on:{"click":_vm.save}},[_c('i',{staticClass:"material-icons"},[_vm._v("save")]),_vm._v(" Simpan")]),_vm._v(" "),_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")]),_vm._v(" Batal")])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"judul"}},[_vm._v("Judul")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"edisiTriwulan"}},[_vm._v("Periode")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"icon"}},[_vm._v("File")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"tags"}},[_vm._v("Tags")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "s6+2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__ = __webpack_require__("Uhku");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e73c2ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__ = __webpack_require__("8a7Y");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e73c2ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "szt/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"block-header"},[_c('h2',[_vm._v(_vm._s(_vm.nama))])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            "+_vm._s(_vm.id_majalah != null ? 'Edit' : 'Tambah')+" "+_vm._s(_vm.nama)+"\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_c('div',{staticClass:"row clearfix"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"judul","type":"text"},model:{value:(_vm.content.judul),callback:function ($$v) {_vm.$set(_vm.content, "judul", $$v)},expression:"content.judul"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"edisiTriwulan","type":"text"},model:{value:(_vm.content.edisiTriwulan),callback:function ($$v) {_vm.$set(_vm.content, "edisiTriwulan", $$v)},expression:"content.edisiTriwulan"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"tahun","type":"number"},model:{value:(_vm.content.tahun),callback:function ($$v) {_vm.$set(_vm.content, "tahun", $$v)},expression:"content.tahun"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(3),_vm._v(" "),(_vm.content.file != null)?_c('div',{staticClass:"col-lg-2"},[_c('a',{staticClass:"btn btn-sm btn-info",attrs:{"target":"_blank","href":_vm.content.file}},[_c('i',{staticClass:"fa fa-paperclip"}),_vm._v(" File")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"id":"icon","type":"file","name":"icon"},on:{"change":function($event){return _vm.handleFile($event)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"type":"text","id":"tags","config":_vm.config},model:{value:(_vm.content.tags),callback:function ($$v) {_vm.$set(_vm.content, "tags", $$v)},expression:"content.tags"}})],1)])]),_vm._v(" "),(_vm.id_majalah)?_c('div',{staticClass:"row clearfix"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('vue-dropzone',{ref:"dropzoneThumnailMajalah",attrs:{"id":"dropzoneThumnailMajalah","destroyDropzone":false,"options":_vm.dropzoneOptionsThumbnail},on:{"vdropzone-removed-file":_vm.vremoved,"vdropzone-success":_vm.onUploadSuccess}})],1)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[(_vm.id_majalah != null)?_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-warning waves-effect waves-button",attrs:{"type":"button"},on:{"click":_vm.update}},[_c('i',{staticClass:"material-icons"},[_vm._v("save")]),_vm._v(" Edit")]):_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect waves-button",attrs:{"type":"button"},on:{"click":_vm.save}},[_c('i',{staticClass:"material-icons"},[_vm._v("save")]),_vm._v(" Simpan")]),_vm._v(" "),_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")]),_vm._v(" Batal")])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"judul"}},[_vm._v("Judul")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"edisiTriwulan"}},[_vm._v("Edisi Triwulan")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"tahun"}},[_vm._v("Tahun")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"icon"}},[_vm._v("File")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"tags"}},[_vm._v("Tags")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"thumnailMajalah"}},[_vm._v("Foto Thumnail Majalah")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "t8bm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormVisiMisi_vue__ = __webpack_require__("qXxo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65b46114_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormVisiMisi_vue__ = __webpack_require__("rFwy");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormVisiMisi_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65b46114_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormVisiMisi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "teIl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__("HCTz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_200a0f1c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__("UPJt");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_200a0f1c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "twRk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListPDP_vue__ = __webpack_require__("fhXe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c3f20f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListPDP_vue__ = __webpack_require__("vcQB");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListPDP_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c3f20f4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListPDP_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "udtj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"dataTables_wrapper form-inline dt-bootstrap",attrs:{"id":"DataTables_Table_0_wrapper"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_length",attrs:{"id":"DataTables_Table_0_length"}},[_c('label',[_vm._v("Show "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.perPage),expression:"perPage"}],staticClass:"form-control input-sm",attrs:{"name":"DataTables_Table_0_length","aria-controls":"DataTables_Table_0"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.perPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_c('option',{attrs:{"value":"100"}},[_vm._v("100")])]),_vm._v(" entries")])])]),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_filter",attrs:{"id":"DataTables_Table_0_filter"}},[_c('label',[_vm._v("Search:"),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control input-sm",attrs:{"type":"search","placeholder":"","aria-controls":"DataTables_Table_0"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])])])]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped table-hover js-basic-example dataTable"},[_vm._m(2),_vm._v(" "),_c('tbody',[(_vm.isLoading)?_c('tr',[_vm._m(3)]):_vm._e(),_vm._v(" "),(_vm.list == '')?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"5"}},[_vm._v("Data tidak ditemukan")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(item,index){return (!_vm.isLoading)?_c('tr',[_c('td',[_vm._v(_vm._s(++index + ((_vm.currentPage-1)*_vm.perPage)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.admin.namaLengkap))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.admin.email))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.log))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.ip))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$moment(item.createdAt).format("Do MMMM YYYY HH:mm:ss")))])]):_vm._e()})],2)])]),_vm._v(" "),_c('pagination',{attrs:{"total-rows":_vm.result.totalElements,"per-page":_vm.result.size},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-header"},[_c('h2',[_vm._v("Log")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            List Log\n                        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("No.")]),_vm._v(" "),_c('th',[_vm._v("Nama")]),_vm._v(" "),_c('th',[_vm._v("Email")]),_vm._v(" "),_c('th',[_vm._v("Log")]),_vm._v(" "),_c('th',[_vm._v("IP")]),_vm._v(" "),_c('th',[_vm._v("Tanggal")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center",attrs:{"colspan":"5"}},[_c('i',{staticClass:"fa fa-spin fa-spinner"}),_vm._v(" Loading data...")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "un2g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormSejarah_vue__ = __webpack_require__("DPvd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4495e648_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSejarah_vue__ = __webpack_require__("glWS");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormSejarah_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4495e648_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSejarah_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-ps": "zWlr",
	"./ar-ps.js": "zWlr",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn-bd": "1C9R",
	"./bn-bd.js": "1C9R",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-mx": "USNP",
	"./es-mx.js": "USNP",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku-kmr": "2ukb",
	"./ku-kmr.js": "2ukb",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tk": "+WRH",
	"./tk.js": "+WRH",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "uzGR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormAdmin_vue__ = __webpack_require__("eWIM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cdc7d4a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormAdmin_vue__ = __webpack_require__("TSBr");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormAdmin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cdc7d4a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormAdmin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "v3Jx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"block-header"},[_c('h2',[_vm._v(_vm._s(_vm.nama)+" ")])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v(_vm._s(_vm.id_pintasan != null ? 'Edit' : 'Tambah')+" "+_vm._s(_vm.nama))])]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit.apply(null, arguments)}}},[_c('div',{staticClass:"row clearfix"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"judul","type":"text"},model:{value:(_vm.data.judul),callback:function ($$v) {_vm.$set(_vm.data, "judul", $$v)},expression:"data.judul"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"penulis","type":"text"},model:{value:(_vm.data.penulis),callback:function ($$v) {_vm.$set(_vm.data, "penulis", $$v)},expression:"data.penulis"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"form-line"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.data.kategori),expression:"data.kategori"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.data, "kategori", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("-- Pilih Kategori --")]),_vm._v(" "),_vm._l((_vm.categories),function(item){return _c('option',{key:item.id,domProps:{"value":item.category}},[_vm._v("\n                          "+_vm._s(item.category)+"\n                        ")])})],2)])])])]),_vm._v(" "),(true)?_c('div',{staticClass:"row clearfix"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('vue-dropzone',{ref:"dropzoneThumnail",attrs:{"id":"dropzone-thumbnail","destroyDropzone":false,"options":_vm.dropzoneOptionsBakground},on:{"vdropzone-removed-file":_vm.vremoved,"vdropzone-success":_vm.onUploadSuccess}})],1)])]):_vm._e(),_vm._v(" "),(true)?_c('div',{staticClass:"row clearfix"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('vue-dropzone',{ref:"dropzonePenulis",attrs:{"id":"dropzone-penulis","destroyDropzone":false,"options":_vm.dropzoneOptionsGif},on:{"vdropzone-removed-file":_vm.vremoved,"vdropzone-success":_vm.onUploadSuccess}})],1)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[(_vm.id_pintasan != null)?_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-warning waves-effect waves-button",attrs:{"type":"button","disabled":_vm.isLoading},on:{"click":_vm.update}},[(_vm.isLoading)?_c('i',{staticClass:"fa fa-spin fa-spinner"}):_vm._e(),(!_vm.isLoading)?_c('i',{staticClass:"material-icons"},[_vm._v("save")]):_vm._e(),_vm._v(" Edit\n                  ")]):_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect waves-button",attrs:{"type":"button","disabled":_vm.isLoading},on:{"click":_vm.save}},[(_vm.isLoading)?_c('i',{staticClass:"fa fa-spin fa-spinner"}):_vm._e(),(!_vm.isLoading)?_c('i',{staticClass:"material-icons"},[_vm._v("save")]):_vm._e(),_vm._v("\n                    Simpan\n                  ")]),_vm._v(" "),_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")]),_vm._v(" Batal\n                  ")])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"judul"}},[_vm._v("Judul")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"penulis"}},[_vm._v("Penulis")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"kategori"}},[_vm._v("Kategori")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"artikel"}},[_vm._v("Foto Thumbnail Artikel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"artikel"}},[_vm._v("Foto Penulis Artikel")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vcQB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"block-header"},[_c('h2',[_vm._v(_vm._s(_vm.nama))])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            List "+_vm._s(_vm.nama)+"\n                        ")]),_vm._v(" "),_c('ul',{staticClass:"header-dropdown m-r--5 m-t--10"},[_c('router-link',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect waves-button",attrs:{"to":'/main/unduh/' + _vm.link + '/tambah',"type":"button"}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#fff"}},[_vm._v("add_box")]),_vm._v(" "),_c('span',[_vm._v("Tambah")])])],1)]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"dataTables_wrapper form-inline dt-bootstrap",attrs:{"id":"DataTables_Table_0_wrapper"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_length",attrs:{"id":"DataTables_Table_0_length"}},[_c('label',[_vm._v("Show "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.perPage),expression:"perPage"}],staticClass:"form-control input-sm",attrs:{"name":"DataTables_Table_0_length","aria-controls":"DataTables_Table_0"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.perPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_c('option',{attrs:{"value":"100"}},[_vm._v("100")])]),_vm._v(" entries")])])]),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_filter",attrs:{"id":"DataTables_Table_0_filter"}},[_c('label',[_vm._v("Search:"),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control input-sm",attrs:{"type":"search","placeholder":"","aria-controls":"DataTables_Table_0"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])])])]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped table-hover js-basic-example dataTable"},[_vm._m(0),_vm._v(" "),_c('tbody',[(_vm.isLoading)?_c('tr',[_vm._m(1)]):_vm._e(),_vm._v(" "),(_vm.list == '')?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"7"}},[_vm._v("Data tidak ditemukan")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(item,index){return (!_vm.isLoading)?_c('tr',[_c('td',[_vm._v(_vm._s(++index + ((_vm.currentPage-1)*_vm.perPage)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.judul))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.stripTags(item.konten)))]),_vm._v(" "),_c('td',[(item.file != null)?_c('a',{staticClass:"btn btn-info",attrs:{"target":"_blank","href":item.file}},[_c('i',{staticClass:"fa fa-paperclip"}),_vm._v(" File")]):_vm._e()]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.stripTags(item.tags)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.tglBerlaku))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn bg-green waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.push('/main/unduh/' + _vm.link + '/edit/' + item.id_pdp_arahan)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("create")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmDelete(item.id_pdp_arahan)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")])]),_vm._v(" "),(index != 1)?_c('button',{staticClass:"btn btn-primary waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.moveUp(index)}}},[_c('i',{staticClass:"fa fa-chevron-up"})]):_vm._e(),_vm._v(" "),(index !== (_vm.list.length))?_c('button',{staticClass:"btn btn-primary waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.moveDown(index)}}},[_c('i',{staticClass:"fa fa-chevron-down"})]):_vm._e()])]):_vm._e()})],2)])]),_vm._v(" "),_c('pagination',{attrs:{"total-rows":_vm.result.totalElements,"per-page":_vm.result.size},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("No.")]),_vm._v(" "),_c('th',[_vm._v("Judul")]),_vm._v(" "),_c('th',[_vm._v("Konten")]),_vm._v(" "),_c('th',[_vm._v("File")]),_vm._v(" "),_c('th',[_vm._v("Tags")]),_vm._v(" "),_c('th',[_vm._v("Berlaku Sampai")]),_vm._v(" "),_c('th',[_vm._v("Aksi")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center",attrs:{"colspan":"7"}},[_c('i',{staticClass:"fa fa-spin fa-spinner"}),_vm._v(" Loading data...")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vigp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"block-header"},[_c('h2',[_vm._v(_vm._s(_vm.nama))])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            "+_vm._s(_vm.id_pdp_arahan != null ? 'Edit' : 'Tambah')+" "+_vm._s(_vm.nama)+"\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_c('div',{staticClass:"row clearfix"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"judul","type":"text"},model:{value:(_vm.content.judul),callback:function ($$v) {_vm.$set(_vm.content, "judul", $$v)},expression:"content.judul"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('Ckeditor',{attrs:{"id":"Konten","config":_vm.config},model:{value:(_vm.content.konten),callback:function ($$v) {_vm.$set(_vm.content, "konten", $$v)},expression:"content.konten"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(2),_vm._v(" "),(_vm.content.file != null)?_c('div',{staticClass:"col-lg-2"},[_c('a',{staticClass:"btn btn-sm btn-info",attrs:{"target":"_blank","href":_vm.content.file}},[_c('i',{staticClass:"fa fa-paperclip"}),_vm._v(" File")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-lg-8 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"id":"icon","type":"file","name":"icon"},on:{"change":function($event){return _vm.handleFile($event)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"type":"text","id":"tags","config":_vm.config},model:{value:(_vm.content.tags),callback:function ($$v) {_vm.$set(_vm.content, "tags", $$v)},expression:"content.tags"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"form-line"},[_c('flat-pickr',{staticClass:"form-control",attrs:{"id":"tglBerlaku","config":_vm.date},model:{value:(_vm.content.tglBerlaku),callback:function ($$v) {_vm.$set(_vm.content, "tglBerlaku", $$v)},expression:"content.tglBerlaku"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[(_vm.id_pdp_arahan != null)?_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-warning waves-effect waves-button",attrs:{"type":"button"},on:{"click":_vm.update}},[_c('i',{staticClass:"material-icons"},[_vm._v("save")]),_vm._v(" Edit")]):_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect waves-button",attrs:{"type":"button"},on:{"click":_vm.save}},[_c('i',{staticClass:"material-icons"},[_vm._v("save")]),_vm._v(" Simpan")]),_vm._v(" "),_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")]),_vm._v(" Batal")])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"judul"}},[_vm._v("Judul")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"konten"}},[_vm._v("Konten")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"icon"}},[_vm._v("File")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"tags"}},[_vm._v("Tags")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"tglBerlaku"}},[_vm._v("Berlaku Sampai")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vle0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormWhistleBlower_vue__ = __webpack_require__("oETZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ab9834b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormWhistleBlower_vue__ = __webpack_require__("3IVZ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormWhistleBlower_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ab9834b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormWhistleBlower_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "w3AW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormLine_vue__ = __webpack_require__("VaXm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dda5620_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormLine_vue__ = __webpack_require__("Bif8");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormLine_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0dda5620_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormLine_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "w4cZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListVisiMisi_vue__ = __webpack_require__("dz20");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7ba109e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListVisiMisi_vue__ = __webpack_require__("9OFn");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListVisiMisi_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7ba109e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListVisiMisi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wY8d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Bar_vue__ = __webpack_require__("cicr");
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Bar_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wlFM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListWhistleBlower_vue__ = __webpack_require__("XFI6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0322b6bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListWhistleBlower_vue__ = __webpack_require__("Opr+");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListWhistleBlower_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0322b6bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListWhistleBlower_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "xJsL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("nKb+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_518279fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("Xj5W");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_518279fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJvq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Pagination',
  props: ['total-rows', 'per-page', 'value'],
  data: function data() {
    return {
      currentPage: this.value,
      maxOffset: 5
    };
  },
  methods: {
    update: function update(currentPage) {
      if (currentPage < 1 || currentPage > this.maxPage) return;
      this.currentPage = currentPage;
      this.$emit('input', this.currentPage);
    }
  },
  computed: {
    offset: function offset() {
      if (this.totalRows == null || this.perPage == null) return 1;
      var result = Math.ceil(this.totalRows / this.perPage);
      if (result < 1) return 1;else if (result > this.maxOffset) return this.maxOffset;else return result;
    },
    maxPage: function maxPage() {
      if (this.totalRows == null || this.perPage == null) return 1;
      var result = Math.ceil(this.totalRows / this.perPage);
      return result < 1 ? 1 : result;
    }
  }
});

/***/ }),

/***/ "xLWt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            "+_vm._s(_vm.id_faq != null ? 'Edit' : 'Tambah')+" FAQ\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_c('div',{staticClass:"row clearfix"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"form-line"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.data.kategori),expression:"data.kategori"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.data, "kategori", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("-- Pilih Kategori --")]),_vm._v(" "),_vm._l((_vm.categories),function(item){return _c('option',{key:item.id,domProps:{"value":item.id}},[_vm._v("\n                                        "+_vm._s(item.category)+"\n                                      ")])})],2)])])])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"pertanyaan","type":"text"},model:{value:(_vm.data.pertanyaan),callback:function ($$v) {_vm.$set(_vm.data, "pertanyaan", $$v)},expression:"data.pertanyaan"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('Ckeditor',{attrs:{"id":"jawaban","config":_vm.config},model:{value:(_vm.data.jawaban),callback:function ($$v) {_vm.$set(_vm.data, "jawaban", $$v)},expression:"data.jawaban"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[(_vm.id_faq)?_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-warning waves-effect waves-button",attrs:{"disabled":_vm.isLoading,"type":"button"},on:{"click":_vm.update}},[(!_vm.isLoading)?_c('span',[_c('i',{staticClass:"material-icons"},[_vm._v("save")]),_vm._v(" Edit")]):_c('span',[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" Loading")])]):_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect waves-button",attrs:{"disabled":_vm.isLoading,"type":"button"},on:{"click":_vm.save}},[(!_vm.isLoading)?_c('span',[_c('i',{staticClass:"material-icons"},[_vm._v("save")]),_vm._v(" Simpan")]):_c('span',[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" Loading")])]),_vm._v(" "),_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-danger waves-effect waves-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")]),_vm._v(" Batal")])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-header"},[_c('h2',[_vm._v("FAQ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"kategori"}},[_vm._v("Kategori")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"pertanyaan"}},[_vm._v("Pertanyaan")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"jawaban"}},[_vm._v("Jawaban")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xW1F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_api__ = __webpack_require__("+Btm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__ = __webpack_require__("w3AW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__["a" /* default */] },
  name: 'KritikDanSaranList',
  data: function data() {
    return {
      result: {},
      list: [],
      currentPage: 1,
      perPage: 10,
      search: '',
      modal: null,
      isLoading: true,
      link: '',
      nama: ''
    };
  },
  methods: {
    getData: function getData() {
      var _this = this;

      var params = [];
      params.search = this.search;
      params.page = this.currentPage - 1;
      params.size = this.perPage;

      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].get('/getallPertanyaanKirik?' + __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(params)).then(function (result) {
        _this.result = result.data;
        _this.list = result.data.content;
        console.log(result);
        _this.isLoading = false;
      }).catch(function (ex) {
        _this.isLoading = false;
        _this.$toastr.e('Gagal terhubung dengan server.');
      });
    },
    confirmDelete: function confirmDelete(id) {
      var _this2 = this;

      this.$swal({
        title: 'Konfirmasi',
        text: 'Anda yakin ingin menghapus data ini?',
        icon: 'warning',
        buttons: [true, {
          text: 'Ok',
          closeModal: false
        }],
        dangerMode: true
      }).then(function (result) {
        if (result) _this2.delete(id);
      });
    },
    delete: function _delete(id) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].delete('//' + id).then(function (result) {
        if (result.data.code === 200) _this3.$toastr.s('Data berhasil dihapus.');else _this3.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this3.$swal.close();
        _this3.getData();
      }).catch(function (e) {
        _this3.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this3.$swal.close();
      });
    },
    checkRoute: function checkRoute(route) {
      this.list = [];
      console.log("ini nama routenya ", route.name);

      if (route.name === 'KritikDanSaran') {
        this.link = 'KritikDanSaran';
      }
    }
  },
  mounted: function mounted() {
    this.checkRoute(this.$route);
    this.getData();
  },
  watch: {
    currentPage: function currentPage(e) {
      this.getData();
    },
    perPage: function perPage(e) {
      this.getData();
    },
    search: function search(e) {
      this.getData();
    },
    '$route': function $route(to, from) {
      this.checkRoute(to);
      this.getData();
    }
  }
});

/***/ }),

/***/ "xbz/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"login-box"},[_c('div',{staticClass:"card",staticStyle:{"margin-top":"38%"}},[_c('div',{staticClass:"body"},[_c('img',{staticStyle:{"margin":"0 auto","display":"block","z-index":"2","margin-top":"-82px","width":"30%","padding-top":"10px","margin-bottom":"15px"},attrs:{"src":__webpack_require__("7Otq")}}),_vm._v(" "),_c('form',{ref:"form",attrs:{"id":"sign_in","method":"POST"},on:{"submit":function($event){$event.preventDefault();return _vm.doReset.apply(null, arguments)}}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"input-group"},[_vm._m(1),_vm._v(" "),_c('formline',{ref:"email",attrs:{"type":"text","name":"email","placeholder":"Email","required":"","autofocus":""},model:{value:(_vm.login.email),callback:function ($$v) {_vm.$set(_vm.login, "email", $$v)},expression:"login.email"}})],1),_vm._v(" "),_c('div',{staticClass:"input-group"},[_vm._m(2),_vm._v(" "),_c('formline',{ref:"password",attrs:{"type":"password","name":"password","placeholder":"Password","required":"","autofocus":""},model:{value:(_vm.login.password),callback:function ($$v) {_vm.$set(_vm.login, "password", $$v)},expression:"login.password"}})],1),_vm._v(" "),_c('div',{staticClass:"input-group"},[_vm._m(3),_vm._v(" "),_c('formline',{ref:"repassword",attrs:{"type":"password","name":"repassword","placeholder":"Ulangi Password","required":"","autofocus":""},model:{value:(_vm.login.repassword),callback:function ($$v) {_vm.$set(_vm.login, "repassword", $$v)},expression:"login.repassword"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin":"0 auto","display":"block","text-align":"center"}},[_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn bg-pink btn-block waves-effect waves-button",staticStyle:{"color":"#fff"},attrs:{"disabled":_vm.isLoading}},[(!_vm.isLoading)?_c('span',[_vm._v("Reset Password")]):_c('span',[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" Loading")])])])])])])]),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('a',{staticStyle:{"color":"#333","font-size":"28px"},attrs:{"href":"#"}},[_vm._v("Admin"),_c('b',[_vm._v("DAPENBI")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"material-icons"},[_vm._v("email")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"material-icons"},[_vm._v("lock")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"material-icons"},[_vm._v("lock")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center","color":"#fff"}},[_c('p',[_vm._v("copyright 2018 | Dana Pensiun Indonesia")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center","color":"#fff"}},[_c('p',[_vm._v("Designed by "),_c('a',{staticStyle:{"color":"#fff"},attrs:{"href":"http://birutekno.com/"}},[_vm._v("Birutekno Inc")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xlJt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            "+_vm._s(_vm.id_logo != null ? 'Edit' : 'Tambah')+" Banner\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form-horizontal",on:{"submit":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_c('div',{staticClass:"row clearfix"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"text1","type":"text"},model:{value:(_vm.data.name),callback:function ($$v) {_vm.$set(_vm.data, "name", $$v)},expression:"data.name"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"text1","type":"text"},model:{value:(_vm.data.titleBanner),callback:function ($$v) {_vm.$set(_vm.data, "titleBanner", $$v)},expression:"data.titleBanner"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"text1","type":"text"},model:{value:(_vm.data.subtitleBanner),callback:function ($$v) {_vm.$set(_vm.data, "subtitleBanner", $$v)},expression:"data.subtitleBanner"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[_c('div',{staticClass:"form-group"},[_c('form-line',{attrs:{"id":"text1","type":"text"},model:{value:(_vm.data.description),callback:function ($$v) {_vm.$set(_vm.data, "description", $$v)},expression:"data.description"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"col-lg-10 col-md-10 col-sm-8 col-xs-7"},[(_vm.data.backgroundImage != null)?_c('img',{attrs:{"src":_vm.data.backgroundImage,"width":"150px","alt":"Foto"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"id":"icon","type":"file","name":"icon"},on:{"change":function($event){return _vm.handleFile($event)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-offset-2 col-md-offset-2 col-sm-offset-4 col-xs-offset-5"},[(_vm.id_logo != null)?_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-warning waves-effect waves-button",attrs:{"disabled":_vm.isLoading,"type":"button"},on:{"click":_vm.update}},[(!_vm.isLoading)?_c('span',[_c('i',{staticClass:"material-icons"},[_vm._v("save")]),_vm._v(" Edit")]):_c('span',[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" Loading")])]):_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect waves-button",attrs:{"disabled":_vm.isLoading,"type":"button"},on:{"click":_vm.save}},[(!_vm.isLoading)?_c('span',[_c('i',{staticClass:"material-icons"},[_vm._v("save")]),_vm._v(" Simpan")]):_c('span',[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" Loading")])]),_vm._v(" "),_c('button',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-danger waves-effect waves-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("cancel")]),_vm._v(" Batal")])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-header"},[_c('h2',[_vm._v("Banner")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"text1"}},[_vm._v("name")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"text1"}},[_vm._v("Title Banner")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"text1"}},[_vm._v("sub title Banner")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"text1"}},[_vm._v("Description")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-2 col-md-2 col-sm-4 col-xs-5 form-control-label"},[_c('label',{attrs:{"for":"icon"}},[_vm._v("background Image")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xy5q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FormLine_vue__ = __webpack_require__("w3AW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_api__ = __webpack_require__("+Btm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Bar__ = __webpack_require__("wY8d");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_0__components_FormLine_vue__["a" /* default */], BarChart: __WEBPACK_IMPORTED_MODULE_3__components_Bar__["a" /* default */] },
  name: 'FormSurvey',
  data: function data() {
    return {
      chartColors: ['rgb(255, 99, 132)', 'rgb(255, 159, 64)', 'rgb(54, 162, 235)', 'rgb(153, 102, 255)', 'rgb(201, 203, 207)', 'rgb(75, 192, 192)', 'rgb(255, 205, 86)'],
      tahun: new Date().getFullYear(),
      result: {},
      year: [],
      list: [],
      chart: {},
      currentPage: 1,
      perPage: 10,
      search: '',
      isLoading: false,
      chartData: {
        labels: ['Sangat Baik', 'Baik', 'Cukup', 'Buruk', 'Sangat Buruk'],
        datasets: []
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        },
        legend: {
          position: 'top'
        }
      }
    };
  },
  methods: {
    getData: function getData() {
      var _this = this;

      var params = [];
      params.search = this.search;
      params.page = this.currentPage - 1;
      params.size = this.perPage;

      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].get('/hasil-survey' + '?' + __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(params)).then(function (result) {
        _this.list = result.data.content;
      }).catch(function (ex) {
        _this.$toastr.e('Terjadi kesalahan pada server, mohon ulangi');
      });
    },
    getGrafik: function getGrafik() {
      var _this2 = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_1__helper_api__["a" /* default */].get('/grafik-survey/?tahun=' + this.tahun).then(function (result) {
        _this2.chart = result.data.object;
        _this2.chartData.datasets = [];

        for (var i = 0; i < _this2.chart.length; i++) {
          var _d = {
            data: [_this2.chart[i].score5, _this2.chart[i].score4, _this2.chart[i].score3, _this2.chart[i].score2, _this2.chart[i].score1],
            label: _this2.chart[i].masterSurvey.pernyataan,
            backgroundColor: _this2.chartColors[i]
          };
          _this2.chartData.datasets.push(_d);
        }
        _this2.isLoading = false;
      }).catch(function (ex) {
        _this2.$toastr.e('Terjadi kesalahan pada server, mohon ulangi');
        _this2.isLoading = false;
      });
    }
  },
  mounted: function mounted() {
    for (var i = 2017; i <= new Date().getFullYear(); i++) {
      this.year.push(i);
    }this.getData();
    this.getGrafik();
  },

  watch: {
    'tahun': function tahun(val) {
      this.getData();
      this.getGrafik();
    },
    currentPage: function currentPage(e) {
      this.getData();
    },
    perPage: function perPage(e) {
      this.getData();
    },
    search: function search(e) {
      this.getData();
    }
  }
});

/***/ }),

/***/ "xzck":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row clearfix"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('h2',[_vm._v("\n                            List Slider\n                        ")]),_vm._v(" "),_c('ul',{staticClass:"header-dropdown m-r--5 m-t--10"},[_c('router-link',{directives:[{name:"waves",rawName:"v-waves.button",modifiers:{"button":true}}],staticClass:"btn btn-primary waves-effect",attrs:{"to":'/main/slider/tambah',"type":"button"}},[_c('i',{staticClass:"material-icons",staticStyle:{"color":"#fff"}},[_vm._v("add_box")]),_vm._v(" "),_c('span',[_vm._v("Tambah")])])],1)]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"dataTables_wrapper form-inline dt-bootstrap",attrs:{"id":"DataTables_Table_0_wrapper"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_length",attrs:{"id":"DataTables_Table_0_length"}},[_c('label',[_vm._v("Show "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.perPage),expression:"perPage"}],staticClass:"form-control input-sm",attrs:{"name":"DataTables_Table_0_length","aria-controls":"DataTables_Table_0"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.perPage=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"10"}},[_vm._v("10")]),_c('option',{attrs:{"value":"25"}},[_vm._v("25")]),_c('option',{attrs:{"value":"50"}},[_vm._v("50")]),_c('option',{attrs:{"value":"100"}},[_vm._v("100")])]),_vm._v(" entries")])])]),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"dataTables_filter",attrs:{"id":"DataTables_Table_0_filter"}},[_c('label',[_vm._v("Search:"),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"form-control input-sm",attrs:{"type":"search","placeholder":"","aria-controls":"DataTables_Table_0"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])])])]),_vm._v(" "),_c('table',{staticClass:"table table-bordered table-striped table-hover js-basic-example dataTable"},[_vm._m(1),_vm._v(" "),_c('tbody',[(_vm.isLoading)?_c('tr',[_vm._m(2)]):_vm._e(),_vm._v(" "),(_vm.list == '')?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"5"}},[_vm._v("Data tidak ditemukan")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.list),function(item,index){return (!_vm.isLoading)?_c('tr',[_c('td',[_vm._v(_vm._s(++index + ((_vm.currentPage-1)*_vm.perPage)))]),_vm._v(" "),_c('td',[_c('img',{attrs:{"src":item.file,"width":"100px"}})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.text1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.text2))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn bg-green waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.$router.push('/main/slider/edit/' + item.id_slider)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("create")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmDelete(item.id_slider)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("delete")])]),_vm._v(" "),(index != 1)?_c('button',{staticClass:"btn btn-primary waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.moveUp(index)}}},[_c('i',{staticClass:"fa fa-chevron-up"})]):_vm._e(),_vm._v(" "),(index !== (_vm.list.length))?_c('button',{staticClass:"btn btn-primary waves-effect",staticStyle:{"padding":"4px 8px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.moveDown(index)}}},[_c('i',{staticClass:"fa fa-chevron-down"})]):_vm._e()])]):_vm._e()})],2)])]),_vm._v(" "),_c('pagination',{attrs:{"total-rows":_vm.result.totalElements,"per-page":_vm.result.size},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-header"},[_c('h2',[_vm._v("Slider")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("No.")]),_vm._v(" "),_c('th',[_vm._v("Foto")]),_vm._v(" "),_c('th',[_vm._v("Text 1")]),_vm._v(" "),_c('th',[_vm._v("Text 2")]),_vm._v(" "),_c('th',[_vm._v("Aksi")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center",attrs:{"colspan":"5"}},[_c('i',{staticClass:"fa fa-spin fa-spinner"}),_vm._v(" Loading data...")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "y/qq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pengumuman_vue__ = __webpack_require__("7v+Q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48025b56_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pengumuman_vue__ = __webpack_require__("fn37");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pengumuman_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48025b56_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pengumuman_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "y8rx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yf5h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KritikDanSaranList_vue__ = __webpack_require__("xW1F");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53507c72_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KritikDanSaranList_vue__ = __webpack_require__("rfCF");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KritikDanSaranList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53507c72_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KritikDanSaranList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yiqP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__ = __webpack_require__("Q8/M");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ed41ba5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__ = __webpack_require__("xbz/");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ed41ba5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yz7T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zX70":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_api__ = __webpack_require__("+Btm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ListNarasumber',
  data: function data() {
    return {
      result: {},
      list: [],
      currentPage: 1,
      perPage: 10,
      search: '',
      modal: null,
      isLoading: true,
      link: '',
      tipe: '',
      nama: ''
    };
  },
  methods: {
    getData: function getData() {
      var _this = this;

      var params = [];
      params.search = this.search;
      params.page = this.currentPage - 1;
      params.size = this.perPage;

      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].get('/narasumber?' + __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(params)).then(function (result) {
        _this.result = result.data;
        _this.list = result.data.content;
        _this.isLoading = false;
      }).catch(function (ex) {
        _this.isLoading = false;
      });
    },
    confirmDelete: function confirmDelete(id) {
      var _this2 = this;

      this.$swal({
        title: 'Konfirmasi',
        text: 'Anda yakin ingin menghapus data ini?',
        icon: 'warning',
        buttons: [true, {
          text: 'Ok',
          closeModal: false
        }],
        dangerMode: true
      }).then(function (result) {
        if (result) _this2.delete(id);
      });
    },
    delete: function _delete(id) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].delete('/narasumber/' + id).then(function (result) {
        if (result.data.code === 200) _this3.$toastr.s('Data berhasil dihapus.');else _this3.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this3.$swal.close();
        _this3.getData();
      }).catch(function (e) {
        _this3.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this3.$swal.close();
      });
    }
  },
  mounted: function mounted() {
    this.getData();
  },
  watch: {
    currentPage: function currentPage(e) {
      this.getData();
    },
    perPage: function perPage(e) {
      this.getData();
    },
    search: function search(e) {
      this.getData();
    }
  }
});

/***/ }),

/***/ "zt+8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormSlider_vue__ = __webpack_require__("kvXw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_93ca884a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSlider_vue__ = __webpack_require__("OngF");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormSlider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_93ca884a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormSlider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zxJn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_api__ = __webpack_require__("+Btm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__ = __webpack_require__("w3AW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */





/* harmony default export */ __webpack_exports__["a"] = ({
  components: { FormLine: __WEBPACK_IMPORTED_MODULE_2__components_FormLine_vue__["a" /* default */] },
  name: 'HakDanKewajiban',
  data: function data() {
    return {
      result: {},
      list: [],
      currentPage: 1,
      perPage: 10,
      search: '',
      modal: null,
      isLoading: true,
      link: '',
      nama: ''
    };
  },
  methods: {
    getData: function getData() {
      var _this = this;

      var params = [];
      params.search = this.search;
      params.page = this.currentPage - 1;
      params.size = this.perPage;

      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].get('/getAllHakKewajiban?' + __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(params)).then(function (result) {
        _this.result = result.data;
        _this.list = result.data.content;
        _this.isLoading = false;
      }).catch(function (ex) {
        _this.isLoading = false;
        _this.$toastr.e('Gagal terhubung dengan server.');
      });
    },
    confirmDelete: function confirmDelete(id) {
      var _this2 = this;

      this.$swal({
        title: 'Konfirmasi',
        text: 'Anda yakin ingin menghapus data ini?',
        icon: 'warning',
        buttons: [true, {
          text: 'Ok',
          closeModal: false
        }],
        dangerMode: true
      }).then(function (result) {
        if (result) _this2.delete(id);
      });
    },
    delete: function _delete(id) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('_token');
      __WEBPACK_IMPORTED_MODULE_0__helper_api__["a" /* default */].delete('deleteHakdanKewajiban/' + id).then(function (result) {
        console.log(result);
        if (result.data.code === 200 || result.status === 200) _this3.$toastr.s('Data berhasil dihapus.');else _this3.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this3.$swal.close();
        _this3.getData();
      }).catch(function (e) {
        _this3.$toastr.e('Gagal menghapus data, terjadi kesalahan pada server.');
        _this3.$swal.close();
      });
    },
    checkRoute: function checkRoute(route) {
      console.log("ini routenya", route);
      this.list = [];
      if (route.name === 'ListHakKewajiban') {
        console.log('masuk sin');
        this.link = 'ListHakdanKewajiban';
        this.nama = 'HakKewajiban';
      }
    }
  },
  mounted: function mounted() {
    this.checkRoute(this.$route);
    this.getData();
  },
  watch: {
    currentPage: function currentPage(e) {
      this.getData();
    },
    perPage: function perPage(e) {
      this.getData();
    },
    search: function search(e) {
      this.getData();
    },
    '$route': function $route(to, from) {
      this.checkRoute(to);
      this.getData();
    }
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.5b5540b9e640bbe8cfd7.js